import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export enum AcceptStatus {
  Accepted = 'accepted',
  Awaiting = 'awaiting',
  Na = 'na',
  Rejected = 'rejected'
}

export type AccessPass = {
  __typename?: 'AccessPass';
  allowedNoOfDaysToRenew: Scalars['Int']['output'];
  aspenId: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  deposit: Scalars['Int']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  enabledOptionList: Array<AccessPassOption>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isFamilyPackage: Scalars['Boolean']['output'];
  isSwpMode: Scalars['Boolean']['output'];
  isWebEnable: Scalars['Boolean']['output'];
  mainAccessPass?: Maybe<AccessPass>;
  mainAccessPassId?: Maybe<Scalars['Int']['output']>;
  maxAge: Scalars['Int']['output'];
  maxNoOfMembersPerPass: Scalars['Int']['output'];
  minAge: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  noOfDaysToForfeitDeposit: Scalars['Int']['output'];
  optionList?: Maybe<Array<AccessPassOption>>;
  renewGracePeriodNoOfDays: Scalars['Int']['output'];
  renewPeriodCountFromRenewDate: Scalars['Boolean']['output'];
  swpModeBlockEndDate?: Maybe<Scalars['String']['output']>;
  swpModeBlockStartDate?: Maybe<Scalars['String']['output']>;
  tncEn: Scalars['String']['output'];
  tncSc: Scalars['String']['output'];
  tncTc: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessPassFacilityAccessRel = {
  __typename?: 'AccessPassFacilityAccessRel';
  accessPassId: Scalars['Int']['output'];
  dayType: WeekdayType;
  endTime: Scalars['String']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
};

export type AccessPassHistory = {
  __typename?: 'AccessPassHistory';
  accessPass?: Maybe<AccessPass>;
  accessPassId: Scalars['Int']['output'];
  accessPassOption?: Maybe<AccessPassOption>;
  accessPassOptionId?: Maybe<Scalars['Int']['output']>;
  autoRenewNextAccessPassOption?: Maybe<AccessPassOption>;
  autoRenewNextAccessPassOptionId?: Maybe<Scalars['Int']['output']>;
  autoRenewNoOfTrial: Scalars['Int']['output'];
  autoRenewNotificationSentDateTime?: Maybe<Scalars['String']['output']>;
  contractEndDate: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  emailReminderSent: Scalars['Boolean']['output'];
  enableAutoRenew: Scalars['Boolean']['output'];
  endDate: Scalars['String']['output'];
  forceNoRenew: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isRenew: Scalars['Boolean']['output'];
  mainMember?: Maybe<FullMember>;
  mainMemberId?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  myorder?: Maybe<Myorder>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  noOfDayVisit?: Maybe<Scalars['Int']['output']>;
  phoneBookingOldInvoiceNo: Scalars['String']['output'];
  pushReminderSent: Scalars['Boolean']['output'];
  smsReminderSent: Scalars['Boolean']['output'];
  startDate: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type AccessPassOption = {
  __typename?: 'AccessPassOption';
  accessPass?: Maybe<AccessPass>;
  accessPassId: Scalars['Int']['output'];
  activeBonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  allowAutoRenew: Scalars['Boolean']['output'];
  apcCatCodeForDeposit: Scalars['String']['output'];
  apcCatCodeForFee: Scalars['String']['output'];
  apcCatCodeForForfeitDeposit: Scalars['String']['output'];
  apcCatCodeForRefundDeposit: Scalars['String']['output'];
  apcDeposit?: Maybe<AcctProductCat>;
  apcFee?: Maybe<AcctProductCat>;
  apcForfeitDeposit?: Maybe<AcctProductCat>;
  apcRefundDeposit?: Maybe<AcctProductCat>;
  bonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  id: Scalars['Int']['output'];
  ignoreMembershipDiscount: Scalars['Boolean']['output'];
  initPrice: Scalars['Float']['output'];
  isEnable: Scalars['Boolean']['output'];
  isStudentOnly: Scalars['Boolean']['output'];
  maxNoOfFacilityAccessPerDay?: Maybe<Scalars['Int']['output']>;
  maxNoOfFacilityAccessPerMonth?: Maybe<Scalars['Int']['output']>;
  maxNoOfFacilityAccessPerPeriod?: Maybe<Scalars['Int']['output']>;
  maxNoOfFacilityAccessPerYear?: Maybe<Scalars['Int']['output']>;
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  newFreeCouponPackage?: Maybe<CouponPackage>;
  newFreeCouponPackageId?: Maybe<Scalars['Int']['output']>;
  newFreeCreditPackage?: Maybe<CreditPackage>;
  newFreeCreditPackageId?: Maybe<Scalars['Int']['output']>;
  noOfDaysToDoAutoRenew: Scalars['Int']['output'];
  noOfDaysToSendAutoRenewNotification: Scalars['Int']['output'];
  noOfDaysToSendRenewReminder: Scalars['Int']['output'];
  orderId: Scalars['Float']['output'];
  renewFreeCouponPackage?: Maybe<CouponPackage>;
  renewFreeCouponPackageId?: Maybe<Scalars['Int']['output']>;
  renewFreeCreditPackage?: Maybe<CreditPackage>;
  renewFreeCreditPackageId?: Maybe<Scalars['Int']['output']>;
  renewPrice: Scalars['Float']['output'];
  validNoOfDay: Scalars['Int']['output'];
  validNoOfMonth: Scalars['Float']['output'];
  validNoOfYear: Scalars['Int']['output'];
};

export type AccessPassOptionPurchaseResGql = {
  __typename?: 'AccessPassOptionPurchaseResGql';
  accessPassOption?: Maybe<AccessPassOption>;
  canNew: Scalars['Boolean']['output'];
  canRenew: Scalars['Boolean']['output'];
  cannotNewReasonCode: AccessPassPurchaseInfoFailReason;
  cannotNewReasonDesc: Scalars['String']['output'];
  cannotRenewReasonCode: AccessPassPurchaseInfoFailReason;
  cannotRenewReasonDesc: Scalars['String']['output'];
  initPrice: Scalars['Float']['output'];
  newEndDate?: Maybe<Scalars['String']['output']>;
  newStartDate?: Maybe<Scalars['String']['output']>;
  renewEndDate?: Maybe<Scalars['String']['output']>;
  renewPrice: Scalars['Float']['output'];
  renewStartDate?: Maybe<Scalars['String']['output']>;
  requiredDeposit: Scalars['Float']['output'];
};

export enum AccessPassPurchaseInfoFailReason {
  AccessPassIsActive = 'AccessPassIsActive',
  AddToMemberMembershipExpired = 'AddToMemberMembershipExpired',
  InvalidAge = 'InvalidAge',
  MainAccessPassNotFound = 'MainAccessPassNotFound',
  MainMemberMembershipExpired = 'MainMemberMembershipExpired',
  MainMemberMustBeParentOrSpouse = 'MainMemberMustBeParentOrSpouse',
  MainMemberNoRequiredAccessPass = 'MainMemberNoRequiredAccessPass',
  MaxNoOfMembersPerPassReached = 'MaxNoOfMembersPerPassReached',
  Na = 'NA',
  NotAValidStudent = 'NotAValidStudent',
  OverlapWithExistingAccessPass = 'OverlapWithExistingAccessPass',
  PaymentPendingOrderExist = 'PaymentPendingOrderExist',
  SwpModeAllowBuyBackDeltaDaysExceed = 'SwpModeAllowBuyBackDeltaDaysExceed',
  SwpModeDoesNotSupportRenew = 'SwpModeDoesNotSupportRenew',
  SwpPeriodIsBlocked = 'SwpPeriodIsBlocked',
  TooEarlyToRenew = 'TooEarlyToRenew',
  TooLateToRenew = 'TooLateToRenew'
}

export type AccessPassPurchaseResGql = {
  __typename?: 'AccessPassPurchaseResGql';
  accessPass: AccessPass;
  purchaseInfoList: Array<AccessPassOptionPurchaseResGql>;
};

export type AcctProductCat = {
  __typename?: 'AcctProductCat';
  acctDesc: Scalars['String']['output'];
  apcAccountNo: Scalars['String']['output'];
  apcCatCode: Scalars['String']['output'];
  apcCode: Scalars['String']['output'];
  apcProjCode: Scalars['String']['output'];
  apcRevcCode: Scalars['String']['output'];
  apcType: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  desc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['String']['output'];
};

export type ActivateLockerListInput = {
  activateStatus: LockerStatus;
  lockerGroupId: Scalars['Int']['input'];
  noOfLockerToActivate?: InputMaybe<Scalars['Int']['input']>;
  prefix: Scalars['String']['input'];
  startingNo: Scalars['Int']['input'];
};

export type AdHocStockInInput = {
  confirmReceivedDate: Scalars['String']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  fromOrgId?: InputMaybe<Scalars['Int']['input']>;
  txList: Array<AdHocStockInTxInput>;
  userRemark: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type AdHocStockInTxInput = {
  inWarehousePartitionId: Scalars['Int']['input'];
  normalQty: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  scrapedQty: Scalars['Int']['input'];
};

export type AddAccessPassFacilityAccessRelInput = {
  accessPassId: Scalars['Int']['input'];
  dayType: WeekdayType;
  endTime: Scalars['String']['input'];
  facilityId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

export type AddAccessPassToBonusPointEarningRuleInput = {
  accessPassId?: InputMaybe<Scalars['Int']['input']>;
  accessPassOptionId?: InputMaybe<Scalars['Int']['input']>;
  bonusPointEarningRatio: Scalars['Int']['input'];
  bonusPointEarningRuleId: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  type: BonusPointEarningRuleAccessPassType;
};

export type AddAccessPassToCartInput = {
  accessPassId: Scalars['Int']['input'];
  accessPassOptionId: Scalars['Int']['input'];
  addToMemberId: Scalars['Int']['input'];
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  isRenew: Scalars['Boolean']['input'];
  mainMemberId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type AddAgreementToLockerHistoryInput = {
  lockerHistoryId: Scalars['Int']['input'];
  uploadFileInput: UploadFileInput;
};

export type AddBannerToAppInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddBonusPointReceiptRegInput = {
  amount: Scalars['Int']['input'];
  deptId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
  receiptDate: Scalars['String']['input'];
  receiptNo: Scalars['String']['input'];
};

export type AddBookingToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  checkCoachFreeslot?: Scalars['Boolean']['input'];
  coachFee?: InputMaybe<Scalars['Float']['input']>;
  coachId?: InputMaybe<Scalars['Int']['input']>;
  coachServiceId?: InputMaybe<Scalars['Int']['input']>;
  endDateTime: Scalars['String']['input'];
  eventCode?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['Int']['input'];
  ignoreAccessPassDependency?: Scalars['Boolean']['input'];
  ignoreLeadTimeCheck?: Scalars['Boolean']['input'];
  ignoreMemberConflictCheck?: Scalars['Boolean']['input'];
  ignoreNoOfTimeslotCheck?: Scalars['Boolean']['input'];
  ignoreNoSameDayBookingRule?: Scalars['Boolean']['input'];
  ignoreNoSameTimeBookingRule?: Scalars['Boolean']['input'];
  ignoreOutstandingOrderCheck?: Scalars['Boolean']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  memberIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  myEventId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type AddBookingToMultiFacilityInput = {
  endDateTime: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  pairList: Array<AddBookingToMultiFacilityPairInput>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type AddBookingToMultiFacilityPairInput = {
  facilityId: Scalars['Int']['input'];
  qty?: Scalars['Int']['input'];
};

export type AddCoachSalaryContractTermsInput = {
  deptId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  salaryType: SalaryType;
  salaryValue: Scalars['Float']['input'];
  userId: Scalars['Int']['input'];
};

export type AddCoachSalaryReportCoachAdjustmentInput = {
  adjustment: Scalars['Float']['input'];
  coachId: Scalars['Int']['input'];
  deptId: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type AddCoachTimeslotInput = {
  coachId: Scalars['Int']['input'];
  daysOfWeeks: Array<Scalars['Int']['input']>;
  endDate: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  isFree: Scalars['Boolean']['input'];
  remark: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type AddCoachToExistingBookingInput = {
  cartType: CartType;
  checkCoachFreeslot?: Scalars['Boolean']['input'];
  coachFee: Scalars['Float']['input'];
  coachId: Scalars['Int']['input'];
  coachServiceId?: InputMaybe<Scalars['Int']['input']>;
  facilityBookingId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
  serviceName: Scalars['String']['input'];
};

export type AddCouponCodeToBonusPointEarningRuleInput = {
  bonusPointEarningRuleId: Scalars['Int']['input'];
  couponCode: Scalars['String']['input'];
  globalQuota?: InputMaybe<Scalars['Int']['input']>;
  isEnable: Scalars['Boolean']['input'];
  memberQuota?: InputMaybe<Scalars['Int']['input']>;
};

export type AddCouponPackageCoachServiceRelInput = {
  coachId: Scalars['Int']['input'];
  coachServiceId: Scalars['Int']['input'];
  couponPackageId: Scalars['Int']['input'];
};

export type AddCouponPackageFacilityRelInput = {
  couponPackageId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
  noOfCouponsPerTimeslotForNormalHour: Scalars['Int']['input'];
  noOfCouponsPerTimeslotForPeakHour: Scalars['Int']['input'];
};

export type AddCouponPackageToCartInput = {
  cartType: CartType;
  couponPackageId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
};

export type AddCourseEnrolmentResGql = {
  __typename?: 'AddCourseEnrolmentResGql';
  conflictTimeslotList: Array<TimeslotUnitResGql>;
  courseEnrolment?: Maybe<CourseEnrolment>;
  listPrice: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  subtotalPrice: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type AddCourseEnrolmentToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  courseId: Scalars['Int']['input'];
  enrolMemberId: Scalars['Int']['input'];
  ignoreAgeCheck?: Scalars['Boolean']['input'];
  ignoreDateCheck?: Scalars['Boolean']['input'];
  ignoreMemberRelationship: Scalars['Boolean']['input'];
  ignoreMemberScheduleConflict: Scalars['Boolean']['input'];
  lessonIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
  uniformOption?: Scalars['String']['input'];
};

export type AddCourseInvitationCodeInput = {
  courseId: Scalars['Int']['input'];
  invitationCode: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddCreditPackageToCartInput = {
  cartType: CartType;
  creditPackageId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
};

export type AddCustomBonusPointToMember = {
  amount: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
  noOfDaysToExpireOverride?: InputMaybe<Scalars['Int']['input']>;
  remark: Scalars['String']['input'];
};

export type AddCustomCreditToMember = {
  amount: Scalars['Float']['input'];
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['Int']['input'];
  noOfDaysToExpireOverride?: InputMaybe<Scalars['Int']['input']>;
  remark: Scalars['String']['input'];
};

export type AddDefaultFacilityFeeInput = {
  dayType: WeekdayType;
  disableForWeb: Scalars['Boolean']['input'];
  endTime: Scalars['String']['input'];
  feeForDept: Scalars['Float']['input'];
  feeForGroup: Scalars['Float']['input'];
  feeForMember: Scalars['Float']['input'];
  feeForRegBody: Scalars['Float']['input'];
  isPeakHour: Scalars['Boolean']['input'];
  orderId: Scalars['Float']['input'];
  startTime: Scalars['String']['input'];
};

export type AddDriveDepositToCartInput = {
  amount: Scalars['Float']['input'];
  cartType: CartType;
  driveTeamId: Scalars['Float']['input'];
  memberId: Scalars['Float']['input'];
};

export type AddEquipmentToBookingInput = {
  bookingId: Scalars['Int']['input'];
  equipmentIdList: Array<Scalars['Int']['input']>;
};

export type AddEquipmentToBookingResGql = {
  __typename?: 'AddEquipmentToBookingResGql';
  addResult: Array<Scalars['Boolean']['output']>;
  facilityBooking: FacilityBooking;
};

export type AddExistingBookingToOrgCartInput = {
  facilityBookingIdList: Array<Scalars['Int']['input']>;
  orgId: Scalars['Int']['input'];
};

export type AddFacilityAccessPassDependencyInput = {
  accessPassId: Scalars['Int']['input'];
  dayType: WeekdayType;
  endTime: Scalars['String']['input'];
  facilityId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

export type AddFacilityAccessPassLeadTimeInput = {
  accessPassId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
  maxLeadTimeInDays: Scalars['Int']['input'];
  minLeadTimeInDays: Scalars['Int']['input'];
};

export type AddFacilityAccessPassNoOfTimeslotInput = {
  accessPassId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
  maxNoOfTimeslot: Scalars['Int']['input'];
  maxNoOfTimeslotForPeakHour: Scalars['Int']['input'];
  minNoOfTimeslot: Scalars['Int']['input'];
};

export type AddFacilityBookingOnlyOpenWhenAllBookedExceptTimeslotInput = {
  dayType: WeekdayType;
  endTime: Scalars['String']['input'];
  facilityId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

export type AddFacilityFeeInput = {
  accessPassId?: InputMaybe<Scalars['Int']['input']>;
  dayList?: Array<Scalars['String']['input']>;
  dayType: WeekdayType;
  disableForWeb: Scalars['Boolean']['input'];
  endTime: Scalars['String']['input'];
  facilityId: Scalars['Int']['input'];
  feeForDept: Scalars['Float']['input'];
  feeForGroup: Scalars['Float']['input'];
  feeForMember: Scalars['Float']['input'];
  feeForRegBody: Scalars['Float']['input'];
  isPeakHour: Scalars['Boolean']['input'];
  orderId: Scalars['Float']['input'];
  startTime: Scalars['String']['input'];
};

export type AddFileInput = {
  parentId: Scalars['Int']['input'];
  uploadFileInput: UploadFileInput;
};

export type AddLessonEnrolmentToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  courseId: Scalars['Int']['input'];
  enrolMemberId: Scalars['Int']['input'];
  ignoreAgeCheck?: Scalars['Boolean']['input'];
  ignoreDateCheck?: Scalars['Boolean']['input'];
  ignoreMemberRelationship: Scalars['Boolean']['input'];
  ignoreMemberScheduleConflict: Scalars['Boolean']['input'];
  ignoreMinNoOfEnrolledLessonsCheck?: Scalars['Boolean']['input'];
  lessonIdList: Array<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
  uniformOption?: Scalars['String']['input'];
};

export type AddLockerGroupFeeInput = {
  allowAutoRenew: Scalars['Boolean']['input'];
  apcCatCodeForDeposit: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForForfeitDeposit: Scalars['String']['input'];
  apcCatCodeForRefundDeposit: Scalars['String']['input'];
  isEnable: Scalars['Boolean']['input'];
  lockerGroupId: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfDay: Scalars['Int']['input'];
  noOfDaysToDoAutoRenew: Scalars['Int']['input'];
  noOfDaysToSendAutoRenewNotification: Scalars['Int']['input'];
  noOfDaysToSendRenewReminder: Scalars['Int']['input'];
  noOfMonth: Scalars['Int']['input'];
  noOfYear: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
  renewPrice: Scalars['Float']['input'];
};

export type AddLockerGroupWaitingListInput = {
  lockerGroupId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type AddLockerToCartInput = {
  cartType: CartType;
  lockerGroupFeeId: Scalars['Int']['input'];
  lockerId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  oldLockerId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddLostCardToCartInput = {
  cartType: CartType;
  memberId: Scalars['Int']['input'];
};

export type AddMemberListAsCourseMemberListToCourseInput = {
  courseId: Scalars['Int']['input'];
  memberListAsCourseMemberListType: MemberListAsCourseMemberListType;
  memberListId: Scalars['Int']['input'];
};

export type AddMemberListAsRecurCourseMemberListToCourseInput = {
  memberListAsCourseMemberListType: MemberListAsCourseMemberListType;
  memberListId: Scalars['Int']['input'];
  recurCourseId: Scalars['Int']['input'];
};

export type AddMemberListByMembershipNoInput = {
  memberListId: Scalars['Int']['input'];
  membershipNoList?: Array<Scalars['String']['input']>;
  remark: Scalars['String']['input'];
};

export type AddMemberListByMembershipNoInputResGql = {
  __typename?: 'AddMemberListByMembershipNoInputResGql';
  addedMemberCount: Scalars['Int']['output'];
  memberList: MemberList;
  notFoundMembershipNoList: Array<Scalars['String']['output']>;
};

export type AddMemberListMemberInput = {
  memberIdList?: Array<Scalars['Int']['input']>;
  memberListId: Scalars['Int']['input'];
  remark: Scalars['String']['input'];
};

export type AddMemberRelationshipRequestInput = {
  memberId: Scalars['Int']['input'];
  relatedMemberId: Scalars['Int']['input'];
  relationshipType: RelationshipType;
};

export type AddMemberToCourseMemberListInput = {
  courseId: Scalars['Int']['input'];
  courseMemberListType: CourseMemberListType;
  memberIdList: Array<Scalars['Int']['input']>;
};

export type AddMembershipToCartInput = {
  cartType: CartType;
  driveMemberId?: InputMaybe<Scalars['Int']['input']>;
  driveTeamId?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['Int']['input'];
  membershipTypeId: Scalars['Int']['input'];
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddMsgToQueueInput = {
  appChannel?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
  dataPayload?: InputMaybe<AppPushNotificationDataPayloadInput>;
  gpTokenId?: InputMaybe<Scalars['Int']['input']>;
  htmlContent: Scalars['String']['input'];
  lessonId?: InputMaybe<Scalars['Int']['input']>;
  memberIdList: Array<Scalars['Int']['input']>;
  msgPlatform: MsgPlatform;
  myEventId?: InputMaybe<Scalars['Int']['input']>;
  phoneNoList?: Array<Scalars['String']['input']>;
  plainContent: Scalars['String']['input'];
  targetUserIdList: Array<Scalars['Int']['input']>;
  timeSlotProgramReservationId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type AddMyEventEnrolmentToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  myEventId: Scalars['Int']['input'];
  myEventTicketTypeId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  seatNoList: Array<Scalars['Int']['input']>;
  teamMemberList?: Array<AddMyEventTeamMemberInput>;
  teamName: Scalars['String']['input'];
};

export type AddMyEventTeamMemberInput = {
  birthDate: Scalars['String']['input'];
  chineseName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName: Scalars['String']['input'];
  emergencyTel: Scalars['String']['input'];
  emergencyTelAreaCode: Scalars['String']['input'];
  gender?: InputMaybe<FilterGender>;
  givenName: Scalars['String']['input'];
  hkid?: InputMaybe<Scalars['String']['input']>;
  isCaptain: Scalars['Boolean']['input'];
  mobileTel: Scalars['String']['input'];
  mobileTelAreaCode: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
};

export type AddMyEventTicketSeatInput = {
  endSeatNo: Scalars['Int']['input'];
  myEventId: Scalars['Int']['input'];
  myEventTicketTypeId: Scalars['Int']['input'];
  startSeatNo: Scalars['Int']['input'];
};

export type AddMyEventTicketTypeInput = {
  apcCatCodeForFee: Scalars['String']['input'];
  defaultFeeForGroup: Scalars['Float']['input'];
  defaultFeeForGuest: Scalars['Float']['input'];
  defaultFeeForMember: Scalars['Float']['input'];
  earlyBirdDiscountAmtForGroup: Scalars['Float']['input'];
  earlyBirdDiscountAmtForGuest: Scalars['Float']['input'];
  earlyBirdDiscountAmtForMember: Scalars['Float']['input'];
  earlyBirdDiscountPercentForGroup: Scalars['Int']['input'];
  earlyBirdDiscountPercentForGuest: Scalars['Int']['input'];
  earlyBirdDiscountPercentForMember: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isFreeSeating: Scalars['Boolean']['input'];
  maxTicketsPerMember: Scalars['Int']['input'];
  minTicketsPerMember: Scalars['Int']['input'];
  myEventId: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type AddMyfileToBookingInput = {
  facilityBookingId: Scalars['Int']['input'];
  uploadFileInput: UploadFileInput;
};

export type AddMyfileToKwtdhcEventInput = {
  kwtdhcEventId: Scalars['Int']['input'];
  uploadFileInput: UploadFileInput;
};

export type AddMyfileToMemberInput = {
  memberId: Scalars['Int']['input'];
  uploadFileInput: UploadFileInput;
};

export type AddOrUpdateFabReservationInput = {
  bookingEndDateTime?: InputMaybe<Scalars['String']['input']>;
  bookingStartDateTime?: InputMaybe<Scalars['String']['input']>;
  depositPaid: Scalars['Int']['input'];
  fabFloorplanId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  ignoreConflict: Scalars['Boolean']['input'];
  ignoreSeatsCheck: Scalars['Boolean']['input'];
  isRequest1: Scalars['Boolean']['input'];
  isRequest2: Scalars['Boolean']['input'];
  isRequest3: Scalars['Boolean']['input'];
  isRequest4: Scalars['Boolean']['input'];
  isRequest5: Scalars['Boolean']['input'];
  isRequest6: Scalars['Boolean']['input'];
  isRequest7: Scalars['Boolean']['input'];
  isRequest8: Scalars['Boolean']['input'];
  isRequest9: Scalars['Boolean']['input'];
  isWalkIn: Scalars['Boolean']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
  mobileNo: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
  status: FabReservationStatus;
  totalNoOfSeats: Scalars['Int']['input'];
  updateTableDtoList: Array<UpdateFabReservationTableRelInput>;
};

export type AddPhotoInput = {
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToBonusPointRedeemPromotionGroupInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToCourseInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToLockerGroupInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToMiniSiteContentInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToMyEventInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToNewsInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToProductCatInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToProductInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToRecurCourseInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToSportTypeGroupInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToSportTypeInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddPhotoToTimeSlotProgramGroupInput = {
  myfileType: MyfileType;
  parentId: Scalars['Int']['input'];
  uploadImageInput: UploadImageInput;
};

export type AddProductToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
  removeExistingQty: Scalars['Boolean']['input'];
  shippedQty: Scalars['Int']['input'];
};

export type AddProductToUserProductGroupAtPositionInput = {
  orderId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  userProductGroupId: Scalars['Int']['input'];
};

export type AddProductToUserProductGroupInput = {
  productIdList: Array<Scalars['Int']['input']>;
  userProductGroupIdList: Array<Scalars['Int']['input']>;
};

export type AddProductToWarehouseStockTakeInput = {
  clearOld: Scalars['Boolean']['input'];
  normalQty: Scalars['Int']['input'];
  normalQtyBefore?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  scrapedQty: Scalars['Int']['input'];
  scrapedQtyBefore?: InputMaybe<Scalars['Int']['input']>;
  warehousePartitionId: Scalars['Int']['input'];
  warehouseStockTakeId: Scalars['Int']['input'];
};

export type AddRecurBookingToFacilityInput = {
  daysOfWeeks: Array<Scalars['Int']['input']>;
  endDate: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  pairList: Array<AddBookingToMultiFacilityPairInput>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type AddRecurBookingToFacilityResGql = {
  __typename?: 'AddRecurBookingToFacilityResGql';
  booking?: Maybe<FacilityBooking>;
  endDateTime: Scalars['String']['output'];
  error: Scalars['String']['output'];
  facility: Facility;
  result: Scalars['Boolean']['output'];
  startDateTime: Scalars['String']['output'];
};

export type AddRefundDepositToCartInput = {
  cartType: CartType;
  depositHistoryId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddRefundItemListToCartInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  myorderId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
  refundItemList?: Array<AddRefundItemToCartInput>;
};

export type AddRefundItemToCartInput = {
  isProductExchange?: Scalars['Boolean']['input'];
  lessonIdList?: Array<Scalars['Int']['input']>;
  myorderItemId: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  refundShippedQty: Scalars['Int']['input'];
  refundUnshippedQty: Scalars['Int']['input'];
  returnAsScraped?: Scalars['Boolean']['input'];
  returnQty: Scalars['Int']['input'];
};

export type AddReturnLockerToCartInput = {
  cartType: CartType;
  lockerId: Scalars['Int']['input'];
  makeAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddTimeSlotProgramLocationInput = {
  locationQuota: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  quotaPerDay: Scalars['Int']['input'];
  timeSlotProgramId: Scalars['Int']['input'];
};

export type AddTimeSlotProgramOpeningHourInput = {
  dayList: Array<Scalars['String']['input']>;
  dayType: WeekdayType;
  disableForWeb: Scalars['Boolean']['input'];
  endTime: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  startTime: Scalars['String']['input'];
  timeSlotProgramId: Scalars['Int']['input'];
  timeSlotProgramLocationId: Scalars['Int']['input'];
  timeslotQuota: Scalars['Int']['input'];
};

export type AddTimeSlotProgramReservationInput = {
  customString01: Scalars['String']['input'];
  customString02: Scalars['String']['input'];
  customString03: Scalars['String']['input'];
  customString04: Scalars['String']['input'];
  customString05: Scalars['String']['input'];
  customString06: Scalars['String']['input'];
  customString07: Scalars['String']['input'];
  customString08: Scalars['String']['input'];
  customString09: Scalars['String']['input'];
  customString10: Scalars['String']['input'];
  endDateTime: Scalars['String']['input'];
  hkid?: InputMaybe<Scalars['String']['input']>;
  ignoreAgeCheck?: Scalars['Boolean']['input'];
  memberId: Scalars['Int']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  refMembershipNo: Scalars['String']['input'];
  remark: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  timeSlotProgramId: Scalars['Int']['input'];
  timeSlotProgramLocationId: Scalars['Int']['input'];
  timeSlotProgramServiceTypeIdList?: Array<Scalars['Int']['input']>;
};

export type AddTimeSlotProgramServiceTypeInput = {
  isEnable: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  timeSlotProgramId: Scalars['Int']['input'];
};

export type AddTimeSlotProgramSummaryUserInput = {
  timeSlotProgramId: Scalars['Int']['input'];
  userIdList: Array<Scalars['Int']['input']>;
};

export type AddTimeslotProgramGridHourInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  timeSlotProgramId: Scalars['Int']['input'];
  timeSlotProgramLocationId: Scalars['Int']['input'];
};

export type AddWhatsappImageMessageToQueueInput = {
  caption: Scalars['String']['input'];
  replyToMsgQueueId?: InputMaybe<Scalars['Int']['input']>;
  uploadFileInput?: InputMaybe<UploadFileInput>;
  waId: Scalars['String']['input'];
};

export type AddWhatsappReactionMessageToQueueInput = {
  emoji: Scalars['String']['input'];
  replyToMsgQueueId: Scalars['Int']['input'];
  waId: Scalars['String']['input'];
};

export type AddWhatsappTemplateMsgToQueueInput = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  gpTokenId?: InputMaybe<Scalars['Int']['input']>;
  lessonId?: InputMaybe<Scalars['Int']['input']>;
  memberIdList: Array<Scalars['Int']['input']>;
  phoneNoList: Array<Scalars['String']['input']>;
  timeSlotProgramReservationId?: InputMaybe<Scalars['Int']['input']>;
  uploadFileInput?: InputMaybe<UploadFileInput>;
  waBodyDataMapping?: InputMaybe<Scalars['String']['input']>;
  waButtonDataMapping?: InputMaybe<Scalars['String']['input']>;
  waHeaderDataMapping?: InputMaybe<Scalars['String']['input']>;
  waMediaDataMapping: Scalars['String']['input'];
  waMediaDataUrl: Scalars['String']['input'];
  waMediaMyfileId?: InputMaybe<Scalars['Int']['input']>;
  whatsappTemplateId?: InputMaybe<Scalars['Int']['input']>;
  whatsappTemplateName?: InputMaybe<Scalars['String']['input']>;
};

export type AddWhatsappTextMessageToQueueInput = {
  content: Scalars['String']['input'];
  replyToMsgQueueId?: InputMaybe<Scalars['Int']['input']>;
  waId: Scalars['String']['input'];
};

export type AddYldsaCourseAdminFeeToCartInput = {
  cartType: CartType;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  myorderItemId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddYldsaOldCourseRefundToCartInput = {
  amount: Scalars['Float']['input'];
  cartType: CartType;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  oldCourseCode: Scalars['String']['input'];
  oldYearMonth: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDeletePassKeyInput = {
  id: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminLoginAsMemberInput = {
  id: Scalars['Int']['input'];
};

export type AdminSearchUserSessionInput = {
  andCondList?: Array<QueryCondMySessionInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMySessionInput>;
  orderBy?: InputMaybe<QueryOrderByMySessionInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMySessionInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type AdminSearchUserSessionResGql = {
  __typename?: 'AdminSearchUserSessionResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MySession>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdminSetting = {
  __typename?: 'AdminSetting';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum AgeCalcType {
  Full = 'full',
  YearMonth = 'yearMonth',
  YearOnly = 'yearOnly'
}

export enum AgeGroup {
  X0to4 = 'x0to4',
  X5to10 = 'x5to10',
  X11to18 = 'x11to18',
  X19to64 = 'x19to64',
  X65plus = 'x65plus'
}

export type AnyRemoveTotpInput = {
  memberId?: InputMaybe<Scalars['Float']['input']>;
  totpId: Scalars['Float']['input'];
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type AnyUpdateMyorderInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  deptTransferDeptId?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  internalRemarks?: InputMaybe<Scalars['String']['input']>;
  isPhoneBooking?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfPickup?: InputMaybe<Scalars['Boolean']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  memberRemarks?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  totalCreditSpent?: InputMaybe<Scalars['Float']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type ApiDeleteUserInput = {
  forceDelete?: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export type AppPushNotificationDataPayloadInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  couponPackageId?: InputMaybe<Scalars['Int']['input']>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
  courseSportTypeGroupId?: InputMaybe<Scalars['Int']['input']>;
  courseSportTypeId?: InputMaybe<Scalars['Int']['input']>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  facilitySportTypeId?: InputMaybe<Scalars['Int']['input']>;
  newsId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplicableCouponPackageInstanceResGql = {
  __typename?: 'ApplicableCouponPackageInstanceResGql';
  couponPackageInstance: CouponPackageInstance;
  isApplied: Scalars['Boolean']['output'];
  requiredCoupons: Scalars['Float']['output'];
};

export type ApplyCouponToFacilityBookingInput = {
  couponPackageInstanceId?: InputMaybe<Scalars['Int']['input']>;
  endDateTime: Scalars['String']['input'];
  facilityBookingId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type ApplyCouponToPrivateCoachInput = {
  coachMyorderItemId: Scalars['Int']['input'];
  couponPackageInstanceId?: InputMaybe<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplyDefaultFacilityFeeInput = {
  facilityId: Scalars['Int']['input'];
};

export type ApplyRoleTemplateToUserInput = {
  roleTemplateId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type ApproveOrRejectInternalBookingInput = {
  bookingId: Scalars['Int']['input'];
  isApprove: Scalars['Boolean']['input'];
  rejectReason?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  actionCode: Scalars['String']['output'];
  actionDesc: Scalars['String']['output'];
  actionJson: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  eventCode: Scalars['String']['output'];
  eventDesc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  uuid1?: Maybe<Scalars['String']['output']>;
  uuid2?: Maybe<Scalars['String']['output']>;
  uuid3?: Maybe<Scalars['String']['output']>;
};

export type AuthSessionWithTotpInput = {
  keepLogin: Scalars['Boolean']['input'];
  totp?: InputMaybe<Scalars['String']['input']>;
};

export type AuthSessionWithTotpResGql = {
  __typename?: 'AuthSessionWithTotpResGql';
  accessToken: Scalars['String']['output'];
};

export type AutoPickCourseLotteryResultInput = {
  refDate?: InputMaybe<Scalars['String']['input']>;
};

export type BonusPointDailyReport = {
  __typename?: 'BonusPointDailyReport';
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalBalance: Scalars['Float']['output'];
  totalEarned: Scalars['Float']['output'];
  totalExpired: Scalars['Float']['output'];
  totalUsed: Scalars['Float']['output'];
};

export type BonusPointEarningRule = {
  __typename?: 'BonusPointEarningRule';
  createdDate: Scalars['String']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  enableCouponCode: Scalars['Boolean']['output'];
  endDate: Scalars['String']['output'];
  erAccessPassList?: Maybe<Array<BonusPointEarningRuleAccessPass>>;
  erCouponCodeList?: Maybe<Array<BonusPointEarningRuleCouponCode>>;
  erCourseList?: Maybe<Array<BonusPointEarningRuleCourse>>;
  erFacilityBookingList?: Maybe<Array<BonusPointEarningRuleFacilityBooking>>;
  erLockerList?: Maybe<Array<BonusPointEarningRuleLocker>>;
  erMyEventList?: Maybe<Array<BonusPointEarningRuleMyEvent>>;
  erNthOrderList?: Maybe<Array<BonusPointEarningRuleNthOrder>>;
  erProductList?: Maybe<Array<BonusPointEarningRuleProduct>>;
  globalQuota?: Maybe<Scalars['Int']['output']>;
  globalQuotaUsed: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  memberQuota?: Maybe<Scalars['Int']['output']>;
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  refBonusPointEarningRatio: Scalars['Int']['output'];
  refExtraBonusPointAmount: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  tncEn: Scalars['String']['output'];
  tncSc: Scalars['String']['output'];
  tncTc: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type BonusPointEarningRuleAccessPass = {
  __typename?: 'BonusPointEarningRuleAccessPass';
  accessPass?: Maybe<AccessPass>;
  accessPassId?: Maybe<Scalars['Int']['output']>;
  accessPassOption?: Maybe<AccessPassOption>;
  accessPassOptionId?: Maybe<Scalars['Int']['output']>;
  bonusPointEarningRatio: Scalars['Int']['output'];
  bonusPointEarningRuleId: Scalars['Int']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  extraBonusPointAmount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  type: BonusPointEarningRuleAccessPassType;
};

export enum BonusPointEarningRuleAccessPassType {
  Any = 'any',
  New = 'new',
  Renew = 'renew'
}

export type BonusPointEarningRuleCouponCode = {
  __typename?: 'BonusPointEarningRuleCouponCode';
  bonusPointEarningRuleId: Scalars['Int']['output'];
  couponCode: Scalars['String']['output'];
  globalQuota?: Maybe<Scalars['Int']['output']>;
  globalQuotaUsed: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  memberQuota?: Maybe<Scalars['Int']['output']>;
};

export type BonusPointEarningRuleCourse = {
  __typename?: 'BonusPointEarningRuleCourse';
  bonusPointEarningRatio: Scalars['Int']['output'];
  bonusPointEarningRuleId: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  course?: Maybe<Course>;
  courseEndDate?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['Int']['output']>;
  courseStartDate?: Maybe<Scalars['String']['output']>;
  courseType?: Maybe<CourseType>;
  courseTypeId?: Maybe<Scalars['Int']['output']>;
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  enrolEndDate?: Maybe<Scalars['String']['output']>;
  enrolStartDate?: Maybe<Scalars['String']['output']>;
  extraBonusPointAmount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  sportType?: Maybe<SportType>;
  sportTypeGroup?: Maybe<SportTypeGroup>;
  sportTypeGroupId?: Maybe<Scalars['Int']['output']>;
  sportTypeId?: Maybe<Scalars['Int']['output']>;
  type: BonusPointEarningRuleCourseType;
};

export enum BonusPointEarningRuleCourseType {
  Any = 'any',
  LastFromRecurCourse = 'lastFromRecurCourse',
  NewFromCourse = 'newFromCourse',
  NewFromDept = 'newFromDept',
  NewFromRecurCourse = 'newFromRecurCourse',
  NewFromSport = 'newFromSport',
  NewFromSportGroup = 'newFromSportGroup',
  ReturnFromCourse = 'returnFromCourse',
  ReturnFromDept = 'returnFromDept',
  ReturnFromRecurCourse = 'returnFromRecurCourse',
  ReturnFromSport = 'returnFromSport',
  ReturnFromSportGroup = 'returnFromSportGroup'
}

export type BonusPointEarningRuleFacilityBooking = {
  __typename?: 'BonusPointEarningRuleFacilityBooking';
  bonusPointEarningRatio: Scalars['Int']['output'];
  bonusPointEarningRuleId: Scalars['Int']['output'];
  bookingEndDate?: Maybe<Scalars['String']['output']>;
  bookingStartDate?: Maybe<Scalars['String']['output']>;
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  extraBonusPointAmount: Scalars['Int']['output'];
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  type: BonusPointEarningRuleFacilityBookingType;
};

export enum BonusPointEarningRuleFacilityBookingType {
  Any = 'any',
  NonPeak = 'nonPeak',
  Peak = 'peak'
}

export type BonusPointEarningRuleLocker = {
  __typename?: 'BonusPointEarningRuleLocker';
  bonusPointEarningRatio: Scalars['Int']['output'];
  bonusPointEarningRuleId: Scalars['Int']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  extraBonusPointAmount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  type: BonusPointEarningRuleLockerType;
};

export enum BonusPointEarningRuleLockerType {
  Any = 'any',
  New = 'new',
  Renew = 'renew'
}

export type BonusPointEarningRuleMyEvent = {
  __typename?: 'BonusPointEarningRuleMyEvent';
  bonusPointEarningRatio: Scalars['Int']['output'];
  bonusPointEarningRuleId: Scalars['Int']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  extraBonusPointAmount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  myEvent?: Maybe<MyEvent>;
  myEventId?: Maybe<Scalars['Int']['output']>;
  sportType?: Maybe<SportType>;
  sportTypeGroup?: Maybe<SportTypeGroup>;
  sportTypeGroupId?: Maybe<Scalars['Int']['output']>;
  sportTypeId?: Maybe<Scalars['Int']['output']>;
};

export type BonusPointEarningRuleNthOrder = {
  __typename?: 'BonusPointEarningRuleNthOrder';
  bonusPointEarningRatio: Scalars['Int']['output'];
  bonusPointEarningRuleId: Scalars['Int']['output'];
  extraBonusPointAmount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  nthOrder: Scalars['Int']['output'];
};

export type BonusPointEarningRuleProduct = {
  __typename?: 'BonusPointEarningRuleProduct';
  bonusPointEarningRatio: Scalars['Int']['output'];
  bonusPointEarningRuleId: Scalars['Int']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  extraBonusPointAmount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productCat?: Maybe<ProductCat>;
  productCatId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
};

export type BonusPointItemTypeEarningRatio = {
  __typename?: 'BonusPointItemTypeEarningRatio';
  createdDate: Scalars['String']['output'];
  earningRatio?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  myorderItemType: MyorderItemType;
  updatedDate: Scalars['String']['output'];
};

export type BonusPointReceiptReg = {
  __typename?: 'BonusPointReceiptReg';
  amount: Scalars['Int']['output'];
  bonusPointTx?: Maybe<BonusPointTx>;
  createdDate: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  receiptDate: Scalars['String']['output'];
  receiptNo: Scalars['String']['output'];
  status: BonusPointReceiptRegStatus;
  updatedDate: Scalars['String']['output'];
};

export enum BonusPointReceiptRegStatus {
  Active = 'active',
  Voided = 'voided'
}

export type BonusPointRedeemPromotionGroup = {
  __typename?: 'BonusPointRedeemPromotionGroup';
  accessPassOptionList?: Maybe<Array<AccessPassOption>>;
  activeAccessPassOptionList?: Maybe<Array<AccessPassOption>>;
  additionalMoneyRequired: Scalars['Int']['output'];
  bonusPointRedeemPromotionGroupAccessPassOptionList?: Maybe<Array<BonusPointRedeemPromotionGroupAccessPassOption>>;
  bonusPointRedeemPromotionGroupCourseList?: Maybe<Array<BonusPointRedeemPromotionGroupCourse>>;
  bonusPointRedeemPromotionGroupEventTicketTypeList?: Maybe<Array<BonusPointRedeemPromotionGroupEventTicketType>>;
  bonusPointRedeemPromotionGroupFacilityList?: Maybe<Array<BonusPointRedeemPromotionGroupFacility>>;
  bonusPointRedeemPromotionGroupProductList?: Maybe<Array<BonusPointRedeemPromotionGroupProduct>>;
  bonusPointRequired: Scalars['Int']['output'];
  courseList?: Maybe<Array<Course>>;
  createdDate: Scalars['String']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  facilityList?: Maybe<Array<Facility>>;
  globalQuota: Scalars['Int']['output'];
  globalUsageCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<FullUser>;
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  memberQuota: Scalars['Int']['output'];
  myEventTicketTypeList?: Maybe<Array<MyEventTicketType>>;
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  photoList?: Maybe<Array<Myfile>>;
  posCourseList?: Maybe<Array<Course>>;
  posFacilityList?: Maybe<Array<Facility>>;
  posMyEventTicketTypeList?: Maybe<Array<MyEventTicketType>>;
  posProductList?: Maybe<Array<Product>>;
  productList?: Maybe<Array<Product>>;
  startDate: Scalars['String']['output'];
  thumbnailPhoto?: Maybe<Array<Myfile>>;
  updatedDate: Scalars['String']['output'];
  webCourseList?: Maybe<Array<Course>>;
  webFacilityList?: Maybe<Array<Facility>>;
  webMyEventTicketTypeList?: Maybe<Array<MyEventTicketType>>;
  webProductList?: Maybe<Array<Product>>;
};

export type BonusPointRedeemPromotionGroupAccessPassOption = {
  __typename?: 'BonusPointRedeemPromotionGroupAccessPassOption';
  accessPassOption?: Maybe<AccessPassOption>;
  accessPassOptionId: Scalars['Int']['output'];
  bonusPointRedeemPromotionGroup?: Maybe<BonusPointRedeemPromotionGroup>;
  bonusPointRedeemPromotionGroupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type BonusPointRedeemPromotionGroupCourse = {
  __typename?: 'BonusPointRedeemPromotionGroupCourse';
  bonusPointRedeemPromotionGroup?: Maybe<BonusPointRedeemPromotionGroup>;
  bonusPointRedeemPromotionGroupId: Scalars['Int']['output'];
  course?: Maybe<Course>;
  courseId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type BonusPointRedeemPromotionGroupEventTicketType = {
  __typename?: 'BonusPointRedeemPromotionGroupEventTicketType';
  bonusPointRedeemPromotionGroup?: Maybe<BonusPointRedeemPromotionGroup>;
  bonusPointRedeemPromotionGroupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  myEventTicketType?: Maybe<MyEventTicketType>;
  myEventTicketTypeId: Scalars['Int']['output'];
};

export type BonusPointRedeemPromotionGroupFacility = {
  __typename?: 'BonusPointRedeemPromotionGroupFacility';
  bonusPointRedeemPromotionGroup?: Maybe<BonusPointRedeemPromotionGroup>;
  bonusPointRedeemPromotionGroupId: Scalars['Int']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  nonPeakHourOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type BonusPointRedeemPromotionGroupFacilityInput = {
  facilityId: Scalars['Int']['input'];
  nonPeakHourOnly: Scalars['Boolean']['input'];
};

export type BonusPointRedeemPromotionGroupProduct = {
  __typename?: 'BonusPointRedeemPromotionGroupProduct';
  bonusPointRedeemPromotionGroup?: Maybe<BonusPointRedeemPromotionGroup>;
  bonusPointRedeemPromotionGroupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productId: Scalars['Int']['output'];
};

export type BonusPointTotalPerType = {
  __typename?: 'BonusPointTotalPerType';
  bonusPointType: BonusPointType;
  total: Scalars['Int']['output'];
};

export type BonusPointTx = {
  __typename?: 'BonusPointTx';
  amount: Scalars['Int']['output'];
  bonusPointReceiptReg?: Maybe<BonusPointReceiptReg>;
  bonusPointReceiptRegId?: Maybe<Scalars['Int']['output']>;
  bonusPointTxUsageList?: Maybe<Array<BonusPointTxUsage>>;
  bonusPointType: BonusPointType;
  createdDate: Scalars['String']['output'];
  expiryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  myorder?: Maybe<Myorder>;
  myorderId?: Maybe<Scalars['Int']['output']>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  remark: Scalars['String']['output'];
  txBalance: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type BonusPointTxUsage = {
  __typename?: 'BonusPointTxUsage';
  amount: Scalars['Int']['output'];
  childBonusPointTx?: Maybe<BonusPointTx>;
  childBonusPointTxId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  parentBonusPointTx?: Maybe<BonusPointTx>;
  parentBonusPointTxId: Scalars['Int']['output'];
};

export enum BonusPointType {
  Birthday = 'birthday',
  Custom = 'custom',
  Expiry = 'expiry',
  HoldByRedeem = 'holdByRedeem',
  MemberGetMemberNewMember = 'memberGetMemberNewMember',
  MemberGetMemberReferral = 'memberGetMemberReferral',
  Order = 'order',
  ReceiptReg = 'receiptReg',
  Redeem = 'redeem',
  Refund = 'refund',
  VoidOrder = 'voidOrder',
  VoidReceiptReg = 'voidReceiptReg'
}

export enum BookByType {
  Dept = 'dept',
  Member = 'member',
  Org = 'org',
  RegBody = 'regBody',
  User = 'user'
}

export enum BookmarkType {
  Course = 'course',
  Facility = 'facility',
  Product = 'product'
}

export type BullQueueProgress = {
  __typename?: 'BullQueueProgress';
  progress: Scalars['Int']['output'];
  result: Scalars['String']['output'];
};

export enum BullQueueStatus {
  Active = 'active',
  Completed = 'completed',
  Delayed = 'delayed',
  Failed = 'failed',
  Paused = 'paused',
  Prioritized = 'prioritized',
  Waiting = 'waiting'
}

export type CalculateCoachSalaryInput = {
  deptId: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export enum CanConfirmDeliveryNoteRes {
  GroupTypeIsNotDeliveryNote = 'groupTypeIsNotDeliveryNote',
  IsClosed = 'isClosed',
  IsConfirmShipped = 'isConfirmShipped',
  NoDeliveryNote = 'noDeliveryNote',
  NoError = 'noError',
  NoOutDept = 'noOutDept',
  NoPermission = 'noPermission',
  StatusIsNotAwaitingShipOut = 'statusIsNotAwaitingShipOut'
}

export enum CanConfirmGoodsReceiveNoteRes {
  DnIsNotConfirmShipped = 'dnIsNotConfirmShipped',
  GroupTypeIsNotGoodsReceiveNote = 'groupTypeIsNotGoodsReceiveNote',
  IsClosed = 'isClosed',
  IsConfirmReceived = 'isConfirmReceived',
  NoError = 'noError',
  NoGoodsReceiveNote = 'noGoodsReceiveNote',
  NoInDept = 'noInDept',
  NoPermission = 'noPermission',
  StatusIsNotAwaitingDelivery = 'statusIsNotAwaitingDelivery'
}

export enum CanUpdateAgreeToReceiveStockTransferRes {
  IsAgreeToReceiveStatusNotAwaiting = 'isAgreeToReceiveStatusNotAwaiting',
  IsClosed = 'isClosed',
  NoError = 'noError',
  NoInDept = 'noInDept',
  NoInventoryRequest = 'noInventoryRequest',
  NoPermission = 'noPermission'
}

export type CancelAllFutureInternalBookingForUserInput = {
  userId: Scalars['Int']['input'];
};

export type CancelAllInQueueAndSoftFailMsgQueueInput = {
  msgPlatform?: InputMaybe<MsgPlatform>;
};

export type CancelCourseEnrolmentInput = {
  cancelReason: Scalars['String']['input'];
  courseId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelInQueueAndSoftFailMsgQueueInput = {
  msgQueuIdList: Array<Scalars['Int']['input']>;
};

export type CancelLessonEnrolmentInput = {
  cancelReason: Scalars['String']['input'];
  courseId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelTimeSlotProgramReservationInput = {
  memberId: Scalars['Int']['input'];
  reservationId: Scalars['Int']['input'];
};

export enum CartType {
  AccessPass = 'accessPass',
  Deposit = 'deposit',
  Enrolment = 'enrolment',
  Facility = 'facility',
  MemDriveDeposit = 'memDriveDeposit',
  Membership = 'membership',
  Mix = 'mix',
  Product = 'product',
  RedeemBonusPoint = 'redeemBonusPoint',
  Refund = 'refund',
  Swp = 'swp'
}

export type CeoApproveRefundPayoutInput = {
  ceoRemark?: InputMaybe<Scalars['String']['input']>;
  refundPayoutRequestId: Scalars['Int']['input'];
};

export type CheckInByMyorderQrCodeInput = {
  qrcode: Scalars['String']['input'];
};

export type CheckInByQuickQrCodeInput = {
  bypassFacilityCheck: Scalars['Boolean']['input'];
  bypassTimeCheck: Scalars['Boolean']['input'];
  qrcode: Scalars['String']['input'];
};

export type CheckInByUserCodeInput = {
  facilityBookingId: Scalars['Int']['input'];
  userCode: Scalars['String']['input'];
};

export type CheckInDevice = {
  __typename?: 'CheckInDevice';
  appUuid: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  facilityList?: Maybe<Array<Facility>>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  lastModifyUserId: Scalars['Int']['output'];
  lastRegDateTime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type CheckInItemResGql = {
  __typename?: 'CheckInItemResGql';
  canCheckIn: Scalars['Boolean']['output'];
  canCheckInHere: Scalars['Boolean']['output'];
  canCheckInNow: Scalars['Boolean']['output'];
  checkInDateTime?: Maybe<Scalars['String']['output']>;
  checkInEndDateTime?: Maybe<Scalars['String']['output']>;
  checkInItemType: CheckInType;
  checkInStartDateTime?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['String']['output']>;
  facilityBooking?: Maybe<FacilityBooking>;
  lessonCoach?: Maybe<LessonCoach>;
  lessonEnrolment?: Maybe<LessonEnrolment>;
  myEventEnrolment?: Maybe<MyEventEnrolment>;
  startDateTime?: Maybe<Scalars['String']['output']>;
  timeSlotProgramReservation?: Maybe<TimeSlotProgramReservation>;
};

export enum CheckInMode {
  Coach = 'coach',
  Manual = 'manual',
  Pos = 'pos',
  Qrcode = 'qrcode',
  UserCode = 'userCode'
}

export type CheckInTimeSlotProgramReservationInput = {
  bypassTimeCheck: Scalars['Boolean']['input'];
  reservationId: Scalars['Int']['input'];
};

export enum CheckInType {
  EventEnrolment = 'eventEnrolment',
  FacilityBooking = 'facilityBooking',
  LessonCoach = 'lessonCoach',
  LessonEnrolment = 'lessonEnrolment',
  MyorderItem = 'myorderItem',
  TimeSlotProgram = 'timeSlotProgram'
}

export type CheckMemberIdentityInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type CheckMemberIdentityResGql = {
  __typename?: 'CheckMemberIdentityResGql';
  dupHkidMemberId?: Maybe<Scalars['Float']['output']>;
  dupPassportMemberId?: Maybe<Scalars['Float']['output']>;
  validHkid: Scalars['Boolean']['output'];
  validPassport: Scalars['Boolean']['output'];
  whole: Scalars['Boolean']['output'];
};

export type CheckMgmReferralCodeInput = {
  referralCode: Scalars['String']['input'];
};

export type CheckMgmReferralCodeResGql = {
  __typename?: 'CheckMgmReferralCodeResGql';
  maskName?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CheckPaymentGatewayLogInput = {
  paymentGateway: Scalars['String']['input'];
  refStringList: Scalars['String']['input'];
};

export type CheckPaymentGatewayLogResGql = {
  __typename?: 'CheckPaymentGatewayLogResGql';
  confirmedOrderList: Array<OneCheckPaymentGatewayLogRes>;
  missingOrderList: Array<OneCheckPaymentGatewayLogRes>;
};

export type CleanMemberSessionInput = {
  memberId: Scalars['Int']['input'];
  sessionIdList?: Array<Scalars['Int']['input']>;
};

export type CleanUserSessionInput = {
  sessionIdList?: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type ClearLessonInput = {
  courseId: Scalars['Int']['input'];
};

export type ClientQueryCondFacilityBookingInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ClientQueryOrderByFacilityBookingInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type ClientSearchFacilityBookingInput = {
  andCondList?: Array<ClientQueryCondFacilityBookingInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<ClientQueryCondFacilityBookingInput>;
  orderBy?: InputMaybe<ClientQueryOrderByFacilityBookingInput>;
  orderByList?: InputMaybe<Array<ClientQueryOrderByFacilityBookingInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type CloseInventoryRequestInput = {
  inventoryRequestId: Scalars['Int']['input'];
  markAs: CloseTxGroupType;
};

export enum CloseTxGroupType {
  Cancelled = 'cancelled',
  Completed = 'completed'
}

export type CoachAddBookingAndCoachToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  coachServiceId: Scalars['Int']['input'];
  endDateTime: Scalars['String']['input'];
  eventCode?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
  memberIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  myEventId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type CoachAddCoachTimeslotInput = {
  daysOfWeeks: Array<Scalars['Int']['input']>;
  endDate: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  isFree: Scalars['Boolean']['input'];
  remark: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type CoachCreateUserCoachServiceRelInput = {
  coachFee: Scalars['Float']['input'];
  coachSalaryContractTermsId?: InputMaybe<Scalars['Int']['input']>;
  coachServiceId: Scalars['Int']['input'];
  isWebEnabled: Scalars['Boolean']['input'];
};

export type CoachDeleteCoachTimeSlotInput = {
  id: Scalars['Int']['input'];
};

export type CoachGetAvailableTimeslotByCoachAndFacilityInput = {
  coachServiceId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
  inputDate: Scalars['String']['input'];
};

export type CoachGetCoachRelatedItemListInput = {
  endDateTime: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
};

export type CoachGetCoachTimeslotSummaryInput = {
  endDateTime: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  timeslotNoOfMins: Scalars['Int']['input'];
};

export type CoachGetLessonCoachQrCodeInput = {
  lessonCoachId: Scalars['Int']['input'];
};

export type CoachGetMemberInput = {
  id: Scalars['Int']['input'];
};

export type CoachGetUserCourseListInput = {
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type CoachGetUserLessonListInput = {
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type CoachLessonCancelAttendanceInput = {
  lessonEnrolmentIdList: Array<Scalars['Int']['input']>;
  lessonId: Scalars['Int']['input'];
};

export type CoachLessonTakeAttendanceInput = {
  lessonEnrolmentIdList: Array<Scalars['Int']['input']>;
  lessonId: Scalars['Int']['input'];
};

export type CoachPrivateLessonCancelAttendanceInput = {
  facilityBookingId: Scalars['Int']['input'];
};

export type CoachPrivateLessonTakeAttendanceInput = {
  facilityBookingId: Scalars['Int']['input'];
};

export type CoachQueryCondCoachTimeslotInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CoachQueryOrderByCoachTimeslotInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type CoachRelatedItemResGql = {
  __typename?: 'CoachRelatedItemResGql';
  checkInItemInfo?: Maybe<CheckInItemResGql>;
  endDateTime: Scalars['String']['output'];
  lesson?: Maybe<Lesson>;
  noOfEnrolment: Scalars['Float']['output'];
  privateCoachMyorderItem?: Maybe<MyorderItem>;
  startDateTime: Scalars['String']['output'];
};

export type CoachRemoveItemFromCartInput = {
  cartType: CartType;
  memberId?: InputMaybe<Scalars['Float']['input']>;
  myorderItemId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Float']['input']>;
};

export type CoachSalaryContractTerms = {
  __typename?: 'CoachSalaryContractTerms';
  dept?: Maybe<Department>;
  deptId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  maxNoOfMember?: Maybe<Scalars['Int']['output']>;
  minNoOfMember?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  salaryType: SalaryType;
  salaryValue: Scalars['Float']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type CoachSalaryReport = {
  __typename?: 'CoachSalaryReport';
  accountConfirmDateTime?: Maybe<Scalars['String']['output']>;
  accountConfirmUser?: Maybe<User>;
  accountConfirmUserId?: Maybe<Scalars['Int']['output']>;
  coachList?: Maybe<Array<FullUser>>;
  coachSalaryReportCoachAdjustmentList?: Maybe<Array<CoachSalaryReportCoachAdjustment>>;
  coachSalaryReportCoachSubtotalList?: Maybe<Array<CoachSalaryReportCoachSubtotal>>;
  coachSalaryReportItemGroupList?: Maybe<Array<CoachSalaryReportItemGroup>>;
  createdDate: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptCode: Scalars['String']['output'];
  deptConfirmDateTime?: Maybe<Scalars['String']['output']>;
  deptConfirmUser?: Maybe<User>;
  deptConfirmUserId?: Maybe<Scalars['Int']['output']>;
  deptId: Scalars['Int']['output'];
  generatedByUser?: Maybe<User>;
  generatedByUserId?: Maybe<Scalars['Int']['output']>;
  generatedDateTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  totalAdjustment: Scalars['Float']['output'];
  totalCoachFee: Scalars['Float']['output'];
  totalCourseFee: Scalars['Float']['output'];
  totalPrivateLessonFee: Scalars['Float']['output'];
  totalTeamFee: Scalars['Float']['output'];
  updatedDate: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type CoachSalaryReportCoachAdjustment = {
  __typename?: 'CoachSalaryReportCoachAdjustment';
  adjustment: Scalars['Float']['output'];
  coach?: Maybe<User>;
  coachId: Scalars['Int']['output'];
  deptId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type CoachSalaryReportCoachSubtotal = {
  __typename?: 'CoachSalaryReportCoachSubtotal';
  coach?: Maybe<User>;
  coachCode: Scalars['String']['output'];
  coachId: Scalars['Int']['output'];
  coachName: Scalars['String']['output'];
  coachSalaryReportId: Scalars['Int']['output'];
  coachTotalAdjustment: Scalars['Float']['output'];
  coachTotalCourseFee: Scalars['Float']['output'];
  coachTotalFee: Scalars['Float']['output'];
  coachTotalPrivateLessonFee: Scalars['Float']['output'];
  coachTotalTeamFee: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
};

export enum CoachSalaryReportConfirmBy {
  Acct = 'acct',
  Dept = 'dept'
}

export type CoachSalaryReportItemGroup = {
  __typename?: 'CoachSalaryReportItemGroup';
  coachSalaryReportId: Scalars['Int']['output'];
  coachService?: Maybe<CoachService>;
  coachServiceId?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']['output']>;
  groupCoachCourseList?: Maybe<Array<CoachSalaryReportItemGroupCoachCourse>>;
  groupCoachList?: Maybe<Array<CoachSalaryReportItemGroupCoach>>;
  groupCoachSubtotalList?: Maybe<Array<CoachSalaryReportItemGroupCoachSubtotal>>;
  groupOrderList?: Maybe<Array<CoachSalaryReportItemGroupOrder>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CoachSalaryReportItemGroupCoach = {
  __typename?: 'CoachSalaryReportItemGroupCoach';
  coachId: Scalars['Int']['output'];
  coachSalaryReportId: Scalars['Int']['output'];
  coachSalaryReportItemGroupId: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  courseSalary?: Maybe<Scalars['Float']['output']>;
  groupCoachOrderList?: Maybe<Array<CoachSalaryReportItemGroupCoachOrder>>;
  groupCourseCoachList?: Maybe<Array<CoachSalaryReportItemGroupCoachCourse>>;
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  lessonRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type CoachSalaryReportItemGroupCoachCourse = {
  __typename?: 'CoachSalaryReportItemGroupCoachCourse';
  coachId: Scalars['Int']['output'];
  coachSalaryReportId: Scalars['Int']['output'];
  coachSalaryReportItemGroupId: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  courseSalary?: Maybe<Scalars['Float']['output']>;
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  hoursAfterThisMonthByCoach: Scalars['Float']['output'];
  hoursBeforeThisMonthByCoach: Scalars['Float']['output'];
  hoursThisMonthByCoach: Scalars['Float']['output'];
  hoursTotalByCoach: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  lessonRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  noOfLessonAfterThisMonthByCoach: Scalars['Int']['output'];
  noOfLessonBeforeThisMonthByCoach: Scalars['Int']['output'];
  noOfLessonThisMonthByCoach: Scalars['Int']['output'];
  noOfLessonTotalByCoach: Scalars['Int']['output'];
  salaryAfterThisMonthByCoach: Scalars['Float']['output'];
  salaryBeforeThisMonthByCoach: Scalars['Float']['output'];
  salaryThisMonthByCoach: Scalars['Float']['output'];
  salaryTotalByCoach: Scalars['Float']['output'];
};

export type CoachSalaryReportItemGroupCoachOrder = {
  __typename?: 'CoachSalaryReportItemGroupCoachOrder';
  balance: Scalars['Float']['output'];
  coachSalaryReportId: Scalars['Int']['output'];
  coachSalaryReportItemGroupCoachId: Scalars['Int']['output'];
  hour: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  materialFee: Scalars['Float']['output'];
  memberId?: Maybe<Scalars['Int']['output']>;
  memberName: Scalars['String']['output'];
  myorderDate?: Maybe<Scalars['String']['output']>;
  myorderId?: Maybe<Scalars['Int']['output']>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  netIncome: Scalars['Float']['output'];
  noOfLessons: Scalars['Int']['output'];
  noOfLessonsCompletedOrRefunded: Scalars['Int']['output'];
  noOfLessonsCompletedOrRefundedBefore: Scalars['Int']['output'];
  orderStatus: Scalars['String']['output'];
  orderTotalCoachFee: Scalars['Float']['output'];
  paid: Scalars['Float']['output'];
  paidPrice: Scalars['Float']['output'];
  payable: Scalars['Float']['output'];
};

export type CoachSalaryReportItemGroupCoachSubtotal = {
  __typename?: 'CoachSalaryReportItemGroupCoachSubtotal';
  coach?: Maybe<User>;
  coachId?: Maybe<Scalars['Int']['output']>;
  coachSalaryReportId: Scalars['Int']['output'];
  coachSalaryReportItemGroupId: Scalars['Int']['output'];
  coachSubtotalBalance: Scalars['Float']['output'];
  coachSubtotalOrderTotalCoachFee: Scalars['Float']['output'];
  coachSubtotalPaid: Scalars['Float']['output'];
  coachSubtotalPayable: Scalars['Float']['output'];
  groupCoachOrderList: Array<FullUser>;
  id: Scalars['Int']['output'];
  subtotalMaterialFee: Scalars['Float']['output'];
  subtotalNetIncome: Scalars['Float']['output'];
  subtotalPaidPrice: Scalars['Float']['output'];
};

export type CoachSalaryReportItemGroupOrder = {
  __typename?: 'CoachSalaryReportItemGroupOrder';
  coachSalaryReportId: Scalars['Int']['output'];
  coachSalaryReportItemGroupId: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  groupOrderCoachList?: Maybe<Array<CoachSalaryReportItemGroupOrderCoach>>;
  hour: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  materialFee: Scalars['Float']['output'];
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  memberName: Scalars['String']['output'];
  myorder?: Maybe<Myorder>;
  myorderDate?: Maybe<Scalars['String']['output']>;
  myorderId?: Maybe<Scalars['Int']['output']>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  netIncome: Scalars['Float']['output'];
  noOfLessons: Scalars['Int']['output'];
  noOfLessonsCompletedOrRefunded: Scalars['Int']['output'];
  noOfLessonsCompletedOrRefundedBefore: Scalars['Int']['output'];
  orderStatus: Scalars['String']['output'];
  paidPrice: Scalars['Float']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
};

export type CoachSalaryReportItemGroupOrderCoach = {
  __typename?: 'CoachSalaryReportItemGroupOrderCoach';
  balance: Scalars['Float']['output'];
  coachId: Scalars['Int']['output'];
  coachSalaryReportId: Scalars['Int']['output'];
  coachSalaryReportItemGroupOrderId: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  courseSalary?: Maybe<Scalars['Float']['output']>;
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  lessonRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  noOfLessonsByCoach: Scalars['Int']['output'];
  noOfLessonsCompletedOrRefundedByCoach: Scalars['Int']['output'];
  noOfLessonsCompletedOrRefundedByCoachBefore: Scalars['Int']['output'];
  orderTotalCoachFee: Scalars['Float']['output'];
  paid: Scalars['Float']['output'];
  payable: Scalars['Float']['output'];
  ratio?: Maybe<Scalars['Float']['output']>;
  type: CoachSalaryReportItemGroupOrderCoachType;
};

export enum CoachSalaryReportItemGroupOrderCoachType {
  Course = 'course',
  PrivateCoach = 'privateCoach',
  Team = 'team'
}

export type CoachSearchCoachTimeslotInput = {
  andCondList?: Array<CoachQueryCondCoachTimeslotInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<CoachQueryCondCoachTimeslotInput>;
  orderBy?: InputMaybe<CoachQueryOrderByCoachTimeslotInput>;
  orderByList?: InputMaybe<Array<CoachQueryOrderByCoachTimeslotInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type CoachService = {
  __typename?: 'CoachService';
  apcCatCodeForFee: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  coachFee?: Maybe<Scalars['Float']['output']>;
  coachList?: Maybe<Array<FullUser>>;
  coachServiceIsWebEnabledForCoach?: Maybe<Scalars['Boolean']['output']>;
  createdDate: Scalars['String']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  facilityList?: Maybe<Array<Facility>>;
  id: Scalars['Int']['output'];
  isWebEnabled: Scalars['Boolean']['output'];
  lastModifyUserId: Scalars['Int']['output'];
  minNoOfLessonsRequired: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  noOfMembersPerLesson: Scalars['Int']['output'];
  noOfMinsPerLesson: Scalars['Int']['output'];
  revenueDept?: Maybe<Department>;
  revenueDeptId: Scalars['Int']['output'];
  sportType?: Maybe<SportType>;
  sportTypeId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  userCoachServiceRelList?: Maybe<Array<UserCoachServiceRel>>;
};

export type CoachTimeslot = {
  __typename?: 'CoachTimeslot';
  addedByUser?: Maybe<User>;
  addedByUserId: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  endDateTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isFree: Scalars['Boolean']['output'];
  remark: Scalars['String']['output'];
  startDateTime: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type CoachTimeslotOneDaySummaryResGql = {
  __typename?: 'CoachTimeslotOneDaySummaryResGql';
  date: Scalars['String']['output'];
  timeslotList: Array<CoachTimeslotResGql>;
};

export type CoachTimeslotResGql = {
  __typename?: 'CoachTimeslotResGql';
  coachTimeslotList: Array<CoachTimeslot>;
  endTime: Scalars['String']['output'];
  isFree: Scalars['Boolean']['output'];
  lessonList: Array<Lesson>;
  privateCoachMyorderItemList: Array<MyorderItem>;
  startTime: Scalars['String']['output'];
};

export type CoachUpdateCoachTimeslotInput = {
  endDateTime: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isFree: Scalars['Boolean']['input'];
  remark: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
};

export type Committee = {
  __typename?: 'Committee';
  aspenId: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  positionList?: Maybe<Array<CommitteePosition>>;
  updatedDate: Scalars['String']['output'];
};

export type CommitteeHistory = {
  __typename?: 'CommitteeHistory';
  createdDate: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  position?: Maybe<CommitteePosition>;
  positionId: Scalars['Int']['output'];
  remark: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type CommitteePosition = {
  __typename?: 'CommitteePosition';
  aspenId: Scalars['String']['output'];
  committee?: Maybe<Committee>;
  committeeHistoryList?: Maybe<Array<CommitteeHistory>>;
  committeeId: Scalars['Float']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type ConfirmCoachSalaryReportInput = {
  confirmByType: CoachSalaryReportConfirmBy;
  id: Scalars['Int']['input'];
};

export type ConfirmCourseEnrolmentInput = {
  courseId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  ignoreMemberScheduleConflict: Scalars['Boolean']['input'];
};

export type ConfirmCourseEnrolmentResGql = {
  __typename?: 'ConfirmCourseEnrolmentResGql';
  conflictTimeslotList: Array<TimeslotUnitResGql>;
  courseEnrolment?: Maybe<CourseEnrolment>;
  success: Scalars['Boolean']['output'];
};

export type ConfirmCourseLotteryResultAndRejectOthersInput = {
  courseEnrolmentIdList: Array<Scalars['Int']['input']>;
  courseId: Scalars['Int']['input'];
};

export type ConfirmDeliveryNoteInput = {
  allowDnOverDelivery?: Scalars['Boolean']['input'];
  allowReqOverDelivery?: Scalars['Boolean']['input'];
  dnTxGroupId: Scalars['Int']['input'];
  nextExpectedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  txList: Array<ConfirmDeliveryNoteInventoryTxInput>;
  userRemark: Scalars['String']['input'];
};

export type ConfirmDeliveryNoteInventoryTxInput = {
  confirmForDnTxId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
};

export type ConfirmGoodsReceiveNoteInput = {
  confirmReceivedDate: Scalars['String']['input'];
  grnTxGroupId: Scalars['Int']['input'];
  nextExpectedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  txList: Array<ConfirmGoodsReceiveNoteInventoryTxInput>;
  userRemark: Scalars['String']['input'];
};

export type ConfirmGoodsReceiveNoteInventoryTxInput = {
  confirmForGrnTxId: Scalars['Int']['input'];
  normalQty: Scalars['Int']['input'];
  scrapedQty: Scalars['Int']['input'];
};

export type ConfirmPaymentInput = {
  id: Scalars['Int']['input'];
  payAmount: Scalars['Float']['input'];
  paymentMethod: Scalars['String']['input'];
  reference1?: InputMaybe<Scalars['String']['input']>;
  reference2?: InputMaybe<Scalars['String']['input']>;
  reference3?: InputMaybe<Scalars['String']['input']>;
  reference4?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmToAddTotpInput = {
  friendlyName: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ConfirmWarehouseStockTakeInput = {
  id: Scalars['Int']['input'];
};

export type Contact = {
  __typename?: 'Contact';
  chineseName: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  gender: FilterGender;
  givenName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  languagePreference: LanguagePreference;
  lastModifyUser?: Maybe<User>;
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  mobileTel: Scalars['String']['output'];
  mobileTelAreaCode: Scalars['String']['output'];
  officeTel: Scalars['String']['output'];
  officeTelAreaCode: Scalars['String']['output'];
  orgId?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  photoMyfileId?: Maybe<Scalars['Int']['output']>;
  remark: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type ConvertPgToNonPgRefundPayoutInput = {
  refundPayoutRequestId: Scalars['Int']['input'];
};

export type ConvertToOrderAndConfirmPaymentInput = {
  cartType: CartType;
  isPhoneBooking: Scalars['Boolean']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  payAmount: Scalars['Float']['input'];
  paymentMethod: Scalars['String']['input'];
  reference1?: InputMaybe<Scalars['String']['input']>;
  reference2?: InputMaybe<Scalars['String']['input']>;
  reference3?: InputMaybe<Scalars['String']['input']>;
  reference4?: InputMaybe<Scalars['String']['input']>;
  updatedDate: Scalars['String']['input'];
};

export type ConvertToOrderAndOutstandingPaymentInput = {
  cartType: CartType;
  isPhoneBooking: Scalars['Boolean']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  payAmount: Scalars['Float']['input'];
  paymentMethod: Scalars['String']['input'];
  reference1?: InputMaybe<Scalars['String']['input']>;
  reference2?: InputMaybe<Scalars['String']['input']>;
  reference3?: InputMaybe<Scalars['String']['input']>;
  reference4?: InputMaybe<Scalars['String']['input']>;
  updatedDate: Scalars['String']['input'];
};

export type ConvertToOrderInput = {
  cartType: CartType;
  gateway?: InputMaybe<Scalars['String']['input']>;
  gpTokenId?: InputMaybe<Scalars['Int']['input']>;
  lang?: Scalars['String']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  saveCreditCard?: Scalars['Boolean']['input'];
  updatedDate: Scalars['String']['input'];
};

export type ConvertToScrapedInventoryRequestTxInput = {
  productId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
  warehousePartitionId: Scalars['Int']['input'];
};

export type Country = {
  __typename?: 'Country';
  aspenCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameEnOnly: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
};

export type CouponPackage = {
  __typename?: 'CouponPackage';
  accessPassDependencyList?: Maybe<Array<AccessPass>>;
  acctCatCode: Scalars['String']['output'];
  apcCatCodeForFee: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  couponPackageCoachServiceRelList?: Maybe<Array<CouponPackageCoachServiceRel>>;
  couponPackageFacilityRelList?: Maybe<Array<CouponPackageFacilityRel>>;
  couponType: CouponType;
  createdDate: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptId: Scalars['Int']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  discountAmt: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isWebEnable: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  listPrice: Scalars['Float']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  noOfCoupons: Scalars['Int']['output'];
  photoList?: Maybe<Array<Myfile>>;
  sku: Scalars['String']['output'];
  tncEn: Scalars['String']['output'];
  tncSc: Scalars['String']['output'];
  tncTc: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  validNoOfDays: Scalars['Int']['output'];
};

export type CouponPackageCoachServiceRel = {
  __typename?: 'CouponPackageCoachServiceRel';
  coach?: Maybe<User>;
  coachId: Scalars['Int']['output'];
  coachService?: Maybe<CoachService>;
  coachServiceId: Scalars['Int']['output'];
  couponPackage?: Maybe<CouponPackage>;
  couponPackageId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type CouponPackageFacilityRel = {
  __typename?: 'CouponPackageFacilityRel';
  couponPackage?: Maybe<CouponPackage>;
  couponPackageId: Scalars['Int']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  noOfCouponsPerTimeslotForNormalHour: Scalars['Int']['output'];
  noOfCouponsPerTimeslotForPeakHour: Scalars['Int']['output'];
};

export type CouponPackageInstance = {
  __typename?: 'CouponPackageInstance';
  couponBought: Scalars['Int']['output'];
  couponExpired: Scalars['Int']['output'];
  couponHeld: Scalars['Int']['output'];
  couponLeft: Scalars['Int']['output'];
  couponPackage?: Maybe<CouponPackage>;
  couponPackageFacilityRel?: Maybe<CouponPackageFacilityRel>;
  couponPackageId: Scalars['Int']['output'];
  couponRefunded: Scalars['Int']['output'];
  couponUsageRefunded: Scalars['Int']['output'];
  couponUsed: Scalars['Int']['output'];
  couponVoided: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId: Scalars['Int']['output'];
  orgId?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  status: CouponPackageInstanceStatus;
  updatedDate: Scalars['String']['output'];
};

export enum CouponPackageInstanceStatus {
  Active = 'active',
  Expired = 'expired',
  FullyRefunded = 'fullyRefunded',
  PartiallyRefunded = 'partiallyRefunded',
  UsedUp = 'usedUp',
  Voided = 'voided'
}

export type CouponPackageInstanceUsageHistory = {
  __typename?: 'CouponPackageInstanceUsageHistory';
  coachMyorderItem?: Maybe<MyorderItem>;
  coachMyorderItemId?: Maybe<Scalars['Int']['output']>;
  couponAmount: Scalars['Int']['output'];
  couponPackage?: Maybe<CouponPackage>;
  couponPackageInstance?: Maybe<CouponPackageInstance>;
  couponPackageInstanceId: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  endDateTime?: Maybe<Scalars['String']['output']>;
  facilityBookingId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
  updatedDate: Scalars['String']['output'];
  usageType: CouponPackageInstanceUsageHistoryUsageType;
};

export enum CouponPackageInstanceUsageHistoryUsageType {
  Expired = 'expired',
  Held = 'held',
  Purchase = 'purchase',
  Refunded = 'refunded',
  UsageRefunded = 'usageRefunded',
  Use = 'use',
  Voided = 'voided'
}

export enum CouponType {
  FacilityBooking = 'facilityBooking',
  PrivateCoach = 'privateCoach'
}

export type Course = {
  __typename?: 'Course';
  accessPassDependencyList?: Maybe<Array<AccessPass>>;
  activeBonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  allowFeeAutoRecalEvenWithEnrolment: Scalars['Boolean']['output'];
  apcCatCodeForFee: Scalars['String']['output'];
  apcCatCodeForMaterial: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  apcMaterial?: Maybe<AcctProductCat>;
  aspenCategoryCode: Scalars['String']['output'];
  aspenPrepaidCategoryCode: Scalars['String']['output'];
  bonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  cancelCourseAlertDate?: Maybe<Scalars['String']['output']>;
  coachInternalRemark: Scalars['String']['output'];
  coachList?: Maybe<Array<CourseCoach>>;
  coachPhoto?: Maybe<Array<Myfile>>;
  coachRemarkEn: Scalars['String']['output'];
  coachRemarkSc: Scalars['String']['output'];
  coachRemarkTc: Scalars['String']['output'];
  code: Scalars['String']['output'];
  courseApplyQuotaPeriodLinkList?: Maybe<Array<CourseApplyQuotaPeriodLink>>;
  courseOrgInvitationCodeRelList?: Maybe<Array<CourseOrgInvitationCodeRel>>;
  courseType?: Maybe<CourseType>;
  courseTypeId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  defaultFeeForGroup: Scalars['Float']['output'];
  defaultFeeForMember: Scalars['Float']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  earlyBirdDiscountAmtForGroup: Scalars['Float']['output'];
  earlyBirdDiscountAmtForMember: Scalars['Float']['output'];
  earlyBirdDiscountPercentForGroup: Scalars['Int']['output'];
  earlyBirdDiscountPercentForMember: Scalars['Int']['output'];
  earlyBirdEndDateForGroup?: Maybe<Scalars['String']['output']>;
  earlyBirdEndDateForMember?: Maybe<Scalars['String']['output']>;
  effectiveEndDate?: Maybe<Scalars['String']['output']>;
  effectiveStartDate?: Maybe<Scalars['String']['output']>;
  enableAccessPassDependency: Scalars['Boolean']['output'];
  enableFeeAutoRecalAfterUpdate: Scalars['Boolean']['output'];
  enableForWeb: Scalars['Boolean']['output'];
  enableGroupEnrol: Scalars['Boolean']['output'];
  enableMemberEnrol: Scalars['Boolean']['output'];
  enableNoShowPenalty: Scalars['Boolean']['output'];
  enablePriorityByCode: Scalars['Boolean']['output'];
  enablePriorityEnrolmentForLastCourseMember: Scalars['Boolean']['output'];
  enableWhiteList: Scalars['Boolean']['output'];
  enrolmentEndDateForGroup: Scalars['String']['output'];
  enrolmentEndDateForMember: Scalars['String']['output'];
  enrolmentStartDateForGroup: Scalars['String']['output'];
  enrolmentStartDateForMember: Scalars['String']['output'];
  enrolmentStartDateForPriority?: Maybe<Scalars['String']['output']>;
  enrolmentType: CourseEnrolmentType;
  facilityCost: Scalars['Float']['output'];
  facilityRemarkEn: Scalars['String']['output'];
  facilityRemarkSc: Scalars['String']['output'];
  facilityRemarkTc: Scalars['String']['output'];
  featureOrderId: Scalars['Float']['output'];
  feeType: CourseFeeType;
  fixedMaterialCost: Scalars['Float']['output'];
  gender: FilterGender;
  gqlSummary?: Maybe<CourseSummaryResGql>;
  id: Scalars['Int']['output'];
  internalRemarks: Scalars['String']['output'];
  isEnable: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  lessonDaysCountAsEarlyBird?: Maybe<Scalars['Int']['output']>;
  lessonDaysForNormalEnrolmentForGroup: Scalars['Int']['output'];
  lessonDaysForNormalEnrolmentForMember: Scalars['Int']['output'];
  lessonDaysForPriorityEnrolment: Scalars['Int']['output'];
  lessonFeeForGroupForAutoRecal: Scalars['Float']['output'];
  lessonFeeForMemberForAutoRecal: Scalars['Float']['output'];
  lessonList?: Maybe<Array<Lesson>>;
  lessonPreviousEnrolledDaysCountAsPriority: Scalars['Int']['output'];
  lessonSelectionType: LessonSelectionType;
  limitEnrolPeriodInDefaultTimeslotOnly?: Maybe<Scalars['Boolean']['output']>;
  lotteryDrawDate?: Maybe<Scalars['String']['output']>;
  lotteryGroupName: Scalars['String']['output'];
  lotteryLog: Scalars['String']['output'];
  loyaltyPoint: Scalars['Int']['output'];
  materialCostPerLesson: Scalars['Float']['output'];
  maxAge: Scalars['Float']['output'];
  maxNoOfEnrolment: Scalars['Int']['output'];
  minAge: Scalars['Float']['output'];
  minNoOfEnrolledLessons?: Maybe<Scalars['Int']['output']>;
  minNoOfEnrolment: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  noOfLessons: Scalars['Int']['output'];
  overrideTimeDescEn: Scalars['String']['output'];
  overrideTimeDescSc: Scalars['String']['output'];
  overrideTimeDescTc: Scalars['String']['output'];
  payTrialFeeOnline: Scalars['Boolean']['output'];
  photoList?: Maybe<Array<Myfile>>;
  recurCourse?: Maybe<RecurCourse>;
  recurCourseId?: Maybe<Scalars['Int']['output']>;
  recurNo: Scalars['Int']['output'];
  remarkEn: Scalars['String']['output'];
  remarkSc: Scalars['String']['output'];
  remarkTc: Scalars['String']['output'];
  requireParQ: Scalars['Boolean']['output'];
  showEnrolmentResultToPublic: Scalars['Boolean']['output'];
  sortQuotaLeft: Scalars['Int']['output'];
  sportType?: Maybe<SportType>;
  sportTypeId?: Maybe<Scalars['Int']['output']>;
  uniformOption: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  webDiscountAmtForMember: Scalars['Float']['output'];
  webDiscountPercentForMember: Scalars['Int']['output'];
  webLessonList?: Maybe<Array<Lesson>>;
  yldsaStandardCourseRule: Scalars['Boolean']['output'];
  youtubeId: Scalars['String']['output'];
};

export type CourseApplyQuotaPeriod = {
  __typename?: 'CourseApplyQuotaPeriod';
  applyQuota: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  monthPerPeriod: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type CourseApplyQuotaPeriodLink = {
  __typename?: 'CourseApplyQuotaPeriodLink';
  course?: Maybe<Course>;
  courseApplyQuotaPeriod?: Maybe<CourseApplyQuotaPeriod>;
  courseApplyQuotaPeriodMonthIndex?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export enum CourseAvailabilityStatus {
  Available = 'available',
  Full = 'full',
  LastOne = 'lastOne',
  LastTwo = 'lastTwo',
  Limited = 'limited'
}

export type CourseCoach = {
  __typename?: 'CourseCoach';
  coach?: Maybe<FullUser>;
  coachForWeb?: Maybe<User>;
  coachId: Scalars['Int']['output'];
  coachSalaryContractTerms?: Maybe<CoachSalaryContractTerms>;
  coachSalaryContractTermsId?: Maybe<Scalars['Int']['output']>;
  courseId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type CourseEnrolment = {
  __typename?: 'CourseEnrolment';
  cancelDate?: Maybe<Scalars['String']['output']>;
  cancelReason: Scalars['String']['output'];
  course?: Maybe<Course>;
  courseEnrolmentStatusHistoryList?: Maybe<Array<CourseEnrolmentStatusHistory>>;
  courseId: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCourseFirstLessonReminderSent: Scalars['Boolean']['output'];
  isEarlyBird: Scalars['Boolean']['output'];
  isFullCourseEnrolment: Scalars['Boolean']['output'];
  lastEmailNotificationDateTime: Scalars['String']['output'];
  lastEmailNotificationStatus?: Maybe<EnrolmentStatus>;
  lastPushNotificationDateTime: Scalars['String']['output'];
  lastPushNotificationStatus?: Maybe<EnrolmentStatus>;
  lastSmsNotificationDateTime: Scalars['String']['output'];
  lastSmsNotificationStatus?: Maybe<EnrolmentStatus>;
  lastWhatsappNotificationDateTime: Scalars['String']['output'];
  lastWhatsappNotificationStatus?: Maybe<EnrolmentStatus>;
  lessonEnrolmentList?: Maybe<Array<LessonEnrolment>>;
  lotteryDrawPriority: LotteryDrawPriority;
  lotteryGroupScore: Scalars['Int']['output'];
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myorder?: Maybe<Myorder>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  qty: Scalars['Int']['output'];
  status: EnrolmentStatus;
  uniformOption: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  webLessonEnrolmentList?: Maybe<Array<LessonEnrolment>>;
};

export type CourseEnrolmentStats = {
  __typename?: 'CourseEnrolmentStats';
  allNoShowMemberCount: Scalars['Int']['output'];
  allNoShowMemberRate: Scalars['Float']['output'];
  allShowMemberCount: Scalars['Int']['output'];
  allShowMemberRate: Scalars['Float']['output'];
  appliedEnrolmentCount: Scalars['Int']['output'];
  appliedEnrolmentFemaleCount: Scalars['Int']['output'];
  appliedEnrolmentMaleCount: Scalars['Int']['output'];
  appliedEnrolmentRate: Scalars['Float']['output'];
  attendedMemberCount: Scalars['Int']['output'];
  attendedMemberFemaleCount: Scalars['Int']['output'];
  attendedMemberMaleCount: Scalars['Int']['output'];
  attendedMemberRate: Scalars['Float']['output'];
  cancelledEnrolmentCount: Scalars['Int']['output'];
  confirmedEnrolmentCount: Scalars['Int']['output'];
  course?: Maybe<Course>;
  courseId: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  enrolmentQuota: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  lessonCount: Scalars['Int']['output'];
  lessonEndDate: Scalars['String']['output'];
  lessonStartDate: Scalars['String']['output'];
  rejectedEnrolmentCount: Scalars['Int']['output'];
  reqEndDate?: Maybe<Scalars['String']['output']>;
  reqStartDate?: Maybe<Scalars['String']['output']>;
  someNoShowMemberCount: Scalars['Int']['output'];
  someNoShowMemberRate: Scalars['Float']['output'];
  totalAttendanceCount: Scalars['Int']['output'];
  totalAttendanceRate: Scalars['Float']['output'];
  totalMemberCount: Scalars['Int']['output'];
  totalNoShowCount: Scalars['Int']['output'];
  totalShowCount: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type CourseEnrolmentStatusHistory = {
  __typename?: 'CourseEnrolmentStatusHistory';
  courseEnrolmentId: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  statusAction: EnrolmentStatusActionType;
  updatedDate: Scalars['String']['output'];
};

export enum CourseEnrolmentType {
  Fcfs = 'fcfs',
  Lottery = 'lottery'
}

export enum CourseFeeType {
  LumpSum = 'lumpSum',
  PerLesson = 'perLesson'
}

export type CourseMemberList = {
  __typename?: 'CourseMemberList';
  course?: Maybe<Course>;
  courseId: Scalars['Int']['output'];
  courseMemberListType: CourseMemberListType;
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export enum CourseMemberListType {
  Blacklist = 'blacklist',
  Priority = 'priority',
  Whitelist = 'whitelist'
}

export type CourseOrgInvitationCodeRel = {
  __typename?: 'CourseOrgInvitationCodeRel';
  course?: Maybe<Course>;
  courseId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orgInvitationCode?: Maybe<OrgInvitationCode>;
  orgInvitationCodeId: Scalars['Int']['output'];
};

export enum CourseSearchGender {
  Any = 'any',
  F = 'f',
  FemaleOnly = 'femaleOnly',
  M = 'm',
  MaleOnly = 'maleOnly',
  Mix = 'mix'
}

export type CourseSummaryResGql = {
  __typename?: 'CourseSummaryResGql';
  availabilityStatus: CourseAvailabilityStatus;
  endDate?: Maybe<Scalars['String']['output']>;
  facilityList: Array<Facility>;
  groupEarlyBirdPrice: Scalars['Float']['output'];
  groupPrice: Scalars['Float']['output'];
  isMemberInPriorityList: Scalars['Boolean']['output'];
  memberEarlyBirdPosPrice: Scalars['Float']['output'];
  memberEarlyBirdWebPrice: Scalars['Float']['output'];
  memberPosPrice: Scalars['Float']['output'];
  memberWebPrice: Scalars['Float']['output'];
  noOfEnrolledEntity: Scalars['Int']['output'];
  noOfLessons: Scalars['Int']['output'];
  noOfWaitingList: Scalars['Int']['output'];
  quotaLeft: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  timeList: Array<Scalars['String']['output']>;
  weekday: Array<Scalars['Int']['output']>;
};

export type CourseType = {
  __typename?: 'CourseType';
  createdDate: Scalars['String']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  enableMiniSite: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  miniSiteSlug: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  shortCode: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type CreateAccessPassInput = {
  allowedNoOfDaysToRenew: Scalars['Int']['input'];
  aspenId: Scalars['String']['input'];
  deposit: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  isEnable: Scalars['Boolean']['input'];
  isFamilyPackage: Scalars['Boolean']['input'];
  isSwpMode: Scalars['Boolean']['input'];
  isWebEnable: Scalars['Boolean']['input'];
  mainAccessPassId?: InputMaybe<Scalars['Int']['input']>;
  maxAge: Scalars['Int']['input'];
  maxNoOfMembersPerPass: Scalars['Int']['input'];
  minAge: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfDaysToForfeitDeposit: Scalars['Int']['input'];
  renewGracePeriodNoOfDays: Scalars['Int']['input'];
  swpModeBlockEndDate?: InputMaybe<Scalars['String']['input']>;
  swpModeBlockStartDate?: InputMaybe<Scalars['String']['input']>;
  tncEn: Scalars['String']['input'];
  tncSc: Scalars['String']['input'];
  tncTc: Scalars['String']['input'];
};

export type CreateAccessPassOptionInput = {
  accessPassId: Scalars['Int']['input'];
  allowAutoRenew: Scalars['Boolean']['input'];
  apcCatCodeForDeposit: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForForfeitDeposit: Scalars['String']['input'];
  apcCatCodeForRefundDeposit: Scalars['String']['input'];
  ignoreMembershipDiscount: Scalars['Boolean']['input'];
  initPrice: Scalars['Float']['input'];
  isEnable: Scalars['Boolean']['input'];
  isStudentOnly: Scalars['Boolean']['input'];
  maxNoOfFacilityAccessPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfFacilityAccessPerMonth?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfFacilityAccessPerPeriod?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfFacilityAccessPerYear?: InputMaybe<Scalars['Int']['input']>;
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  newFreeCouponPackageId?: InputMaybe<Scalars['Int']['input']>;
  newFreeCreditPackageId?: InputMaybe<Scalars['Int']['input']>;
  noOfDaysToDoAutoRenew: Scalars['Int']['input'];
  noOfDaysToSendAutoRenewNotification: Scalars['Int']['input'];
  noOfDaysToSendRenewReminder: Scalars['Int']['input'];
  orderId: Scalars['Float']['input'];
  renewFreeCouponPackageId?: InputMaybe<Scalars['Int']['input']>;
  renewFreeCreditPackageId?: InputMaybe<Scalars['Int']['input']>;
  renewPrice: Scalars['Float']['input'];
  validNoOfDay: Scalars['Int']['input'];
  validNoOfMonth: Scalars['Float']['input'];
  validNoOfYear: Scalars['Int']['input'];
};

export type CreateAcctProductCatInput = {
  acctDesc: Scalars['String']['input'];
  apcAccountNo: Scalars['String']['input'];
  apcCode: Scalars['String']['input'];
  apcProjCode: Scalars['String']['input'];
  apcRevcCode: Scalars['String']['input'];
  apcType: Scalars['String']['input'];
  desc: Scalars['String']['input'];
};

export type CreateBlackoutInput = {
  dateList: Array<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  eventCode: Scalars['String']['input'];
  facilityIdList: Array<Scalars['Int']['input']>;
  fri: Scalars['Boolean']['input'];
  ignoreAllBookingConflict?: Scalars['Boolean']['input'];
  mon: Scalars['Boolean']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameSc?: InputMaybe<Scalars['String']['input']>;
  nameTc?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  remark: Scalars['String']['input'];
  sat: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  sun: Scalars['Boolean']['input'];
  thu: Scalars['Boolean']['input'];
  tue: Scalars['Boolean']['input'];
  wed: Scalars['Boolean']['input'];
};

export type CreateBlackoutResGql = {
  __typename?: 'CreateBlackoutResGql';
  facilityBlackout: FacilityBlackout;
  facilityTimeslotResList: Array<FacilityTimeslotResGql>;
};

export type CreateBonusPointEarningRuleCourseInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  bonusPointEarningRuleId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  courseId?: InputMaybe<Scalars['Int']['input']>;
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  sportTypeGroupId?: InputMaybe<Scalars['Int']['input']>;
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  type: BonusPointEarningRuleCourseType;
};

export type CreateBonusPointEarningRuleFacilityBookingInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  bonusPointEarningRuleId: Scalars['Int']['input'];
  bookingEndDate?: InputMaybe<Scalars['String']['input']>;
  bookingStartDate?: InputMaybe<Scalars['String']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  type: BonusPointEarningRuleFacilityBookingType;
};

export type CreateBonusPointEarningRuleInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  enableCouponCode: Scalars['Boolean']['input'];
  endDate: Scalars['String']['input'];
  globalQuota?: InputMaybe<Scalars['Int']['input']>;
  isEnable: Scalars['Boolean']['input'];
  memberQuota?: InputMaybe<Scalars['Int']['input']>;
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  refBonusPointEarningRatio: Scalars['Int']['input'];
  refExtraBonusPointAmount: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
  tncEn: Scalars['String']['input'];
  tncSc: Scalars['String']['input'];
  tncTc: Scalars['String']['input'];
};

export type CreateBonusPointEarningRuleLockerInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  bonusPointEarningRuleId: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  type: BonusPointEarningRuleLockerType;
};

export type CreateBonusPointEarningRuleMyEventInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  bonusPointEarningRuleId: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  myEventId?: InputMaybe<Scalars['Int']['input']>;
  sportTypeGroupId?: InputMaybe<Scalars['Int']['input']>;
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateBonusPointEarningRuleNthOrderInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  bonusPointEarningRuleId: Scalars['Int']['input'];
  extraBonusPointAmount: Scalars['Int']['input'];
  nthOrder: Scalars['Int']['input'];
};

export type CreateBonusPointEarningRuleProductInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  bonusPointEarningRuleId: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  productCatId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateBonusPointItemTypeEarningRatioInput = {
  earningRatio?: InputMaybe<Scalars['Int']['input']>;
  myorderItemType: MyorderItemType;
};

export type CreateBonusPointRedeemPromotionGroupInput = {
  accessPassOptionIdList: Array<Scalars['Int']['input']>;
  additionalMoneyRequired: Scalars['Int']['input'];
  bonusPointRequired: Scalars['Int']['input'];
  courseIdList: Array<Scalars['Int']['input']>;
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  facilityInputList: Array<BonusPointRedeemPromotionGroupFacilityInput>;
  globalQuota: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  memberQuota: Scalars['Int']['input'];
  myEventTicketTypeIdList: Array<Scalars['Int']['input']>;
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  productIdList: Array<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
};

export type CreateCheckInDeviceInput = {
  appUuid: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateCoachServiceInput = {
  apcCatCodeForFee: Scalars['String']['input'];
  coachIdList: Array<Scalars['Int']['input']>;
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  facilityIdList: Array<Scalars['Int']['input']>;
  isWebEnabled: Scalars['Boolean']['input'];
  minNoOfLessonsRequired: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfMembersPerLesson: Scalars['Int']['input'];
  noOfMinsPerLesson: Scalars['Int']['input'];
  revenueDeptId: Scalars['Int']['input'];
  sportTypeId: Scalars['Int']['input'];
};

export type CreateCommitteeHistoryInput = {
  endDate: Scalars['String']['input'];
  memberId: Scalars['Int']['input'];
  positionId: Scalars['Int']['input'];
  remark: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type CreateCommitteeInput = {
  aspenId: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
};

export type CreateCommitteePositionInput = {
  aspenId: Scalars['String']['input'];
  committeeId: Scalars['Float']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
};

export type CreateContactInput = {
  chineseName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender: FilterGender;
  givenName: Scalars['String']['input'];
  languagePreference: LanguagePreference;
  mobileTel: Scalars['String']['input'];
  mobileTelAreaCode: Scalars['String']['input'];
  officeTel: Scalars['String']['input'];
  officeTelAreaCode: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
  remark: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateConvertToScrapedInput = {
  deptId?: InputMaybe<Scalars['Int']['input']>;
  txList: Array<ConvertToScrapedInventoryRequestTxInput>;
  userRemark: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type CreateCouponPackageInput = {
  accessPassDependencyIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  acctCatCode: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  couponType: CouponType;
  deptId: Scalars['Int']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  discountAmt: Scalars['Float']['input'];
  isEnable: Scalars['Boolean']['input'];
  isWebEnable: Scalars['Boolean']['input'];
  listPrice: Scalars['Float']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfCoupons: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  tncEn: Scalars['String']['input'];
  tncSc: Scalars['String']['input'];
  tncTc: Scalars['String']['input'];
  validNoOfDays: Scalars['Int']['input'];
};

export type CreateCourseApplyQuotaPeriodInput = {
  applyQuota: Scalars['Int']['input'];
  monthPerPeriod: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateCourseInput = {
  allowFeeAutoRecalEvenWithEnrolment: Scalars['Boolean']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForMaterial: Scalars['String']['input'];
  aspenCategoryCode: Scalars['String']['input'];
  aspenPrepaidCategoryCode: Scalars['String']['input'];
  cancelCourseAlertDate?: InputMaybe<Scalars['String']['input']>;
  coachInternalRemark: Scalars['String']['input'];
  coachRemarkEn: Scalars['String']['input'];
  coachRemarkSc: Scalars['String']['input'];
  coachRemarkTc: Scalars['String']['input'];
  code: Scalars['String']['input'];
  courseApplyQuotaPeriodIdList?: Array<Scalars['Int']['input']>;
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
  defaultFeeForGroup: Scalars['Float']['input'];
  defaultFeeForMember: Scalars['Float']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  earlyBirdDiscountAmtForGroup: Scalars['Float']['input'];
  earlyBirdDiscountAmtForMember: Scalars['Float']['input'];
  earlyBirdDiscountPercentForGroup: Scalars['Int']['input'];
  earlyBirdDiscountPercentForMember: Scalars['Int']['input'];
  earlyBirdEndDateForGroup?: InputMaybe<Scalars['String']['input']>;
  earlyBirdEndDateForMember?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['String']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['String']['input']>;
  enableAccessPassDependency: Scalars['Boolean']['input'];
  enableFeeAutoRecalAfterUpdate: Scalars['Boolean']['input'];
  enableForWeb: Scalars['Boolean']['input'];
  enableGroupEnrol: Scalars['Boolean']['input'];
  enableMemberEnrol: Scalars['Boolean']['input'];
  enableNoShowPenalty: Scalars['Boolean']['input'];
  enablePriorityByCode: Scalars['Boolean']['input'];
  enablePriorityEnrolmentForLastCourseMember: Scalars['Boolean']['input'];
  enableWhiteList: Scalars['Boolean']['input'];
  enrolmentEndDateForGroup: Scalars['String']['input'];
  enrolmentEndDateForMember: Scalars['String']['input'];
  enrolmentStartDateForGroup: Scalars['String']['input'];
  enrolmentStartDateForMember: Scalars['String']['input'];
  enrolmentStartDateForPriority?: InputMaybe<Scalars['String']['input']>;
  enrolmentType: CourseEnrolmentType;
  facilityCost: Scalars['Float']['input'];
  facilityRemarkEn: Scalars['String']['input'];
  facilityRemarkSc: Scalars['String']['input'];
  facilityRemarkTc: Scalars['String']['input'];
  featureOrderId: Scalars['Float']['input'];
  feeType: CourseFeeType;
  fixedMaterialCost: Scalars['Float']['input'];
  gender: FilterGender;
  internalRemarks: Scalars['String']['input'];
  isEnable: Scalars['Boolean']['input'];
  isTrial: Scalars['Boolean']['input'];
  lessonDaysCountAsEarlyBird?: InputMaybe<Scalars['Int']['input']>;
  lessonDaysForNormalEnrolmentForGroup: Scalars['Int']['input'];
  lessonDaysForNormalEnrolmentForMember: Scalars['Int']['input'];
  lessonDaysForPriorityEnrolment: Scalars['Int']['input'];
  lessonFeeForGroupForAutoRecal: Scalars['Float']['input'];
  lessonFeeForMemberForAutoRecal: Scalars['Float']['input'];
  lessonPreviousEnrolledDaysCountAsPriority: Scalars['Int']['input'];
  lessonSelectionType: LessonSelectionType;
  limitEnrolPeriodInDefaultTimeslotOnly?: InputMaybe<Scalars['Boolean']['input']>;
  lotteryDrawDate?: InputMaybe<Scalars['String']['input']>;
  lotteryGroupName: Scalars['String']['input'];
  loyaltyPoint: Scalars['Int']['input'];
  materialCostPerLesson: Scalars['Float']['input'];
  maxAge: Scalars['Float']['input'];
  maxNoOfEnrolment: Scalars['Int']['input'];
  minAge: Scalars['Float']['input'];
  minNoOfEnrolledLessons?: InputMaybe<Scalars['Int']['input']>;
  minNoOfEnrolment: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  overrideTimeDescEn: Scalars['String']['input'];
  overrideTimeDescSc: Scalars['String']['input'];
  overrideTimeDescTc: Scalars['String']['input'];
  payTrialFeeOnline: Scalars['Boolean']['input'];
  recurCourseId?: InputMaybe<Scalars['Int']['input']>;
  remarkEn: Scalars['String']['input'];
  remarkSc: Scalars['String']['input'];
  remarkTc: Scalars['String']['input'];
  requireParQ: Scalars['Boolean']['input'];
  showEnrolmentResultToPublic: Scalars['Boolean']['input'];
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  uniformOption: Scalars['String']['input'];
  webDiscountAmtForMember: Scalars['Float']['input'];
  webDiscountPercentForMember: Scalars['Int']['input'];
  yldsaStandardCourseRule: Scalars['Boolean']['input'];
  youtubeId: Scalars['String']['input'];
};

export type CreateCourseTypeInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  enableMiniSite: Scalars['Boolean']['input'];
  isEnable: Scalars['Boolean']['input'];
  miniSiteSlug: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  shortCode: Scalars['String']['input'];
};

export type CreateCreditPackageInput = {
  apcCatCodeForFee: Scalars['String']['input'];
  creditAmount: Scalars['Float']['input'];
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  deptId: Scalars['Int']['input'];
  expiryDays: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isWebEnable: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  sku: Scalars['String']['input'];
};

export type CreateCreditTypeInput = {
  code: Scalars['String']['input'];
  defaultExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  isEnable: Scalars['Boolean']['input'];
  myorderItemTypeList?: InputMaybe<Array<MyorderItemType>>;
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
};

export type CreateDepartmentInput = {
  aspenId: Scalars['String']['input'];
  bonusPointReceiptRegRatio: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  forReceiptReg: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  receiveOrderEmail: Scalars['Boolean']['input'];
  shortCode: Scalars['String']['input'];
  telNo: Scalars['String']['input'];
};

export type CreateDocxTemplateInput = {
  docType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shareTo: ShareTo;
  uploadFileInput: UploadFileInput;
};

export type CreateDriveTeamInput = {
  code: Scalars['String']['input'];
  isEnable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateFabFloorplanInput = {
  isEnable: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type CreateFabFloorplanPeriodInput = {
  defaultMealMins: Scalars['Int']['input'];
  defaultTimeslotMins: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  fabFloorplanId: Scalars['Int']['input'];
  groupName: Scalars['String']['input'];
  isEnable: Scalars['Boolean']['input'];
  mustBookWholePeriod: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type CreateFabTableInput = {
  fabFloorplanId: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  noOfSeats: Scalars['Int']['input'];
  shape: FabTableShape;
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type CreateFacilityInput = {
  advanceBookingChargeRule?: InputMaybe<Scalars['Boolean']['input']>;
  allowInternalBooking?: InputMaybe<Scalars['Boolean']['input']>;
  apcCatCodeForAdvanceBookingCharge: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForLateCharge: Scalars['String']['input'];
  aspenId?: InputMaybe<Scalars['String']['input']>;
  customType?: InputMaybe<Scalars['String']['input']>;
  defaultFeeForDept?: InputMaybe<Scalars['Float']['input']>;
  defaultFeeForGroup?: InputMaybe<Scalars['Float']['input']>;
  defaultFeeForMember?: InputMaybe<Scalars['Float']['input']>;
  defaultFeeForRegBody?: InputMaybe<Scalars['Float']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  descEn?: InputMaybe<Scalars['String']['input']>;
  descSc?: InputMaybe<Scalars['String']['input']>;
  descTc?: InputMaybe<Scalars['String']['input']>;
  enableForWeb?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  facilityGroupCode?: InputMaybe<Scalars['String']['input']>;
  gridDisplayName?: InputMaybe<Scalars['String']['input']>;
  ignoreLeadTimeCheckInPos?: InputMaybe<Scalars['Boolean']['input']>;
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifyUserId?: InputMaybe<Scalars['Int']['input']>;
  locationAreaId: Scalars['Int']['input'];
  maxLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfTimeslot?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfTimeslotForPeakHour?: InputMaybe<Scalars['Int']['input']>;
  minLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  minNoOfTimeslot?: InputMaybe<Scalars['Int']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameSc?: InputMaybe<Scalars['String']['input']>;
  nameTc?: InputMaybe<Scalars['String']['input']>;
  noSameDayBookingRule?: InputMaybe<Scalars['Boolean']['input']>;
  noSameTimeBookingRule?: InputMaybe<Scalars['Boolean']['input']>;
  openForMemberBooking?: InputMaybe<Scalars['Boolean']['input']>;
  openForUserBooking?: InputMaybe<Scalars['Boolean']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  refCapacity?: InputMaybe<Scalars['String']['input']>;
  requiredNoOfMembers?: InputMaybe<Scalars['Int']['input']>;
  revenueDeptId?: InputMaybe<Scalars['Int']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  systemType?: InputMaybe<FacilitySystemType>;
  timeSlotMins?: InputMaybe<Scalars['Int']['input']>;
  youtubeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHolidayInput = {
  date: Scalars['String']['input'];
  icalId: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
};

export type CreateInterWarehouseInventoryTransferAtOnceInput = {
  fromContactAddress1: Scalars['String']['input'];
  fromContactAddress2: Scalars['String']['input'];
  fromContactAddress3: Scalars['String']['input'];
  fromContactAddress4: Scalars['String']['input'];
  fromContactAddress5: Scalars['String']['input'];
  fromContactEmail?: InputMaybe<Scalars['String']['input']>;
  fromContactName: Scalars['String']['input'];
  fromContactPhone: Scalars['String']['input'];
  inDeptId?: InputMaybe<Scalars['Int']['input']>;
  inWarehouseId: Scalars['Int']['input'];
  outDeptId?: InputMaybe<Scalars['Int']['input']>;
  outWarehouseId: Scalars['Int']['input'];
  throwNonCriticalBorrowCheckError?: Scalars['Boolean']['input'];
  toContactAddress1: Scalars['String']['input'];
  toContactAddress2: Scalars['String']['input'];
  toContactAddress3: Scalars['String']['input'];
  toContactAddress4: Scalars['String']['input'];
  toContactAddress5: Scalars['String']['input'];
  toContactEmail?: InputMaybe<Scalars['String']['input']>;
  toContactName: Scalars['String']['input'];
  toContactPhone: Scalars['String']['input'];
  toUserId?: InputMaybe<Scalars['Int']['input']>;
  txList: Array<TwoWayInventoryRequestTxInput>;
  userRemark: Scalars['String']['input'];
};

export type CreateInterWarehouseInventoryTransferInput = {
  expectedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  fromContactAddress1: Scalars['String']['input'];
  fromContactAddress2: Scalars['String']['input'];
  fromContactAddress3: Scalars['String']['input'];
  fromContactAddress4: Scalars['String']['input'];
  fromContactAddress5: Scalars['String']['input'];
  fromContactEmail?: InputMaybe<Scalars['String']['input']>;
  fromContactName: Scalars['String']['input'];
  fromContactPhone: Scalars['String']['input'];
  inDeptId?: InputMaybe<Scalars['Int']['input']>;
  inWarehouseId: Scalars['Int']['input'];
  outDeptId?: InputMaybe<Scalars['Int']['input']>;
  outWarehouseId: Scalars['Int']['input'];
  throwNonCriticalBorrowCheckError?: Scalars['Boolean']['input'];
  toContactAddress1: Scalars['String']['input'];
  toContactAddress2: Scalars['String']['input'];
  toContactAddress3: Scalars['String']['input'];
  toContactAddress4: Scalars['String']['input'];
  toContactAddress5: Scalars['String']['input'];
  toContactEmail?: InputMaybe<Scalars['String']['input']>;
  toContactName: Scalars['String']['input'];
  toContactPhone: Scalars['String']['input'];
  toUserId?: InputMaybe<Scalars['Int']['input']>;
  txList: Array<TwoWayInventoryRequestTxInput>;
  userRemark: Scalars['String']['input'];
};

export type CreateIntraWarehouseInventoryTransferAtOnceInput = {
  fromContactAddress1: Scalars['String']['input'];
  fromContactAddress2: Scalars['String']['input'];
  fromContactAddress3: Scalars['String']['input'];
  fromContactAddress4: Scalars['String']['input'];
  fromContactAddress5: Scalars['String']['input'];
  fromContactEmail?: InputMaybe<Scalars['String']['input']>;
  fromContactName: Scalars['String']['input'];
  fromContactPhone: Scalars['String']['input'];
  inDeptId?: InputMaybe<Scalars['Int']['input']>;
  outDeptId?: InputMaybe<Scalars['Int']['input']>;
  throwNonCriticalBorrowCheckError?: Scalars['Boolean']['input'];
  toContactAddress1: Scalars['String']['input'];
  toContactAddress2: Scalars['String']['input'];
  toContactAddress3: Scalars['String']['input'];
  toContactAddress4: Scalars['String']['input'];
  toContactAddress5: Scalars['String']['input'];
  toContactEmail?: InputMaybe<Scalars['String']['input']>;
  toContactName: Scalars['String']['input'];
  toContactPhone: Scalars['String']['input'];
  toUserId?: InputMaybe<Scalars['Int']['input']>;
  txList: Array<TwoWayInventoryRequestTxInput>;
  userRemark: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type CreateIntraWarehouseInventoryTransferInput = {
  autoPhysicalTransferForIntra?: Scalars['Boolean']['input'];
  expectedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  fromContactAddress1: Scalars['String']['input'];
  fromContactAddress2: Scalars['String']['input'];
  fromContactAddress3: Scalars['String']['input'];
  fromContactAddress4: Scalars['String']['input'];
  fromContactAddress5: Scalars['String']['input'];
  fromContactEmail?: InputMaybe<Scalars['String']['input']>;
  fromContactName: Scalars['String']['input'];
  fromContactPhone: Scalars['String']['input'];
  inDeptId?: InputMaybe<Scalars['Int']['input']>;
  outDeptId?: InputMaybe<Scalars['Int']['input']>;
  throwNonCriticalBorrowCheckError?: Scalars['Boolean']['input'];
  toContactAddress1: Scalars['String']['input'];
  toContactAddress2: Scalars['String']['input'];
  toContactAddress3: Scalars['String']['input'];
  toContactAddress4: Scalars['String']['input'];
  toContactAddress5: Scalars['String']['input'];
  toContactEmail?: InputMaybe<Scalars['String']['input']>;
  toContactName: Scalars['String']['input'];
  toContactPhone: Scalars['String']['input'];
  toUserId?: InputMaybe<Scalars['Int']['input']>;
  txList: Array<TwoWayInventoryRequestTxInput>;
  userRemark: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type CreateKwtdhcEventInput = {
  annualHrfa: Scalars['Int']['input'];
  attendance: Scalars['Int']['input'];
  ccdcEnrolment: Scalars['Int']['input'];
  ccdcPreEnrolment: Scalars['Int']['input'];
  centerLocation: Scalars['String']['input'];
  collaborativeWith: Scalars['String']['input'];
  eventDate?: InputMaybe<Scalars['String']['input']>;
  eventEndTime?: InputMaybe<Scalars['String']['input']>;
  eventStartTime?: InputMaybe<Scalars['String']['input']>;
  firstHrfa: Scalars['Int']['input'];
  flu: Scalars['Int']['input'];
  hpv: Scalars['Int']['input'];
  method: Scalars['String']['input'];
  name: Scalars['String']['input'];
  otherVaccination: Scalars['Int']['input'];
  outreachLocation: Scalars['String']['input'];
  outreachType: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  pneumococcal: Scalars['Int']['input'];
  remark: Scalars['String']['input'];
  types: Scalars['String']['input'];
  uploadFileInput: UploadFileInput;
  zoster: Scalars['Int']['input'];
};

export type CreateKwtdhcMemberFollowupInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  isFollowUpAlready: Scalars['Boolean']['input'];
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
  remark: Scalars['String']['input'];
};

export type CreateLessonInput = {
  coachIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  courseId: Scalars['Int']['input'];
  endDateTime: Scalars['String']['input'];
  facilityIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  ignoreCoachConflict?: Scalars['Boolean']['input'];
  ignoreFacilityConflict?: Scalars['Boolean']['input'];
  isCancelled: Scalars['Boolean']['input'];
  isEnable: Scalars['Boolean']['input'];
  makeupLessonId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type CreateLocationAreaInput = {
  locationId: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  phone: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type CreateLocationInput = {
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type CreateLockerGroupInput = {
  accessPassDependencyIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  allowedNoOfDaysToRenew: Scalars['Int']['input'];
  column: Scalars['Int']['input'];
  countDayAsWorkingDays: Scalars['Boolean']['input'];
  deposit: Scalars['Float']['input'];
  depositAcctCode: Scalars['String']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  gender: FilterGender;
  isEnable: Scalars['Boolean']['input'];
  isWebEnable: Scalars['Boolean']['input'];
  locationAreaId?: InputMaybe<Scalars['Int']['input']>;
  lockerTypeId?: InputMaybe<Scalars['Int']['input']>;
  nameEn: Scalars['String']['input'];
  namePos: Scalars['String']['input'];
  nameReceipt: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfDaysToForfeitDeposit: Scalars['Int']['input'];
  renewGracePeriodNoOfDays: Scalars['Int']['input'];
  rentalAcctCode: Scalars['String']['input'];
  row: Scalars['Int']['input'];
  shortCode: Scalars['String']['input'];
};

export type CreateLockerTypeInput = {
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  shortCode: Scalars['String']['input'];
};

export type CreateMemberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  aspenSeqNo?: InputMaybe<Scalars['String']['input']>;
  autoRenewNoOfTrial?: InputMaybe<Scalars['Int']['input']>;
  autoRenewNotificationSentDateTime?: InputMaybe<Scalars['String']['input']>;
  birthDate: Scalars['String']['input'];
  cardIssueDate?: InputMaybe<Scalars['String']['input']>;
  cardLostNo?: InputMaybe<Scalars['Int']['input']>;
  cardReplacementNo?: InputMaybe<Scalars['Float']['input']>;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableMemberLogin?: InputMaybe<Scalars['Boolean']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName: Scalars['String']['input'];
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  isAddressIncorrect?: InputMaybe<Scalars['Boolean']['input']>;
  isAddressIncorrectDate?: InputMaybe<Scalars['String']['input']>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklistedDate?: InputMaybe<Scalars['String']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidentialDate?: InputMaybe<Scalars['String']['input']>;
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  isDeceasedDate?: InputMaybe<Scalars['String']['input']>;
  isImmigrated?: InputMaybe<Scalars['Boolean']['input']>;
  isImmigratedDate?: InputMaybe<Scalars['String']['input']>;
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspendedDate?: InputMaybe<Scalars['String']['input']>;
  joinDate?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  lastValidMembershipStartDate?: InputMaybe<Scalars['String']['input']>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  loginMobile?: InputMaybe<Scalars['String']['input']>;
  memDriveDepositTotal?: InputMaybe<Scalars['Float']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveReferralId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveTeamId?: InputMaybe<Scalars['Int']['input']>;
  membershipNo?: InputMaybe<Scalars['String']['input']>;
  membershipTypeId: Scalars['Int']['input'];
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  photoMyfileId?: InputMaybe<Scalars['Int']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  proofMyfileId?: InputMaybe<Scalars['Int']['input']>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requireReview?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMemberListInput = {
  deptId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  remark: Scalars['String']['input'];
  whitelistMsgEn: Scalars['String']['input'];
  whitelistMsgSc: Scalars['String']['input'];
  whitelistMsgTc: Scalars['String']['input'];
};

export type CreateMembershipTypeInput = {
  allowedNoOfDaysToRenew: Scalars['Int']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForRenew: Scalars['String']['input'];
  aspenId: Scalars['String']['input'];
  canApplyOnline: Scalars['Boolean']['input'];
  initPrice: Scalars['Float']['input'];
  maxAge: Scalars['Int']['input'];
  maxAgeToWaiveStudentIdCheck: Scalars['Int']['input'];
  membershipNoPrefix: Scalars['String']['input'];
  minAge: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderDiscountPercent: Scalars['Int']['input'];
  printNameEn: Scalars['String']['input'];
  printNameSc: Scalars['String']['input'];
  printNameTc: Scalars['String']['input'];
  renewPrice: Scalars['Float']['input'];
  validNoOfDay: Scalars['Int']['input'];
  validNoOfMonth: Scalars['Int']['input'];
  validNoOfYear: Scalars['Int']['input'];
};

export type CreateMyEventInput = {
  ageCountYearOnly: Scalars['Boolean']['input'];
  asEventGroup: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  deptId: Scalars['Int']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  earlyBirdEndDateForGroup?: InputMaybe<Scalars['String']['input']>;
  earlyBirdEndDateForGuest?: InputMaybe<Scalars['String']['input']>;
  earlyBirdEndDateForMember?: InputMaybe<Scalars['String']['input']>;
  enableForWeb: Scalars['Boolean']['input'];
  enableGroupEnrol: Scalars['Boolean']['input'];
  enableGuestEnrol: Scalars['Boolean']['input'];
  enableMemberEnrol: Scalars['Boolean']['input'];
  enableWhiteList: Scalars['Boolean']['input'];
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  enrolmentEndDateForGroup: Scalars['String']['input'];
  enrolmentEndDateForGuest: Scalars['String']['input'];
  enrolmentEndDateForMember: Scalars['String']['input'];
  enrolmentStartDateForGroup: Scalars['String']['input'];
  enrolmentStartDateForGuest: Scalars['String']['input'];
  enrolmentStartDateForMember: Scalars['String']['input'];
  facilityRemarkEn: Scalars['String']['input'];
  facilityRemarkSc: Scalars['String']['input'];
  facilityRemarkTc: Scalars['String']['input'];
  gender: FilterGender;
  isEnable: Scalars['Boolean']['input'];
  isTeamMode: Scalars['Boolean']['input'];
  isTeamModePricePerHead: Scalars['Boolean']['input'];
  maxAge: Scalars['Float']['input'];
  maxNoOfFemaleTeamMembers: Scalars['Int']['input'];
  maxNoOfMaleTeamMembers: Scalars['Int']['input'];
  maxNoOfTotalTeamMembers: Scalars['Int']['input'];
  minAge: Scalars['Float']['input'];
  minNoOfFemaleTeamMembers: Scalars['Int']['input'];
  minNoOfMaleTeamMembers: Scalars['Int']['input'];
  minNoOfTotalTeamMembers: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  parentMyEventId?: InputMaybe<Scalars['Int']['input']>;
  remarkEn: Scalars['String']['input'];
  remarkSc: Scalars['String']['input'];
  remarkTc: Scalars['String']['input'];
  requireTeamName: Scalars['Boolean']['input'];
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  teamGenderType: TeamGenderType;
  youtubeId: Scalars['String']['input'];
};

export type CreateNewsInput = {
  contentEn: Scalars['String']['input'];
  contentSc: Scalars['String']['input'];
  contentTc: Scalars['String']['input'];
  publishDateTime: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
  titleSc: Scalars['String']['input'];
  titleTc: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  address3: Scalars['String']['input'];
  address4: Scalars['String']['input'];
  code: Scalars['String']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  rgb?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};

export type CreateOverrideLotteryGroupScoreInput = {
  lotteryGroupName: Scalars['String']['input'];
  memberId: Scalars['Int']['input'];
  score?: Scalars['Int']['input'];
};

export type CreateProductCatInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  parentProductCatId?: InputMaybe<Scalars['Int']['input']>;
  showInWeb: Scalars['Boolean']['input'];
};

export type CreateProductInput = {
  allowPosOversell: Scalars['Boolean']['input'];
  allowWebOversell: Scalars['Boolean']['input'];
  apcCatCodeForCost: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  barcode: Scalars['String']['input'];
  cost: Scalars['Float']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  isEnable: Scalars['Boolean']['input'];
  isOpenItem: Scalars['Boolean']['input'];
  isVirtual: Scalars['Boolean']['input'];
  loyaltyPoint: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderLevelPercentageFeeOrDiscount: Scalars['Int']['input'];
  posDiscountAmt: Scalars['Float']['input'];
  posDiscountPercent: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
  productCatIdList: Array<Scalars['Int']['input']>;
  redeemEndDate?: InputMaybe<Scalars['String']['input']>;
  redeemEndDaysAfterPurchase: Scalars['Int']['input'];
  requireOfflineRedemption: Scalars['Boolean']['input'];
  revenueDeptId: Scalars['Int']['input'];
  showInWeb: Scalars['Boolean']['input'];
  sku: Scalars['String']['input'];
  supplier: Scalars['String']['input'];
  tagList: Array<Scalars['String']['input']>;
  webDiscountAmt: Scalars['Float']['input'];
  webDiscountPercent: Scalars['Int']['input'];
};

export type CreatePurchaseOrderInput = {
  deptId?: InputMaybe<Scalars['Int']['input']>;
  expectedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  fromContactAddress1: Scalars['String']['input'];
  fromContactAddress2: Scalars['String']['input'];
  fromContactAddress3: Scalars['String']['input'];
  fromContactAddress4: Scalars['String']['input'];
  fromContactAddress5: Scalars['String']['input'];
  fromContactEmail?: InputMaybe<Scalars['String']['input']>;
  fromContactName: Scalars['String']['input'];
  fromContactPhone: Scalars['String']['input'];
  orgId: Scalars['Int']['input'];
  toContactAddress1: Scalars['String']['input'];
  toContactAddress2: Scalars['String']['input'];
  toContactAddress3: Scalars['String']['input'];
  toContactAddress4: Scalars['String']['input'];
  toContactAddress5: Scalars['String']['input'];
  toContactEmail?: InputMaybe<Scalars['String']['input']>;
  toContactName: Scalars['String']['input'];
  toContactPhone: Scalars['String']['input'];
  toUserId?: InputMaybe<Scalars['Int']['input']>;
  txList: Array<CreatePurchaseOrderInventoryTxInput>;
  userRemark: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type CreatePurchaseOrderInventoryTxInput = {
  inWarehousePartitionId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
};

export type CreatePureStockOutInput = {
  expectedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  fromContactAddress1: Scalars['String']['input'];
  fromContactAddress2: Scalars['String']['input'];
  fromContactAddress3: Scalars['String']['input'];
  fromContactAddress4: Scalars['String']['input'];
  fromContactAddress5: Scalars['String']['input'];
  fromContactEmail?: InputMaybe<Scalars['String']['input']>;
  fromContactName: Scalars['String']['input'];
  fromContactPhone: Scalars['String']['input'];
  inDeptId?: InputMaybe<Scalars['Int']['input']>;
  inWarehouseId?: InputMaybe<Scalars['Int']['input']>;
  outDeptId?: InputMaybe<Scalars['Int']['input']>;
  outWarehouseId: Scalars['Int']['input'];
  requireGrnConfirmation?: Scalars['Boolean']['input'];
  toContactAddress1: Scalars['String']['input'];
  toContactAddress2: Scalars['String']['input'];
  toContactAddress3: Scalars['String']['input'];
  toContactAddress4: Scalars['String']['input'];
  toContactAddress5: Scalars['String']['input'];
  toContactEmail?: InputMaybe<Scalars['String']['input']>;
  toContactName: Scalars['String']['input'];
  toContactPhone: Scalars['String']['input'];
  toOrgId?: InputMaybe<Scalars['Int']['input']>;
  toUserId?: InputMaybe<Scalars['Int']['input']>;
  txList: Array<CreatePureStockOutTxInput>;
  userRemark: Scalars['String']['input'];
};

export type CreatePureStockOutTxInput = {
  isScraped: Scalars['Boolean']['input'];
  outWarehousePartitionId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
};

export type CreateRecurCourseInput = {
  allowFeeAutoRecalEvenWithEnrolment: Scalars['Boolean']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForMaterial: Scalars['String']['input'];
  aspenCategoryCode: Scalars['String']['input'];
  aspenPrepaidCategoryCode: Scalars['String']['input'];
  coachInternalRemark: Scalars['String']['input'];
  coachRemarkEn: Scalars['String']['input'];
  coachRemarkSc: Scalars['String']['input'];
  coachRemarkTc: Scalars['String']['input'];
  courseTypeId: Scalars['Int']['input'];
  deptId: Scalars['Int']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  earlyBirdDiscountAmtForGroup: Scalars['Float']['input'];
  earlyBirdDiscountAmtForMember: Scalars['Float']['input'];
  earlyBirdDiscountPercentForGroup: Scalars['Float']['input'];
  earlyBirdDiscountPercentForMember: Scalars['Float']['input'];
  enableFeeAutoRecalAfterUpdate: Scalars['Boolean']['input'];
  enableGroupEnrol: Scalars['Boolean']['input'];
  enableMemberEnrol: Scalars['Boolean']['input'];
  enableNoShowPenalty: Scalars['Boolean']['input'];
  enablePriorityEnrolmentForLastCourseMember: Scalars['Boolean']['input'];
  endTime?: InputMaybe<Scalars['String']['input']>;
  enrolmentType: CourseEnrolmentType;
  facilityCostPerLesson: Scalars['Float']['input'];
  facilityRemarkEn: Scalars['String']['input'];
  facilityRemarkSc: Scalars['String']['input'];
  facilityRemarkTc: Scalars['String']['input'];
  feeType: RecurCourseFeeType;
  fixCalendarDayForEarlyBirdGroupEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixCalendarDayForEarlyBirdMemberEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixCalendarDayForGroupEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixCalendarDayForMemberEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixCalendarDayForPriorityEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixedAmountFeeForGroup: Scalars['Float']['input'];
  fixedAmountFeeForMember: Scalars['Float']['input'];
  fixedFacilityCost: Scalars['Float']['input'];
  fixedMaterialCost: Scalars['Float']['input'];
  fri: Scalars['Boolean']['input'];
  gender: FilterGender;
  isSkipPublicHoliday: Scalars['Boolean']['input'];
  leadNoOfDaysEarlyBirdForGroup: Scalars['Int']['input'];
  leadNoOfDaysEarlyBirdForMember: Scalars['Int']['input'];
  leadNoOfDaysEnrolmentForGroup: Scalars['Int']['input'];
  leadNoOfDaysEnrolmentForMember: Scalars['Int']['input'];
  leadNoOfDaysForCancelCourseAlert?: InputMaybe<Scalars['Int']['input']>;
  leadNoOfDaysForPriorityEnrolment: Scalars['Int']['input'];
  lessonFeeForGroup: Scalars['Float']['input'];
  lessonFeeForMember: Scalars['Float']['input'];
  lessonRemark: Scalars['String']['input'];
  limitEnrolPeriodInDefaultTimeslotOnly?: InputMaybe<Scalars['Boolean']['input']>;
  lotteryGroupName: Scalars['String']['input'];
  materialCostPerLesson: Scalars['Float']['input'];
  maxAge: Scalars['Float']['input'];
  maxNoOfEnrolment: Scalars['Int']['input'];
  minAge: Scalars['Float']['input'];
  minNoOfEnrolment: Scalars['Int']['input'];
  mon: Scalars['Boolean']['input'];
  overrideTimeDescEn: Scalars['String']['input'];
  overrideTimeDescSc: Scalars['String']['input'];
  overrideTimeDescTc: Scalars['String']['input'];
  prefixNameEn: Scalars['String']['input'];
  prefixNameSc: Scalars['String']['input'];
  prefixNameTc: Scalars['String']['input'];
  recurBy: RecurCourseRecurBy;
  recurCourseApplyQuotaPeriodIdList?: Array<Scalars['Int']['input']>;
  recurFixedNoOfLesson: Scalars['Int']['input'];
  recurNoOfCalendarMonths: Scalars['Int']['input'];
  remarkEn: Scalars['String']['input'];
  remarkSc: Scalars['String']['input'];
  remarkTc: Scalars['String']['input'];
  requireParQ: Scalars['Boolean']['input'];
  sat: Scalars['Boolean']['input'];
  showEnrolmentResultToPublic: Scalars['Boolean']['input'];
  sportTypeId: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  suffixCode: Scalars['String']['input'];
  sun: Scalars['Boolean']['input'];
  thu: Scalars['Boolean']['input'];
  tue: Scalars['Boolean']['input'];
  uniformOption: Scalars['String']['input'];
  webDiscountAmtForMember: Scalars['Float']['input'];
  webDiscountPercentForMember: Scalars['Float']['input'];
  wed: Scalars['Boolean']['input'];
  yldsaStandardCourseRule: Scalars['Boolean']['input'];
  youtubeId: Scalars['String']['input'];
};

export type CreateRoleTemplateInput = {
  name: Scalars['String']['input'];
  roleNameList: Array<Scalars['String']['input']>;
  updateDeptDtoList: Array<UpdateOnePermissionTypeUserDeptListInput>;
  warehouseIdList: Array<Scalars['Int']['input']>;
};

export type CreateSportTypeGroupInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  externalLink: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  shortCode: Scalars['String']['input'];
  youtubeId: Scalars['String']['input'];
};

export type CreateSportTypeInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  externalLink: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  shortCode: Scalars['String']['input'];
  sportTypeGroupId: Scalars['Int']['input'];
  youtubeId: Scalars['String']['input'];
};

export type CreateStaffMemberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  aspenSeqNo?: InputMaybe<Scalars['String']['input']>;
  autoRenewNoOfTrial?: InputMaybe<Scalars['Int']['input']>;
  autoRenewNotificationSentDateTime?: InputMaybe<Scalars['String']['input']>;
  cardIssueDate?: InputMaybe<Scalars['String']['input']>;
  cardLostNo?: InputMaybe<Scalars['Int']['input']>;
  cardReplacementNo?: InputMaybe<Scalars['Float']['input']>;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableMemberLogin?: InputMaybe<Scalars['Boolean']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName: Scalars['String']['input'];
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  isAddressIncorrect?: InputMaybe<Scalars['Boolean']['input']>;
  isAddressIncorrectDate?: InputMaybe<Scalars['String']['input']>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklistedDate?: InputMaybe<Scalars['String']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidentialDate?: InputMaybe<Scalars['String']['input']>;
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  isDeceasedDate?: InputMaybe<Scalars['String']['input']>;
  isImmigrated?: InputMaybe<Scalars['Boolean']['input']>;
  isImmigratedDate?: InputMaybe<Scalars['String']['input']>;
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspendedDate?: InputMaybe<Scalars['String']['input']>;
  joinDate?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  lastValidMembershipStartDate?: InputMaybe<Scalars['String']['input']>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  loginMobile?: InputMaybe<Scalars['String']['input']>;
  memDriveDepositTotal?: InputMaybe<Scalars['Float']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveReferralId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveTeamId?: InputMaybe<Scalars['Int']['input']>;
  membershipNo?: InputMaybe<Scalars['String']['input']>;
  membershipTypeId: Scalars['Int']['input'];
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  photoMyfileId?: InputMaybe<Scalars['Int']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  proofMyfileId?: InputMaybe<Scalars['Int']['input']>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requireReview?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSwpTestCardQrCodeInput = {
  memberId: Scalars['Int']['input'];
  validUntilDateTime: Scalars['String']['input'];
};

export type CreateTextTemplateInput = {
  docType: Scalars['String']['input'];
  htmlContent: Scalars['String']['input'];
  msgPlatform: MsgPlatform;
  name: Scalars['String']['input'];
  plainContent: Scalars['String']['input'];
  shareTo: ShareTo;
  title: Scalars['String']['input'];
  waBodyDataMapping?: InputMaybe<Scalars['String']['input']>;
  waButtonDataMapping?: InputMaybe<Scalars['String']['input']>;
  waHeaderDataMapping?: InputMaybe<Scalars['String']['input']>;
  waMediaDataMapping: Scalars['String']['input'];
  waMediaDataUrl: Scalars['String']['input'];
  waTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTimeSlotProgramGroupInput = {
  disableForWeb: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
};

export type CreateTimeSlotProgramInput = {
  ageCalcType: AgeCalcType;
  customStringLabel01En: Scalars['String']['input'];
  customStringLabel01Sc: Scalars['String']['input'];
  customStringLabel01Tc: Scalars['String']['input'];
  customStringLabel02En: Scalars['String']['input'];
  customStringLabel02Sc: Scalars['String']['input'];
  customStringLabel02Tc: Scalars['String']['input'];
  customStringLabel03En: Scalars['String']['input'];
  customStringLabel03Sc: Scalars['String']['input'];
  customStringLabel03Tc: Scalars['String']['input'];
  customStringLabel04En: Scalars['String']['input'];
  customStringLabel04Sc: Scalars['String']['input'];
  customStringLabel04Tc: Scalars['String']['input'];
  customStringLabel05En: Scalars['String']['input'];
  customStringLabel05Sc: Scalars['String']['input'];
  customStringLabel05Tc: Scalars['String']['input'];
  customStringLabel06En: Scalars['String']['input'];
  customStringLabel06Sc: Scalars['String']['input'];
  customStringLabel06Tc: Scalars['String']['input'];
  customStringLabel07En: Scalars['String']['input'];
  customStringLabel07Sc: Scalars['String']['input'];
  customStringLabel07Tc: Scalars['String']['input'];
  customStringLabel08En: Scalars['String']['input'];
  customStringLabel08Sc: Scalars['String']['input'];
  customStringLabel08Tc: Scalars['String']['input'];
  customStringLabel09En: Scalars['String']['input'];
  customStringLabel09Sc: Scalars['String']['input'];
  customStringLabel09Tc: Scalars['String']['input'];
  customStringLabel10En: Scalars['String']['input'];
  customStringLabel10Sc: Scalars['String']['input'];
  customStringLabel10Tc: Scalars['String']['input'];
  deptId: Scalars['Int']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  enableForWeb: Scalars['Boolean']['input'];
  endDate: Scalars['String']['input'];
  gender: FilterGender;
  isEnable: Scalars['Boolean']['input'];
  isMemberOnly: Scalars['Boolean']['input'];
  isNoIdentityCheckMode: Scalars['Boolean']['input'];
  maxAge: Scalars['Float']['input'];
  maxNoOfServiceTypesPerReservation: Scalars['Int']['input'];
  maxQuota: Scalars['Int']['input'];
  minAge: Scalars['Float']['input'];
  minNoOfServiceTypesPerReservation: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  posNoOfDaysAfterTodayToEndReserve: Scalars['Int']['input'];
  posNoOfDaysAfterTodayToStartReserve: Scalars['Int']['input'];
  posNoOfDaysToCancel: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
  timeSlotMins: Scalars['Int']['input'];
  timeSlotProgramGroupId?: InputMaybe<Scalars['Int']['input']>;
  tnc: Scalars['String']['input'];
  webNoOfDaysAfterTodayToEndReserve: Scalars['Int']['input'];
  webNoOfDaysAfterTodayToStartReserve: Scalars['Int']['input'];
  webNoOfDaysToCancel: Scalars['Int']['input'];
};

export type CreateTrialMemberAndAddCourseEnrolmentToCartResGql = {
  __typename?: 'CreateTrialMemberAndAddCourseEnrolmentToCartResGql';
  loginMemberResGql: LoginMemberResGql;
  myorder: Myorder;
};

export type CreateTrialMemberAndAddToCourseEnrolmentInput = {
  courseId: Scalars['Int']['input'];
  createTrialMemberInput: CreateTrialMemberInput;
  lessonIdList: Array<Scalars['Int']['input']>;
  uniformOption?: Scalars['String']['input'];
};

export type CreateTrialMemberAndAddToCourseEnrolmentResGql = {
  __typename?: 'CreateTrialMemberAndAddToCourseEnrolmentResGql';
  addCourseEnrolmentResGql: AddCourseEnrolmentResGql;
  loginMemberResGql: LoginMemberResGql;
};

export type CreateTrialMemberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  autoRenewNoOfTrial?: InputMaybe<Scalars['Int']['input']>;
  autoRenewNotificationSentDateTime?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  lastValidMembershipStartDate?: InputMaybe<Scalars['String']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserCoachServiceRelInput = {
  coachFee: Scalars['Float']['input'];
  coachSalaryContractTermsId?: InputMaybe<Scalars['Int']['input']>;
  coachServiceId: Scalars['Int']['input'];
  isWebEnabled: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type CreateUserInput = {
  aspenUserCode: Scalars['String']['input'];
  coachAllowSameTimeslotBooking: Scalars['Boolean']['input'];
  coachRemarkEn: Scalars['String']['input'];
  coachRemarkSc: Scalars['String']['input'];
  coachRemarkTc: Scalars['String']['input'];
  coachTimeslotEndTime: Scalars['String']['input'];
  coachTimeslotMins: Scalars['Int']['input'];
  coachTimeslotStartTime: Scalars['String']['input'];
  code: Scalars['String']['input'];
  defaultReceiptName: Scalars['String']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  displayName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  isEnable: Scalars['Boolean']['input'];
  isEquipmentTeam: Scalars['Boolean']['input'];
  isVenueTeam: Scalars['Boolean']['input'];
  languagePreference: LanguagePreference;
  mobileTel: Scalars['String']['input'];
  monthlySalary: Scalars['Float']['input'];
  password: Scalars['String']['input'];
  ssoMapping?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['Float']['input'];
  username: Scalars['String']['input'];
};

export type CreateUserProductGroupInput = {
  column: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  row: Scalars['Int']['input'];
};

export type CreateWarehouseInput = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  address3: Scalars['String']['input'];
  address4: Scalars['String']['input'];
  cutoffTime: Scalars['String']['input'];
  districtId?: InputMaybe<Scalars['Int']['input']>;
  isEnable: Scalars['Boolean']['input'];
  isPosEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWarehousePartitionInput = {
  code: Scalars['String']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  isEnable: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  parentWarehousePartitionId?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWarehouseStockTakeInput = {
  deptId?: InputMaybe<Scalars['Int']['input']>;
  remark: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type CreateWhatsappTemplateInput = {
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CreateWriteOffInput = {
  deptId?: InputMaybe<Scalars['Int']['input']>;
  outDeptId: Scalars['Int']['input'];
  outWarehouseId: Scalars['Int']['input'];
  txList: Array<CreatePureStockOutTxInput>;
  userRemark: Scalars['String']['input'];
};

export type CreditDailyReport = {
  __typename?: 'CreditDailyReport';
  creditType?: Maybe<CreditType>;
  creditTypeId?: Maybe<Scalars['Int']['output']>;
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalBalance: Scalars['Float']['output'];
  totalEarned: Scalars['Float']['output'];
  totalExpired: Scalars['Float']['output'];
  totalUsed: Scalars['Float']['output'];
};

export enum CreditMovementType {
  CancelRefundToCredit = 'cancelRefundToCredit',
  Custom = 'custom',
  Expiry = 'expiry',
  HoldByOrder = 'holdByOrder',
  Order = 'order',
  PurchaseCredit = 'purchaseCredit',
  RefundPurchaseCredit = 'refundPurchaseCredit',
  RefundToCredit = 'refundToCredit',
  UpdateCreditType = 'updateCreditType',
  VoidOrder = 'voidOrder',
  VoidPurchaseCredit = 'voidPurchaseCredit',
  VoidWithdrawCredit = 'voidWithdrawCredit',
  WithdrawCredit = 'withdrawCredit'
}

export type CreditPackage = {
  __typename?: 'CreditPackage';
  apcCatCodeForFee: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  createdDate: Scalars['String']['output'];
  creditAmount: Scalars['Float']['output'];
  creditType?: Maybe<CreditType>;
  creditTypeId?: Maybe<Scalars['Int']['output']>;
  dept?: Maybe<Department>;
  deptId: Scalars['Int']['output'];
  expiryDays: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isWebEnable: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type CreditTotalPerType = {
  __typename?: 'CreditTotalPerType';
  creditMovementType: CreditMovementType;
  total: Scalars['Float']['output'];
};

export type CreditTx = {
  __typename?: 'CreditTx';
  amount: Scalars['Float']['output'];
  createdDate: Scalars['String']['output'];
  creditMovementType: CreditMovementType;
  creditPackage?: Maybe<CreditPackage>;
  creditPackageId?: Maybe<Scalars['Int']['output']>;
  creditTxUsageList?: Maybe<Array<CreditTxUsage>>;
  creditType?: Maybe<CreditType>;
  creditTypeId?: Maybe<Scalars['Int']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  myorder?: Maybe<Myorder>;
  myorderId?: Maybe<Scalars['Int']['output']>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  remark: Scalars['String']['output'];
  txBalance: Scalars['Float']['output'];
  updatedDate: Scalars['String']['output'];
};

export type CreditTxUsage = {
  __typename?: 'CreditTxUsage';
  amount: Scalars['Float']['output'];
  childCreditTx?: Maybe<CreditTx>;
  childCreditTxId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  parentCreditTx?: Maybe<CreditTx>;
  parentCreditTxId: Scalars['Int']['output'];
};

export type CreditType = {
  __typename?: 'CreditType';
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  defaultExpiryDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  myorderItemTypeList: Array<CreditTypeMyorderItemType>;
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type CreditTypeMyorderItemType = {
  __typename?: 'CreditTypeMyorderItemType';
  createdDate: Scalars['String']['output'];
  creditTypeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  myorderItemType: MyorderItemType;
  updatedDate: Scalars['String']['output'];
};

export type CustomSearchLockerInput = {
  deptId: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<LockerStatus>;
};

export type DailyDepositBalancePerItemResGql = {
  __typename?: 'DailyDepositBalancePerItemResGql';
  accessPass?: Maybe<AccessPass>;
  added: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  carriedForward: Scalars['Float']['output'];
  forfeited: Scalars['Float']['output'];
  lockerGroup?: Maybe<LockerGroup>;
  refunded: Scalars['Float']['output'];
};

export type DailyDepositBalanceResGql = {
  __typename?: 'DailyDepositBalanceResGql';
  accessPassBalanceList: Array<DailyDepositBalancePerItemResGql>;
  accessPassTotalAdded: Scalars['Float']['output'];
  accessPassTotalBalance: Scalars['Float']['output'];
  accessPassTotalCarriedForward: Scalars['Float']['output'];
  accessPassTotalForfeited: Scalars['Float']['output'];
  accessPassTotalRefunded: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  lockerBalanceList: Array<DailyDepositBalancePerItemResGql>;
  lockerTotalAdded: Scalars['Float']['output'];
  lockerTotalBalance: Scalars['Float']['output'];
  lockerTotalCarriedForward: Scalars['Float']['output'];
  lockerTotalForfeited: Scalars['Float']['output'];
  lockerTotalRefunded: Scalars['Float']['output'];
  totalAdded: Scalars['Float']['output'];
  totalBalance: Scalars['Float']['output'];
  totalCarriedForward: Scalars['Float']['output'];
  totalForfeited: Scalars['Float']['output'];
  totalRefunded: Scalars['Float']['output'];
};

export type DeleteAccessPassFacilityAccessRelInput = {
  accessPassId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteAccessPassInput = {
  id: Scalars['Int']['input'];
};

export type DeleteAccessPassOptionInput = {
  accessPassId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteAccessPassToBonusPointEarningRuleInput = {
  id: Scalars['Int']['input'];
};

export type DeleteAcctProductCatInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBlackoutInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBonusPointEarningRuleCourseInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBonusPointEarningRuleFacilityBookingInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBonusPointEarningRuleInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBonusPointEarningRuleLockerInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBonusPointEarningRuleMyEventInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBonusPointEarningRuleNthOrderInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBonusPointEarningRuleProductInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBonusPointItemTypeEarningRatioInput = {
  id: Scalars['Int']['input'];
};

export type DeleteBookingActAsAdminInput = {
  facilityBookingId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
  quickActAdminCode: Scalars['String']['input'];
};

export type DeleteBookingInput = {
  facilityBookingId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
};

export type DeleteCheckInDeviceInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCoachSalaryContractTermsInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCoachSalaryReportCoachAdjustmentInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCoachSalaryReportInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCoachServiceInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCoachTimeSlotInput = {
  coachId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteCommitteeHistoryInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCommitteeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCommitteePositionInput = {
  id: Scalars['Int']['input'];
};

export type DeleteContactInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCouponCodeToBonusPointEarningRuleInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCouponPackageCoachServiceRelInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCouponPackageFacilityRelInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCouponPackageInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCourseApplyQuotaPeriodInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCourseEnrolmentForTrialMemberInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCourseInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCourseInvitationCodeInput = {
  courseOrgInvitationCodeRelId: Scalars['Int']['input'];
};

export type DeleteCourseTypeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCreditPackageInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCreditTypeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteDefaultFacilityFeeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteDepartmentInput = {
  id: Scalars['Int']['input'];
};

export type DeleteDocxTemplateInput = {
  id: Scalars['Int']['input'];
};

export type DeleteDriveTeamInput = {
  id: Scalars['Int']['input'];
};

export type DeleteFabFloorplanInput = {
  id: Scalars['Int']['input'];
};

export type DeleteFabFloorplanPeriodInput = {
  id: Scalars['Int']['input'];
};

export type DeleteFabTableInput = {
  id: Scalars['Int']['input'];
};

export type DeleteFacilityAccessPassDependencyInput = {
  facilityId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteFacilityAccessPassLeadTimeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteFacilityAccessPassNoOfTimeslotInput = {
  id: Scalars['Int']['input'];
};

export type DeleteFacilityBookingOnlyOpenWhenAllBookedExceptTimeslotInput = {
  facilityId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteFacilityFeeInput = {
  facilityId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DeleteHolidayInput = {
  id: Scalars['Int']['input'];
};

export type DeleteKwtdhcMemberFollowupInput = {
  id: Scalars['Int']['input'];
};

export type DeleteLessonEnrolmentForTrialMemberInput = {
  id: Scalars['Int']['input'];
};

export type DeleteLessonInput = {
  courseId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
};

export type DeleteLocationAreaInput = {
  id: Scalars['Int']['input'];
};

export type DeleteLocationInput = {
  id: Scalars['Int']['input'];
};

export type DeleteLockerGroupFeeInput = {
  id: Scalars['Int']['input'];
  lockerGroupId: Scalars['Int']['input'];
};

export type DeleteLockerGroupInput = {
  id: Scalars['Int']['input'];
};

export type DeleteLockerGroupWaitingListInput = {
  lockerGroupId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type DeleteLockerTypeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteMemberFromCourseMemberListInput = {
  courseId: Scalars['Int']['input'];
  courseMemberListType: CourseMemberListType;
  memberIdList: Array<Scalars['Int']['input']>;
};

export type DeleteMemberListAsCourseMemberListFromCourseInput = {
  courseId: Scalars['Int']['input'];
  memberListAsCourseMemberListType: MemberListAsCourseMemberListType;
  memberListId: Scalars['Int']['input'];
};

export type DeleteMemberListAsRecurCourseMemberListFromCourseInput = {
  memberListAsCourseMemberListType: MemberListAsCourseMemberListType;
  memberListId: Scalars['Int']['input'];
  recurCourseId: Scalars['Int']['input'];
};

export type DeleteMemberListInput = {
  id: Scalars['Int']['input'];
};

export type DeleteMemberListMemberInput = {
  id: Scalars['Int']['input'];
  memberListId: Scalars['Int']['input'];
};

export type DeleteMemberRelationshipInput = {
  memberRelationshipId: Scalars['Int']['input'];
};

export type DeleteMembershipTypeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteMiniSiteContentInput = {
  id: Scalars['Int']['input'];
};

export type DeleteMyEventInput = {
  id: Scalars['Int']['input'];
};

export type DeleteMyEventTicketSeatInput = {
  endSeatNo: Scalars['Int']['input'];
  myEventId: Scalars['Int']['input'];
  myEventTicketTypeId: Scalars['Int']['input'];
  startSeatNo: Scalars['Int']['input'];
};

export type DeleteMyEventTicketTypeInput = {
  id: Scalars['Int']['input'];
  myEventId: Scalars['Int']['input'];
};

export type DeleteNewsInput = {
  id: Scalars['Int']['input'];
};

export type DeleteOrganizationInput = {
  id: Scalars['Int']['input'];
};

export type DeleteOverrideLotteryGroupScoreInput = {
  id: Scalars['Int']['input'];
};

export type DeletePassKeyInput = {
  id: Scalars['Int']['input'];
};

export type DeleteProductCatInput = {
  id: Scalars['Int']['input'];
};

export type DeleteProductFromUserProductGroupInput = {
  id: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};

export type DeleteProductInput = {
  id: Scalars['Int']['input'];
};

export type DeleteRecurCourseInput = {
  id: Scalars['Int']['input'];
};

export type DeleteRoleTemplateInput = {
  id: Scalars['Int']['input'];
};

export type DeleteSportTypeGroupInput = {
  id: Scalars['Int']['input'];
};

export type DeleteSportTypeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteSwpTestCardQrCodeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteTextTemplateInput = {
  id: Scalars['Int']['input'];
};

export type DeleteTimeSlotProgramGroupInput = {
  id: Scalars['Int']['input'];
};

export type DeleteTimeSlotProgramInput = {
  id: Scalars['Int']['input'];
};

export type DeleteTimeSlotProgramLocationInput = {
  id: Scalars['Int']['input'];
};

export type DeleteTimeSlotProgramOpeningHourInput = {
  id: Scalars['Int']['input'];
};

export type DeleteTimeSlotProgramServiceTypeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteTimeSlotProgramSummaryUserInput = {
  timeSlotProgramId: Scalars['Int']['input'];
  userIdList: Array<Scalars['Int']['input']>;
};

export type DeleteTimeslotProgramGridHourInput = {
  id: Scalars['Int']['input'];
};

export type DeleteTmpHoldBookingInput = {
  facilityBookingId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
};

export type DeleteUserCoachServiceRelInput = {
  coachServiceId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type DeleteUserInput = {
  id: Scalars['Int']['input'];
};

export type DeleteUserProductGroupInput = {
  id: Scalars['Int']['input'];
};

export type DeleteWarehouseInput = {
  id: Scalars['Int']['input'];
};

export type DeleteWarehousePartitionInput = {
  id: Scalars['Int']['input'];
};

export type DeleteWarehouseStockTakeInput = {
  id: Scalars['Int']['input'];
};

export type DeliveryNote = {
  __typename?: 'DeliveryNote';
  confirmReceivedByUser?: Maybe<User>;
  confirmReceivedByUserId?: Maybe<Scalars['Int']['output']>;
  confirmReceivedDate?: Maybe<Scalars['String']['output']>;
  confirmShippedByUser?: Maybe<User>;
  confirmShippedByUserId?: Maybe<Scalars['Int']['output']>;
  confirmShippedDate?: Maybe<Scalars['String']['output']>;
  dnNo?: Maybe<Scalars['String']['output']>;
  dnTxList?: Maybe<Array<DeliveryNoteTx>>;
  expectedDeliveryDate?: Maybe<Scalars['String']['output']>;
  goodsReceiveNote?: Maybe<GoodsReceiveNote>;
  goodsReceiveNoteId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inventoryRequest?: Maybe<InventoryRequest>;
  inventoryRequestId: Scalars['Int']['output'];
  inventoryTxGroup?: Maybe<InventoryTxGroup>;
  inventoryTxGroupId: Scalars['Int']['output'];
  isConfirmReceived: Scalars['Boolean']['output'];
  isConfirmShipped: Scalars['Boolean']['output'];
};

export type DeliveryNoteTx = {
  __typename?: 'DeliveryNoteTx';
  confirmReceivedQty?: Maybe<Scalars['Int']['output']>;
  confirmShippedQty?: Maybe<Scalars['Int']['output']>;
  deliveryNote?: Maybe<DeliveryNote>;
  deliveryNoteId: Scalars['Int']['output'];
  goodsReceiveNoteTx?: Maybe<GoodsReceiveNoteTx>;
  id: Scalars['Int']['output'];
  inventoryRequestTx?: Maybe<InventoryRequestTx>;
  inventoryRequestTxId: Scalars['Int']['output'];
  plannedQty?: Maybe<Scalars['Int']['output']>;
};

export type Department = {
  __typename?: 'Department';
  aspenId: Scalars['String']['output'];
  bonusPointReceiptRegRatio: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  forReceiptReg: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  receiveOrderEmail: Scalars['Boolean']['output'];
  shortCode: Scalars['String']['output'];
  telNo: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  warehouseList?: Maybe<Array<Warehouse>>;
};

export type DepositHistory = {
  __typename?: 'DepositHistory';
  accessPass?: Maybe<AccessPass>;
  accessPassId?: Maybe<Scalars['Int']['output']>;
  amount: Scalars['Float']['output'];
  carriedForwardDate?: Maybe<Scalars['String']['output']>;
  carriedForwardFromId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  depositType: DepositType;
  forfeitDate: Scalars['String']['output'];
  forfeitMyorder?: Maybe<Myorder>;
  forfeitMyorderItemId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  locker?: Maybe<Locker>;
  lockerGroup?: Maybe<LockerGroup>;
  lockerId?: Maybe<Scalars['Int']['output']>;
  mainMemberId?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myorder?: Maybe<Myorder>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  org?: Maybe<Organization>;
  orgId?: Maybe<Scalars['Int']['output']>;
  phoneBookingDepositOldInvoiceNo?: Maybe<Scalars['String']['output']>;
  phoneBookingRefundOldInvoiceNo?: Maybe<Scalars['String']['output']>;
  refOldBalance?: Maybe<Scalars['Int']['output']>;
  refundMyorder?: Maybe<Myorder>;
  refundMyorderItemId?: Maybe<Scalars['Int']['output']>;
  refundedDate?: Maybe<Scalars['String']['output']>;
  status: DepositStatus;
  targetHistoryId?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['String']['output'];
};

export enum DepositStatus {
  Active = 'active',
  CarriedForward = 'carriedForward',
  Forfeited = 'forfeited',
  Refunded = 'refunded'
}

export type DepositSummaryResGql = {
  __typename?: 'DepositSummaryResGql';
  accessPassTotalAdded: Scalars['Float']['output'];
  accessPassTotalCarriedForward: Scalars['Float']['output'];
  accessPassTotalForfeited: Scalars['Float']['output'];
  accessPassTotalRefunded: Scalars['Float']['output'];
  lockerTotalAdded: Scalars['Float']['output'];
  lockerTotalCarriedForward: Scalars['Float']['output'];
  lockerTotalForfeited: Scalars['Float']['output'];
  lockerTotalRefunded: Scalars['Float']['output'];
  totalAdded: Scalars['Float']['output'];
  totalCarriedForward: Scalars['Float']['output'];
  totalForfeited: Scalars['Float']['output'];
  totalRefunded: Scalars['Float']['output'];
};

export enum DepositType {
  AccessPass = 'accessPass',
  Locker = 'locker'
}

export type DeptBorrowSummary = {
  __typename?: 'DeptBorrowSummary';
  createdDate: Scalars['String']['output'];
  fromDept?: Maybe<Department>;
  fromDeptId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productId: Scalars['Int']['output'];
  qty: Scalars['Int']['output'];
  scrapedQty: Scalars['Int']['output'];
  toDept?: Maybe<Department>;
  toDeptId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type DeptConfirmCoachSalaryReportInput = {
  id: Scalars['Int']['input'];
};

export type DeptGetCoachSalaryReportListInput = {
  deptId: Scalars['Int']['input'];
};

export type District = {
  __typename?: 'District';
  aspenCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  memberLocationId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  subDistrictList?: Maybe<Array<SubDistrict>>;
};

export type DocxTemplate = {
  __typename?: 'DocxTemplate';
  createdDate: Scalars['String']['output'];
  docType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  myfile?: Maybe<Myfile>;
  myfileId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  shareTo: ShareTo;
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type DriveDepositHistory = {
  __typename?: 'DriveDepositHistory';
  amount: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  createdDate: Scalars['String']['output'];
  drivePhase: Scalars['Int']['output'];
  driveYear: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  membershipType?: Maybe<MembershipType>;
  membershipTypeId?: Maybe<Scalars['Int']['output']>;
  myorder?: Maybe<Myorder>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  spentByMember?: Maybe<FullMember>;
  spentByMemberId?: Maybe<Scalars['Int']['output']>;
  type: DriveDepositType;
  updatedDate: Scalars['String']['output'];
};

export enum DriveDepositType {
  Cancelled = 'cancelled',
  Deposit = 'deposit',
  Donation = 'donation',
  OldDeposit = 'oldDeposit',
  Refunded = 'refunded',
  Spend = 'spend',
  Void = 'void'
}

export type DriveMemberRankResGql = {
  __typename?: 'DriveMemberRankResGql';
  driveMember: FullMember;
  totalMemberCount: Scalars['Float']['output'];
  totalScore: Scalars['Float']['output'];
};

export type DriveScoreHistory = {
  __typename?: 'DriveScoreHistory';
  createdDate: Scalars['String']['output'];
  driveDepositHistory?: Maybe<DriveDepositHistory>;
  driveDepositHistoryId?: Maybe<Scalars['Int']['output']>;
  driveMember?: Maybe<FullMember>;
  driveMemberId?: Maybe<Scalars['Int']['output']>;
  drivePhase: Scalars['Int']['output'];
  driveTeam?: Maybe<DriveTeam>;
  driveTeamId?: Maybe<Scalars['Int']['output']>;
  driveYear: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastModifyUserId: Scalars['Int']['output'];
  memberCount: Scalars['Int']['output'];
  memberId?: Maybe<Scalars['Int']['output']>;
  membershipType?: Maybe<MembershipType>;
  membershipTypeId?: Maybe<Scalars['Int']['output']>;
  myorder?: Maybe<Myorder>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  scoreByMember?: Maybe<FullMember>;
  scoreCount: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type DriveTeam = {
  __typename?: 'DriveTeam';
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  leader?: Maybe<FullMember>;
  memberList?: Maybe<Array<FullMember>>;
  name: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type DriveTeamRankResGql = {
  __typename?: 'DriveTeamRankResGql';
  driveTeam: DriveTeam;
  totalScore: Scalars['Float']['output'];
};

export type DuplicateFacilityInput = {
  srcFacilityId: Scalars['Int']['input'];
};

export type DuplicateTimeSlotProgramInput = {
  id: Scalars['Int']['input'];
};

export type DynamicQrCode = {
  __typename?: 'DynamicQrCode';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  type: DynamicQrCodeType;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  validUntilDateTime: Scalars['String']['output'];
};

export enum DynamicQrCodeType {
  Staff = 'staff',
  SwpTest = 'swpTest'
}

export enum EnrolmentStatus {
  Applied = 'applied',
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Held = 'held',
  Refunded = 'refunded',
  Rejected = 'rejected',
  Waiting = 'waiting'
}

export enum EnrolmentStatusActionType {
  AddToWaitingList = 'addToWaitingList',
  Apply = 'apply',
  Cancel = 'cancel',
  Confirm = 'confirm',
  Held = 'held',
  Reject = 'reject',
  Withdraw = 'withdraw'
}

export type EquipmentWithBookingCountResGql = {
  __typename?: 'EquipmentWithBookingCountResGql';
  bookingCount: Scalars['Int']['output'];
  equipment: Facility;
  isAvaliable: Scalars['Boolean']['output'];
};

export type FabFloorplan = {
  __typename?: 'FabFloorplan';
  createdDate: Scalars['String']['output'];
  fabFloorplanPeriodList?: Maybe<Array<FabFloorplanPeriod>>;
  fabFloorplanRequest?: Maybe<FabFloorplanRequest>;
  fabTableList?: Maybe<Array<FabTable>>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['Int']['output'];
};

export type FabFloorplanPeriod = {
  __typename?: 'FabFloorplanPeriod';
  defaultMealMins: Scalars['Int']['output'];
  defaultTimeslotMins: Scalars['Int']['output'];
  endTime: Scalars['String']['output'];
  fabFloorplan?: Maybe<FabFloorplan>;
  fabFloorplanId: Scalars['Int']['output'];
  groupName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  mustBookWholePeriod: Scalars['Boolean']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type FabFloorplanRequest = {
  __typename?: 'FabFloorplanRequest';
  fabFloorplan?: Maybe<FabFloorplan>;
  fabFloorplanId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  request1en: Scalars['String']['output'];
  request1sc: Scalars['String']['output'];
  request1tc: Scalars['String']['output'];
  request2en: Scalars['String']['output'];
  request2sc: Scalars['String']['output'];
  request2tc: Scalars['String']['output'];
  request3en: Scalars['String']['output'];
  request3sc: Scalars['String']['output'];
  request3tc: Scalars['String']['output'];
  request4en: Scalars['String']['output'];
  request4sc: Scalars['String']['output'];
  request4tc: Scalars['String']['output'];
  request5en: Scalars['String']['output'];
  request5sc: Scalars['String']['output'];
  request5tc: Scalars['String']['output'];
  request6en: Scalars['String']['output'];
  request6sc: Scalars['String']['output'];
  request6tc: Scalars['String']['output'];
  request7en: Scalars['String']['output'];
  request7sc: Scalars['String']['output'];
  request7tc: Scalars['String']['output'];
  request8en: Scalars['String']['output'];
  request8sc: Scalars['String']['output'];
  request8tc: Scalars['String']['output'];
  request9en: Scalars['String']['output'];
  request9sc: Scalars['String']['output'];
  request9tc: Scalars['String']['output'];
};

export type FabReservation = {
  __typename?: 'FabReservation';
  assignStatus: FabReservationAssignStatus;
  bookingEndDateTime?: Maybe<Scalars['String']['output']>;
  bookingStartDateTime?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  depositPaid: Scalars['Int']['output'];
  fabFloorplan?: Maybe<FabFloorplan>;
  fabFloorplanId: Scalars['Int']['output'];
  fabFloorplanPeriod?: Maybe<FabFloorplanPeriod>;
  fabFloorplanPeriodId?: Maybe<Scalars['Int']['output']>;
  fabReservationTableRelList?: Maybe<Array<FabReservationTableRel>>;
  history: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isRequest1: Scalars['Boolean']['output'];
  isRequest2: Scalars['Boolean']['output'];
  isRequest3: Scalars['Boolean']['output'];
  isRequest4: Scalars['Boolean']['output'];
  isRequest5: Scalars['Boolean']['output'];
  isRequest6: Scalars['Boolean']['output'];
  isRequest7: Scalars['Boolean']['output'];
  isRequest8: Scalars['Boolean']['output'];
  isRequest9: Scalars['Boolean']['output'];
  isWalkIn: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  mobileNo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  org?: Maybe<Organization>;
  orgId?: Maybe<Scalars['Int']['output']>;
  status: FabReservationStatus;
  totalNoOfSeats: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export enum FabReservationAssignStatus {
  Assigned = 'assigned',
  PartialAssigned = 'partialAssigned',
  Unassigned = 'unassigned'
}

export type FabReservationStatsPerDay = {
  __typename?: 'FabReservationStatsPerDay';
  createdDate: Scalars['String']['output'];
  cutoffDate: Scalars['String']['output'];
  deltaOfReservation: Scalars['Float']['output'];
  fabFloorplan?: Maybe<FabFloorplan>;
  fabFloorplanId?: Maybe<Scalars['Int']['output']>;
  fabFloorplanPeriodGroupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  noOfArrived: Scalars['Float']['output'];
  noOfBooked: Scalars['Int']['output'];
  noOfCancelled: Scalars['Int']['output'];
  noOfComingGuest: Scalars['Float']['output'];
  noOfFinished: Scalars['Int']['output'];
  noOfGuest: Scalars['Int']['output'];
  noOfNoShow: Scalars['Int']['output'];
  noOfReservation: Scalars['Int']['output'];
  noOfWalkIn: Scalars['Int']['output'];
  pctOfCancelled: Scalars['Int']['output'];
  pctOfFinished: Scalars['Int']['output'];
  pctOfNoShow: Scalars['Int']['output'];
  pctOfWalkIn: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type FabReservationStatsPerDayOneDayResGql = {
  __typename?: 'FabReservationStatsPerDayOneDayResGql';
  cutoffDate: Scalars['String']['output'];
  stats: FabReservationStatsPerDay;
};

export type FabReservationStatsPerMonth = {
  __typename?: 'FabReservationStatsPerMonth';
  createdDate: Scalars['String']['output'];
  deltaOfReservation: Scalars['Int']['output'];
  fabFloorplan?: Maybe<FabFloorplan>;
  fabFloorplanId?: Maybe<Scalars['Int']['output']>;
  fabFloorplanPeriodGroupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  noOfBooked: Scalars['Int']['output'];
  noOfCancelled: Scalars['Int']['output'];
  noOfFinished: Scalars['Int']['output'];
  noOfGuest: Scalars['Int']['output'];
  noOfNoShow: Scalars['Int']['output'];
  noOfReservation: Scalars['Int']['output'];
  noOfWalkIn: Scalars['Int']['output'];
  pctOfCancelled: Scalars['Int']['output'];
  pctOfFinished: Scalars['Int']['output'];
  pctOfNoShow: Scalars['Int']['output'];
  pctOfWalkIn: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type FabReservationStatsPerMonthOneMonthResGql = {
  __typename?: 'FabReservationStatsPerMonthOneMonthResGql';
  month: Scalars['Float']['output'];
  stats: FabReservationStatsPerMonth;
  year: Scalars['Float']['output'];
};

export enum FabReservationStatus {
  Arrived = 'arrived',
  Booked = 'booked',
  Cancel = 'cancel',
  Finished = 'finished',
  InProgress = 'inProgress',
  Noshow = 'noshow',
  Unassigned = 'unassigned',
  WaitingList = 'waitingList'
}

export type FabReservationTableRel = {
  __typename?: 'FabReservationTableRel';
  endDateTime?: Maybe<Scalars['String']['output']>;
  fabReservation?: Maybe<FabReservation>;
  fabReservationId: Scalars['Int']['output'];
  fabTable?: Maybe<FabTable>;
  fabTableId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  noOfSeats: Scalars['Float']['output'];
  startDateTime?: Maybe<Scalars['String']['output']>;
  sysEndDateTime?: Maybe<Scalars['String']['output']>;
  sysStartDateTime?: Maybe<Scalars['String']['output']>;
  tableStatus: FabReservationStatus;
};

export type FabSwapTablesInput = {
  fabReservationId1: Scalars['Int']['input'];
  fabReservationId2: Scalars['Int']['input'];
  ignoreConflict: Scalars['Boolean']['input'];
  ignoreSameDayCheck: Scalars['Boolean']['input'];
  ignoreSameFloorplanCheck: Scalars['Boolean']['input'];
  ignoreSeatsCheck: Scalars['Boolean']['input'];
};

export type FabTable = {
  __typename?: 'FabTable';
  fabFloorplan?: Maybe<FabFloorplan>;
  fabFloorplanId: Scalars['Int']['output'];
  fabReservationTableRelList?: Maybe<Array<FabReservationTableRel>>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  noOfSeats: Scalars['Int']['output'];
  shape: FabTableShape;
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export enum FabTableShape {
  Circle = 'circle',
  Square = 'square'
}

export type FabTableTimeslotResGql = {
  __typename?: 'FabTableTimeslotResGql';
  timeslotList: Array<FabTimeslotResGql>;
};

export type FabTimeslotCellResGql = {
  __typename?: 'FabTimeslotCellResGql';
  periodList: Array<FabFloorplanPeriod>;
  reservationList: Array<Maybe<FabReservation>>;
};

export type FabTimeslotHourRowResGql = {
  __typename?: 'FabTimeslotHourRowResGql';
  isEnableList: Array<Scalars['Boolean']['output']>;
  time: Scalars['String']['output'];
  timeslotCellList: Array<FabTimeslotCellResGql>;
};

export type FabTimeslotHourRowV2ResGql = {
  __typename?: 'FabTimeslotHourRowV2ResGql';
  enable: Scalars['Boolean']['output'];
  tableTimeslotList: Array<FabTableTimeslotResGql>;
  time: Scalars['String']['output'];
};

export type FabTimeslotPeriodResGql = {
  __typename?: 'FabTimeslotPeriodResGql';
  hourRowList: Array<FabTimeslotHourRowResGql>;
  period: FabFloorplanPeriod;
};

export type FabTimeslotResGql = {
  __typename?: 'FabTimeslotResGql';
  endDateTime: Scalars['String']['output'];
  period?: Maybe<FabFloorplanPeriod>;
  rel?: Maybe<FabReservationTableRel>;
  startDateTime: Scalars['String']['output'];
};

export type FacialTerminal = {
  __typename?: 'FacialTerminal';
  activeDaysToKeep: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  facialUploadBaseurl: Scalars['String']['output'];
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  mustAllowExit: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type Facility = {
  __typename?: 'Facility';
  accessPassDependencyList?: Maybe<Array<AccessPass>>;
  activeBonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  advanceBookingChargeRule: Scalars['Boolean']['output'];
  allowInternalBooking: Scalars['Boolean']['output'];
  apcAdvanceBookingCharge?: Maybe<AcctProductCat>;
  apcCatCodeForAdvanceBookingCharge: Scalars['String']['output'];
  apcCatCodeForFee: Scalars['String']['output'];
  apcCatCodeForLateCharge: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  apcLateCharge?: Maybe<AcctProductCat>;
  aspenId: Scalars['String']['output'];
  bonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  bookingOnlyOpenWhenAllBookedExceptTimeslotList?: Maybe<Array<FacilityBookingOnlyOpenWhenAllBookedExceptTimeslot>>;
  bookingOnlyOpenWhenAllBookedFacilityList?: Maybe<Array<Facility>>;
  bookingRelatedFacilityList?: Maybe<Array<Facility>>;
  coachServiceList?: Maybe<Array<CoachService>>;
  createdDate: Scalars['String']['output'];
  customType: Scalars['String']['output'];
  defaultFeeForDept: Scalars['Float']['output'];
  defaultFeeForGroup: Scalars['Float']['output'];
  defaultFeeForMember: Scalars['Float']['output'];
  defaultFeeForRegBody: Scalars['Float']['output'];
  department?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  enableForWeb: Scalars['Boolean']['output'];
  endTime: Scalars['String']['output'];
  equipmentList?: Maybe<Array<Facility>>;
  facilityAccessPassLeadTimeList?: Maybe<Array<FacilityAccessPassLeadTime>>;
  facilityAccessPassNoOfTimeslotList?: Maybe<Array<FacilityAccessPassNoOfTimeslot>>;
  facilityAvailableToFacilityList?: Maybe<Array<Facility>>;
  facilityFeeList?: Maybe<Array<FacilityFee>>;
  facilityGroupCode: Scalars['String']['output'];
  facilityManagerList: Array<FullUser>;
  gridDisplayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  ignoreLeadTimeCheckInPos: Scalars['Boolean']['output'];
  isEnable: Scalars['Boolean']['output'];
  lastModifyUserId: Scalars['Int']['output'];
  locationArea?: Maybe<LocationArea>;
  locationAreaId: Scalars['Int']['output'];
  maxLeadTimeInDays: Scalars['Int']['output'];
  maxNoOfTimeslot: Scalars['Int']['output'];
  maxNoOfTimeslotForPeakHour: Scalars['Int']['output'];
  minLeadTimeInDays: Scalars['Int']['output'];
  minNoOfTimeslot: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  noSameDayBookingRule: Scalars['Boolean']['output'];
  noSameTimeBookingRule: Scalars['Boolean']['output'];
  openForMemberBooking: Scalars['Boolean']['output'];
  openForUserBooking: Scalars['Boolean']['output'];
  quota: Scalars['Int']['output'];
  refCapacity: Scalars['String']['output'];
  requiredNoOfMembers: Scalars['Int']['output'];
  revenueDeptId?: Maybe<Scalars['Int']['output']>;
  shortCode: Scalars['String']['output'];
  sportTypeId?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['String']['output'];
  systemType: FacilitySystemType;
  timeSlotMins: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  youtubeId: Scalars['String']['output'];
};

export type FacilityAccessLog = {
  __typename?: 'FacilityAccessLog';
  accessDateTime: Scalars['String']['output'];
  accessPassOption?: Maybe<AccessPassOption>;
  accessPassOptionId?: Maybe<Scalars['Int']['output']>;
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  gateCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isSuccess: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myEvent?: Maybe<MyEvent>;
  myEventId?: Maybe<Scalars['Int']['output']>;
  result: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type FacilityAccessPassDependency = {
  __typename?: 'FacilityAccessPassDependency';
  accessPass?: Maybe<AccessPass>;
  accessPassId: Scalars['Int']['output'];
  dayType: WeekdayType;
  endTime: Scalars['String']['output'];
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
};

export type FacilityAccessPassLeadTime = {
  __typename?: 'FacilityAccessPassLeadTime';
  accessPass?: Maybe<AccessPass>;
  accessPassId: Scalars['Int']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  maxLeadTimeInDays: Scalars['Int']['output'];
  minLeadTimeInDays: Scalars['Int']['output'];
};

export type FacilityAccessPassNoOfTimeslot = {
  __typename?: 'FacilityAccessPassNoOfTimeslot';
  accessPass?: Maybe<AccessPass>;
  accessPassId: Scalars['Int']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  maxNoOfTimeslot: Scalars['Int']['output'];
  maxNoOfTimeslotForPeakHour: Scalars['Int']['output'];
  minNoOfTimeslot: Scalars['Int']['output'];
};

export type FacilityBlackout = {
  __typename?: 'FacilityBlackout';
  bookingList?: Maybe<Array<FacilityBooking>>;
  createdDate: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  eventCode: Scalars['String']['output'];
  facilityList?: Maybe<Array<Facility>>;
  fri: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  mon: Scalars['Boolean']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  org?: Maybe<Organization>;
  orgId?: Maybe<Scalars['Int']['output']>;
  remark: Scalars['String']['output'];
  sat: Scalars['Boolean']['output'];
  startDate: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  sun: Scalars['Boolean']['output'];
  thu: Scalars['Boolean']['output'];
  tue: Scalars['Boolean']['output'];
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  wed: Scalars['Boolean']['output'];
};

export type FacilityBooking = {
  __typename?: 'FacilityBooking';
  blackout?: Maybe<FacilityBlackout>;
  blackoutId?: Maybe<Scalars['Int']['output']>;
  bookingType: FacilityBookingType;
  checkInDateTime?: Maybe<Scalars['String']['output']>;
  checkInDeviceId?: Maybe<Scalars['Int']['output']>;
  checkInMode?: Maybe<CheckInMode>;
  checkInUser?: Maybe<User>;
  checkInUserId?: Maybe<Scalars['Int']['output']>;
  coach?: Maybe<User>;
  coachMyorder?: Maybe<Myorder>;
  coachMyorderItem?: Maybe<MyorderItem>;
  coachMyorderItemId?: Maybe<Scalars['Int']['output']>;
  confirmedByUserId?: Maybe<Scalars['Int']['output']>;
  conflictRemark?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Course>;
  createdDate: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  endDateTime: Scalars['String']['output'];
  eventCode: Scalars['String']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  fileList?: Maybe<Array<Myfile>>;
  id: Scalars['Int']['output'];
  lesson?: Maybe<Lesson>;
  lessonId?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myEvent?: Maybe<MyEvent>;
  myEventId?: Maybe<Scalars['Int']['output']>;
  myorder?: Maybe<Myorder>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  note: Scalars['String']['output'];
  org?: Maybe<Organization>;
  orgId?: Maybe<Scalars['Int']['output']>;
  otherMemberList?: Maybe<Array<Member>>;
  parentBooking?: Maybe<FacilityBooking>;
  parentBookingId?: Maybe<Scalars['Int']['output']>;
  qty: Scalars['Int']['output'];
  rejectReason: Scalars['String']['output'];
  relatedBookingList?: Maybe<Array<FacilityBooking>>;
  remark: Scalars['String']['output'];
  startDateTime: Scalars['String']['output'];
  status: FacilityBookingStatus;
  timeSlotProgram?: Maybe<TimeSlotProgram>;
  timeSlotProgramId?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type FacilityBookingDailyTimeSlotResGql = {
  __typename?: 'FacilityBookingDailyTimeSlotResGql';
  facilityId: Scalars['Int']['output'];
  gridDisplayName: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  timeslotInfoList: Array<FacilityBookingTimeslotResGql>;
};

export type FacilityBookingOnlyOpenWhenAllBookedExceptTimeslot = {
  __typename?: 'FacilityBookingOnlyOpenWhenAllBookedExceptTimeslot';
  dayType: WeekdayType;
  endTime: Scalars['String']['output'];
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
};

export enum FacilityBookingStatus {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Held = 'held',
  Refunded = 'refunded',
  Rejected = 'rejected',
  Released = 'released',
  Requested = 'requested'
}

export type FacilityBookingSummaryLocationAreaInfoResGql = {
  __typename?: 'FacilityBookingSummaryLocationAreaInfoResGql';
  locationArea: LocationArea;
  noOfFacility: Scalars['Int']['output'];
};

export type FacilityBookingTimeslotResGql = {
  __typename?: 'FacilityBookingTimeslotResGql';
  bookingInfoList: Array<FacilityBooking>;
  endDateTime: Scalars['String']['output'];
  fee: Scalars['Float']['output'];
  isConflicted: Scalars['Boolean']['output'];
  isFree: Scalars['Boolean']['output'];
  isPeakHour: Scalars['Boolean']['output'];
  startDateTime: Scalars['String']['output'];
};

export enum FacilityBookingType {
  Blackout = 'blackout',
  Internal = 'internal',
  Lesson = 'lesson',
  MyEvent = 'myEvent',
  Normal = 'normal',
  Other = 'other',
  PrivateLesson = 'privateLesson',
  TimeSlotProgram = 'timeSlotProgram',
  TmpHold = 'tmpHold'
}

export type FacilityFee = {
  __typename?: 'FacilityFee';
  accessPass?: Maybe<AccessPass>;
  accessPassId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  dayList: Array<Scalars['String']['output']>;
  dayType: WeekdayType;
  disableForWeb: Scalars['Boolean']['output'];
  endTime: Scalars['String']['output'];
  facilityId: Scalars['Int']['output'];
  feeForDept: Scalars['Float']['output'];
  feeForGroup: Scalars['Float']['output'];
  feeForMember: Scalars['Float']['output'];
  feeForRegBody: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  isPeakHour: Scalars['Boolean']['output'];
  orderId: Scalars['Float']['output'];
  startTime: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type FacilityGroup = {
  __typename?: 'FacilityGroup';
  facilityGroupCode: Scalars['String']['output'];
  facilityList: Array<Facility>;
};

export type FacilityStatsDaily = {
  __typename?: 'FacilityStatsDaily';
  createdDate: Scalars['String']['output'];
  cutoffDate: Scalars['String']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  normalUsagePct: Scalars['Float']['output'];
  peakUsagePct: Scalars['Float']['output'];
  totalNoOfBooking: Scalars['Int']['output'];
  totalNoOfNormalBooking: Scalars['Int']['output'];
  totalNoOfPeakBooking: Scalars['Int']['output'];
  totalNormalUsageMins: Scalars['Int']['output'];
  totalPeakUsageMins: Scalars['Int']['output'];
  totalPossibleMins: Scalars['Int']['output'];
  totalPossibleNormalMins: Scalars['Int']['output'];
  totalPossiblePeakMins: Scalars['Int']['output'];
  totalUsageMins: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  usagePct: Scalars['Float']['output'];
};

export type FacilityStatsSummaryResGql = {
  __typename?: 'FacilityStatsSummaryResGql';
  createdDate: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  normalUsagePct: Scalars['Float']['output'];
  peakUsagePct: Scalars['Float']['output'];
  startDate: Scalars['String']['output'];
  totalNoOfBooking: Scalars['Int']['output'];
  totalNoOfNormalBooking: Scalars['Int']['output'];
  totalNoOfPeakBooking: Scalars['Int']['output'];
  totalNormalUsageMins: Scalars['Int']['output'];
  totalPeakUsageMins: Scalars['Int']['output'];
  totalPossibleMins: Scalars['Int']['output'];
  totalPossibleNormalMins: Scalars['Int']['output'];
  totalPossiblePeakMins: Scalars['Int']['output'];
  totalUsageMins: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  usagePct: Scalars['Float']['output'];
};

export enum FacilitySystemType {
  Equipment = 'equipment',
  Venue = 'venue'
}

export type FacilityTimeslotFeeResGql = {
  __typename?: 'FacilityTimeslotFeeResGql';
  endDateTime: Scalars['String']['output'];
  fee: Scalars['Float']['output'];
  isPeakHour: Scalars['Boolean']['output'];
  startDateTime: Scalars['String']['output'];
};

export type FacilityTimeslotResGql = {
  __typename?: 'FacilityTimeslotResGql';
  facility: Facility;
  timeslotResList: Array<TimeslotResGql>;
};

export enum FilterGender {
  Both = 'BOTH',
  F = 'F',
  M = 'M'
}

export type FinanceApproveRefundPayoutInput = {
  financeRemark?: InputMaybe<Scalars['String']['input']>;
  refundPayoutRequestId: Scalars['Int']['input'];
};

export type ForceDeleteMemberFaceFromTerminalInput = {
  executeImmdiately: Scalars['Boolean']['input'];
  facialTerminalId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type ForceUploadMemberFaceToTerminalInput = {
  executeImmdiately: Scalars['Boolean']['input'];
  facialTerminalId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type FreightCostSettingResGql = {
  __typename?: 'FreightCostSettingResGql';
  allowSelfPickup: Scalars['Boolean']['output'];
  allowShipping: Scalars['Boolean']['output'];
  freeShippingAmountIncludePhysicalProductOnly: Scalars['Boolean']['output'];
  minFreeShippingAmount: Scalars['Float']['output'];
  shippingFee: Scalars['Float']['output'];
};

export type FullMember = {
  __typename?: 'FullMember';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  address3: Scalars['String']['output'];
  address4: Scalars['String']['output'];
  address5: Scalars['String']['output'];
  addressCountry?: Maybe<Country>;
  addressCountryId?: Maybe<Scalars['Int']['output']>;
  ageGroup?: Maybe<AgeGroup>;
  allowToSelfCheckIn: Scalars['Boolean']['output'];
  aspenSeqNo?: Maybe<Scalars['String']['output']>;
  autoRenewNoOfTrial: Scalars['Int']['output'];
  autoRenewNotificationSentDateTime?: Maybe<Scalars['String']['output']>;
  birthDate: Scalars['String']['output'];
  bonusPoint: Scalars['Int']['output'];
  cardIssueDate?: Maybe<Scalars['String']['output']>;
  cardLostNo: Scalars['Int']['output'];
  cardReplacementNo: Scalars['Float']['output'];
  chineseName: Scalars['String']['output'];
  cleanUpDateTime?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  customString01: Scalars['String']['output'];
  customString02: Scalars['String']['output'];
  customString03: Scalars['String']['output'];
  customString04: Scalars['String']['output'];
  customString05: Scalars['String']['output'];
  customString06: Scalars['String']['output'];
  customString07: Scalars['String']['output'];
  customString08: Scalars['String']['output'];
  customString09: Scalars['String']['output'];
  customString10: Scalars['String']['output'];
  disableMemberLogin: Scalars['Boolean']['output'];
  disableNoShowPenaltyUntilDate?: Maybe<Scalars['String']['output']>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailReminderSent: Scalars['Boolean']['output'];
  emergencyContactName: Scalars['String']['output'];
  emergencyTel: Scalars['String']['output'];
  emergencyTelAreaCode: Scalars['String']['output'];
  enableAutoRenew: Scalars['Boolean']['output'];
  ethnicity: Scalars['String']['output'];
  favouriteSportId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<FilterGender>;
  givenName: Scalars['String']['output'];
  gpTokenList?: Maybe<Array<GpToken>>;
  hkid?: Maybe<Scalars['String']['output']>;
  hkidPartial: Scalars['String']['output'];
  homeTel: Scalars['String']['output'];
  homeTelAreaCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAddressIncorrect: Scalars['Boolean']['output'];
  isAddressIncorrectDate?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isBlacklisted: Scalars['Boolean']['output'];
  isBlacklistedDate?: Maybe<Scalars['String']['output']>;
  isConfidential: Scalars['Boolean']['output'];
  isConfidentialDate?: Maybe<Scalars['String']['output']>;
  isDeceased: Scalars['Boolean']['output'];
  isDeceasedDate?: Maybe<Scalars['String']['output']>;
  isImmigrated: Scalars['Boolean']['output'];
  isImmigratedDate?: Maybe<Scalars['String']['output']>;
  isSuspended: Scalars['Boolean']['output'];
  isSuspendedDate?: Maybe<Scalars['String']['output']>;
  isTmp: Scalars['Boolean']['output'];
  isValidMember: Scalars['Boolean']['output'];
  joinDate?: Maybe<Scalars['String']['output']>;
  languagePreference: LanguagePreference;
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  lastValidMembershipStartDate?: Maybe<Scalars['String']['output']>;
  latestMemberParQ?: Maybe<MemberParQ>;
  loginEmail?: Maybe<Scalars['String']['output']>;
  loginMobile?: Maybe<Scalars['String']['output']>;
  memDriveDepositTotal: Scalars['Float']['output'];
  memberCreditBalanceList?: Maybe<Array<MemberCreditBalance>>;
  memberLocation?: Maybe<MemberLocation>;
  memberLocationId?: Maybe<Scalars['Int']['output']>;
  memberPhoto?: Maybe<Myfile>;
  memberStripe?: Maybe<Array<MemberStripe>>;
  membershipDriveReferral?: Maybe<Member>;
  membershipDriveReferralId?: Maybe<Scalars['Int']['output']>;
  membershipDriveTeam?: Maybe<DriveTeam>;
  membershipDriveTeamId?: Maybe<Scalars['Int']['output']>;
  membershipExpiryDate?: Maybe<Scalars['String']['output']>;
  membershipNo: Scalars['String']['output'];
  membershipType?: Maybe<MembershipType>;
  membershipTypeId?: Maybe<Scalars['Int']['output']>;
  mobileTel: Scalars['String']['output'];
  mobileTelAreaCode: Scalars['String']['output'];
  msgPlatform?: Maybe<MsgPlatform>;
  myMgmReferralCode?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Country>;
  nationalityId?: Maybe<Scalars['Int']['output']>;
  officeTel: Scalars['String']['output'];
  officeTelAreaCode: Scalars['String']['output'];
  oldMembershipNo: Scalars['String']['output'];
  passKeyList: Array<PartialPassKey>;
  passport?: Maybe<Scalars['String']['output']>;
  passportExpiryDate?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  photoMyfileId?: Maybe<Scalars['Int']['output']>;
  printFormat: MemberNamePrintFormat;
  proofMyfileId?: Maybe<Scalars['Int']['output']>;
  pushReminderSent: Scalars['Boolean']['output'];
  referralMember?: Maybe<Member>;
  referralMemberId: Scalars['Int']['output'];
  referralOrg?: Maybe<Organization>;
  referralOrgId?: Maybe<Scalars['Int']['output']>;
  remark: Scalars['String']['output'];
  requireReview: Scalars['Boolean']['output'];
  searchKey: Scalars['String']['output'];
  smsReminderSent: Scalars['Boolean']['output'];
  studentExpiryDate?: Maybe<Scalars['String']['output']>;
  studentStatus?: Maybe<StudentStatus>;
  subDistrict?: Maybe<SubDistrict>;
  subDistrictId?: Maybe<Scalars['Int']['output']>;
  subscribeNews: Scalars['Boolean']['output'];
  surname: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totpList: Array<Totp>;
  updatedDate: Scalars['String']['output'];
};

export type FullUser = {
  __typename?: 'FullUser';
  aspenUserCode: Scalars['String']['output'];
  coachAllowSameTimeslotBooking: Scalars['Boolean']['output'];
  coachFee: Scalars['Float']['output'];
  coachRemarkEn: Scalars['String']['output'];
  coachRemarkSc: Scalars['String']['output'];
  coachRemarkTc: Scalars['String']['output'];
  coachSalaryContractTermsList: Array<CoachSalaryContractTerms>;
  coachServiceIsWebEnabledForCoach: Scalars['Boolean']['output'];
  coachServiceList: Array<CoachService>;
  coachTimeslotEndTime: Scalars['String']['output'];
  coachTimeslotMins: Scalars['Int']['output'];
  coachTimeslotStartTime: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  defaultReceiptName: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isEquipmentTeam: Scalars['Boolean']['output'];
  isSuspensedDueToWrongPassword: Scalars['Boolean']['output'];
  isSystemUser: Scalars['Boolean']['output'];
  isVenueTeam: Scalars['Boolean']['output'];
  languagePreference: LanguagePreference;
  mobileTel: Scalars['String']['output'];
  monthlySalary: Scalars['Float']['output'];
  passKeyList: Array<PartialPassKey>;
  password: Scalars['String']['output'];
  roleList: Array<UserRole>;
  roleTemplate?: Maybe<RoleTemplate>;
  roleTemplateId?: Maybe<Scalars['Int']['output']>;
  ssoMapping: Scalars['String']['output'];
  totpList: Array<Totp>;
  type: Scalars['Float']['output'];
  updatedDate: Scalars['String']['output'];
  userCoachServiceRelList: Array<UserCoachServiceRel>;
  userWarehouseList: Array<UserWarehouse>;
  username: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  wrongPasswordInputNo: Scalars['Int']['output'];
};

export type GenerateCourseByRecurCourseInput = {
  firstStartDate?: InputMaybe<Scalars['String']['input']>;
  ignoreCoachConflict?: Scalars['Boolean']['input'];
  initRecurNo?: InputMaybe<Scalars['Int']['input']>;
  noOfCycles: Scalars['Int']['input'];
  recurCourseId: Scalars['Int']['input'];
};

export type GenerateStaffQrCodeInput = {
  memberId: Scalars['Int']['input'];
};

export type GenericAddBookingToFacilityInput = {
  blackoutId?: InputMaybe<Scalars['Int']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  endDateTime: Scalars['String']['input'];
  eventCode?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['Int']['input'];
  lessonId?: InputMaybe<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  memberIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  myEventId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type GetAccessPassExpiryListInput = {
  accessPassId: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetAccessPassFacilityAccessRelListInput = {
  accessPassId: Scalars['Int']['input'];
};

export type GetAccessPassInput = {
  id: Scalars['Int']['input'];
};

export type GetAccessPassPurchaseListInput = {
  addToMemberId?: InputMaybe<Scalars['Int']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  getNonMainList: Scalars['Boolean']['input'];
  mainMemberId: Scalars['Int']['input'];
};

export type GetAcctProductCatInput = {
  id: Scalars['Int']['input'];
};

export type GetAdminSettingInput = {
  name: Scalars['String']['input'];
};

export type GetAllCoachSalaryReportListInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type GetAllMemberEnrolmentStatsInput = {
  forceRecal: Scalars['Boolean']['input'];
  noOfMonths: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type GetAllMemberRelationshipListInput = {
  memberId: Scalars['Int']['input'];
};

export type GetAllMemberRelationshipListResGql = {
  __typename?: 'GetAllMemberRelationshipListResGql';
  confirmedList: Array<MemberRelationship>;
  requestList: Array<MemberRelationship>;
  unconfirmedList: Array<MemberRelationship>;
};

export type GetApcSummaryInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetApcSummaryOneRowGql = {
  __typename?: 'GetApcSummaryOneRowGql';
  apcAccountNo?: Maybe<Scalars['String']['output']>;
  apcAccountNoCost?: Maybe<Scalars['String']['output']>;
  apcAccountNoMaterialFee?: Maybe<Scalars['String']['output']>;
  apcCatCode?: Maybe<Scalars['String']['output']>;
  apcCatCodeCost?: Maybe<Scalars['String']['output']>;
  apcCatCodeMaterialFee?: Maybe<Scalars['String']['output']>;
  apcProjCode?: Maybe<Scalars['String']['output']>;
  apcProjCodeCost?: Maybe<Scalars['String']['output']>;
  apcProjCodeMaterialFee?: Maybe<Scalars['String']['output']>;
  apcRevcCode?: Maybe<Scalars['String']['output']>;
  apcRevcCodeCost?: Maybe<Scalars['String']['output']>;
  apcRevcCodeMaterialFee?: Maybe<Scalars['String']['output']>;
  totalAmt: Scalars['Float']['output'];
  totalQty: Scalars['Int']['output'];
};

export type GetApcSummaryResGql = {
  __typename?: 'GetApcSummaryResGql';
  apcAccountNoCostSummaryList: Array<GetApcSummaryOneRowGql>;
  apcAccountNoMaterialFeeSummaryList: Array<GetApcSummaryOneRowGql>;
  apcAccountNoSummaryList: Array<GetApcSummaryOneRowGql>;
  apcCatCodeCostSummaryList: Array<GetApcSummaryOneRowGql>;
  apcCatCodeMaterialFeeSummaryList: Array<GetApcSummaryOneRowGql>;
  apcCatCodeSummaryList: Array<GetApcSummaryOneRowGql>;
  apcProjCodeCostSummaryList: Array<GetApcSummaryOneRowGql>;
  apcProjCodeMaterialFeeSummaryList: Array<GetApcSummaryOneRowGql>;
  apcProjCodeSummaryList: Array<GetApcSummaryOneRowGql>;
};

export type GetAvailableCoachAndCoachServiceByFacilityForPosOrderInput = {
  facilityId: Scalars['Int']['input'];
  showAllForAdmin: Scalars['Boolean']['input'];
};

export type GetAvailableCoachServiceAndCoachResGql = {
  __typename?: 'GetAvailableCoachServiceAndCoachResGql';
  availableCoachServiceAndCoachList: Array<OneAvailableCoachServiceAndCoachListResGql>;
};

export type GetAvailableEquipmentInput = {
  allowInternalBookingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDateTime: Scalars['String']['input'];
  facilityIdList: Array<Scalars['Int']['input']>;
  locationAreaId?: InputMaybe<Scalars['Int']['input']>;
  parentBookingId?: InputMaybe<Scalars['Int']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type GetAvailableFabTableListInput = {
  endDateTime: Scalars['String']['input'];
  floorplanId?: InputMaybe<Scalars['Int']['input']>;
  noOfSeats?: Scalars['Int']['input'];
  startDateTime: Scalars['String']['input'];
};

export type GetAvailableVenueInput = {
  allowInternalBookingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDateTime: Scalars['String']['input'];
  locationAreaIdList: Array<Scalars['Int']['input']>;
  parentBookingId?: InputMaybe<Scalars['Int']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type GetBannerListInput = {
  myfileType: MyfileType;
};

export type GetBlackoutInput = {
  id: Scalars['Int']['input'];
};

export type GetBonusPointEarningRuleInput = {
  id: Scalars['Int']['input'];
};

export type GetBonusPointItemTypeEarningRatioInput = {
  id: Scalars['Int']['input'];
};

export type GetBonusPointMovementReportInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetBonusPointMovementReportResGql = {
  __typename?: 'GetBonusPointMovementReportResGql';
  afterBalance: Scalars['Int']['output'];
  beforeBalance: Scalars['Int']['output'];
  bonusPointTotalPerType: Array<BonusPointTotalPerType>;
};

export type GetBonusPointRedeemPromotionGroupInput = {
  id: Scalars['Int']['input'];
};

export type GetBonusPointReportDailyInput = {
  endDate: Scalars['String']['input'];
  forceRecal: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
};

export type GetBookingListForVenueDisplayInput = {
  facilityId: Scalars['Int']['input'];
  testTimestamp?: InputMaybe<Scalars['String']['input']>;
};

export type GetBookingQrCodeInput = {
  facilityBookingId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type GetBookingQrCodeResGql = {
  __typename?: 'GetBookingQrCodeResGql';
  qrcode?: Maybe<Scalars['String']['output']>;
};

export type GetBookmarkListResGql = {
  __typename?: 'GetBookmarkListResGql';
  courseList: Array<Course>;
  facilityList: Array<Facility>;
  productList: Array<Product>;
};

export type GetBullQueueJobGqlInput = {
  jobId: Scalars['String']['input'];
};

export type GetCartInput = {
  cartType: CartType;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCheckInDeviceInput = {
  id: Scalars['Int']['input'];
};

export type GetCheckInItemListResGql = {
  __typename?: 'GetCheckInItemListResGql';
  checkInItemInfoList: Array<CheckInItemResGql>;
};

export type GetCoachRelatedItemListResGql = {
  __typename?: 'GetCoachRelatedItemListResGql';
  itemList: Array<CoachRelatedItemResGql>;
};

export type GetCoachSalaryReportInput = {
  coachId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type GetCoachServiceInput = {
  id: Scalars['Int']['input'];
};

export type GetCoachTimeslotSummaryInput = {
  coachId: Scalars['Int']['input'];
  endDateTime: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  timeslotNoOfMins: Scalars['Int']['input'];
  withDetails: Scalars['Boolean']['input'];
};

export type GetCoachTimeslotSummaryResGql = {
  __typename?: 'GetCoachTimeslotSummaryResGql';
  summaryList: Array<CoachTimeslotOneDaySummaryResGql>;
};

export type GetCommitteeHistoryInput = {
  id: Scalars['Int']['input'];
};

export type GetCommitteeInput = {
  id: Scalars['Int']['input'];
};

export type GetCommitteePositionInput = {
  id: Scalars['Int']['input'];
};

export type GetConfirmGrnUserListInput = {
  deptId: Scalars['Int']['input'];
};

export type GetContactInput = {
  id: Scalars['Int']['input'];
};

export type GetCouponPackageInput = {
  id: Scalars['Int']['input'];
};

export type GetCouponPackageUsageMovementReportInput = {
  couponPackageId?: InputMaybe<Scalars['Int']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetCouponPackageUsageMovementReportResGql = {
  __typename?: 'GetCouponPackageUsageMovementReportResGql';
  afterBalance: Scalars['Int']['output'];
  beforeBalance: Scalars['Int']['output'];
  totalExpired: Scalars['Int']['output'];
  totalHeld: Scalars['Int']['output'];
  totalPurchased: Scalars['Int']['output'];
  totalRefunded: Scalars['Int']['output'];
  totalUsageRefunded: Scalars['Int']['output'];
  totalUsed: Scalars['Int']['output'];
  totalVoided: Scalars['Int']['output'];
};

export type GetCourseApplyQuotaPeriodInput = {
  id: Scalars['Int']['input'];
};

export type GetCourseAttendanceSheetDataInput = {
  courseId: Scalars['Float']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetCourseAttendanceSheetDataResGql = {
  __typename?: 'GetCourseAttendanceSheetDataResGql';
  lessonList: Array<Lesson>;
  memberDataList: Array<GetCourseAttendanceSheetMemberDataResGql>;
  noOfMemberList: Array<Scalars['Int']['output']>;
};

export type GetCourseAttendanceSheetMemberDataResGql = {
  __typename?: 'GetCourseAttendanceSheetMemberDataResGql';
  isLessonEnrolledList: Array<Scalars['Boolean']['output']>;
  isLessonPaidList: Array<Scalars['Boolean']['output']>;
  member: FullMember;
  myorderId?: Maybe<Scalars['Int']['output']>;
  myorderIdList: Array<Scalars['Int']['output']>;
};

export type GetCourseCoachListInput = {
  id: Scalars['Int']['input'];
};

export type GetCourseEnrolmentQrCodeInput = {
  courseEnrolmentId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCourseEnrolmentResultResGql = {
  __typename?: 'GetCourseEnrolmentResultResGql';
  course: Course;
  courseId: Scalars['Int']['output'];
  enrolmentList: Array<MaskedCourseEnrolmentResultResGql>;
};

export type GetCourseEnrolmentStatsInput = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['String']['input'];
  forceRecal: Scalars['Boolean']['input'];
  shortCode?: InputMaybe<Scalars['String']['input']>;
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
};

export type GetCourseInput = {
  id: Scalars['Int']['input'];
};

export type GetCourseLotteryResultInput = {
  courseId: Scalars['Int']['input'];
  noOfResult: Scalars['Int']['input'];
  simplePriorityMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetCourseMemberListInput = {
  courseId: Scalars['Int']['input'];
  courseMemberListType: CourseMemberListType;
};

export type GetCourseTypeInput = {
  id: Scalars['Int']['input'];
};

export type GetCreditMovementReportInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetCreditMovementReportResGql = {
  __typename?: 'GetCreditMovementReportResGql';
  afterBalance: Scalars['Float']['output'];
  beforeBalance: Scalars['Float']['output'];
  creditTotalPerType: Array<CreditTotalPerType>;
};

export type GetCreditPackageInput = {
  id: Scalars['Int']['input'];
};

export type GetCreditReportDailyInput = {
  endDate: Scalars['String']['input'];
  forceRecal: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
};

export type GetCreditTypeInput = {
  id: Scalars['Int']['input'];
};

export type GetDeliveryNoteInput = {
  id: Scalars['Int']['input'];
};

export type GetDeliveryNoteTxInput = {
  id: Scalars['Int']['input'];
};

export type GetDepartmentInput = {
  id: Scalars['Int']['input'];
};

export type GetDepositBalanceInput = {
  accessPassIdList?: Array<Scalars['Int']['input']>;
  endDate: Scalars['String']['input'];
  lockerGroupIdList?: Array<Scalars['Int']['input']>;
  showAllForAdmin?: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
};

export type GetDepositBalanceResGql = {
  __typename?: 'GetDepositBalanceResGql';
  dailyList: Array<DailyDepositBalanceResGql>;
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  summary: DepositSummaryResGql;
};

export type GetDocxTemplateInput = {
  id: Scalars['Int']['input'];
};

export type GetDocxTemplateListInput = {
  docType?: InputMaybe<Scalars['String']['input']>;
  mineOnly: Scalars['Boolean']['input'];
};

export type GetDriveMemberAliasInput = {
  driveMemberId: Scalars['Int']['input'];
  driveTeamId: Scalars['Int']['input'];
};

export type GetDriveStatsInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  phase?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GetDriveStatsResGql = {
  __typename?: 'GetDriveStatsResGql';
  memberRankList: Array<DriveMemberRankResGql>;
  teamRankList: Array<DriveTeamRankResGql>;
};

export type GetDriveTeamInput = {
  id: Scalars['Int']['input'];
};

export type GetEffectiveBookingInfoInput = {
  facilityIdList: Array<Scalars['Int']['input']>;
  memberId: Scalars['Int']['input'];
};

export type GetEffectiveBookingInfoResGql = {
  __typename?: 'GetEffectiveBookingInfoResGql';
  endDateForBooking: Scalars['String']['output'];
  facilityId: Scalars['Int']['output'];
  maxLeadTimeInDays: Scalars['Int']['output'];
  maxNoOfTimeslot: Scalars['Int']['output'];
  maxNoOfTimeslotForPeakHour: Scalars['Int']['output'];
  minLeadTimeInDays: Scalars['Int']['output'];
  minNoOfTimeslot: Scalars['Int']['output'];
  startDateForBooking: Scalars['String']['output'];
};

export type GetFabFloorplanGridInput = {
  date: Scalars['String']['input'];
  fabFloorplanId: Scalars['Int']['input'];
};

export type GetFabFloorplanGridResGql = {
  __typename?: 'GetFabFloorplanGridResGql';
  hourRowList: Array<FabTimeslotHourRowResGql>;
  periodInfoList: Array<FabTimeslotPeriodResGql>;
  periodList: Array<FabFloorplanPeriod>;
  tableList: Array<FabTable>;
};

export type GetFabFloorplanGridV2ResGql = {
  __typename?: 'GetFabFloorplanGridV2ResGql';
  hourRowList: Array<FabTimeslotHourRowV2ResGql>;
  tableList: Array<FabTable>;
};

export type GetFabFloorplanInput = {
  id: Scalars['Int']['input'];
  withDisabledTable?: Scalars['Boolean']['input'];
};

export type GetFabReservationInput = {
  id: Scalars['Int']['input'];
};

export type GetFabReservationRealTimeStatsInput = {
  endCutoffDate: Scalars['String']['input'];
  fabFloorplanId?: InputMaybe<Scalars['Int']['input']>;
  startCutoffDate: Scalars['String']['input'];
};

export type GetFabReservationRealTimeStatsOneResGql = {
  __typename?: 'GetFabReservationRealTimeStatsOneResGql';
  labelEn: Scalars['String']['output'];
  labelSc: Scalars['String']['output'];
  labelTc: Scalars['String']['output'];
  noOfGuest: Scalars['Float']['output'];
  noOfReservation: Scalars['Float']['output'];
};

export type GetFabReservationRealTimeStatsResGql = {
  __typename?: 'GetFabReservationRealTimeStatsResGql';
  perHourRes: Array<GetFabReservationRealTimeStatsOneResGql>;
  perPeriodRes: Array<GetFabReservationRealTimeStatsOneResGql>;
};

export type GetFabReservationStatsPerDayInput = {
  endCutoffDate: Scalars['String']['input'];
  fabFloorplanId?: InputMaybe<Scalars['Int']['input']>;
  fabFloorplanPeriodGroupName?: InputMaybe<Scalars['String']['input']>;
  forceRecal?: Scalars['Boolean']['input'];
  startCutoffDate: Scalars['String']['input'];
};

export type GetFabReservationStatsPerMonthInput = {
  endCutoffDate: Scalars['String']['input'];
  fabFloorplanId?: InputMaybe<Scalars['Int']['input']>;
  fabFloorplanPeriodGroupName?: InputMaybe<Scalars['String']['input']>;
  forceRecalPerDay?: Scalars['Boolean']['input'];
  forceRecalPerMonth?: Scalars['Boolean']['input'];
  startCutoffDate: Scalars['String']['input'];
};

export type GetFabTableWithReservationListInput = {
  endDateTime: Scalars['String']['input'];
  fabFloorplanId: Scalars['Int']['input'];
  startDateTime: Scalars['String']['input'];
};

export type GetFacilityAccessLogAccessPassOptionIdListToUpdateInput = {
  id: Scalars['Int']['input'];
};

export type GetFacilityAccessPassDependencyListInput = {
  facilityId: Scalars['Int']['input'];
};

export type GetFacilityBookingApplicableCouponPackageInstanceListInput = {
  facilityBookingId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetFacilityBookingApplicableCouponPackageInstanceListResGql = {
  __typename?: 'GetFacilityBookingApplicableCouponPackageInstanceListResGql';
  applicableCouponPackageInstanceList: Array<ApplicableCouponPackageInstanceResGql>;
  endDateTime: Scalars['String']['output'];
  isPeakHour: Scalars['Boolean']['output'];
  startDateTime: Scalars['String']['output'];
};

export type GetFacilityBookingSummaryInput = {
  bookBy: BookByType;
  endDateTime: Scalars['String']['input'];
  facilityIdList: Array<Scalars['Int']['input']>;
  startDateTime: Scalars['String']['input'];
  targetMemberId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetFacilityBookingSummaryResGql = {
  __typename?: 'GetFacilityBookingSummaryResGql';
  displayDate: Scalars['String']['output'];
  facilityBookingDailyTimeSlotDtoList: Array<FacilityBookingDailyTimeSlotResGql>;
  locationAreaInfoList: Array<FacilityBookingSummaryLocationAreaInfoResGql>;
};

export type GetFacilityEffectiveLeadTimeForMemberInput = {
  facilityId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetFacilityEffectiveLeadTimeForMemberResGql = {
  __typename?: 'GetFacilityEffectiveLeadTimeForMemberResGql';
  endDateForBooking: Scalars['String']['output'];
  maxLeadTimeInDays: Scalars['Int']['output'];
  minLeadTimeInDays: Scalars['Int']['output'];
  startDateForBooking: Scalars['String']['output'];
};

export type GetFacilityEffectiveNoOfTimeslotForMemberInput = {
  facilityId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetFacilityEffectiveNoOfTimeslotForMemberResGql = {
  __typename?: 'GetFacilityEffectiveNoOfTimeslotForMemberResGql';
  maxNoOfTimeslot: Scalars['Int']['output'];
  maxNoOfTimeslotForPeakHour: Scalars['Int']['output'];
  minNoOfTimeslot: Scalars['Int']['output'];
};

export type GetFacilityFeeListInput = {
  facilityId: Scalars['Int']['input'];
};

export type GetFacilityInput = {
  id: Scalars['Int']['input'];
};

export type GetFacilityStatsDailyInput = {
  endDate: Scalars['String']['input'];
  facilityIdList: Array<Scalars['Int']['input']>;
  forceRecal: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
};

export type GetFacilityStatsDailyResGql = {
  __typename?: 'GetFacilityStatsDailyResGql';
  facility: Facility;
  statsList: Array<FacilityStatsDaily>;
  summary: FacilityStatsSummaryResGql;
};

export type GetGoodsReceiveNoteInput = {
  id: Scalars['Int']['input'];
};

export type GetGoodsReceiveNoteTxInput = {
  id: Scalars['Int']['input'];
};

export type GetGpLogInput = {
  id: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type GetGpLogResGql = {
  __typename?: 'GetGpLogResGql';
  referenceCode: Scalars['String']['output'];
  responseCode: Scalars['String']['output'];
};

export type GetHolidayInput = {
  id: Scalars['Int']['input'];
};

export type GetInfoByQuickQrCodeInput = {
  qrcode: Scalars['String']['input'];
};

export type GetInternalBookingInput = {
  parentBookingId: Scalars['Int']['input'];
};

export type GetInternalBookingResGql = {
  __typename?: 'GetInternalBookingResGql';
  bookingList: Array<FacilityBooking>;
  parentBooking: FacilityBooking;
};

export type GetInventoryRequestInput = {
  id: Scalars['Int']['input'];
};

export type GetInventoryRequestTxInput = {
  id: Scalars['Int']['input'];
};

export type GetInventoryTxCountInput = {
  id: Scalars['Int']['input'];
};

export type GetInventoryTxGroupInput = {
  id: Scalars['Int']['input'];
};

export type GetKpayNotifyLogInput = {
  myorderId: Scalars['Int']['input'];
};

export type GetKpayNotifyLogResGql = {
  __typename?: 'GetKpayNotifyLogResGql';
  transactionState?: Maybe<Scalars['Int']['output']>;
  transactionStateDesc: Scalars['String']['output'];
};

export type GetKwtdhcEventInput = {
  id: Scalars['Int']['input'];
};

export type GetKwtdhcMemberFollowupInput = {
  id: Scalars['Int']['input'];
};

export type GetLastMembershipOrderInput = {
  memberId: Scalars['Int']['input'];
};

export type GetLatestMemberAccessPassHistoryListInput = {
  memberId: Scalars['Int']['input'];
  showExpired: Scalars['Boolean']['input'];
};

export type GetLatestMemberDepositHistoryListInput = {
  memberId: Scalars['Int']['input'];
  showActiveOnly: Scalars['Boolean']['input'];
};

export type GetLessonCoachQrCodeInput = {
  coachId: Scalars['Int']['input'];
  lessonCoachId: Scalars['Int']['input'];
};

export type GetLessonCoachQrCodeResGql = {
  __typename?: 'GetLessonCoachQrCodeResGql';
  qrcode?: Maybe<Scalars['String']['output']>;
};

export type GetLessonEnrolmentListInput = {
  coachId: Scalars['Int']['input'];
  lessonId: Scalars['Int']['input'];
};

export type GetLessonEnrolmentListResGql = {
  __typename?: 'GetLessonEnrolmentListResGql';
  checkInItemInfo?: Maybe<CheckInItemResGql>;
  course: Course;
  enrolmentList: Array<LessonEnrolment>;
  lesson: Lesson;
};

export type GetLessonListInput = {
  checkConflict?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GetLocationAreaInput = {
  id: Scalars['Int']['input'];
};

export type GetLocationInput = {
  id: Scalars['Int']['input'];
};

export type GetLockerExpiryListInput = {
  excludeEmailReminderSent: Scalars['Boolean']['input'];
  excludeLetterReminderSent: Scalars['Boolean']['input'];
  excludeSmsReminderSent: Scalars['Boolean']['input'];
  expiryFromDate: Scalars['String']['input'];
  expiryToDate: Scalars['String']['input'];
  lockerGroupIdList?: Array<Scalars['Int']['input']>;
};

export type GetLockerGroupInput = {
  id: Scalars['Int']['input'];
};

export type GetLockerInput = {
  id: Scalars['Int']['input'];
};

export type GetLockerListInput = {
  forWebOnly?: Scalars['Boolean']['input'];
  lockerGroupId: Scalars['Int']['input'];
};

export type GetLockerTypeInput = {
  id: Scalars['Int']['input'];
};

export type GetLostCardHistoryInput = {
  memberId: Scalars['Int']['input'];
};

export type GetLotteryGroupScoreInput = {
  lotteryGroupName: Scalars['String']['input'];
  memberId: Scalars['Int']['input'];
};

export type GetMemberAccessPassHistoryInput = {
  accessPassId?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['Int']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
};

export type GetMemberActivityListInput = {
  endDate: Scalars['String']['input'];
  memberId: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type GetMemberActivityListResGql = {
  __typename?: 'GetMemberActivityListResGql';
  activityList: Array<MemberActivityResGql>;
};

export type GetMemberCourseEnrolmentHistoryInput = {
  memberId: Scalars['Int']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  statusList: Array<EnrolmentStatus>;
};

export type GetMemberDepositHistoryInput = {
  accessPassId?: InputMaybe<Scalars['Int']['input']>;
  depositType?: InputMaybe<DepositType>;
  lockerId?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['Int']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
  status?: InputMaybe<DepositStatus>;
};

export type GetMemberDriveDepositHistoryInput = {
  drivePhase?: InputMaybe<Scalars['Int']['input']>;
  driveYear?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['Int']['input'];
  myorderId?: InputMaybe<Scalars['Int']['input']>;
  myorderItemId?: InputMaybe<Scalars['Int']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  type?: InputMaybe<DriveDepositType>;
};

export type GetMemberDriveScoreHistoryInput = {
  driveMemberId?: InputMaybe<Scalars['Int']['input']>;
  drivePhase?: InputMaybe<Scalars['Int']['input']>;
  driveTeamId?: InputMaybe<Scalars['Int']['input']>;
  driveYear?: InputMaybe<Scalars['Int']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
};

export type GetMemberDriveTeamListInput = {
  memberId: Scalars['Int']['input'];
};

export type GetMemberFacilityBookingHistoryInput = {
  memberId: Scalars['Int']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetMemberIdByMembershipNoInput = {
  membershipNo: Scalars['String']['input'];
};

export type GetMemberIdByMembershipNoResGql = {
  __typename?: 'GetMemberIdByMembershipNoResGql';
  memberId: Scalars['Float']['output'];
};

export type GetMemberInput = {
  id: Scalars['Int']['input'];
};

export type GetMemberLessonEnrolmentHistoryInput = {
  memberId: Scalars['Int']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  statusList: Array<EnrolmentStatus>;
};

export type GetMemberListAsCourseMemberListInput = {
  courseId: Scalars['Int']['input'];
  memberListAsCourseMemberListType: MemberListAsCourseMemberListType;
};

export type GetMemberListAsRecurCourseMemberListInput = {
  memberListAsCourseMemberListType: MemberListAsCourseMemberListType;
  recurCourseId: Scalars['Int']['input'];
};

export type GetMemberListInput = {
  id: Scalars['Int']['input'];
};

export type GetMemberMembershipHistoryInput = {
  memberId: Scalars['Int']['input'];
  membershipTypeId?: InputMaybe<Scalars['Int']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
};

export type GetMemberMovementInput = {
  endDate: Scalars['String']['input'];
  forceRecal?: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
};

export type GetMemberMovementResGql = {
  __typename?: 'GetMemberMovementResGql';
  statsList: Array<MemberMovementStats>;
  total: MemberMovementStats;
};

export type GetMemberMovementYearInput = {
  forceRecal?: Scalars['Boolean']['input'];
  year?: Scalars['Int']['input'];
};

export type GetMemberMovementYearResGql = {
  __typename?: 'GetMemberMovementYearResGql';
  yearStatsList: Array<GetMemberMovementResGql>;
};

export type GetMemberMsgQueueInput = {
  id: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetMemberMyorderHistoryInput = {
  memberId: Scalars['Int']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  status?: InputMaybe<MyorderAllStatus>;
};

export type GetMemberPhoneBookingStatusInput = {
  id: Scalars['Int']['input'];
};

export type GetMemberProductRedeemOrderInput = {
  memberId: Scalars['Int']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy?: InputMaybe<QueryOrderByMyorderInput>;
  pageNo?: Scalars['Int']['input'];
  status?: Scalars['String']['input'];
};

export type GetMemberValidityInput = {
  atDate: Scalars['String']['input'];
  membershipNo: Scalars['String']['input'];
};

export type GetMemberValidityResGql = {
  __typename?: 'GetMemberValidityResGql';
  isValid: Scalars['Boolean']['output'];
  memberId?: Maybe<Scalars['Int']['output']>;
};

export type GetMembershipHistoryInput = {
  getMember?: Scalars['Boolean']['input'];
  getMembershipType?: Scalars['Boolean']['input'];
  getMyorder?: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export type GetMembershipHistoryResGql = {
  __typename?: 'GetMembershipHistoryResGql';
  member?: Maybe<FullMember>;
  membershipHistory: MembershipHistory;
  membershipType?: Maybe<MembershipType>;
  myorder?: Maybe<Myorder>;
};

export type GetMembershipTypeInput = {
  id: Scalars['Int']['input'];
  withUpgradeOption?: Scalars['Boolean']['input'];
};

export type GetMiniSiteContentInput = {
  id: Scalars['Int']['input'];
};

export type GetMsgQueueByHashInput = {
  id: Scalars['Int']['input'];
  msgHash: Scalars['String']['input'];
};

export type GetMsgQueueInput = {
  id: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type GetMyEventInput = {
  id: Scalars['Int']['input'];
};

export type GetMyfileInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  myfileId: Scalars['Int']['input'];
  returnB64: Scalars['Boolean']['input'];
  viewport?: InputMaybe<Scalars['Int']['input']>;
};

export type GetMyfileResGql = {
  __typename?: 'GetMyfileResGql';
  data?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
  myfileId: Scalars['Float']['output'];
  orginalId: Scalars['Float']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
  size: Scalars['Float']['output'];
};

export type GetMyorderInput = {
  id: Scalars['Int']['input'];
};

export type GetMyorderItemQrCodeInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  myorderItemId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetMyorderItemQrCodeResGql = {
  __typename?: 'GetMyorderItemQrCodeResGql';
  b64DataList: Array<Scalars['String']['output']>;
  expiryDateTime?: Maybe<Scalars['String']['output']>;
  qrcodeList: Array<Scalars['String']['output']>;
};

export type GetNewsInput = {
  id: Scalars['Int']['input'];
};

export type GetOneCourseEnrolmentStatsInput = {
  courseId: Scalars['Int']['input'];
  forceRecal: Scalars['Boolean']['input'];
};

export type GetOneMemberEnrolmentStatsInput = {
  forceRecal: Scalars['Boolean']['input'];
  memberId: Scalars['Int']['input'];
  noOfMonths: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type GetOrderPaymentMethodSummaryInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetOrderPaymentMethodSummaryOneRowResGql = {
  __typename?: 'GetOrderPaymentMethodSummaryOneRowResGql';
  amount: Scalars['Float']['output'];
  paymentMethod: Scalars['String']['output'];
  qty: Scalars['Int']['output'];
};

export type GetOrderPaymentMethodSummaryPerDayInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetOrderPaymentMethodSummaryPerDayOneDayResGql = {
  __typename?: 'GetOrderPaymentMethodSummaryPerDayOneDayResGql';
  amount: Array<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
};

export type GetOrderPaymentMethodSummaryPerDayResGql = {
  __typename?: 'GetOrderPaymentMethodSummaryPerDayResGql';
  paymentMethodList: Array<Scalars['String']['output']>;
  rows: Array<GetOrderPaymentMethodSummaryPerDayOneDayResGql>;
  total: GetOrderPaymentMethodSummaryPerDayOneDayResGql;
};

export type GetOrderPaymentMethodSummaryResGql = {
  __typename?: 'GetOrderPaymentMethodSummaryResGql';
  rows: Array<GetOrderPaymentMethodSummaryOneRowResGql>;
  total: GetOrderPaymentMethodSummaryOneRowResGql;
};

export type GetOrganizationInput = {
  id: Scalars['Int']['input'];
};

export type GetPosFacilityTreeDeptResGql = {
  __typename?: 'GetPosFacilityTreeDeptResGql';
  dept: Department;
  facilityGroupList: Array<FacilityGroup>;
};

export type GetPosFacilityTreeInput = {
  openForMemberOnly: Scalars['Boolean']['input'];
  openForUserOnly: Scalars['Boolean']['input'];
};

export type GetPosFacilityTreeResGql = {
  __typename?: 'GetPosFacilityTreeResGql';
  deptList: Array<GetPosFacilityTreeDeptResGql>;
};

export type GetPrivateCoachApplicableCouponPackageInstanceListInput = {
  coachMyorderItemId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetProductCatInput = {
  id: Scalars['Int']['input'];
};

export type GetProductInput = {
  id: Scalars['Int']['input'];
};

export type GetProductInventoryLevelPerPartitionByDeptInput = {
  deptId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};

export type GetQuickQrCodeResGql = {
  __typename?: 'GetQuickQrCodeResGql';
  b64Data: Scalars['String']['output'];
  expiryDateTime?: Maybe<Scalars['String']['output']>;
  qrcode: Scalars['String']['output'];
};

export type GetReceiptInput = {
  id: Scalars['Int']['input'];
  sendToMember: Scalars['Boolean']['input'];
};

export type GetRecurCourseInput = {
  id: Scalars['Int']['input'];
};

export type GetRefundPayoutRequestInput = {
  id: Scalars['Int']['input'];
};

export type GetRoleTemplateInput = {
  id: Scalars['Int']['input'];
};

export type GetSalesReportItemTypePerDayInput = {
  endCutoffDate: Scalars['String']['input'];
  forceRecal?: Scalars['Boolean']['input'];
  startCutoffDate: Scalars['String']['input'];
};

export type GetSalesReportItemTypePerDayResGql = {
  __typename?: 'GetSalesReportItemTypePerDayResGql';
  allWarehouseData: SalesReportItemTypePerDayOneWarehouseResGql;
  perWarehouseDataList: Array<SalesReportItemTypePerDayOneWarehouseResGql>;
  updatedDateList: Array<Scalars['String']['output']>;
};

export type GetSalesReportItemTypePerDeptPerDayInput = {
  endCutoffDate: Scalars['String']['input'];
  forceRecal?: Scalars['Boolean']['input'];
  startCutoffDate: Scalars['String']['input'];
};

export type GetSalesReportItemTypePerDeptPerDayResGql = {
  __typename?: 'GetSalesReportItemTypePerDeptPerDayResGql';
  allDeptData: SalesReportItemTypePerDeptPerDayOneDeptResGql;
  perDeptDataList: Array<SalesReportItemTypePerDeptPerDayOneDeptResGql>;
  updatedDateList: Array<Scalars['String']['output']>;
};

export type GetSalesReportItemTypePerDeptPerMonthInput = {
  endCutoffDate: Scalars['String']['input'];
  forceRecalPerDay?: Scalars['Boolean']['input'];
  forceRecalPerMonth?: Scalars['Boolean']['input'];
  startCutoffDate: Scalars['String']['input'];
};

export type GetSalesReportItemTypePerDeptPerMonthResGql = {
  __typename?: 'GetSalesReportItemTypePerDeptPerMonthResGql';
  allDeptData: SalesReportItemTypePerDeptPerMonthOneDeptResGql;
  perDeptDataList: Array<SalesReportItemTypePerDeptPerMonthOneDeptResGql>;
  updatedDateList: Array<Scalars['String']['output']>;
};

export type GetSalesReportItemTypePerMonthInput = {
  endCutoffDate: Scalars['String']['input'];
  forceRecalPerDay?: Scalars['Boolean']['input'];
  forceRecalPerMonth?: Scalars['Boolean']['input'];
  startCutoffDate: Scalars['String']['input'];
};

export type GetSalesReportItemTypePerMonthResGql = {
  __typename?: 'GetSalesReportItemTypePerMonthResGql';
  allWarehouseData: SalesReportItemTypePerMonthOneWarehouseResGql;
  perWarehouseDataList: Array<SalesReportItemTypePerMonthOneWarehouseResGql>;
  updatedDateList: Array<Scalars['String']['output']>;
};

export type GetSalesReportPaymentMethodPerDayInput = {
  endCutoffDate: Scalars['String']['input'];
  forceRecal?: Scalars['Boolean']['input'];
  startCutoffDate: Scalars['String']['input'];
};

export type GetSalesReportPaymentMethodPerDayResGql = {
  __typename?: 'GetSalesReportPaymentMethodPerDayResGql';
  allWarehouseData: SalesReportPaymentMethodPerDayOneWarehouseResGql;
  perWarehouseDataList: Array<SalesReportPaymentMethodPerDayOneWarehouseResGql>;
  updatedDateList: Array<Scalars['String']['output']>;
};

export type GetSalesReportPaymentMethodPerMonthInput = {
  endCutoffDate: Scalars['String']['input'];
  forceRecalPerDay?: Scalars['Boolean']['input'];
  forceRecalPerMonth?: Scalars['Boolean']['input'];
  startCutoffDate: Scalars['String']['input'];
};

export type GetSalesReportPaymentMethodPerMonthResGql = {
  __typename?: 'GetSalesReportPaymentMethodPerMonthResGql';
  allWarehouseData: SalesReportPaymentMethodPerMonthOneWarehouseResGql;
  perWarehouseDataList: Array<SalesReportPaymentMethodPerMonthOneWarehouseResGql>;
  updatedDateList: Array<Scalars['String']['output']>;
};

export type GetSelectionJsonResGql = {
  __typename?: 'GetSelectionJsonResGql';
  countryList: Array<Country>;
  departmentList: Array<Department>;
  districtList: Array<District>;
  facilityLocationAreaList: Array<LocationArea>;
  facilityLocationList: Array<Location>;
  locationList: Array<MemberLocation>;
  shipmentWarehouseList: Array<Warehouse>;
  sportTypeList: Array<SportType>;
  userRoleSettingDtoList: Array<UserRoleSettingResGql>;
  warehouseList: Array<Warehouse>;
};

export type GetSportTypeGroupInput = {
  id: Scalars['Int']['input'];
};

export type GetSportTypeGroupListWithActiveCourseListInput = {
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetSportTypeInput = {
  id: Scalars['Int']['input'];
};

export type GetSportTypeListWithActiveCourseListInput = {
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
  sportTypeGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetSwpFeeInput = {
  id: Scalars['Int']['input'];
};

export type GetSwpSessionInput = {
  id: Scalars['Int']['input'];
};

export type GetTextTemplateInput = {
  id: Scalars['Int']['input'];
};

export type GetTextTemplateListInput = {
  docType?: InputMaybe<Scalars['String']['input']>;
  mineOnly: Scalars['Boolean']['input'];
  msgPlatform?: InputMaybe<MsgPlatform>;
};

export type GetTimeSlotProgramFullDayInfoInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  timeSlotProgramId: Scalars['Int']['input'];
};

export type GetTimeSlotProgramFullDayResGql = {
  __typename?: 'GetTimeSlotProgramFullDayResGql';
  locationInfoList: Array<LocationTimeSlotProgramTimeSlotInfo>;
  programQuotaLeft: Scalars['Int']['output'];
};

export type GetTimeSlotProgramGroupInput = {
  id: Scalars['Int']['input'];
};

export type GetTimeSlotProgramInput = {
  id: Scalars['Int']['input'];
};

export type GetTimeSlotProgramReservationQrCodeInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  reservationId: Scalars['Int']['input'];
};

export type GetTimeSlotProgramStatsInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  timeslotProgramGroupIdList: Array<Scalars['Int']['input']>;
};

export type GetTimeSlotProgramStatsResGql = {
  __typename?: 'GetTimeSlotProgramStatsResGql';
  statsRowList: Array<TimeSlotProgramStatsRow>;
  timeslotProgramList: Array<TimeSlotProgram>;
};

export type GetTimeSlotProgramSummaryInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  timeSlotProgramId: Scalars['Int']['input'];
};

export type GetTimeSlotProgramSummaryResGql = {
  __typename?: 'GetTimeSlotProgramSummaryResGql';
  locationSummaryList: Array<TimeSlotProgramLocationSummaryInfo>;
};

export type GetTotpSecretResGql = {
  __typename?: 'GetTotpSecretResGql';
  authUrl: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type GetUpgradableMembershipTypeListInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  isOnlineList?: Scalars['Boolean']['input'];
  memberId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetUserCourseListResGql = {
  __typename?: 'GetUserCourseListResGql';
  courseList: Array<Course>;
};

export type GetUserDeptListPerDomainInput = {
  domain: UserDeptListDomain;
  userId: Scalars['Int']['input'];
};

export type GetUserDeptListPerPermissionTypeInput = {
  permissionType: PermissionType;
  userId: Scalars['Int']['input'];
};

export type GetUserInput = {
  id: Scalars['Int']['input'];
};

export type GetUserLessonListResGql = {
  __typename?: 'GetUserLessonListResGql';
  lessonList: Array<Lesson>;
};

export type GetUserPrivateLessonListInput = {
  coachId: Scalars['Int']['input'];
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserPrivateLessonListResGql = {
  __typename?: 'GetUserPrivateLessonListResGql';
  bookingList: Array<FacilityBooking>;
};

export type GetUserProductGroupInput = {
  id: Scalars['Int']['input'];
};

export type GetUserWarehouseListInput = {
  userId: Scalars['Int']['input'];
};

export type GetUsernameInput = {
  id: Scalars['Int']['input'];
};

export type GetUsernameResGql = {
  __typename?: 'GetUsernameResGql';
  username: Scalars['String']['output'];
};

export type GetWarehouseInput = {
  id: Scalars['Int']['input'];
};

export type GetWarehousePartitionInput = {
  id: Scalars['Int']['input'];
};

export type GetWarehouseStockTakeDeltaInput = {
  id: Scalars['Int']['input'];
};

export type GetWarehouseStockTakeInput = {
  id: Scalars['Int']['input'];
};

export type GetWebFacilityTreeByFacilityGroupResGql = {
  __typename?: 'GetWebFacilityTreeByFacilityGroupResGql';
  facilityGroupList: Array<FacilityGroup>;
};

export type GoodsReceiveNote = {
  __typename?: 'GoodsReceiveNote';
  confirmReceivedByUser?: Maybe<User>;
  confirmReceivedByUserId?: Maybe<Scalars['Int']['output']>;
  confirmReceivedDate?: Maybe<Scalars['String']['output']>;
  deliveryNote?: Maybe<DeliveryNote>;
  deliveryNoteId?: Maybe<Scalars['Int']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['String']['output']>;
  grnNo?: Maybe<Scalars['String']['output']>;
  grnTxList?: Maybe<Array<GoodsReceiveNoteTx>>;
  id: Scalars['Int']['output'];
  inventoryRequest?: Maybe<InventoryRequest>;
  inventoryRequestId: Scalars['Int']['output'];
  inventoryTxGroup?: Maybe<InventoryTxGroup>;
  inventoryTxGroupId: Scalars['Int']['output'];
  isConfirmReceived: Scalars['Boolean']['output'];
};

export type GoodsReceiveNoteTx = {
  __typename?: 'GoodsReceiveNoteTx';
  confirmReceivedNormalQty?: Maybe<Scalars['Int']['output']>;
  confirmReceivedScrapedQty?: Maybe<Scalars['Int']['output']>;
  deliveryNoteTx?: Maybe<DeliveryNoteTx>;
  goodsReceiveNote?: Maybe<GoodsReceiveNote>;
  goodsReceiveNoteId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inventoryRequestTx?: Maybe<InventoryRequestTx>;
  inventoryRequestTxId: Scalars['Int']['output'];
  plannedQty: Scalars['Int']['output'];
};

export type GpRefundLog = {
  __typename?: 'GpRefundLog';
  createdDate: Scalars['String']['output'];
  gpOriginalTransactionUUid: Scalars['String']['output'];
  gpRefundTransactionUUid: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  merchantId: Scalars['String']['output'];
  myorder?: Maybe<Myorder>;
  myorderId: Scalars['Int']['output'];
  processRes: Scalars['String']['output'];
  referenceCode: Scalars['String']['output'];
  refundAmount: Scalars['Float']['output'];
  refundMyorder?: Maybe<Myorder>;
  refundMyorderId: Scalars['Int']['output'];
  refundPayoutRequest?: Maybe<RefundPayoutRequest>;
  refundPayoutRequestId: Scalars['Int']['output'];
  responseCode: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type GpToken = {
  __typename?: 'GpToken';
  cardExpiryDate: Scalars['String']['output'];
  cardExpiryMonth: Scalars['String']['output'];
  cardExpiryYear: Scalars['String']['output'];
  cardNumber: Scalars['String']['output'];
  cardType: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  deleteFailedCount: Scalars['Int']['output'];
  deleteFailedReason: Scalars['String']['output'];
  deletedByUser?: Maybe<User>;
  deletedByUserId: Scalars['Int']['output'];
  deletedCode?: Maybe<Scalars['String']['output']>;
  deletedDate?: Maybe<Scalars['String']['output']>;
  deletedReason: Scalars['String']['output'];
  failCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastSuccessDateTime: Scalars['String']['output'];
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  token: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type GuestGetAvailableCoachServiceAndCoachInput = {
  endDateTime: Scalars['String']['input'];
  facilityId: Scalars['Int']['input'];
  startDateTime: Scalars['String']['input'];
};

export type GuestGetAvailableTimeslotByCoachAndFacilityInput = {
  coachId: Scalars['Int']['input'];
  coachServiceId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
  inputDate: Scalars['String']['input'];
};

export type GuestGetCoachTimeslotSummaryInput = {
  coachId: Scalars['Int']['input'];
  startDateTime: Scalars['String']['input'];
  timeslotNoOfMins: Scalars['Int']['input'];
};

export type GuestGetUpgradableMembershipTypeListInput = {
  birthDate: Scalars['String']['input'];
};

export type HeldMyEventTicketSeatInput = {
  endSeatNo: Scalars['Int']['input'];
  myEventId: Scalars['Int']['input'];
  myEventTicketTypeId: Scalars['Int']['input'];
  startSeatNo: Scalars['Int']['input'];
};

export type Holiday = {
  __typename?: 'Holiday';
  date: Scalars['String']['output'];
  icalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
};

export type ImportMemberErrorRowResGql = {
  __typename?: 'ImportMemberErrorRowResGql';
  errorMsg: Scalars['String']['output'];
  errorRefId: Scalars['String']['output'];
};

export type ImportMemberInput = {
  b64Content: Scalars['String']['input'];
};

export type ImportMemberResGql = {
  __typename?: 'ImportMemberResGql';
  errorList: Array<ImportMemberErrorRowResGql>;
  successRefIdList: Array<Scalars['String']['output']>;
};

export enum InboxAction {
  Delete = 'delete',
  Read = 'read',
  Undelete = 'undelete',
  Unread = 'unread'
}

export type InventoryRequest = {
  __typename?: 'InventoryRequest';
  canCloseInventoryRequest: Scalars['Boolean']['output'];
  canUndoCloseInventoryRequest: Scalars['Boolean']['output'];
  canUpdateInventoryRequest: Scalars['Boolean']['output'];
  createdDate: Scalars['String']['output'];
  dnList?: Maybe<Array<DeliveryNote>>;
  expectedDeliveryDate?: Maybe<Scalars['String']['output']>;
  fromContactAddress1: Scalars['String']['output'];
  fromContactAddress2: Scalars['String']['output'];
  fromContactAddress3: Scalars['String']['output'];
  fromContactAddress4: Scalars['String']['output'];
  fromContactAddress5: Scalars['String']['output'];
  fromContactEmail?: Maybe<Scalars['String']['output']>;
  fromContactName: Scalars['String']['output'];
  fromContactPhone: Scalars['String']['output'];
  fromUser?: Maybe<User>;
  fromUserId?: Maybe<Scalars['Int']['output']>;
  grnList?: Maybe<Array<GoodsReceiveNote>>;
  id: Scalars['Int']['output'];
  inventoryTxGroup?: Maybe<InventoryTxGroup>;
  inventoryTxGroupId: Scalars['Int']['output'];
  isAgreeToReceiveStatus: AcceptStatus;
  isAgreeToReceiveUpdatedByUser?: Maybe<User>;
  isAgreeToReceiveUpdatedByUserId?: Maybe<Scalars['Int']['output']>;
  isAgreeToReceiveUpdatedDate?: Maybe<Scalars['String']['output']>;
  isAutoPhysicalTransfer: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  lastReceivedByUser?: Maybe<User>;
  lastReceivedByUserId?: Maybe<Scalars['Int']['output']>;
  lastReceivedDate?: Maybe<Scalars['String']['output']>;
  reqNo?: Maybe<Scalars['String']['output']>;
  toContactAddress1: Scalars['String']['output'];
  toContactAddress2: Scalars['String']['output'];
  toContactAddress3: Scalars['String']['output'];
  toContactAddress4: Scalars['String']['output'];
  toContactAddress5: Scalars['String']['output'];
  toContactEmail?: Maybe<Scalars['String']['output']>;
  toContactName: Scalars['String']['output'];
  toContactPhone: Scalars['String']['output'];
  toUser?: Maybe<User>;
  toUserId?: Maybe<Scalars['Int']['output']>;
  txList?: Maybe<Array<InventoryRequestTx>>;
  updatedDate: Scalars['String']['output'];
};

export type InventoryRequestTx = {
  __typename?: 'InventoryRequestTx';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  inWarehouse?: Maybe<Warehouse>;
  inWarehouseId?: Maybe<Scalars['Int']['output']>;
  inWarehousePartition?: Maybe<WarehousePartition>;
  inWarehousePartitionId?: Maybe<Scalars['Int']['output']>;
  inventoryRequest?: Maybe<InventoryRequest>;
  inventoryRequestId: Scalars['Int']['output'];
  isBorrowOut: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isOverShipped: Scalars['Boolean']['output'];
  isReturnBorrow: Scalars['Boolean']['output'];
  isScraped: Scalars['Boolean']['output'];
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  outWarehouse?: Maybe<Warehouse>;
  outWarehouseId?: Maybe<Scalars['Int']['output']>;
  outWarehousePartition?: Maybe<WarehousePartition>;
  outWarehousePartitionId?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Product>;
  productId: Scalars['Int']['output'];
  qty: Scalars['Int']['output'];
  totalConfirmReceivedQty: Scalars['Int']['output'];
  totalRefundQty: Scalars['Int']['output'];
  totalRemainingQty: Scalars['Int']['output'];
  totalReturnQty: Scalars['Int']['output'];
  totalShippedButAwaitingConfirmReceivedQty: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type InventoryTxCount = {
  __typename?: 'InventoryTxCount';
  actionType: InventoryTxCountActionType;
  batchDate: Scalars['String']['output'];
  holdQty: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inventoryLevelBefore?: Maybe<Scalars['Int']['output']>;
  inventoryRequestTx?: Maybe<InventoryRequestTx>;
  inventoryRequestTxId?: Maybe<Scalars['Int']['output']>;
  inventoryTxGroup?: Maybe<InventoryTxGroup>;
  inventoryTxGroupId: Scalars['Int']['output'];
  isScraped: Scalars['Boolean']['output'];
  pendingInQty: Scalars['Int']['output'];
  pendingOutQty: Scalars['Int']['output'];
  physicalQty: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productId: Scalars['Int']['output'];
  systemRemark: Scalars['String']['output'];
  usableQty: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['Int']['output'];
  warehousePartition?: Maybe<WarehousePartition>;
  warehousePartitionId: Scalars['Int']['output'];
};

export enum InventoryTxCountActionType {
  CancelByUndoConfirm = 'cancelByUndoConfirm',
  ConfirmDn = 'confirmDn',
  ConfirmGrn = 'confirmGrn',
  ConvertToScraped = 'convertToScraped',
  CreateAndConfirmDn = 'createAndConfirmDn',
  CreateAndConfirmGrn = 'createAndConfirmGrn',
  CreateDn = 'createDn',
  CreateDnForRemaining = 'createDnForRemaining',
  CreateGrn = 'createGrn',
  CreateGrnForMyorder = 'createGrnForMyorder',
  CreateGrnForRemaining = 'createGrnForRemaining',
  CreatePo = 'createPo',
  HoldByMyorder = 'holdByMyorder',
  HoldByReturnShipment = 'holdByReturnShipment',
  MarkAsCancelled = 'markAsCancelled',
  MarkAsCompleted = 'markAsCompleted',
  OrderShipment = 'orderShipment',
  RefundAndReturnForMyorder = 'refundAndReturnForMyorder',
  RefundUnshippedForMyorder = 'refundUnshippedForMyorder',
  RequestHold = 'requestHold',
  ReturnShipment = 'returnShipment',
  StockTakeDelta = 'stockTakeDelta',
  TransferInAtOnce = 'transferInAtOnce',
  TransferOutAtOnce = 'transferOutAtOnce',
  UndoCloseInventoryRequest = 'undoCloseInventoryRequest',
  UndoConfirmDn = 'undoConfirmDn',
  UndoConfirmGrn = 'undoConfirmGrn',
  UnholdByOrderShipment = 'unholdByOrderShipment',
  UnholdByRejectToReceive = 'unholdByRejectToReceive',
  UnholdForMyorder = 'unholdForMyorder',
  VoidRefund = 'voidRefund',
  Writeoff = 'writeoff'
}

export type InventoryTxGroup = {
  __typename?: 'InventoryTxGroup';
  canConfirmDeliveryNote: CanConfirmDeliveryNoteRes;
  canConfirmGoodsReceiveNote: CanConfirmGoodsReceiveNoteRes;
  canUndoConfirmDeliveryNote: Scalars['Boolean']['output'];
  canUndoConfirmGoodsReceiveNote: Scalars['Boolean']['output'];
  canUpdateAgreeToReceiveStockTransfer: CanUpdateAgreeToReceiveStockTransferRes;
  canUpdateInventoryTxGroupDetails: Scalars['Boolean']['output'];
  closedByUser?: Maybe<User>;
  closedByUserId?: Maybe<Scalars['Int']['output']>;
  closedDate?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  deliveryNote?: Maybe<DeliveryNote>;
  fromOrg?: Maybe<Organization>;
  fromOrgId?: Maybe<Scalars['Int']['output']>;
  goodsReceiveNote?: Maybe<GoodsReceiveNote>;
  groupType: InventoryTxGroupType;
  id: Scalars['Int']['output'];
  inDept?: Maybe<Department>;
  inDeptId?: Maybe<Scalars['Int']['output']>;
  inWarehouse?: Maybe<Warehouse>;
  inWarehouseId?: Maybe<Scalars['Int']['output']>;
  inventoryRequest?: Maybe<InventoryRequest>;
  inventoryTxCountList?: Maybe<Array<InventoryTxCount>>;
  isClosed: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myfileList?: Maybe<Array<Myfile>>;
  myorder?: Maybe<Myorder>;
  myorderId?: Maybe<Scalars['Int']['output']>;
  outDept?: Maybe<Department>;
  outDeptId?: Maybe<Scalars['Int']['output']>;
  outWarehouse?: Maybe<Warehouse>;
  outWarehouseId?: Maybe<Scalars['Int']['output']>;
  status: InventoryTxGroupStatus;
  systemRemark: Scalars['String']['output'];
  toOrg?: Maybe<Organization>;
  toOrgId?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['String']['output'];
  userRemark: Scalars['String']['output'];
};

export enum InventoryTxGroupStatus {
  AwaitingAcceptToReceive = 'awaitingAcceptToReceive',
  AwaitingConfirmReceive = 'awaitingConfirmReceive',
  AwaitingDelivery = 'awaitingDelivery',
  AwaitingShipOut = 'awaitingShipOut',
  AwaitingTransfer = 'awaitingTransfer',
  CancelByUndoConfirm = 'cancelByUndoConfirm',
  Cancelled = 'cancelled',
  Completed = 'completed',
  InProgress = 'inProgress',
  MarkAsCancelled = 'markAsCancelled',
  MarkAsCompleted = 'markAsCompleted',
  Na = 'na',
  RejectedToReceive = 'rejectedToReceive'
}

export enum InventoryTxGroupType {
  AdjustBorrow = 'adjustBorrow',
  AdjustPo = 'adjustPo',
  CancelMyorder = 'cancelMyorder',
  ConvertToScraped = 'convertToScraped',
  DeliveryNote = 'deliveryNote',
  GoodsReceiveNote = 'goodsReceiveNote',
  Hold = 'hold',
  HoldByMyorder = 'holdByMyorder',
  Myorder = 'myorder',
  PurchaseOrder = 'purchaseOrder',
  PureStockOut = 'pureStockOut',
  RefundMyorder = 'refundMyorder',
  ReportDamaged = 'reportDamaged',
  ReturnForPo = 'returnForPo',
  SelfPickUp = 'selfPickUp',
  ShipmentReturnNote = 'shipmentReturnNote',
  Shipped = 'shipped',
  StockInAdHoc = 'stockInAdHoc',
  Stocktake = 'stocktake',
  Transfer = 'transfer',
  Unhold = 'unhold',
  VoidMyorder = 'voidMyorder',
  WriteOff = 'writeOff'
}

export type IsItemBookmarkedResGql = {
  __typename?: 'IsItemBookmarkedResGql';
  isBookmarked: Scalars['Boolean']['output'];
};

export type KwtdhcBatchImportMemberInput = {
  resetArchive: Scalars['Boolean']['input'];
  uploadFileInput: UploadFileInput;
};

export type KwtdhcBatchImportMemberJob = {
  __typename?: 'KwtdhcBatchImportMemberJob';
  createdDateTime: Scalars['String']['output'];
  data?: Maybe<KwtdhcBatchImportMemberProcessData>;
  failedReason: Scalars['String']['output'];
  finishedDateTime?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  progress: BullQueueProgress;
  result?: Maybe<KwtdhcBatchImportMemberProcessResult>;
  status: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type KwtdhcBatchImportMemberProcessData = {
  __typename?: 'KwtdhcBatchImportMemberProcessData';
  myfileId?: Maybe<Scalars['Int']['output']>;
  resetArchive: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
};

export type KwtdhcBatchImportMemberProcessResult = {
  __typename?: 'KwtdhcBatchImportMemberProcessResult';
  importedMemberIdList: Array<Scalars['Int']['output']>;
  noOfImported: Scalars['Int']['output'];
  noOfSkipped: Scalars['Int']['output'];
  result: Scalars['String']['output'];
  skippedRowList: Array<Scalars['Int']['output']>;
  totalNoOfRows: Scalars['Int']['output'];
};

export type KwtdhcBatchImportMemberSearchBullQueueResGql = {
  __typename?: 'KwtdhcBatchImportMemberSearchBullQueueResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<KwtdhcBatchImportMemberJob>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type KwtdhcEvent = {
  __typename?: 'KwtdhcEvent';
  annualHrfa: Scalars['Int']['output'];
  attendance: Scalars['Int']['output'];
  ccdcEnrolment: Scalars['Int']['output'];
  ccdcPreEnrolment: Scalars['Int']['output'];
  centerLocation: Scalars['String']['output'];
  collaborativeWith: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  eventDate?: Maybe<Scalars['String']['output']>;
  eventEndTime?: Maybe<Scalars['String']['output']>;
  eventStartTime?: Maybe<Scalars['String']['output']>;
  firstHrfa: Scalars['Int']['output'];
  flu: Scalars['Int']['output'];
  hpv: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  method: Scalars['String']['output'];
  myfileList?: Maybe<Array<Myfile>>;
  name: Scalars['String']['output'];
  otherVaccination: Scalars['Int']['output'];
  outreachLocation: Scalars['String']['output'];
  outreachType: Scalars['String']['output'];
  partnerName: Scalars['String']['output'];
  pneumococcal: Scalars['Int']['output'];
  remark: Scalars['String']['output'];
  types: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  zoster: Scalars['Int']['output'];
};

export type KwtdhcLoginByJwtInput = {
  jwt: Scalars['String']['input'];
};

export type KwtdhcMemberFollowup = {
  __typename?: 'KwtdhcMemberFollowup';
  createdDate: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isFollowUpAlready: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  mobile: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remark: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export enum LanguagePreference {
  En = 'en',
  Sc = 'sc',
  Tc = 'tc'
}

export type Lesson = {
  __typename?: 'Lesson';
  coachCheckInRecord?: Maybe<LessonCoach>;
  coachList?: Maybe<Array<FullUser>>;
  conflictBookingList?: Maybe<Array<FacilityBooking>>;
  course?: Maybe<Course>;
  courseId: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  dayOfWeek: Scalars['Int']['output'];
  endDateTime: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  enrolmentList?: Maybe<Array<LessonEnrolment>>;
  facilityList?: Maybe<Array<Facility>>;
  id: Scalars['Int']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isEnable: Scalars['Boolean']['output'];
  lessonCoachList?: Maybe<Array<LessonCoach>>;
  makeupLesson?: Maybe<Lesson>;
  makeupLessonId?: Maybe<Scalars['Int']['output']>;
  remark: Scalars['String']['output'];
  sortQuotaLeft: Scalars['Int']['output'];
  startDateTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};


export type LessonCoachCheckInRecordArgs = {
  coachId: Scalars['Float']['input'];
};

export type LessonCancelAttendanceInput = {
  bypassTimeCheck: Scalars['Boolean']['input'];
  coachId?: InputMaybe<Scalars['Int']['input']>;
  lessonEnrolmentIdList: Array<Scalars['Int']['input']>;
  lessonId: Scalars['Int']['input'];
};

export type LessonCoach = {
  __typename?: 'LessonCoach';
  checkInDateTime?: Maybe<Scalars['String']['output']>;
  checkInDeviceId?: Maybe<Scalars['Int']['output']>;
  checkInMode?: Maybe<CheckInMode>;
  coach?: Maybe<User>;
  coachId: Scalars['Int']['output'];
  course?: Maybe<Course>;
  id: Scalars['Int']['output'];
  isCommissionOverloaded: Scalars['Boolean']['output'];
  lesson?: Maybe<Lesson>;
  lessonId: Scalars['Int']['output'];
};

export type LessonEnrolment = {
  __typename?: 'LessonEnrolment';
  cancelDate?: Maybe<Scalars['String']['output']>;
  cancelReason: Scalars['String']['output'];
  checkInByCoachId?: Maybe<Scalars['Int']['output']>;
  checkInCoach?: Maybe<User>;
  checkInDateTime?: Maybe<Scalars['String']['output']>;
  checkInDeviceId?: Maybe<Scalars['Int']['output']>;
  checkInMode?: Maybe<CheckInMode>;
  course?: Maybe<Course>;
  courseEnrolment?: Maybe<CourseEnrolment>;
  courseEnrolmentId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  emailReminderSent: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isEarlyBird: Scalars['Boolean']['output'];
  lesson?: Maybe<Lesson>;
  lessonEnrolmentStatusHistoryList?: Maybe<Array<LessonEnrolmentStatusHistory>>;
  lessonId: Scalars['Int']['output'];
  makeupFromLesson?: Maybe<Lesson>;
  makeupFromLessonId?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myorder?: Maybe<Myorder>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  pushReminderSent: Scalars['Boolean']['output'];
  qty: Scalars['Int']['output'];
  refundByMyorderItem?: Maybe<MyorderItem>;
  smsReminderSent: Scalars['Boolean']['output'];
  status: EnrolmentStatus;
  uniformOption: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  whatsappReminderSent: Scalars['Boolean']['output'];
};

export type LessonEnrolmentStatusHistory = {
  __typename?: 'LessonEnrolmentStatusHistory';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  lessonEnrolmentId: Scalars['Int']['output'];
  statusAction: EnrolmentStatusActionType;
  updatedDate: Scalars['String']['output'];
};

export enum LessonSelectionType {
  FirstLesson = 'firstLesson',
  Free = 'free',
  None = 'none'
}

export type LessonTakeAttendanceInput = {
  bypassTimeCheck: Scalars['Boolean']['input'];
  coachId?: InputMaybe<Scalars['Int']['input']>;
  lessonEnrolmentIdList: Array<Scalars['Int']['input']>;
  lessonId: Scalars['Int']['input'];
};

export type LoadInventoryToStockTakeInput = {
  id: Scalars['Int']['input'];
};

export type Location = {
  __typename?: 'Location';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locationAreaList?: Maybe<Array<LocationArea>>;
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  shortCode: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type LocationArea = {
  __typename?: 'LocationArea';
  createdDate: Scalars['String']['output'];
  facilityList?: Maybe<Array<Facility>>;
  id: Scalars['Int']['output'];
  location?: Maybe<Location>;
  locationId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  phone: Scalars['String']['output'];
  shortCode: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type LocationTimeSlotProgramTimeSlotInfo = {
  __typename?: 'LocationTimeSlotProgramTimeSlotInfo';
  dailyInfoList: Array<TimeSlotProgramDailyInfo>;
  locationQuotaLeft: Scalars['Int']['output'];
  timeSlotProgramLocation?: Maybe<TimeSlotProgramLocation>;
  timeSlotProgramLocationId: Scalars['Int']['output'];
};

export type Locker = {
  __typename?: 'Locker';
  activeLockerHistory?: Maybe<LockerHistory>;
  activeLockerHistoryId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  holdByMyorderItem?: Maybe<MyorderItem>;
  holdByMyorderItemId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isWebEnable: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  lockerGroup?: Maybe<LockerGroup>;
  lockerGroupId: Scalars['Int']['output'];
  password: Scalars['String']['output'];
  remark: Scalars['String']['output'];
  status: LockerStatus;
  updatedDate: Scalars['String']['output'];
};

export type LockerGroup = {
  __typename?: 'LockerGroup';
  accessPassDependencyList?: Maybe<Array<AccessPass>>;
  allowedNoOfDaysToRenew: Scalars['Int']['output'];
  column: Scalars['Int']['output'];
  countDayAsWorkingDays: Scalars['Boolean']['output'];
  createdDate: Scalars['String']['output'];
  deposit: Scalars['Float']['output'];
  depositAcctCode: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  gender: FilterGender;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isWebEnable: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  locationArea?: Maybe<LocationArea>;
  locationAreaId?: Maybe<Scalars['Int']['output']>;
  lockerGroupFeeList?: Maybe<Array<LockerGroupFee>>;
  lockerList?: Maybe<Array<Locker>>;
  lockerType?: Maybe<LockerType>;
  lockerTypeId?: Maybe<Scalars['Int']['output']>;
  nameEn: Scalars['String']['output'];
  namePos: Scalars['String']['output'];
  nameReceipt: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  noOfDaysToForfeitDeposit: Scalars['Int']['output'];
  photoList?: Maybe<Array<Myfile>>;
  renewGracePeriodNoOfDays: Scalars['Int']['output'];
  rentalAcctCode: Scalars['String']['output'];
  row: Scalars['Int']['output'];
  shortCode: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  waitingList?: Maybe<Array<LockerGroupWaitingList>>;
};

export type LockerGroupFee = {
  __typename?: 'LockerGroupFee';
  allowAutoRenew: Scalars['Boolean']['output'];
  apcCatCodeForDeposit: Scalars['String']['output'];
  apcCatCodeForFee: Scalars['String']['output'];
  apcCatCodeForForfeitDeposit: Scalars['String']['output'];
  apcCatCodeForRefundDeposit: Scalars['String']['output'];
  apcDeposit?: Maybe<AcctProductCat>;
  apcFee?: Maybe<AcctProductCat>;
  apcForfeitDeposit?: Maybe<AcctProductCat>;
  apcRefundDeposit?: Maybe<AcctProductCat>;
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  lockerGroup?: Maybe<LockerGroup>;
  lockerGroupId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  noOfDay: Scalars['Int']['output'];
  noOfDaysToDoAutoRenew: Scalars['Int']['output'];
  noOfDaysToSendAutoRenewNotification: Scalars['Int']['output'];
  noOfDaysToSendRenewReminder: Scalars['Int']['output'];
  noOfMonth: Scalars['Int']['output'];
  noOfYear: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  renewPrice: Scalars['Float']['output'];
  updatedDate: Scalars['String']['output'];
};

export type LockerGroupWaitingList = {
  __typename?: 'LockerGroupWaitingList';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lockerGroupId: Scalars['Int']['output'];
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type LockerHistory = {
  __typename?: 'LockerHistory';
  activeDepositHistory?: Maybe<DepositHistory>;
  agreementMyFile?: Maybe<Myfile>;
  agreementMyfileId?: Maybe<Scalars['Int']['output']>;
  autoRenewNextLockerGroupFee?: Maybe<LockerGroupFee>;
  autoRenewNextLockerGroupFeeId?: Maybe<Scalars['Int']['output']>;
  autoRenewNoOfTrial: Scalars['Int']['output'];
  autoRenewNotificationSentDateTime?: Maybe<Scalars['String']['output']>;
  contractEndDate: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  depositHistory: Array<DepositHistory>;
  emailReminderSent: Scalars['Boolean']['output'];
  enableAutoRenew: Scalars['Boolean']['output'];
  endDate: Scalars['String']['output'];
  forceNoRenew: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isRenew: Scalars['Boolean']['output'];
  isRenewableNow: Scalars['Boolean']['output'];
  letterReminderSent: Scalars['Boolean']['output'];
  locker?: Maybe<Locker>;
  lockerGroupFee?: Maybe<LockerGroupFee>;
  lockerGroupFeeId?: Maybe<Scalars['Int']['output']>;
  lockerId: Scalars['Int']['output'];
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  note: Scalars['String']['output'];
  oldAgreementNo: Scalars['String']['output'];
  oldOrderNo: Scalars['String']['output'];
  org?: Maybe<Organization>;
  orgId?: Maybe<Scalars['Int']['output']>;
  password: Scalars['String']['output'];
  pushReminderSent: Scalars['Boolean']['output'];
  renewEndDate: Scalars['String']['output'];
  renewStartDate: Scalars['String']['output'];
  returnDate?: Maybe<Scalars['String']['output']>;
  smsReminderSent: Scalars['Boolean']['output'];
  startDate: Scalars['String']['output'];
  transferFromLockerHistory?: Maybe<LockerHistory>;
  transferFromLockerHistoryId?: Maybe<Scalars['Int']['output']>;
  transferToLockerHistory?: Maybe<LockerHistory>;
  updatedDate: Scalars['String']['output'];
};

export enum LockerStatus {
  Available = 'available',
  Broken = 'broken',
  Expired = 'expired',
  Hold = 'hold',
  NotExist = 'notExist',
  Returned = 'returned',
  Taken = 'taken',
  TakenAlmostExpired = 'takenAlmostExpired',
  TakenExpired = 'takenExpired'
}

export type LockerType = {
  __typename?: 'LockerType';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  shortCode: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type LoginByAzureSsoInput = {
  idToken: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginByMemberNoInput = {
  membershipNo: Scalars['String']['input'];
};

export type LoginByTimeSlotProgramReservationInput = {
  hkid?: InputMaybe<Scalars['String']['input']>;
  mobileNo?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  reservationId: Scalars['Int']['input'];
};

export type LoginMemberInput = {
  appBuildNo?: InputMaybe<Scalars['Int']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  keepLogin: Scalars['Boolean']['input'];
  loginKey: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginMemberResGql = {
  __typename?: 'LoginMemberResGql';
  accessToken: Scalars['String']['output'];
  member: FullMember;
  requireTotp: Scalars['Boolean']['output'];
};

export type LoginUserInput = {
  keepLogin?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginUserResGql = {
  __typename?: 'LoginUserResGql';
  accessToken: Scalars['String']['output'];
  enforceTotpSetup: Scalars['Boolean']['output'];
  requirePasswordChange: Scalars['Boolean']['output'];
  requireTotp: Scalars['Boolean']['output'];
  user: FullUser;
};

export enum LotteryDrawPriority {
  MustDraw = 'mustDraw',
  MustNotDraw = 'mustNotDraw',
  Normal = 'normal'
}

export type MakeLockerAvailableInput = {
  lockerId: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type MakeReturnShipmentInput = {
  myorderId: Scalars['Int']['input'];
  shipmentDtoList: Array<ReturnShipmentInput>;
  userRemark: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type MakeShipmentInput = {
  ignoreProductRedeemEndDateCheck?: InputMaybe<Scalars['Boolean']['input']>;
  myorderId: Scalars['Int']['input'];
  outDeptId?: InputMaybe<Scalars['Int']['input']>;
  shipmentDtoList: Array<ShipmentInput>;
  warehouseId: Scalars['Int']['input'];
};

export type ManualAddAccessPassHistoryInput = {
  accessPassId: Scalars['Int']['input'];
  accessPassOptionId: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  memberId: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type ManualCheckInAuthInput = {
  hkid4: Scalars['String']['input'];
  mobileTel: Scalars['String']['input'];
};

export type ManualCheckInAuthResGql = {
  __typename?: 'ManualCheckInAuthResGql';
  accessToken: Scalars['String']['output'];
  member: FullMember;
};

export type ManualDeleteAccessPassHistoryInput = {
  id: Scalars['Int']['input'];
};

export type ManualOverrideMembershipInfoInput = {
  memberId: Scalars['Int']['input'];
  membershipTypeId: Scalars['Int']['input'];
  newEndDate?: InputMaybe<Scalars['String']['input']>;
};

export type ManualUpdateAccessPassHistoryInput = {
  accessPassId: Scalars['Int']['input'];
  accessPassOptionId: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type MarkDriveDepositAsDonationInput = {
  memberId: Scalars['Int']['input'];
};

export type MarkMsgQueueAsReadWithHashInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  msgHash: Scalars['String']['input'];
  msgQueueId: Scalars['Int']['input'];
  targetUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkNonPgRefundPayoutCompletedInput = {
  completionNote?: InputMaybe<Scalars['String']['input']>;
  refundPayoutRequestId: Scalars['Int']['input'];
};

export type MaskedCourseEnrolmentResultResGql = {
  __typename?: 'MaskedCourseEnrolmentResultResGql';
  maskedMemberNameEn: Scalars['String']['output'];
  maskedMemberNameTc: Scalars['String']['output'];
  membershipNo: Scalars['String']['output'];
};

export type MassAddLessonToCourseInput = {
  coachIdList: Array<Scalars['Int']['input']>;
  daysOfWeeks: Array<Scalars['Int']['input']>;
  endDate: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  facilityIdList: Array<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  ignoreCoachConflict?: Scalars['Boolean']['input'];
  ignoreFacilityConflict?: Scalars['Boolean']['input'];
  remark: Scalars['String']['input'];
  returnLessonRangeEnd?: InputMaybe<Scalars['String']['input']>;
  returnLessonRangeStart?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type MassAddLessonToCourseResGql = {
  __typename?: 'MassAddLessonToCourseResGql';
  id: Scalars['Int']['output'];
  lessonList: Array<Lesson>;
  timeslotResList: Array<TimeslotResGql>;
};

export type MassUpdateLessonInput = {
  coachIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  courseId: Scalars['Int']['input'];
  endTime?: InputMaybe<Scalars['String']['input']>;
  facilityIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  ignoreCoachConflict?: Scalars['Boolean']['input'];
  ignoreFacilityConflict?: Scalars['Boolean']['input'];
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  lessonIdList: Array<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type MeAddAccessPassToCartInput = {
  accessPassId: Scalars['Int']['input'];
  accessPassOptionId: Scalars['Int']['input'];
  addToMemberId: Scalars['Int']['input'];
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  isRenew: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type MeAddBbsToCartInput = {
  bbsReferral: Scalars['String']['input'];
  cartType: CartType;
};

export type MeAddBookingAndCoachToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  coachId: Scalars['Int']['input'];
  coachServiceId: Scalars['Int']['input'];
  endDateTime: Scalars['String']['input'];
  eventCode?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['Int']['input'];
  memberIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  myEventId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type MeAddBookingToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  endDateTime: Scalars['String']['input'];
  eventCode?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['Int']['input'];
  memberIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  myEventId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type MeAddBookmarkInput = {
  bookmarkType: BookmarkType;
  id: Scalars['Int']['input'];
};

export type MeAddCoachToExistingBookingInput = {
  cartType: CartType;
  coachId: Scalars['Int']['input'];
  coachServiceId: Scalars['Int']['input'];
  facilityBookingId: Scalars['Int']['input'];
};

export type MeAddCouponPackageToCartInput = {
  cartType: CartType;
  couponPackageId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
};

export type MeAddCourseEnrolmentInput = {
  courseId: Scalars['Int']['input'];
  enrolMemberId: Scalars['Int']['input'];
  uniformOption: Scalars['String']['input'];
};

export type MeAddCourseEnrolmentToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  courseId: Scalars['Int']['input'];
  enrolMemberId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
  uniformOption?: Scalars['String']['input'];
};

export type MeAddCreditPackageToCartInput = {
  cartType: CartType;
  creditPackageId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
};

export type MeAddDriveDepositToCartInput = {
  amount: Scalars['Float']['input'];
  cartType: CartType;
  driveTeamId: Scalars['Float']['input'];
};

export type MeAddFunkidsCompetitionToCartInput = {
  address: Scalars['String']['input'];
  birthCert: Scalars['String']['input'];
  chineseName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emergencyNo: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  gender: FilterGender;
  givenName: Scalars['String']['input'];
  hkid: Scalars['String']['input'];
  item01: Scalars['Boolean']['input'];
  item02: Scalars['Boolean']['input'];
  item03: Scalars['Boolean']['input'];
  item04: Scalars['Boolean']['input'];
  item05: Scalars['Boolean']['input'];
  item06: Scalars['Boolean']['input'];
  item07: Scalars['Boolean']['input'];
  item08: Scalars['Boolean']['input'];
  item09: Scalars['Boolean']['input'];
  item10: Scalars['Boolean']['input'];
  item11: Scalars['Boolean']['input'];
  item12: Scalars['Boolean']['input'];
  item13: Scalars['Boolean']['input'];
  item14: Scalars['Boolean']['input'];
  item15: Scalars['Boolean']['input'];
  mobile1: Scalars['String']['input'];
  mobile2: Scalars['String']['input'];
  parentName: Scalars['String']['input'];
  passport: Scalars['String']['input'];
  yob: Scalars['Int']['input'];
};

export type MeAddLessonEnrolmentToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  courseId: Scalars['Int']['input'];
  enrolMemberId: Scalars['Int']['input'];
  lessonIdList: Array<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
  uniformOption?: Scalars['String']['input'];
};

export type MeAddLockerToCartInput = {
  cartType: CartType;
  lockerGroupFeeId: Scalars['Int']['input'];
  lockerId: Scalars['Int']['input'];
  oldLockerId?: InputMaybe<Scalars['Int']['input']>;
};

export type MeAddLostCardToCartInput = {
  cartType: CartType;
};

export type MeAddMemberRelationshipRequestInput = {
  relatedMemberId: Scalars['Int']['input'];
  relationshipType: RelationshipType;
};

export type MeAddMemberToWaitingList = {
  courseId: Scalars['Int']['input'];
  enrolMemberId: Scalars['Int']['input'];
  ignoreAgeCheck?: Scalars['Boolean']['input'];
  ignoreDateCheck?: Scalars['Boolean']['input'];
  ignoreMemberRelationship: Scalars['Boolean']['input'];
  ignoreMemberScheduleConflict: Scalars['Boolean']['input'];
};

export type MeAddMembershipToCartInput = {
  cartType: CartType;
  driveMemberId?: InputMaybe<Scalars['Int']['input']>;
  driveTeamId?: InputMaybe<Scalars['Int']['input']>;
  membershipTypeId: Scalars['Int']['input'];
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
};

export type MeAddMyEventEnrolmentToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  myEventId: Scalars['Int']['input'];
  myEventTicketTypeId: Scalars['Int']['input'];
  qty?: InputMaybe<Scalars['Int']['input']>;
  seatNoList: Array<Scalars['Int']['input']>;
  teamMemberList?: Array<AddMyEventTeamMemberInput>;
  teamName: Scalars['String']['input'];
};

export type MeAddMyfileToMemberInput = {
  uploadFileInput: UploadFileInput;
};

export type MeAddProductToCartInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  cartType: CartType;
  productId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
  removeExistingQty: Scalars['Boolean']['input'];
};

export type MeAddTennisOpen2022ToCartInput = {
  competitionId: Scalars['Int']['input'];
  p1Over18: Scalars['Boolean']['input'];
  p1address: Scalars['String']['input'];
  p1birthCert: Scalars['String']['input'];
  p1chineseName: Scalars['String']['input'];
  p1club: Scalars['String']['input'];
  p1division: Scalars['String']['input'];
  p1email: Scalars['String']['input'];
  p1emergencyNo: Scalars['String']['input'];
  p1familyName: Scalars['String']['input'];
  p1givenName: Scalars['String']['input'];
  p1hkid: Scalars['String']['input'];
  p1hktaPin: Scalars['String']['input'];
  p1mobile1: Scalars['String']['input'];
  p1mobile2: Scalars['String']['input'];
  p1parentName: Scalars['String']['input'];
  p1passport: Scalars['String']['input'];
  p1prcId: Scalars['String']['input'];
  p2Over18: Scalars['Boolean']['input'];
  p2address: Scalars['String']['input'];
  p2birthCert: Scalars['String']['input'];
  p2chineseName: Scalars['String']['input'];
  p2club: Scalars['String']['input'];
  p2division: Scalars['String']['input'];
  p2email: Scalars['String']['input'];
  p2emergencyNo: Scalars['String']['input'];
  p2familyName: Scalars['String']['input'];
  p2givenName: Scalars['String']['input'];
  p2hkid: Scalars['String']['input'];
  p2hktaPin: Scalars['String']['input'];
  p2mobile1: Scalars['String']['input'];
  p2mobile2: Scalars['String']['input'];
  p2parentName: Scalars['String']['input'];
  p2passport: Scalars['String']['input'];
  p2prcId: Scalars['String']['input'];
};

export type MeAddTimeSlotProgramReservationInput = {
  customString01: Scalars['String']['input'];
  customString02: Scalars['String']['input'];
  customString03: Scalars['String']['input'];
  customString04: Scalars['String']['input'];
  customString05: Scalars['String']['input'];
  customString06: Scalars['String']['input'];
  customString07: Scalars['String']['input'];
  customString08: Scalars['String']['input'];
  customString09: Scalars['String']['input'];
  customString10: Scalars['String']['input'];
  endDateTime: Scalars['String']['input'];
  hkid?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  refMembershipNo: Scalars['String']['input'];
  remark: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  timeSlotProgramId: Scalars['Int']['input'];
  timeSlotProgramLocationId: Scalars['Int']['input'];
  timeSlotProgramServiceTypeIdList?: Array<Scalars['Int']['input']>;
};

export type MeAddTkdCompetitionToCartInput = {
  address: Scalars['String']['input'];
  birthCert: Scalars['String']['input'];
  chineseName: Scalars['String']['input'];
  competitionGroup: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emergencyNo: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  gender: FilterGender;
  givenName: Scalars['String']['input'];
  grade: Scalars['String']['input'];
  height: Scalars['String']['input'];
  hkid: Scalars['String']['input'];
  mobile1: Scalars['String']['input'];
  mobile2: Scalars['String']['input'];
  parentName: Scalars['String']['input'];
  passport: Scalars['String']['input'];
  weight: Scalars['String']['input'];
  yob: Scalars['Int']['input'];
};

export type MeApplyCouponToFacilityBookingInput = {
  couponPackageInstanceId?: InputMaybe<Scalars['Int']['input']>;
  endDateTime: Scalars['String']['input'];
  facilityBookingId: Scalars['Int']['input'];
  startDateTime: Scalars['String']['input'];
};

export type MeApplyCouponToPrivateCoachInput = {
  coachMyorderItemId: Scalars['Int']['input'];
  couponPackageInstanceId?: InputMaybe<Scalars['Int']['input']>;
};

export type MeCancelCourseEnrolmentInput = {
  cancelReason: Scalars['String']['input'];
  courseId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type MeCancelMyorderInput = {
  id: Scalars['Int']['input'];
};

export type MeCancelTimeSlotProgramReservationInput = {
  reservationId: Scalars['Int']['input'];
};

export type MeCleanMemberSessionInput = {
  sessionIdList?: Array<Scalars['Int']['input']>;
};

export type MeConvertToOrderAndGetStripeSessionUrlInput = {
  cancelUrl: Scalars['String']['input'];
  cartType: CartType;
  lang?: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
  updatedDate: Scalars['String']['input'];
};

export type MeConvertToOrderInput = {
  cartType: CartType;
  gateway?: InputMaybe<Scalars['String']['input']>;
  gpTokenId?: InputMaybe<Scalars['Int']['input']>;
  lang?: Scalars['String']['input'];
  saveCreditCard?: Scalars['Boolean']['input'];
  updatedDate: Scalars['String']['input'];
};

export type MeCreateTrialMemberAndAddCourseEnrolmentToCartInput = {
  courseId: Scalars['Int']['input'];
  createTrialMemberInput: CreateTrialMemberInput;
  invitationCode?: Scalars['String']['input'];
  lessonIdList: Array<Scalars['Int']['input']>;
  uniformOption?: Scalars['String']['input'];
};

export type MeCreateTrialMemberAndAddLessonEnrolmentToCartInput = {
  courseId: Scalars['Int']['input'];
  createTrialMemberInput: CreateTrialMemberInput;
  invitationCode?: Scalars['String']['input'];
  lessonIdList: Array<Scalars['Int']['input']>;
  uniformOption?: Scalars['String']['input'];
};

export type MeCreateTrialMemberAndAddToCourseEnrolmentInput = {
  courseId: Scalars['Int']['input'];
  createTrialMemberInput: CreateTrialMemberInput;
  invitationCode?: Scalars['String']['input'];
  lessonIdList: Array<Scalars['Int']['input']>;
  uniformOption?: Scalars['String']['input'];
};

export type MeDeleteBookmarkInput = {
  bookmarkType: BookmarkType;
  id: Scalars['Int']['input'];
};

export type MeGetAccessPassPurchaseListInput = {
  addToMemberId?: InputMaybe<Scalars['Int']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  getNonMainList: Scalars['Boolean']['input'];
};

export type MeGetBiometricTokenResInput = {
  __typename?: 'MeGetBiometricTokenResInput';
  sessionId: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

export type MeGetCartInput = {
  cartType: CartType;
};

export type MeGetCourseEnrolmentQrCodeInput = {
  courseEnrolmentId: Scalars['Int']['input'];
};

export type MeGetEffectiveBookingInfoInput = {
  facilityIdList: Array<Scalars['Int']['input']>;
};

export type MeGetFacilityEffectiveLeadTimeForMemberInput = {
  facilityId: Scalars['Int']['input'];
};

export type MeGetFacilityEffectiveNoOfTimeslotForMemberInput = {
  facilityId: Scalars['Int']['input'];
};

export type MeGetLatestMemberAccessPassHistoryListInput = {
  showExpired: Scalars['Boolean']['input'];
};

export type MeGetLatestMemberDepositHistoryListInput = {
  showActiveOnly: Scalars['Boolean']['input'];
};

export type MeGetLockerListInput = {
  lockerGroupId: Scalars['Int']['input'];
};

export type MeGetMemberActivityListInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type MeGetMemberCourseEnrolmentHistoryInput = {
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  statusList: Array<EnrolmentStatus>;
};

export type MeGetMemberDepositHistoryInput = {
  accessPassId?: InputMaybe<Scalars['Int']['input']>;
  depositType?: InputMaybe<DepositType>;
  lockerId?: InputMaybe<Scalars['Int']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
  status?: InputMaybe<DepositStatus>;
};

export type MeGetMemberDriveScoreHistoryInput = {
  drivePhase?: InputMaybe<Scalars['Int']['input']>;
  driveYear?: InputMaybe<Scalars['Int']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
};

export type MeGetMemberFacilityBookingHistoryInput = {
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
};

export type MeGetMemberLessonEnrolmentHistoryInput = {
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  statusList: Array<EnrolmentStatus>;
};

export type MeGetMemberMembershipHistoryInput = {
  membershipTypeId?: InputMaybe<Scalars['Int']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
};

export type MeGetMemberMyorderHistoryInput = {
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: QueryOrderByTypeEnum;
  pageNo?: Scalars['Int']['input'];
  status?: InputMaybe<MyorderAllStatus>;
};

export type MeGetMemberProductRedeemOrderInput = {
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy?: InputMaybe<QueryOrderByMyorderInput>;
  pageNo?: Scalars['Int']['input'];
  status?: Scalars['String']['input'];
};

export type MeGetMsgQueueInput = {
  id: Scalars['Int']['input'];
};

export type MeGetMyfileInput = {
  myfileId: Scalars['Int']['input'];
  returnB64: Scalars['Boolean']['input'];
  viewport?: InputMaybe<Scalars['Int']['input']>;
};

export type MeGetMyorderItemQrCodeInput = {
  myorderItemId: Scalars['Int']['input'];
};

export type MeGetOtpInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  membershipNo?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
};

export type MeGetStripeSessionUrlInput = {
  cancelUrl: Scalars['String']['input'];
  myorderId: Scalars['Int']['input'];
  successUrl: Scalars['String']['input'];
};

export type MeGetTimeSlotProgramReservationQrCodeInput = {
  reservationId: Scalars['Int']['input'];
};

export type MeIsItemBookmarkedInput = {
  bookmarkType: BookmarkType;
  id: Scalars['Int']['input'];
};

export type MeManualCheckInInput = {
  checkInType: CheckInType;
  myEventEnrolmentId?: InputMaybe<Scalars['Int']['input']>;
  myorderItemId?: InputMaybe<Scalars['Int']['input']>;
};

export type MeMarkMsgQueueAsReadInput = {
  msgQueueId: Scalars['Int']['input'];
};

export type MePurgeMyfileFromMemberInput = {
  myfileId: Scalars['Int']['input'];
};

export type MeQueryCondCoachServiceInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MeQueryCondProductCatInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MeQueryCondProductInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MeQueryOrderByCoachServiceInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type MeQueryOrderByProductCatInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type MeQueryOrderByProductInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type MeRegisterEshopMemberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  ageGroup?: InputMaybe<AgeGroup>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  aspenSeqNo?: InputMaybe<Scalars['String']['input']>;
  autoRenewNoOfTrial?: InputMaybe<Scalars['Int']['input']>;
  autoRenewNotificationSentDateTime?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cardIssueDate?: InputMaybe<Scalars['String']['input']>;
  cardLostNo?: InputMaybe<Scalars['Int']['input']>;
  cardReplacementNo?: InputMaybe<Scalars['Float']['input']>;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  isAddressIncorrectDate?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklistedDate?: InputMaybe<Scalars['String']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidentialDate?: InputMaybe<Scalars['String']['input']>;
  isDeceasedDate?: InputMaybe<Scalars['String']['input']>;
  isImmigratedDate?: InputMaybe<Scalars['String']['input']>;
  isSuspendedDate?: InputMaybe<Scalars['String']['input']>;
  joinDate?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  lastModifyUserId?: InputMaybe<Scalars['Int']['input']>;
  lastValidMembershipStartDate?: InputMaybe<Scalars['String']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveReferralId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveTeamId?: InputMaybe<Scalars['Int']['input']>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  photoMyfileId?: InputMaybe<Scalars['Int']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  proofMyfileId?: InputMaybe<Scalars['Int']['input']>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requireReview?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
};

export type MeRemoveGpTokenInput = {
  gpTokenId: Scalars['Int']['input'];
};

export type MeRemoveItemFromCartInput = {
  cartType: CartType;
  myorderItemId: Scalars['Int']['input'];
};

export type MeSearchCoachServiceInput = {
  andCondList?: Array<MeQueryCondCoachServiceInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<MeQueryCondCoachServiceInput>;
  orderBy?: InputMaybe<MeQueryOrderByCoachServiceInput>;
  orderByList?: InputMaybe<Array<MeQueryOrderByCoachServiceInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type MeSearchProductCatInput = {
  andCondList?: Array<MeQueryCondProductCatInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<MeQueryCondProductCatInput>;
  orderBy?: InputMaybe<MeQueryOrderByProductCatInput>;
  orderByList?: InputMaybe<Array<MeQueryOrderByProductCatInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type MeSearchProductInput = {
  andCondList?: Array<MeQueryCondProductInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<MeQueryCondProductInput>;
  orderBy?: InputMaybe<MeQueryOrderByProductInput>;
  orderByList?: InputMaybe<Array<MeQueryOrderByProductInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type MeSetGpTokenDefaultInput = {
  gpTokenId: Scalars['Int']['input'];
};

export type MeSubmitParQInput = {
  d1: Scalars['Boolean']['input'];
  q1: Scalars['Boolean']['input'];
  q2: Scalars['Boolean']['input'];
  q3: Scalars['Boolean']['input'];
  q4: Scalars['Boolean']['input'];
  q5: Scalars['Boolean']['input'];
  q6: Scalars['Boolean']['input'];
  q7: Scalars['Boolean']['input'];
  signature: UploadImageInput;
};

export type MeUpdateAccessPassHistoryAutoRenewInput = {
  accessPassHistoryId: Scalars['Int']['input'];
  autoRenewNextAccessPassOptionId?: InputMaybe<Scalars['Int']['input']>;
  enableAutoRenew: Scalars['Boolean']['input'];
};

export type MeUpdateBbsCartInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  bbsReferral: Scalars['String']['input'];
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cartType: CartType;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  driveMemberId?: InputMaybe<Scalars['Int']['input']>;
  driveTeamId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  loginMobile?: InputMaybe<Scalars['String']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  mgmReferralCode: Scalars['String']['input'];
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MeUpdateEshopMemberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  ageGroup?: InputMaybe<AgeGroup>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  aspenSeqNo?: InputMaybe<Scalars['String']['input']>;
  autoRenewNoOfTrial?: InputMaybe<Scalars['Int']['input']>;
  autoRenewNotificationSentDateTime?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cardIssueDate?: InputMaybe<Scalars['String']['input']>;
  cardLostNo?: InputMaybe<Scalars['Int']['input']>;
  cardReplacementNo?: InputMaybe<Scalars['Float']['input']>;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  isAddressIncorrectDate?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklistedDate?: InputMaybe<Scalars['String']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidentialDate?: InputMaybe<Scalars['String']['input']>;
  isDeceasedDate?: InputMaybe<Scalars['String']['input']>;
  isImmigratedDate?: InputMaybe<Scalars['String']['input']>;
  isSuspendedDate?: InputMaybe<Scalars['String']['input']>;
  joinDate?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  lastModifyUserId?: InputMaybe<Scalars['Int']['input']>;
  lastValidMembershipStartDate?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveReferralId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveTeamId?: InputMaybe<Scalars['Int']['input']>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  photoMyfileId?: InputMaybe<Scalars['Int']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  proofMyfileId?: InputMaybe<Scalars['Int']['input']>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requireReview?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
};

export type MeUpdateGuestAndCartInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cartType: CartType;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  driveMemberId?: InputMaybe<Scalars['Int']['input']>;
  driveTeamId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  loginMobile?: InputMaybe<Scalars['String']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  membershipTypeId: Scalars['Int']['input'];
  mgmReferralCode: Scalars['String']['input'];
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MeUpdateGuestInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  loginMobile?: InputMaybe<Scalars['String']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MeUpdateInboxStatusInput = {
  action: InboxAction;
  idList: Array<Scalars['Int']['input']>;
};

export type MeUpdateLockerHistoryAutoRenewInput = {
  autoRenewNextLockerGroupFeeId?: InputMaybe<Scalars['Int']['input']>;
  enableAutoRenew: Scalars['Boolean']['input'];
  lockerHistoryId: Scalars['Int']['input'];
};

export type MeUpdateMemberImageFileInput = {
  image: UploadImageInput;
  imageType: MyfileType;
};

export type MeUpdateMemberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  ageGroup?: InputMaybe<AgeGroup>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  aspenSeqNo?: InputMaybe<Scalars['String']['input']>;
  autoRenewNoOfTrial?: InputMaybe<Scalars['Int']['input']>;
  autoRenewNotificationSentDateTime?: InputMaybe<Scalars['String']['input']>;
  cardIssueDate?: InputMaybe<Scalars['String']['input']>;
  cardLostNo?: InputMaybe<Scalars['Int']['input']>;
  cardReplacementNo?: InputMaybe<Scalars['Float']['input']>;
  createdDate?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  isAddressIncorrectDate?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklistedDate?: InputMaybe<Scalars['String']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidentialDate?: InputMaybe<Scalars['String']['input']>;
  isDeceasedDate?: InputMaybe<Scalars['String']['input']>;
  isImmigratedDate?: InputMaybe<Scalars['String']['input']>;
  isSuspendedDate?: InputMaybe<Scalars['String']['input']>;
  joinDate?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  lastModifyUserId?: InputMaybe<Scalars['Int']['input']>;
  lastValidMembershipStartDate?: InputMaybe<Scalars['String']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveReferralId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveTeamId?: InputMaybe<Scalars['Int']['input']>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  photoMyfileId?: InputMaybe<Scalars['Int']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  proofMyfileId?: InputMaybe<Scalars['Int']['input']>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requireReview?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
};

export type MeUpdateMemberRelationshipRequestInput = {
  isApprove: Scalars['Boolean']['input'];
  relatedMemberId: Scalars['Int']['input'];
  relationshipId: Scalars['Int']['input'];
};

export type MeUpdateTimeSlotProgramReservationInput = {
  customString01: Scalars['String']['input'];
  customString02: Scalars['String']['input'];
  customString03: Scalars['String']['input'];
  customString04: Scalars['String']['input'];
  customString05: Scalars['String']['input'];
  customString06: Scalars['String']['input'];
  customString07: Scalars['String']['input'];
  customString08: Scalars['String']['input'];
  customString09: Scalars['String']['input'];
  customString10: Scalars['String']['input'];
  endDateTime: Scalars['String']['input'];
  oldReservationId: Scalars['Int']['input'];
  refMembershipNo: Scalars['String']['input'];
  remark: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  timeSlotProgramLocationId: Scalars['Int']['input'];
  timeSlotProgramServiceTypeIdList?: Array<Scalars['Int']['input']>;
};

export type MeUpdateUserInput = {
  coachTimeslotEndTime?: InputMaybe<Scalars['String']['input']>;
  coachTimeslotMins?: InputMaybe<Scalars['Int']['input']>;
  coachTimeslotStartTime?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  ssoMapping?: InputMaybe<Scalars['String']['input']>;
};

export type MeVerifyOtpInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  membershipNo?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};

export type Member = {
  __typename?: 'Member';
  ageGroup?: Maybe<AgeGroup>;
  allowToSelfCheckIn: Scalars['Boolean']['output'];
  aspenSeqNo?: Maybe<Scalars['String']['output']>;
  birthDate: Scalars['String']['output'];
  bonusPoint: Scalars['Int']['output'];
  cardLostNo: Scalars['Int']['output'];
  chineseName: Scalars['String']['output'];
  customString01: Scalars['String']['output'];
  customString02: Scalars['String']['output'];
  customString03: Scalars['String']['output'];
  customString04: Scalars['String']['output'];
  customString05: Scalars['String']['output'];
  customString06: Scalars['String']['output'];
  customString07: Scalars['String']['output'];
  customString08: Scalars['String']['output'];
  customString09: Scalars['String']['output'];
  customString10: Scalars['String']['output'];
  disableMemberLogin: Scalars['Boolean']['output'];
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emergencyContactName: Scalars['String']['output'];
  emergencyTel: Scalars['String']['output'];
  emergencyTelAreaCode: Scalars['String']['output'];
  enableAutoRenew: Scalars['Boolean']['output'];
  ethnicity: Scalars['String']['output'];
  favouriteSportId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<FilterGender>;
  givenName: Scalars['String']['output'];
  homeTel: Scalars['String']['output'];
  homeTelAreaCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDeceased: Scalars['Boolean']['output'];
  isSuspended: Scalars['Boolean']['output'];
  isTmp: Scalars['Boolean']['output'];
  isValidMember: Scalars['Boolean']['output'];
  joinDate?: Maybe<Scalars['String']['output']>;
  languagePreference: LanguagePreference;
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  lastValidMembershipStartDate?: Maybe<Scalars['String']['output']>;
  latestMemberParQ?: Maybe<MemberParQ>;
  memDriveDepositTotal: Scalars['Float']['output'];
  memberCreditBalanceList?: Maybe<Array<MemberCreditBalance>>;
  memberPhoto?: Maybe<Myfile>;
  membershipExpiryDate?: Maybe<Scalars['String']['output']>;
  membershipNo: Scalars['String']['output'];
  membershipTypeId?: Maybe<Scalars['Int']['output']>;
  mobileTel: Scalars['String']['output'];
  mobileTelAreaCode: Scalars['String']['output'];
  nationality?: Maybe<Country>;
  officeTel: Scalars['String']['output'];
  officeTelAreaCode: Scalars['String']['output'];
  oldMembershipNo: Scalars['String']['output'];
  photoMyfileId?: Maybe<Scalars['Int']['output']>;
  referralOrg?: Maybe<Organization>;
  referralOrgId?: Maybe<Scalars['Int']['output']>;
  remark: Scalars['String']['output'];
  studentExpiryDate?: Maybe<Scalars['String']['output']>;
  studentStatus?: Maybe<StudentStatus>;
  subDistrict?: Maybe<SubDistrict>;
  subDistrictId?: Maybe<Scalars['Int']['output']>;
  surname: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type MemberActivityResGql = {
  __typename?: 'MemberActivityResGql';
  endDateTime: Scalars['String']['output'];
  facilityBooking?: Maybe<FacilityBooking>;
  lessonEnrolment?: Maybe<LessonEnrolment>;
  myEventEnrolment?: Maybe<MyEventEnrolment>;
  startDateTime: Scalars['String']['output'];
};

export type MemberCreditBalance = {
  __typename?: 'MemberCreditBalance';
  balance: Scalars['Float']['output'];
  createdDate: Scalars['String']['output'];
  creditType?: Maybe<CreditType>;
  creditTypeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  memberId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type MemberEnrolmentStats = {
  __typename?: 'MemberEnrolmentStats';
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCancelled: Scalars['Int']['output'];
  isConfirmed: Scalars['Int']['output'];
  isRejected: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  totalAttendanceCount?: Maybe<Scalars['Int']['output']>;
  totalAttendanceRate?: Maybe<Scalars['Float']['output']>;
  totalNoShowCount?: Maybe<Scalars['Int']['output']>;
  totalShowCount?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['String']['output'];
};

export type MemberFacial = {
  __typename?: 'MemberFacial';
  checkingLotId: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  deleteRetryCount: Scalars['Int']['output'];
  facialTerminal?: Maybe<FacialTerminal>;
  facialTerminalId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastResult: Scalars['String']['output'];
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  nextDeleteDate?: Maybe<Scalars['String']['output']>;
  nextRetryDate?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  uploadDate?: Maybe<Scalars['String']['output']>;
};

export type MemberHdtBg = {
  __typename?: 'MemberHdtBg';
  bg: Scalars['Float']['output'];
  centreCode: Scalars['String']['output'];
  dataCaptureDateTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isLatest: Scalars['Boolean']['output'];
  mealType: Scalars['String']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  memberNo: Scalars['String']['output'];
  operatorId?: Maybe<Scalars['String']['output']>;
};

export type MemberHdtBpHr = {
  __typename?: 'MemberHdtBpHr';
  bpDia: Scalars['Int']['output'];
  bpPulse: Scalars['Int']['output'];
  bpSys: Scalars['Int']['output'];
  centreCode: Scalars['String']['output'];
  dataCaptureDateTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isLatest: Scalars['Boolean']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  memberNo: Scalars['String']['output'];
  operatorId?: Maybe<Scalars['String']['output']>;
};

export type MemberHdtBt = {
  __typename?: 'MemberHdtBt';
  bt: Scalars['Float']['output'];
  btBodysite: Scalars['String']['output'];
  centreCode: Scalars['String']['output'];
  dataCaptureDateTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isLatest: Scalars['Boolean']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  memberNo: Scalars['String']['output'];
  operatorId?: Maybe<Scalars['String']['output']>;
};

export type MemberHdtBwBhBmi = {
  __typename?: 'MemberHdtBwBhBmi';
  bh: Scalars['Int']['output'];
  bmi: Scalars['Float']['output'];
  bw: Scalars['Float']['output'];
  centreCode: Scalars['String']['output'];
  dataCaptureDateTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isLatest: Scalars['Boolean']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  memberNo: Scalars['String']['output'];
  operatorId?: Maybe<Scalars['String']['output']>;
};

export type MemberHdtSpo2Hr = {
  __typename?: 'MemberHdtSpo2Hr';
  centreCode: Scalars['String']['output'];
  dataCaptureDateTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isLatest: Scalars['Boolean']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  memberNo: Scalars['String']['output'];
  operatorId?: Maybe<Scalars['String']['output']>;
  spo2: Scalars['Int']['output'];
  spo2Pulse: Scalars['Int']['output'];
};

export type MemberList = {
  __typename?: 'MemberList';
  createdDate: Scalars['String']['output'];
  deptId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  memberListMemList?: Maybe<Array<MemberListMember>>;
  name: Scalars['String']['output'];
  remark: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  whitelistMsgEn: Scalars['String']['output'];
  whitelistMsgSc: Scalars['String']['output'];
  whitelistMsgTc: Scalars['String']['output'];
};

export type MemberListAsCourseMemberList = {
  __typename?: 'MemberListAsCourseMemberList';
  course?: Maybe<Course>;
  courseId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  memberList?: Maybe<MemberList>;
  memberListAsCourseMemberListType: MemberListAsCourseMemberListType;
  memberListId: Scalars['Int']['output'];
};

export enum MemberListAsCourseMemberListType {
  AutoAdd = 'autoAdd',
  Blacklist = 'blacklist',
  Priority = 'priority',
  Whitelist = 'whitelist'
}

export type MemberListAsRecurCourseMemberList = {
  __typename?: 'MemberListAsRecurCourseMemberList';
  id: Scalars['Int']['output'];
  memberList?: Maybe<MemberList>;
  memberListAsCourseMemberListType: MemberListAsCourseMemberListType;
  memberListId: Scalars['Int']['output'];
  recurCourse?: Maybe<RecurCourse>;
  recurCourseId: Scalars['Int']['output'];
};

export type MemberListMember = {
  __typename?: 'MemberListMember';
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  memberListId: Scalars['Int']['output'];
  remark: Scalars['String']['output'];
  sysRemark: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type MemberLocation = {
  __typename?: 'MemberLocation';
  aspenCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
};

export type MemberLotteryGroupScoreOverride = {
  __typename?: 'MemberLotteryGroupScoreOverride';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  lotteryGroupName: Scalars['String']['output'];
  member?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type MemberMovementStats = {
  __typename?: 'MemberMovementStats';
  beforeActive: Scalars['Int']['output'];
  beforeBlacklisted: Scalars['Int']['output'];
  beforeDeceased: Scalars['Int']['output'];
  beforeSuspended: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  currentActive: Scalars['Int']['output'];
  currentBlacklisted: Scalars['Int']['output'];
  currentDeceased: Scalars['Int']['output'];
  currentSuspended: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  expired: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  membershipType?: Maybe<MembershipType>;
  membershipTypeId?: Maybe<Scalars['Int']['output']>;
  newJoin: Scalars['Int']['output'];
  renewFromActive: Scalars['Int']['output'];
  renewFromExpired: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  upgradeFromActive: Scalars['Int']['output'];
  upgradeFromExpired: Scalars['Int']['output'];
  upgradeToOther: Scalars['Int']['output'];
};

export enum MemberNamePrintFormat {
  GivenNameFirst = 'GivenNameFirst',
  SurnameFirst = 'SurnameFirst'
}

export type MemberParQ = {
  __typename?: 'MemberParQ';
  approvedByUser?: Maybe<User>;
  approvedByUserId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  d1: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  internalRemark: Scalars['String']['output'];
  isSuperceded: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  q1: Scalars['Boolean']['output'];
  q2: Scalars['Boolean']['output'];
  q3: Scalars['Boolean']['output'];
  q4: Scalars['Boolean']['output'];
  q5: Scalars['Boolean']['output'];
  q6: Scalars['Boolean']['output'];
  q7: Scalars['Boolean']['output'];
  recommendedStatusByAnswers: MemberParQRecommendedStatusByAnswer;
  rejectUntilDate?: Maybe<Scalars['String']['output']>;
  rejectedByUser?: Maybe<User>;
  rejectedByUserId?: Maybe<Scalars['Int']['output']>;
  remark: Scalars['String']['output'];
  signatureMyfile?: Maybe<Myfile>;
  signatureMyfileId?: Maybe<Scalars['Int']['output']>;
  status: MemberParQStatus;
  updatedDate: Scalars['String']['output'];
  validUntilDate?: Maybe<Scalars['String']['output']>;
};

export enum MemberParQRecommendedStatusByAnswer {
  Rejected = 'rejected',
  Valid = 'valid'
}

export enum MemberParQStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
  Valid = 'valid'
}

export type MemberRelationship = {
  __typename?: 'MemberRelationship';
  confirmDate?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  memberId: Scalars['Int']['output'];
  relatedMember: Member;
  relatedMemberId: Scalars['Int']['output'];
  relationship: RelationshipType;
  updatedDate: Scalars['String']['output'];
};

export type MemberStripe = {
  __typename?: 'MemberStripe';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  memberId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type MembershipHistory = {
  __typename?: 'MembershipHistory';
  createdDate: Scalars['String']['output'];
  effectiveEndDate?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isNew: Scalars['Boolean']['output'];
  isRenew: Scalars['Boolean']['output'];
  isRenewFromActive: Scalars['Boolean']['output'];
  isRenewFromExpired: Scalars['Boolean']['output'];
  isUpgrade: Scalars['Boolean']['output'];
  isUpgradeFromActive: Scalars['Boolean']['output'];
  isUpgradeFromExpired: Scalars['Boolean']['output'];
  isUpgradeToOther: Scalars['Boolean']['output'];
  memberId: Scalars['Int']['output'];
  membershipNo: Scalars['String']['output'];
  membershipType?: Maybe<MembershipType>;
  membershipTypeId: Scalars['Int']['output'];
  myorder?: Maybe<Myorder>;
  myorderId?: Maybe<Scalars['Int']['output']>;
  remark: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  upgradeFromMembershipTypeId?: Maybe<Scalars['Int']['output']>;
};

export type MembershipType = {
  __typename?: 'MembershipType';
  allowedNoOfDaysToRenew: Scalars['Int']['output'];
  apcCatCodeForFee: Scalars['String']['output'];
  apcCatCodeForRenew: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  apcRenew?: Maybe<AcctProductCat>;
  aspenId: Scalars['String']['output'];
  canApplyOnline: Scalars['Boolean']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  initPrice: Scalars['Float']['output'];
  maxAge: Scalars['Int']['output'];
  maxAgeToWaiveStudentIdCheck: Scalars['Int']['output'];
  membershipNoPrefix: Scalars['String']['output'];
  minAge: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  nextSerialNo: Scalars['Int']['output'];
  orderDiscountPercent: Scalars['Int']['output'];
  printNameEn: Scalars['String']['output'];
  printNameSc: Scalars['String']['output'];
  printNameTc: Scalars['String']['output'];
  renewPrice: Scalars['Float']['output'];
  updatedDate: Scalars['String']['output'];
  validNoOfDay: Scalars['Int']['output'];
  validNoOfMonth: Scalars['Int']['output'];
  validNoOfYear: Scalars['Int']['output'];
};

export type MembershipTypeWithExpiryDateResGql = {
  __typename?: 'MembershipTypeWithExpiryDateResGql';
  allowedNoOfDaysToRenew: Scalars['Int']['output'];
  apcCatCodeForFee: Scalars['String']['output'];
  apcCatCodeForRenew: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  apcRenew?: Maybe<AcctProductCat>;
  aspenId: Scalars['String']['output'];
  canApplyOnline: Scalars['Boolean']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  initPrice: Scalars['Float']['output'];
  maxAge: Scalars['Int']['output'];
  maxAgeToWaiveStudentIdCheck: Scalars['Int']['output'];
  membershipNoPrefix: Scalars['String']['output'];
  minAge: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  newExpiryDate?: Maybe<Scalars['String']['output']>;
  nextSerialNo: Scalars['Int']['output'];
  orderDiscountPercent: Scalars['Int']['output'];
  printNameEn: Scalars['String']['output'];
  printNameSc: Scalars['String']['output'];
  printNameTc: Scalars['String']['output'];
  renewPrice: Scalars['Float']['output'];
  updatedDate: Scalars['String']['output'];
  validNoOfDay: Scalars['Int']['output'];
  validNoOfMonth: Scalars['Int']['output'];
  validNoOfYear: Scalars['Int']['output'];
};

export type MgmReferralCodeCheckInput = {
  code: Scalars['String']['input'];
};

export type MgmReferralCodeCheckResGql = {
  __typename?: 'MgmReferralCodeCheckResGql';
  isValid: Scalars['Boolean']['output'];
};

export type MiniSiteContent = {
  __typename?: 'MiniSiteContent';
  bannerList?: Maybe<Array<Myfile>>;
  bannerListEn: Array<Myfile>;
  bannerListSc: Array<Myfile>;
  bannerListTc: Array<Myfile>;
  courseType: CourseType;
  courseTypeId: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  htmlContentEn: Scalars['String']['output'];
  htmlContentSc: Scalars['String']['output'];
  htmlContentTc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  sportGroupId?: Maybe<Scalars['Int']['output']>;
  sportId?: Maybe<Scalars['Int']['output']>;
  sportType?: Maybe<SportType>;
  sportTypeGroup?: Maybe<SportTypeGroup>;
  updatedDate: Scalars['String']['output'];
};


export type MiniSiteContentBannerListArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
};

export enum MsgPlatform {
  AppPush = 'appPush',
  Email = 'email',
  Inbox = 'inbox',
  Sms = 'sms',
  WebPush = 'webPush',
  Whatsapp = 'whatsapp'
}

export type MsgQueue = {
  __typename?: 'MsgQueue';
  appChannel: Scalars['String']['output'];
  attachmentJson?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  docType: Scalars['String']['output'];
  emoji: Scalars['String']['output'];
  fromSystem: Scalars['Boolean']['output'];
  hookDataJson?: Maybe<Scalars['String']['output']>;
  htmlContent: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  inboxMsgId?: Maybe<Scalars['Int']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  msgPlatform: MsgPlatform;
  msgStatus: MsgStatus;
  nextRetryDateTime?: Maybe<Scalars['String']['output']>;
  plainContent: Scalars['String']['output'];
  replyToMsg?: Maybe<MsgQueue>;
  replyToMsgId?: Maybe<Scalars['Int']['output']>;
  responseCode: Scalars['String']['output'];
  softFailCount: Scalars['Int']['output'];
  targetId?: Maybe<Scalars['Int']['output']>;
  targetUser?: Maybe<User>;
  targetUserId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  waAudio?: Maybe<Myfile>;
  waBodyDataMapping?: Maybe<Scalars['String']['output']>;
  waBsuId: Scalars['String']['output'];
  waButtonDataMapping?: Maybe<Scalars['String']['output']>;
  waConversationExpirationDate?: Maybe<Scalars['String']['output']>;
  waConversationId: Scalars['String']['output'];
  waDeliveredDate?: Maybe<Scalars['String']['output']>;
  waDocument?: Maybe<Myfile>;
  waDownloadFailCount: Scalars['Int']['output'];
  waDownloadUrl: Scalars['String']['output'];
  waHeaderDataMapping?: Maybe<Scalars['String']['output']>;
  waId: Scalars['String']['output'];
  waImage?: Maybe<Myfile>;
  waMediaCaption: Scalars['String']['output'];
  waMediaDataMapping: Scalars['String']['output'];
  waMediaDataUrl: Scalars['String']['output'];
  waMediaId: Scalars['String']['output'];
  waMediaIsAvailable: Scalars['Boolean']['output'];
  waMediaMimeType: Scalars['String']['output'];
  waMediaMyfileId?: Maybe<Scalars['Int']['output']>;
  waReadDate?: Maybe<Scalars['String']['output']>;
  waStatus?: Maybe<WaStatusEnum>;
  waSticker?: Maybe<Myfile>;
  waTemplateId?: Maybe<Scalars['String']['output']>;
  waVideo?: Maybe<Myfile>;
  wamType?: Maybe<WaMessageTypesEnum>;
  wamid: Scalars['String']['output'];
};

export enum MsgStatus {
  Cancel = 'cancel',
  Fail = 'fail',
  InQueue = 'inQueue',
  Received = 'received',
  Sent = 'sent',
  SoftFail = 'softFail'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateLockerList: Array<Locker>;
  adHocStockIn: InventoryTxGroup;
  addAccessPassFacilityAccessRel: Array<AccessPassFacilityAccessRel>;
  addAccessPassToBonusPointEarningRule: BonusPointEarningRule;
  addAccessPassToCart: Myorder;
  addAgreementToLockerHistory: Myfile;
  addBannerToApp: Array<Myfile>;
  addBonusPointReceiptReg?: Maybe<BonusPointReceiptReg>;
  addBookingToMultiFacility: Array<FacilityBooking>;
  addCoachSalaryContractTerms: CoachSalaryContractTerms;
  addCoachSalaryReportCoachAdjustment: CoachSalaryReport;
  addCoachTimeslot?: Maybe<Scalars['Void']['output']>;
  addCoachToExistingBooking: Myorder;
  addCouponCodeToBonusPointEarningRule: BonusPointEarningRule;
  addCouponPackageCoachServiceRel: Array<CouponPackageCoachServiceRel>;
  addCouponPackageFacilityRel: Array<CouponPackageFacilityRel>;
  addCouponPackageToCart: Myorder;
  addCourseEnrolmentToCart: Myorder;
  addCourseInvitationCode: Array<CourseOrgInvitationCodeRel>;
  addCreditPackageToCart: Myorder;
  addCustomBonusPointToMember?: Maybe<Scalars['Void']['output']>;
  addCustomCreditToMember?: Maybe<Scalars['Void']['output']>;
  addDefaultFacilityFee: Array<FacilityFee>;
  addDriveDepositToCart: Myorder;
  addEquipmentToBooking: AddEquipmentToBookingResGql;
  addExistingBookingToOrgCart: Myorder;
  addFacilityAccessPassDependency: Array<FacilityAccessPassDependency>;
  addFacilityAccessPassLeadTime: Array<FacilityAccessPassLeadTime>;
  addFacilityAccessPassNoOfTimeslot: Array<FacilityAccessPassNoOfTimeslot>;
  addFacilityBookingOnlyOpenWhenAllBookedExceptTimeslot: Array<FacilityBookingOnlyOpenWhenAllBookedExceptTimeslot>;
  addFacilityBookingToCart: Myorder;
  addFacilityFee: Array<FacilityFee>;
  addFileToInventoryGroup: InventoryTxGroup;
  addFunkidsCompetitionToOrder: Myorder;
  addLessonEnrolmentToCart: Myorder;
  addLessonToCourse: Lesson;
  addLockerGroupFee: Array<LockerGroupFee>;
  addLockerGroupWaitingList: Array<LockerGroupWaitingList>;
  addLockerToCart: Myorder;
  addLostCardToCart: Myorder;
  addMemberListAsCourseMemberListToCourse: Array<MemberListAsCourseMemberList>;
  addMemberListAsRecurCourseMemberListToCourse: Array<MemberListAsRecurCourseMemberList>;
  addMemberListByMembershipNo: AddMemberListByMembershipNoInputResGql;
  addMemberListMember: MemberList;
  addMemberRelationship: MemberRelationship;
  addMemberRelationshipRequest: MemberRelationship;
  addMemberToCourseMemberList: Array<CourseMemberList>;
  addMembershipToCart: Myorder;
  addMsgToQueue?: Maybe<Scalars['Void']['output']>;
  addMyEventEnrolmentToCart: Myorder;
  addMyEventTicketSeat: MyEvent;
  addMyEventTicketType: MyEvent;
  addMyfileToBooking: Myfile;
  addMyfileToKwtdhcEvent: Myfile;
  addMyfileToMember: Myfile;
  addMyfileToMyorder: Myorder;
  addOrUpdateFabReservation: FabReservation;
  addPhotoToBonusPointRedeemPromotionGroup: BonusPointRedeemPromotionGroup;
  addPhotoToCouponPackage: CouponPackage;
  addPhotoToCourse: Course;
  addPhotoToLockerGroup: LockerGroup;
  addPhotoToMiniSiteContent: MiniSiteContent;
  addPhotoToMyEvent: MyEvent;
  addPhotoToNews: News;
  addPhotoToProduct: Product;
  addPhotoToProductCat: ProductCat;
  addPhotoToRecurCourse: RecurCourse;
  addPhotoToSportType: SportType;
  addPhotoToSportTypeGroup: SportTypeGroup;
  addPhotoToTimeSlotProgramGroup: TimeSlotProgramGroup;
  addPrivateFileToProduct: Product;
  addProductToCart: Myorder;
  addProductToUserProductGroup?: Maybe<Scalars['Void']['output']>;
  addProductToUserProductGroupAtPosition?: Maybe<Scalars['Void']['output']>;
  addProductToWarehouseStockTake: WarehouseStockTake;
  addRecurBookingToFacility: Array<AddRecurBookingToFacilityResGql>;
  addRefundDepositToCart: Myorder;
  addRefundItemListToCart: Myorder;
  addReturnLockerToCart: Myorder;
  addTennisOpen2022ToOrder: Myorder;
  addTimeSlotProgramLocation: TimeSlotProgram;
  addTimeSlotProgramOpeningHour: TimeSlotProgram;
  addTimeSlotProgramReservation: TimeSlotProgramReservation;
  addTimeSlotProgramServiceType: TimeSlotProgram;
  addTimeSlotProgramSummaryUser: Array<TimeSlotProgramSummaryUser>;
  addTimeslotProgramGridHour: TimeSlotProgram;
  addTkdCompetitionToOrder: Myorder;
  addWaMediaToTextTemplate: TextTemplate;
  addWhatsappImageMessageToQueue?: Maybe<Scalars['Void']['output']>;
  addWhatsappReactionMessageToQueue?: Maybe<Scalars['Void']['output']>;
  addWhatsappTemplateMsgToQueue?: Maybe<Scalars['Void']['output']>;
  addWhatsappTextMessageToQueue?: Maybe<Scalars['Void']['output']>;
  addYldsaCourseAdminFeeToCart: Myorder;
  addYldsaOldCourseRefundToCart: Myorder;
  adminCleanUserSession?: Maybe<Scalars['Void']['output']>;
  adminDeletePassKey?: Maybe<Scalars['Void']['output']>;
  adminLoginAsMember: LoginMemberResGql;
  adminRemoveTotp?: Maybe<Scalars['Void']['output']>;
  apiDeleteUser?: Maybe<Scalars['Void']['output']>;
  applyCouponToFacilityBooking: Myorder;
  applyCouponToPrivateCoach: Myorder;
  applyDefaultFacilityFee: Array<FacilityFee>;
  applyRoleTemplateToUser?: Maybe<Scalars['Void']['output']>;
  approveOrRejectInternalBooking: FacilityBooking;
  authSessionWithTotp: AuthSessionWithTotpResGql;
  autoPickCourseLotteryResult?: Maybe<Scalars['Void']['output']>;
  autoSendAccessPassReminder?: Maybe<Scalars['Void']['output']>;
  autoSendLockerReminder?: Maybe<Scalars['Void']['output']>;
  autoSendMemberReminder?: Maybe<Scalars['Void']['output']>;
  buildSysWarehousePartition?: Maybe<Scalars['Void']['output']>;
  calculateCoachSalary: CoachSalaryReport;
  cancelAllFutureInternalBookingForUser?: Maybe<Scalars['Void']['output']>;
  cancelAllInQueueAndSoftFailMsgQueue?: Maybe<Scalars['Void']['output']>;
  cancelCheckInTimeSlotProgramReservation: TimeSlotProgramReservation;
  cancelCourseEnrolment?: Maybe<Scalars['Void']['output']>;
  cancelLessonEnrolment?: Maybe<Scalars['Void']['output']>;
  cancelMsgQueue?: Maybe<Scalars['Void']['output']>;
  cancelTimeSlotProgramReservation: TimeSlotProgramReservation;
  ceoApproveRefundPayout: RefundPayoutRequest;
  ceoConvertPgToNonPgRefundPayout: RefundPayoutRequest;
  ceoProcessGlobalPaymentRefundPayout: RefundPayoutRequest;
  ceoRejectRefundPayoutRequest: RefundPayoutRequest;
  checkInByMyorderQrCode?: Maybe<Scalars['Void']['output']>;
  checkInByQuickQrCode?: Maybe<CheckInItemResGql>;
  checkInByUserCode?: Maybe<Scalars['Void']['output']>;
  checkInTimeSlotProgramReservation: TimeSlotProgramReservation;
  cleanMemberSession?: Maybe<Scalars['Void']['output']>;
  cleanUpGpToken?: Maybe<Scalars['Void']['output']>;
  clearCart?: Maybe<Scalars['Void']['output']>;
  clearLesson?: Maybe<Scalars['Void']['output']>;
  closeInventoryRequest: InventoryTxGroup;
  coachAddBookingAndCoachToCart: Myorder;
  coachAddCoachTimeslot?: Maybe<Scalars['Void']['output']>;
  coachApplyCouponToPrivateCoach: Myorder;
  coachConvertToOrder: Myorder;
  coachCreateUserCoachServiceRel: UserCoachServiceRel;
  coachDeleteCoachTimeSlot?: Maybe<Scalars['Void']['output']>;
  coachDeleteUserCoachServiceRel?: Maybe<Scalars['Void']['output']>;
  coachLessonCancelAttendance: Array<LessonEnrolment>;
  coachLessonTakeAttendance: Array<LessonEnrolment>;
  coachPrivateLessonCancelAttendance: FacilityBooking;
  coachPrivateLessonTakeAttendance: FacilityBooking;
  coachRemoveItemFromCart: Myorder;
  coachUpdateCoachTimeslot: CoachTimeslot;
  coachUpdateUserCoachServiceRel: UserCoachServiceRel;
  confirmCoachSalaryReport: CoachSalaryReport;
  confirmCourseEnrolment: ConfirmCourseEnrolmentResGql;
  confirmCourseLotteryResultAndRejectOthers?: Maybe<Scalars['Void']['output']>;
  confirmDeliveryNote: InventoryTxGroup;
  confirmGoodsReceiveNote: InventoryTxGroup;
  confirmLessonEnrolment: LessonEnrolment;
  confirmPayment: Myorder;
  confirmToAddTotp: AuthSessionWithTotpResGql;
  confirmWarehouseStockTake: InventoryTxGroup;
  convertToOrder: Myorder;
  convertToOrderAndConfirmPayment: Myorder;
  convertToOrderAndOutstandingPayment: Myorder;
  createAccessPass: AccessPass;
  createAccessPassOption: AccessPass;
  createAcctProductCat: AcctProductCat;
  createBlackout: CreateBlackoutResGql;
  createBonusPointEarningRule: BonusPointEarningRule;
  createBonusPointEarningRuleCourse: BonusPointEarningRule;
  createBonusPointEarningRuleFacilityBooking: BonusPointEarningRule;
  createBonusPointEarningRuleLocker: BonusPointEarningRule;
  createBonusPointEarningRuleMyEvent: BonusPointEarningRule;
  createBonusPointEarningRuleNthOrder: BonusPointEarningRule;
  createBonusPointEarningRuleProduct: BonusPointEarningRule;
  createBonusPointItemTypeEarningRatio: BonusPointItemTypeEarningRatio;
  createBonusPointRedeemPromotionGroup: BonusPointRedeemPromotionGroup;
  createCheckInDevice: CheckInDevice;
  createCoach: FullUser;
  createCoachService: CoachService;
  createCommittee: Committee;
  createCommitteeHistory: CommitteeHistory;
  createCommitteePosition: CommitteePosition;
  createContact: Contact;
  createConvertToScraped: InventoryTxGroup;
  createCouponPackage: CouponPackage;
  createCourse: Course;
  createCourseApplyQuotaPeriod: CourseApplyQuotaPeriod;
  createCourseType: CourseType;
  createCreditPackage: CreditPackage;
  createCreditType: CreditType;
  createDepartment: Department;
  createDocxTemplate: DocxTemplate;
  createDriveTeam: DriveTeam;
  createFabFloorplan: FabFloorplan;
  createFabFloorplanPeriod: FabFloorplan;
  createFabTable: FabFloorplan;
  createFacility: Facility;
  createGuest: LoginMemberResGql;
  createHoliday: Holiday;
  createInterWarehouseInventoryTransfer: InventoryTxGroup;
  createInterWarehouseInventoryTransferAtOnce: InventoryTxGroup;
  createIntraWarehouseInventoryTransfer: InventoryTxGroup;
  createIntraWarehouseInventoryTransferAtOnce: InventoryTxGroup;
  createKwtdhcEvent: KwtdhcEvent;
  createKwtdhcMemberFollowup: KwtdhcMemberFollowup;
  createLocation: Location;
  createLocationArea: LocationArea;
  createLockerGroup: LockerGroup;
  createLockerType: LockerType;
  createMember: FullMember;
  createMemberList: MemberList;
  createMemberLotteryGroupScoreOverride: MemberLotteryGroupScoreOverride;
  createMembershipType: MembershipType;
  createMyEvent: MyEvent;
  createNews: News;
  createOrganization: Organization;
  createProduct: Product;
  createProductCat: ProductCat;
  createPurchaseOrder: InventoryTxGroup;
  createPureStockOut: InventoryTxGroup;
  createRecurCourse: RecurCourse;
  createRequestRefundPayout: RefundPayoutRequest;
  createRoleTemplate: RoleTemplate;
  createSportType: SportType;
  createSportTypeGroup: SportTypeGroup;
  createStaffMember: FullMember;
  createSwpTestCardQrCode: DynamicQrCode;
  createTextTemplate: TextTemplate;
  createTimeSlotProgram: TimeSlotProgram;
  createTimeSlotProgramGroup: TimeSlotProgramGroup;
  createTmpMember: LoginMemberResGql;
  createTrialMember: FullMember;
  createTrialMemberAndAddToCourseEnrolment: CreateTrialMemberAndAddToCourseEnrolmentResGql;
  createUser: FullUser;
  createUserCoachServiceRel: UserCoachServiceRel;
  createUserProductGroup: UserProductGroup;
  createWarehouse: Warehouse;
  createWarehousePartition: WarehousePartition;
  createWarehouseStockTake: WarehouseStockTake;
  createWhatsappTemplate?: Maybe<Scalars['Void']['output']>;
  createWriteOff: InventoryTxGroup;
  deleteAccessPass?: Maybe<Scalars['Void']['output']>;
  deleteAccessPassFacilityAccessRel: Array<AccessPassFacilityAccessRel>;
  deleteAccessPassOption: AccessPass;
  deleteAccessPassToBonusPointEarningRule: BonusPointEarningRule;
  deleteAcctProductCat?: Maybe<Scalars['Void']['output']>;
  deleteBlackout?: Maybe<Scalars['Void']['output']>;
  deleteBonusPointEarningRule?: Maybe<Scalars['Void']['output']>;
  deleteBonusPointEarningRuleCourse: BonusPointEarningRule;
  deleteBonusPointEarningRuleFacilityBooking: BonusPointEarningRule;
  deleteBonusPointEarningRuleLocker: BonusPointEarningRule;
  deleteBonusPointEarningRuleMyEvent: BonusPointEarningRule;
  deleteBonusPointEarningRuleNthOrder: BonusPointEarningRule;
  deleteBonusPointEarningRuleProduct: BonusPointEarningRule;
  deleteBonusPointItemTypeEarningRatio?: Maybe<Scalars['Void']['output']>;
  deleteBooking?: Maybe<Scalars['Void']['output']>;
  deleteBookingActAsAdmin?: Maybe<Scalars['Void']['output']>;
  deleteCheckInDevice?: Maybe<Scalars['Void']['output']>;
  deleteCoach?: Maybe<Scalars['Void']['output']>;
  deleteCoachSalaryContractTerms?: Maybe<Scalars['Void']['output']>;
  deleteCoachSalaryReport?: Maybe<Scalars['Void']['output']>;
  deleteCoachSalaryReportCoachAdjustment: CoachSalaryReport;
  deleteCoachService?: Maybe<Scalars['Void']['output']>;
  deleteCoachTimeSlot?: Maybe<Scalars['Void']['output']>;
  deleteCommittee?: Maybe<Scalars['Void']['output']>;
  deleteCommitteeHistory?: Maybe<Scalars['Void']['output']>;
  deleteCommitteePosition?: Maybe<Scalars['Void']['output']>;
  deleteContact?: Maybe<Scalars['Void']['output']>;
  deleteCouponCodeToBonusPointEarningRule: BonusPointEarningRule;
  deleteCouponPackage?: Maybe<Scalars['Void']['output']>;
  deleteCouponPackageCoachServiceRel: Array<CouponPackageCoachServiceRel>;
  deleteCouponPackageFacilityRel: Array<CouponPackageFacilityRel>;
  deleteCourse?: Maybe<Scalars['Void']['output']>;
  deleteCourseApplyQuotaPeriod?: Maybe<Scalars['Void']['output']>;
  deleteCourseEnrolmentForTrialMember?: Maybe<Scalars['Void']['output']>;
  deleteCourseInvitationCode: Array<CourseOrgInvitationCodeRel>;
  deleteCourseType?: Maybe<Scalars['Void']['output']>;
  deleteCreditPackage?: Maybe<Scalars['Void']['output']>;
  deleteCreditType?: Maybe<Scalars['Void']['output']>;
  deleteDefaultFacilityFee: Array<FacilityFee>;
  deleteDepartment?: Maybe<Scalars['Void']['output']>;
  deleteDocxTemplate?: Maybe<Scalars['Void']['output']>;
  deleteDriveTeam?: Maybe<Scalars['Void']['output']>;
  deleteFabFloorplan?: Maybe<Scalars['Void']['output']>;
  deleteFabFloorplanPeriod: FabFloorplan;
  deleteFabTable: FabFloorplan;
  deleteFacilityAccessPassDependency: Array<FacilityAccessPassDependency>;
  deleteFacilityAccessPassLeadTime: Array<FacilityAccessPassLeadTime>;
  deleteFacilityAccessPassNoOfTimeslot: Array<FacilityAccessPassNoOfTimeslot>;
  deleteFacilityBookingOnlyOpenWhenAllBookedExceptTimeslot: Array<FacilityBookingOnlyOpenWhenAllBookedExceptTimeslot>;
  deleteFacilityFee: Array<FacilityFee>;
  deleteHoliday?: Maybe<Scalars['Void']['output']>;
  deleteKwtdhcEvent?: Maybe<Scalars['Void']['output']>;
  deleteKwtdhcMemberFollowup: Scalars['Void']['output'];
  deleteLesson?: Maybe<Scalars['Void']['output']>;
  deleteLessonEnrolmentForTrialMember?: Maybe<Scalars['Void']['output']>;
  deleteLocation?: Maybe<Scalars['Void']['output']>;
  deleteLocationArea?: Maybe<Scalars['Void']['output']>;
  deleteLockerGroup?: Maybe<Scalars['Void']['output']>;
  deleteLockerGroupFee: Array<LockerGroupFee>;
  deleteLockerGroupWaitingList: Array<LockerGroupWaitingList>;
  deleteLockerType?: Maybe<Scalars['Void']['output']>;
  deleteMemberFromCourseMemberList: Array<CourseMemberList>;
  deleteMemberList?: Maybe<Scalars['Void']['output']>;
  deleteMemberListAsCourseMemberListFromCourse: Array<MemberListAsCourseMemberList>;
  deleteMemberListAsRecurCourseMemberListFromCourse: Array<MemberListAsRecurCourseMemberList>;
  deleteMemberListMember: MemberList;
  deleteMemberLotteryGroupScoreOverride?: Maybe<Scalars['Void']['output']>;
  deleteMemberRelationship?: Maybe<Scalars['Void']['output']>;
  deleteMembershipType?: Maybe<Scalars['Void']['output']>;
  deleteMiniSiteContent?: Maybe<Scalars['Void']['output']>;
  deleteMyEvent?: Maybe<Scalars['Void']['output']>;
  deleteMyEventTicketSeat: MyEvent;
  deleteMyEventTicketType?: Maybe<Scalars['Void']['output']>;
  deleteNews?: Maybe<Scalars['Void']['output']>;
  deleteOrganization?: Maybe<Scalars['Void']['output']>;
  deleteProduct?: Maybe<Scalars['Void']['output']>;
  deleteProductCat?: Maybe<Scalars['Void']['output']>;
  deleteProductFromUserProductGroup?: Maybe<Scalars['Void']['output']>;
  deleteRecurCourse?: Maybe<Scalars['Void']['output']>;
  deleteRoleTemplate?: Maybe<Scalars['Void']['output']>;
  deleteSetting?: Maybe<Scalars['Void']['output']>;
  deleteSportType?: Maybe<Scalars['Void']['output']>;
  deleteSportTypeGroup?: Maybe<Scalars['Void']['output']>;
  deleteSwpTestCardQrCode: Scalars['Void']['output'];
  deleteTextTemplate?: Maybe<Scalars['Void']['output']>;
  deleteTimeSlotProgram?: Maybe<Scalars['Void']['output']>;
  deleteTimeSlotProgramGroup?: Maybe<Scalars['Void']['output']>;
  deleteTimeSlotProgramLocation: TimeSlotProgram;
  deleteTimeSlotProgramOpeningHour: TimeSlotProgram;
  deleteTimeSlotProgramServiceType: TimeSlotProgram;
  deleteTimeSlotProgramSummaryUser: Array<TimeSlotProgramSummaryUser>;
  deleteTimeslotProgramGridHour: TimeSlotProgram;
  deleteTmpHoldBooking?: Maybe<Scalars['Void']['output']>;
  deleteUser?: Maybe<Scalars['Void']['output']>;
  deleteUserCoachServiceRel?: Maybe<Scalars['Void']['output']>;
  deleteUserProductGroup?: Maybe<Scalars['Void']['output']>;
  deleteWarehouse?: Maybe<Scalars['Void']['output']>;
  deleteWarehousePartition?: Maybe<Scalars['Void']['output']>;
  deleteWarehouseStockTake?: Maybe<Scalars['Void']['output']>;
  deptConfirmCoachSalaryReport: CoachSalaryReport;
  duplicateFacility: Facility;
  duplicateTimeSlotProgram: TimeSlotProgram;
  financeApproveRefundPayout: RefundPayoutRequest;
  financeConvertPgToNonPgRefundPayout: RefundPayoutRequest;
  financeProcessGlobalPaymentRefundPayout: RefundPayoutRequest;
  financeRejectRefundPayoutRequest: RefundPayoutRequest;
  forceDeleteMemberFaceFromTerminal?: Maybe<MemberFacial>;
  forceUploadMemberFaceToTerminal?: Maybe<MemberFacial>;
  forceVoidMyorder: Myorder;
  generateCourseByRecurCourse: Array<Course>;
  generateStaffQrCode: DynamicQrCode;
  getAllMemberEnrolmentStats: Array<OneMemberEnrolmentStatsSummaryResGql>;
  getBonusPointDailyReport: Array<BonusPointDailyReport>;
  getCourseEnrolmentStats: Array<CourseEnrolmentStats>;
  getCreditDailyReport: Array<CreditDailyReport>;
  getOneCourseEnrolmentStats: CourseEnrolmentStats;
  getOneMemberEnrolmentStats: OneMemberEnrolmentStatsSummaryResGql;
  heldMyEventTicketSeat: MyEvent;
  holdBookingToFacility: FacilityBooking;
  importMember: ImportMemberResGql;
  kwtdhcBatchImportMember?: Maybe<Scalars['Void']['output']>;
  kwtdhcLoginByJwt: LoginMemberResGql;
  lessonCancelAttendance: Array<LessonEnrolment>;
  lessonTakeAttendance: Array<LessonEnrolment>;
  loadInventoryToStockTake: WarehouseStockTake;
  loginByBiometricToken: LoginMemberResGql;
  loginByMemberNo: LoginMemberResGql;
  loginByTimeSlotProgramReservation: LoginMemberResGql;
  logout?: Maybe<Scalars['Void']['output']>;
  machineLogin: LoginUserResGql;
  makeLockerAvailable: Locker;
  makeReturnShipment: InventoryTxGroup;
  makeShipment: InventoryTxGroup;
  manualAddAccessPassHistory: AccessPassHistory;
  manualCheckIn?: Maybe<Scalars['Void']['output']>;
  manualDeleteAccessPassHistory?: Maybe<Scalars['Void']['output']>;
  manualOverrideMembershipInfo: Member;
  manualUpdateAccessPassHistory: AccessPassHistory;
  markAllDriveDepositAsDonation?: Maybe<Scalars['Void']['output']>;
  markDriveDepositAsDonation?: Maybe<Scalars['Void']['output']>;
  markMsgQueueAsReadWithHash: MsgQueue;
  markNonPgRefundPayoutCompleted: RefundPayoutRequest;
  massAddLessonToCourse: MassAddLessonToCourseResGql;
  massUpdateLesson: Array<Lesson>;
  meAddAccessPassToCart: Myorder;
  meAddBbsToCart: Myorder;
  meAddBookingAndCoachToCart: Myorder;
  meAddBookmark?: Maybe<Scalars['Void']['output']>;
  meAddCoachToExistingBooking: Myorder;
  meAddCouponPackageToCart: Myorder;
  meAddCourseEnrolment?: Maybe<AddCourseEnrolmentResGql>;
  meAddCourseEnrolmentToCart: Myorder;
  meAddCreditPackageToCart: Myorder;
  meAddDriveDepositToCart: Myorder;
  meAddFacilityBookingToCart: Myorder;
  meAddLessonEnrolmentToCart: Myorder;
  meAddLockerToCart: Myorder;
  meAddLostCardToCart: Myorder;
  meAddMemberRelationshipRequest: MemberRelationship;
  meAddMemberToWaitingList?: Maybe<AddCourseEnrolmentResGql>;
  meAddMembershipToCart: Myorder;
  meAddMyEventEnrolmentToCart: Myorder;
  meAddMyfileToMember: Myfile;
  meAddProductToCart: Myorder;
  meAddTimeSlotProgramReservation: TimeSlotProgramReservation;
  meApplyCouponToFacilityBooking: Myorder;
  meApplyCouponToPrivateCoach: Myorder;
  meCancelCourseEnrolment?: Maybe<Scalars['Void']['output']>;
  meCancelMyorder: Myorder;
  meCancelTimeSlotProgramReservation: TimeSlotProgramReservation;
  meCleanMemberSession?: Maybe<Scalars['Void']['output']>;
  meClearCart?: Maybe<Scalars['Void']['output']>;
  meConfirmToAddTotp: AuthSessionWithTotpResGql;
  meConvertToOrder: Myorder;
  meConvertToOrderAndGetStripeSessionUrl: Scalars['String']['output'];
  meCreateTrialMember: LoginMemberResGql;
  meCreateTrialMemberAndAddCourseEnrolmentToCart: CreateTrialMemberAndAddCourseEnrolmentToCartResGql;
  meCreateTrialMemberAndAddLessonEnrolmentToCart: CreateTrialMemberAndAddCourseEnrolmentToCartResGql;
  meCreateTrialMemberAndAddToCourseEnrolment: CreateTrialMemberAndAddToCourseEnrolmentResGql;
  meDeleteAllInboxMsg?: Maybe<Scalars['Void']['output']>;
  meDeleteBookmark?: Maybe<Scalars['Void']['output']>;
  meDeletePassKey?: Maybe<Scalars['Void']['output']>;
  meDisableMemberLogin?: Maybe<Scalars['Void']['output']>;
  meGetBiometricToken: MeGetBiometricTokenResInput;
  meGetOtp?: Maybe<Scalars['Void']['output']>;
  meGetStripeSessionUrl: Scalars['String']['output'];
  meInitEshopMember: FullMember;
  meIsItemBookmarked: IsItemBookmarkedResGql;
  meMarkAllInboxMsgAsRead?: Maybe<Scalars['Void']['output']>;
  meMarkMsgQueueAsRead: MsgQueue;
  mePurgeMyfileFromMember?: Maybe<Scalars['Void']['output']>;
  meRegisterEshopMember: LoginMemberResGql;
  meRemoveGpToken?: Maybe<Scalars['Void']['output']>;
  meRemoveItemFromCart: Myorder;
  meRemoveTotp?: Maybe<Scalars['Void']['output']>;
  meSetDefaultGpToken?: Maybe<Scalars['Void']['output']>;
  meSubmitParQ: MemberParQ;
  meUpdateAccessPassHistoryAutoRenew: AccessPassHistory;
  meUpdateBbsCart: UpdateGuestAndCartResGql;
  meUpdateEshopMember: FullMember;
  meUpdateGuest: FullMember;
  meUpdateGuestAndCart: UpdateGuestAndCartResGql;
  meUpdateInboxStatus?: Maybe<Scalars['Void']['output']>;
  meUpdateLockerHistoryAutoRenew: LockerHistory;
  meUpdateMember: FullMember;
  meUpdateMemberImageFile: FullMember;
  meUpdateMemberRelationshipRequest?: Maybe<Scalars['Void']['output']>;
  meUpdateMyorder: Myorder;
  meUpdateNotificationSub?: Maybe<Array<NotificationSub>>;
  meUpdateTimeSlotProgramReservation: TimeSlotProgramReservation;
  meVerifyOtp?: Maybe<Scalars['Void']['output']>;
  memberLogin: LoginMemberResGql;
  migrateWarehouseAndInventoryV2o46?: Maybe<Scalars['Void']['output']>;
  normalizeAllMemberHistory?: Maybe<Scalars['Void']['output']>;
  pingAndRefreshUserSessionToken: AuthSessionWithTotpResGql;
  processWhatsappQueue?: Maybe<Scalars['Void']['output']>;
  purgeBannerFromApp?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromBonusPointRedeemPromotionGroup?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromCouponPackage?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromCourse?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromInventoryGroup?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromKwtdhcEvent?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromLockerGroup?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromMember?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromMyEvent?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromNews?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromProduct?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromProductCat?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromRecurCourse?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromSportType?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromSportTypeGroup?: Maybe<Scalars['Void']['output']>;
  purgeMyfileFromTimeSlotProgramGroup?: Maybe<Scalars['Void']['output']>;
  purgeOldIdProof?: Maybe<Scalars['Void']['output']>;
  purgeOriginalMyfile?: Maybe<Scalars['Void']['output']>;
  recalAllLockerForfeitDate?: Maybe<Scalars['Void']['output']>;
  recalAllWarehouseInventory?: Maybe<Scalars['Void']['output']>;
  regCheckInDevice?: Maybe<RegCheckInDeviceResGql>;
  regenerateRefundPayoutLink: RefundPayoutRequest;
  registerMemberLoginKey: FullMember;
  rejectCourseEnrolment?: Maybe<Scalars['Void']['output']>;
  rejectLessonEnrolment?: Maybe<Scalars['Void']['output']>;
  removeAgreementFromLockerHistory?: Maybe<Scalars['Void']['output']>;
  removeItemFromCart: Myorder;
  removeProductFromWarehouseStockTake: WarehouseStockTake;
  reorderPhoto?: Maybe<Scalars['Void']['output']>;
  replaceDocxTemplateFile: DocxTemplate;
  resetMemberPassword: ResetMemberPasswordResGql;
  resyncCourseAutoAddMemberList?: Maybe<Scalars['Void']['output']>;
  runAutoRenewAccessPass?: Maybe<Scalars['Void']['output']>;
  runAutoRenewLocker?: Maybe<Scalars['Void']['output']>;
  runAutoRenewMembership?: Maybe<Scalars['Void']['output']>;
  scaaExportCoachMonthlySalaryCsvToFtp?: Maybe<Scalars['Void']['output']>;
  scaaImportCoachFromFtp?: Maybe<Scalars['Void']['output']>;
  sendAccessPassReminder?: Maybe<Scalars['Void']['output']>;
  sendCourseFirstLessonReminder?: Maybe<Scalars['Void']['output']>;
  sendDailySummaryMail?: Maybe<Scalars['Void']['output']>;
  sendLockerReminder?: Maybe<Scalars['Void']['output']>;
  sendTimeSlotProgramDailySummaryMail?: Maybe<Scalars['Void']['output']>;
  setDefaultGpToken?: Maybe<Scalars['Void']['output']>;
  setupLocker: Locker;
  staffLoginOnlyOnce: LoginMemberResGql;
  submitRefundPayoutDetail: RefundPayoutRequest;
  swapFabTables: Array<FabReservation>;
  transferDocxTemplateToUser?: Maybe<Scalars['Void']['output']>;
  transferTextTemplateToUser?: Maybe<Scalars['Void']['output']>;
  transferTmpHold?: Maybe<Scalars['Void']['output']>;
  undoCloseInventoryRequest: InventoryTxGroup;
  undoConfirmDeliveryNote: InventoryTxGroup;
  undoConfirmGoodsReceiveNote: InventoryTxGroup;
  unheldMyEventTicketSeat: MyEvent;
  updateAccessPass: AccessPass;
  updateAccessPassFacilityAccessRel: Array<AccessPassFacilityAccessRel>;
  updateAccessPassHistoryAutoRenew: AccessPassHistory;
  updateAccessPassHistoryForceNoRenew: AccessPassHistory;
  updateAccessPassOption: AccessPass;
  updateAcctProductCat: AcctProductCat;
  updateAgreeToReceiveStockTransfer: InventoryTxGroup;
  updateAllLockerStatus?: Maybe<Scalars['Void']['output']>;
  updateBlackout: FacilityBlackout;
  updateBonusPointEarningRule: BonusPointEarningRule;
  updateBonusPointEarningRuleAccessPass: BonusPointEarningRule;
  updateBonusPointEarningRuleCouponCode: BonusPointEarningRule;
  updateBonusPointEarningRuleCourse: BonusPointEarningRule;
  updateBonusPointEarningRuleFacilityBooking: BonusPointEarningRule;
  updateBonusPointEarningRuleLocker: BonusPointEarningRule;
  updateBonusPointEarningRuleMyEvent: BonusPointEarningRule;
  updateBonusPointEarningRuleNthOrder: BonusPointEarningRule;
  updateBonusPointEarningRuleProduct: BonusPointEarningRule;
  updateBonusPointItemTypeEarningRatio: BonusPointItemTypeEarningRatio;
  updateBonusPointRedeemPromotionGroup: BonusPointRedeemPromotionGroup;
  updateBookingMeta: FacilityBooking;
  updateCheckInDevice: CheckInDevice;
  updateCoach: FullUser;
  updateCoachEnable: FullUser;
  updateCoachSalaryContractTerms: CoachSalaryContractTerms;
  updateCoachSalaryReportCoachAdjustment: CoachSalaryReport;
  updateCoachService: CoachService;
  updateCoachTimeslot: CoachTimeslot;
  updateCommittee: Committee;
  updateCommitteeHistory: CommitteeHistory;
  updateCommitteePosition: CommitteePosition;
  updateContact: Contact;
  updateCouponPackage: CouponPackage;
  updateCouponPackageFacilityRel: Array<CouponPackageFacilityRel>;
  updateCourse: Course;
  updateCourseApplyQuotaPeriod: CourseApplyQuotaPeriod;
  updateCourseCoachList: Array<FullUser>;
  updateCourseEnable: Course;
  updateCourseEnrolmentLotteryDrawPriority: CourseEnrolment;
  updateCourseInvitationCode: Array<CourseOrgInvitationCodeRel>;
  updateCourseType: CourseType;
  updateCreditPackage: CreditPackage;
  updateCreditType: CreditType;
  updateDefaultFacilityFee: Array<FacilityFee>;
  updateDepartment: Department;
  updateDepositForfeitDate: DepositHistory;
  updateDocxTemplate: DocxTemplate;
  updateDriveTeam: DriveTeam;
  updateDriveTeamForMember: Myorder;
  updateDriveTeamForMyorder: Myorder;
  updateDriveTeamMemberList: DriveTeam;
  updateExpiredMemberHistory?: Maybe<Scalars['Void']['output']>;
  updateFabFloorplan: FabFloorplan;
  updateFabFloorplanPeriod: FabFloorplan;
  updateFabFloorplanRequest: FabFloorplanRequest;
  updateFabTable: FabFloorplan;
  updateFacility: Facility;
  updateFacilityAccessLogAccessPassOptionId: FacilityAccessLog;
  updateFacilityAccessPassDependency: Array<FacilityAccessPassDependency>;
  updateFacilityAccessPassLeadTime: Array<FacilityAccessPassLeadTime>;
  updateFacilityAccessPassNoOfTimeslot: Array<FacilityAccessPassNoOfTimeslot>;
  updateFacilityEnable: Facility;
  updateFacilityFee: Array<FacilityFee>;
  updateFcmTokenToSession?: Maybe<Scalars['Void']['output']>;
  updateGuest: FullMember;
  updateGuestAndCart: UpdateGuestAndCartResGql;
  updateHoliday: Holiday;
  updateInternalBooking: Array<FacilityBooking>;
  updateInventoryTxGroup?: Maybe<InventoryTxGroup>;
  updateKwtdhcEvent: KwtdhcEvent;
  updateKwtdhcMemberFollowup: KwtdhcMemberFollowup;
  updateLesson: Lesson;
  updateLocation: Location;
  updateLocationArea: LocationArea;
  updateLocker: Locker;
  updateLockerGroup: LockerGroup;
  updateLockerGroupFee: Array<LockerGroupFee>;
  updateLockerHistoryAutoRenew: LockerHistory;
  updateLockerHistoryForceNoRenew: LockerHistory;
  updateLockerStatus: Locker;
  updateLockerType: LockerType;
  updateMember: FullMember;
  updateMemberImageFile: FullMember;
  updateMemberList: MemberList;
  updateMemberListMember: MemberList;
  updateMemberLotteryGroupScoreOverride: MemberLotteryGroupScoreOverride;
  updateMemberRelationshipRequest?: Maybe<Scalars['Void']['output']>;
  updateMembershipType: MembershipType;
  updateMembershipTypeIdAndAddDonation: Myorder;
  updateMiniSiteContent: MiniSiteContent;
  updateMyEvent: MyEvent;
  updateMyEventFacilityList: MyEvent;
  updateMyEventTicketType: MyEvent;
  updateMyEventWhiteList: Array<FullMember>;
  updateMyorder: Myorder;
  updateMyorderItem: Myorder;
  updateMyorderItemApc: MyorderItem;
  updateNews: News;
  updateOrganization: Organization;
  updateProduct: Product;
  updateProductCat: ProductCat;
  updateProductOrdering: Array<Product>;
  updateProductSubCatOrdering: Array<ProductCat>;
  updateRecurCourse: RecurCourse;
  updateRecurCourseCoachList: RecurCourse;
  updateRecurCourseExceptionDateList: RecurCourse;
  updateRecurCourseFacilityList: RecurCourse;
  updateRoleTemplate: RoleTemplate;
  updateSetting: AdminSetting;
  updateSportType: SportType;
  updateSportTypeGroup: SportTypeGroup;
  updateStaffMember: FullMember;
  updateSwpFee: SwpFee;
  updateSwpSession: SwpSession;
  updateSwpTestCardQrCode: DynamicQrCode;
  updateTextTemplate: TextTemplate;
  updateTimeSlotProgram: TimeSlotProgram;
  updateTimeSlotProgramDailySummary?: Maybe<Scalars['Void']['output']>;
  updateTimeSlotProgramGroup: TimeSlotProgramGroup;
  updateTimeSlotProgramLocation: TimeSlotProgram;
  updateTimeSlotProgramOpeningHour: TimeSlotProgram;
  updateTimeSlotProgramReservation: TimeSlotProgramReservation;
  updateTimeSlotProgramReservationRemark: TimeSlotProgramReservation;
  updateTimeSlotProgramServiceType: TimeSlotProgram;
  updateTimeslotProgramGridHour: TimeSlotProgram;
  updateTrialMember: FullMember;
  updateUser: FullUser;
  updateUserCoachServiceRel: UserCoachServiceRel;
  updateUserDeptListPerDomain: Array<UserDeptListResGql>;
  updateUserDeptListPerPermissionType: Array<UserDeptListResGql>;
  updateUserEnable: FullUser;
  updateUserProduct?: Maybe<Scalars['Void']['output']>;
  updateUserProductGroup: UserProductGroup;
  updateUserProductGroupListOrderId?: Maybe<Scalars['Void']['output']>;
  updateUserProductGroupProductOrdering?: Maybe<Scalars['Void']['output']>;
  updateUserRoleList: FullUser;
  updateUserWarehouseList: Array<Warehouse>;
  updateWarehouse: Warehouse;
  updateWarehousePartition: WarehousePartition;
  updateWarehouseStockTake: WarehouseStockTake;
  updateWhatsappSummary: WhatsappSummary;
  updateWhatsappTemplate?: Maybe<Scalars['Void']['output']>;
  userAddCourseEnrolment?: Maybe<AddCourseEnrolmentResGql>;
  userAddMemberToWaitingList?: Maybe<AddCourseEnrolmentResGql>;
  userCleanUserSession?: Maybe<Scalars['Void']['output']>;
  userDeleteAllInboxMsg?: Maybe<Scalars['Void']['output']>;
  userDeleteMemberParQ?: Maybe<Scalars['Void']['output']>;
  userDeletePassKey?: Maybe<Scalars['Void']['output']>;
  userLogin: LoginUserResGql;
  userLoginByAzureSSO: LoginUserResGql;
  userMarkAllInboxMsgAsRead?: Maybe<Scalars['Void']['output']>;
  userMarkMsgQueueAsRead: MsgQueue;
  userRemoveGpToken?: Maybe<Scalars['Void']['output']>;
  userRemoveTotp?: Maybe<Scalars['Void']['output']>;
  userSubmitParQ: MemberParQ;
  userUpdateInboxStatus?: Maybe<Scalars['Void']['output']>;
  userUpdateMemberParQ: MemberParQ;
  userUpdateNotificationSub?: Maybe<Array<NotificationSub>>;
  userUpdateUser: FullUser;
  v5dataMigration?: Maybe<Scalars['Void']['output']>;
  voidBonusPointReceiptReg?: Maybe<BonusPointReceiptReg>;
  voidMyorder: Myorder;
  webPushSubscriptionDelete?: Maybe<Scalars['Void']['output']>;
  webPushSubscriptionUpdate?: Maybe<Scalars['Void']['output']>;
  withdrawCredit: Myorder;
  writeFacilityBookingAspenSyncCsv?: Maybe<Scalars['Void']['output']>;
  yldsaRegisterMemberLoginKey: FullMember;
};


export type MutationActivateLockerListArgs = {
  input: ActivateLockerListInput;
};


export type MutationAdHocStockInArgs = {
  input: AdHocStockInInput;
};


export type MutationAddAccessPassFacilityAccessRelArgs = {
  input: AddAccessPassFacilityAccessRelInput;
};


export type MutationAddAccessPassToBonusPointEarningRuleArgs = {
  input: AddAccessPassToBonusPointEarningRuleInput;
};


export type MutationAddAccessPassToCartArgs = {
  input: AddAccessPassToCartInput;
};


export type MutationAddAgreementToLockerHistoryArgs = {
  input: AddAgreementToLockerHistoryInput;
};


export type MutationAddBannerToAppArgs = {
  input: AddBannerToAppInput;
};


export type MutationAddBonusPointReceiptRegArgs = {
  input: AddBonusPointReceiptRegInput;
};


export type MutationAddBookingToMultiFacilityArgs = {
  input: AddBookingToMultiFacilityInput;
};


export type MutationAddCoachSalaryContractTermsArgs = {
  input: AddCoachSalaryContractTermsInput;
};


export type MutationAddCoachSalaryReportCoachAdjustmentArgs = {
  input: AddCoachSalaryReportCoachAdjustmentInput;
};


export type MutationAddCoachTimeslotArgs = {
  input: AddCoachTimeslotInput;
};


export type MutationAddCoachToExistingBookingArgs = {
  input: AddCoachToExistingBookingInput;
};


export type MutationAddCouponCodeToBonusPointEarningRuleArgs = {
  input: AddCouponCodeToBonusPointEarningRuleInput;
};


export type MutationAddCouponPackageCoachServiceRelArgs = {
  input: AddCouponPackageCoachServiceRelInput;
};


export type MutationAddCouponPackageFacilityRelArgs = {
  input: AddCouponPackageFacilityRelInput;
};


export type MutationAddCouponPackageToCartArgs = {
  input: AddCouponPackageToCartInput;
};


export type MutationAddCourseEnrolmentToCartArgs = {
  input: AddCourseEnrolmentToCartInput;
};


export type MutationAddCourseInvitationCodeArgs = {
  input: AddCourseInvitationCodeInput;
};


export type MutationAddCreditPackageToCartArgs = {
  input: AddCreditPackageToCartInput;
};


export type MutationAddCustomBonusPointToMemberArgs = {
  input: AddCustomBonusPointToMember;
};


export type MutationAddCustomCreditToMemberArgs = {
  input: AddCustomCreditToMember;
};


export type MutationAddDefaultFacilityFeeArgs = {
  input: AddDefaultFacilityFeeInput;
};


export type MutationAddDriveDepositToCartArgs = {
  input: AddDriveDepositToCartInput;
};


export type MutationAddEquipmentToBookingArgs = {
  input: AddEquipmentToBookingInput;
};


export type MutationAddExistingBookingToOrgCartArgs = {
  input: AddExistingBookingToOrgCartInput;
};


export type MutationAddFacilityAccessPassDependencyArgs = {
  input: AddFacilityAccessPassDependencyInput;
};


export type MutationAddFacilityAccessPassLeadTimeArgs = {
  input: AddFacilityAccessPassLeadTimeInput;
};


export type MutationAddFacilityAccessPassNoOfTimeslotArgs = {
  input: AddFacilityAccessPassNoOfTimeslotInput;
};


export type MutationAddFacilityBookingOnlyOpenWhenAllBookedExceptTimeslotArgs = {
  input: AddFacilityBookingOnlyOpenWhenAllBookedExceptTimeslotInput;
};


export type MutationAddFacilityBookingToCartArgs = {
  input: AddBookingToCartInput;
};


export type MutationAddFacilityFeeArgs = {
  input: AddFacilityFeeInput;
};


export type MutationAddFileToInventoryGroupArgs = {
  input: AddFileInput;
};


export type MutationAddFunkidsCompetitionToOrderArgs = {
  input: MeAddFunkidsCompetitionToCartInput;
};


export type MutationAddLessonEnrolmentToCartArgs = {
  input: AddLessonEnrolmentToCartInput;
};


export type MutationAddLessonToCourseArgs = {
  input: CreateLessonInput;
};


export type MutationAddLockerGroupFeeArgs = {
  input: AddLockerGroupFeeInput;
};


export type MutationAddLockerGroupWaitingListArgs = {
  input: AddLockerGroupWaitingListInput;
};


export type MutationAddLockerToCartArgs = {
  input: AddLockerToCartInput;
};


export type MutationAddLostCardToCartArgs = {
  input: AddLostCardToCartInput;
};


export type MutationAddMemberListAsCourseMemberListToCourseArgs = {
  input: AddMemberListAsCourseMemberListToCourseInput;
};


export type MutationAddMemberListAsRecurCourseMemberListToCourseArgs = {
  input: AddMemberListAsRecurCourseMemberListToCourseInput;
};


export type MutationAddMemberListByMembershipNoArgs = {
  input: AddMemberListByMembershipNoInput;
};


export type MutationAddMemberListMemberArgs = {
  input: AddMemberListMemberInput;
};


export type MutationAddMemberRelationshipArgs = {
  input: AddMemberRelationshipRequestInput;
};


export type MutationAddMemberRelationshipRequestArgs = {
  input: AddMemberRelationshipRequestInput;
};


export type MutationAddMemberToCourseMemberListArgs = {
  input: AddMemberToCourseMemberListInput;
};


export type MutationAddMembershipToCartArgs = {
  input: AddMembershipToCartInput;
};


export type MutationAddMsgToQueueArgs = {
  input: AddMsgToQueueInput;
};


export type MutationAddMyEventEnrolmentToCartArgs = {
  input: AddMyEventEnrolmentToCartInput;
};


export type MutationAddMyEventTicketSeatArgs = {
  input: AddMyEventTicketSeatInput;
};


export type MutationAddMyEventTicketTypeArgs = {
  input: AddMyEventTicketTypeInput;
};


export type MutationAddMyfileToBookingArgs = {
  input: AddMyfileToBookingInput;
};


export type MutationAddMyfileToKwtdhcEventArgs = {
  input: AddMyfileToKwtdhcEventInput;
};


export type MutationAddMyfileToMemberArgs = {
  input: AddMyfileToMemberInput;
};


export type MutationAddMyfileToMyorderArgs = {
  input: AddFileInput;
};


export type MutationAddOrUpdateFabReservationArgs = {
  input: AddOrUpdateFabReservationInput;
};


export type MutationAddPhotoToBonusPointRedeemPromotionGroupArgs = {
  input: AddPhotoToBonusPointRedeemPromotionGroupInput;
};


export type MutationAddPhotoToCouponPackageArgs = {
  input: AddPhotoInput;
};


export type MutationAddPhotoToCourseArgs = {
  input: AddPhotoToCourseInput;
};


export type MutationAddPhotoToLockerGroupArgs = {
  input: AddPhotoToLockerGroupInput;
};


export type MutationAddPhotoToMiniSiteContentArgs = {
  input: AddPhotoToMiniSiteContentInput;
};


export type MutationAddPhotoToMyEventArgs = {
  input: AddPhotoToMyEventInput;
};


export type MutationAddPhotoToNewsArgs = {
  input: AddPhotoToNewsInput;
};


export type MutationAddPhotoToProductArgs = {
  input: AddPhotoToProductInput;
};


export type MutationAddPhotoToProductCatArgs = {
  input: AddPhotoToProductCatInput;
};


export type MutationAddPhotoToRecurCourseArgs = {
  input: AddPhotoToRecurCourseInput;
};


export type MutationAddPhotoToSportTypeArgs = {
  input: AddPhotoToSportTypeInput;
};


export type MutationAddPhotoToSportTypeGroupArgs = {
  input: AddPhotoToSportTypeGroupInput;
};


export type MutationAddPhotoToTimeSlotProgramGroupArgs = {
  input: AddPhotoToTimeSlotProgramGroupInput;
};


export type MutationAddPrivateFileToProductArgs = {
  input: AddFileInput;
};


export type MutationAddProductToCartArgs = {
  input: AddProductToCartInput;
};


export type MutationAddProductToUserProductGroupArgs = {
  input: AddProductToUserProductGroupInput;
};


export type MutationAddProductToUserProductGroupAtPositionArgs = {
  input: AddProductToUserProductGroupAtPositionInput;
};


export type MutationAddProductToWarehouseStockTakeArgs = {
  input: AddProductToWarehouseStockTakeInput;
};


export type MutationAddRecurBookingToFacilityArgs = {
  input: AddRecurBookingToFacilityInput;
};


export type MutationAddRefundDepositToCartArgs = {
  input: AddRefundDepositToCartInput;
};


export type MutationAddRefundItemListToCartArgs = {
  input: AddRefundItemListToCartInput;
};


export type MutationAddReturnLockerToCartArgs = {
  input: AddReturnLockerToCartInput;
};


export type MutationAddTennisOpen2022ToOrderArgs = {
  input: MeAddTennisOpen2022ToCartInput;
};


export type MutationAddTimeSlotProgramLocationArgs = {
  input: AddTimeSlotProgramLocationInput;
};


export type MutationAddTimeSlotProgramOpeningHourArgs = {
  input: AddTimeSlotProgramOpeningHourInput;
};


export type MutationAddTimeSlotProgramReservationArgs = {
  input: AddTimeSlotProgramReservationInput;
};


export type MutationAddTimeSlotProgramServiceTypeArgs = {
  input: AddTimeSlotProgramServiceTypeInput;
};


export type MutationAddTimeSlotProgramSummaryUserArgs = {
  input: AddTimeSlotProgramSummaryUserInput;
};


export type MutationAddTimeslotProgramGridHourArgs = {
  input: AddTimeslotProgramGridHourInput;
};


export type MutationAddTkdCompetitionToOrderArgs = {
  input: MeAddTkdCompetitionToCartInput;
};


export type MutationAddWaMediaToTextTemplateArgs = {
  input: AddFileInput;
};


export type MutationAddWhatsappImageMessageToQueueArgs = {
  input: AddWhatsappImageMessageToQueueInput;
};


export type MutationAddWhatsappReactionMessageToQueueArgs = {
  input: AddWhatsappReactionMessageToQueueInput;
};


export type MutationAddWhatsappTemplateMsgToQueueArgs = {
  input: AddWhatsappTemplateMsgToQueueInput;
};


export type MutationAddWhatsappTextMessageToQueueArgs = {
  input: AddWhatsappTextMessageToQueueInput;
};


export type MutationAddYldsaCourseAdminFeeToCartArgs = {
  input: AddYldsaCourseAdminFeeToCartInput;
};


export type MutationAddYldsaOldCourseRefundToCartArgs = {
  input: AddYldsaOldCourseRefundToCartInput;
};


export type MutationAdminCleanUserSessionArgs = {
  input: CleanUserSessionInput;
};


export type MutationAdminDeletePassKeyArgs = {
  input: AdminDeletePassKeyInput;
};


export type MutationAdminLoginAsMemberArgs = {
  input: AdminLoginAsMemberInput;
};


export type MutationAdminRemoveTotpArgs = {
  input: AnyRemoveTotpInput;
};


export type MutationApiDeleteUserArgs = {
  input: ApiDeleteUserInput;
};


export type MutationApplyCouponToFacilityBookingArgs = {
  input: ApplyCouponToFacilityBookingInput;
};


export type MutationApplyCouponToPrivateCoachArgs = {
  input: ApplyCouponToPrivateCoachInput;
};


export type MutationApplyDefaultFacilityFeeArgs = {
  input: ApplyDefaultFacilityFeeInput;
};


export type MutationApplyRoleTemplateToUserArgs = {
  input: ApplyRoleTemplateToUserInput;
};


export type MutationApproveOrRejectInternalBookingArgs = {
  input: ApproveOrRejectInternalBookingInput;
};


export type MutationAuthSessionWithTotpArgs = {
  input: AuthSessionWithTotpInput;
};


export type MutationAutoPickCourseLotteryResultArgs = {
  input: AutoPickCourseLotteryResultInput;
};


export type MutationCalculateCoachSalaryArgs = {
  input: CalculateCoachSalaryInput;
};


export type MutationCancelAllFutureInternalBookingForUserArgs = {
  input: CancelAllFutureInternalBookingForUserInput;
};


export type MutationCancelAllInQueueAndSoftFailMsgQueueArgs = {
  input: CancelAllInQueueAndSoftFailMsgQueueInput;
};


export type MutationCancelCheckInTimeSlotProgramReservationArgs = {
  input: CheckInTimeSlotProgramReservationInput;
};


export type MutationCancelCourseEnrolmentArgs = {
  input: CancelCourseEnrolmentInput;
};


export type MutationCancelLessonEnrolmentArgs = {
  input: CancelLessonEnrolmentInput;
};


export type MutationCancelMsgQueueArgs = {
  input: CancelInQueueAndSoftFailMsgQueueInput;
};


export type MutationCancelTimeSlotProgramReservationArgs = {
  input: CancelTimeSlotProgramReservationInput;
};


export type MutationCeoApproveRefundPayoutArgs = {
  input: CeoApproveRefundPayoutInput;
};


export type MutationCeoConvertPgToNonPgRefundPayoutArgs = {
  input: ConvertPgToNonPgRefundPayoutInput;
};


export type MutationCeoProcessGlobalPaymentRefundPayoutArgs = {
  input: ProcessGlobalPaymentRefundPayoutInput;
};


export type MutationCeoRejectRefundPayoutRequestArgs = {
  input: RejectRefundPayoutRequestInput;
};


export type MutationCheckInByMyorderQrCodeArgs = {
  input: CheckInByMyorderQrCodeInput;
};


export type MutationCheckInByQuickQrCodeArgs = {
  input: CheckInByQuickQrCodeInput;
};


export type MutationCheckInByUserCodeArgs = {
  input: CheckInByUserCodeInput;
};


export type MutationCheckInTimeSlotProgramReservationArgs = {
  input: CheckInTimeSlotProgramReservationInput;
};


export type MutationCleanMemberSessionArgs = {
  input: CleanMemberSessionInput;
};


export type MutationClearCartArgs = {
  input: GetCartInput;
};


export type MutationClearLessonArgs = {
  input: ClearLessonInput;
};


export type MutationCloseInventoryRequestArgs = {
  input: CloseInventoryRequestInput;
};


export type MutationCoachAddBookingAndCoachToCartArgs = {
  input: CoachAddBookingAndCoachToCartInput;
};


export type MutationCoachAddCoachTimeslotArgs = {
  input: CoachAddCoachTimeslotInput;
};


export type MutationCoachApplyCouponToPrivateCoachArgs = {
  input: ApplyCouponToPrivateCoachInput;
};


export type MutationCoachConvertToOrderArgs = {
  input: ConvertToOrderInput;
};


export type MutationCoachCreateUserCoachServiceRelArgs = {
  input: CoachCreateUserCoachServiceRelInput;
};


export type MutationCoachDeleteCoachTimeSlotArgs = {
  input: CoachDeleteCoachTimeSlotInput;
};


export type MutationCoachDeleteUserCoachServiceRelArgs = {
  input: DeleteUserCoachServiceRelInput;
};


export type MutationCoachLessonCancelAttendanceArgs = {
  input: CoachLessonCancelAttendanceInput;
};


export type MutationCoachLessonTakeAttendanceArgs = {
  input: CoachLessonTakeAttendanceInput;
};


export type MutationCoachPrivateLessonCancelAttendanceArgs = {
  input: CoachPrivateLessonCancelAttendanceInput;
};


export type MutationCoachPrivateLessonTakeAttendanceArgs = {
  input: CoachPrivateLessonTakeAttendanceInput;
};


export type MutationCoachRemoveItemFromCartArgs = {
  input: CoachRemoveItemFromCartInput;
};


export type MutationCoachUpdateCoachTimeslotArgs = {
  input: CoachUpdateCoachTimeslotInput;
};


export type MutationCoachUpdateUserCoachServiceRelArgs = {
  input: UpdateUserCoachServiceRelInput;
};


export type MutationConfirmCoachSalaryReportArgs = {
  input: ConfirmCoachSalaryReportInput;
};


export type MutationConfirmCourseEnrolmentArgs = {
  input: ConfirmCourseEnrolmentInput;
};


export type MutationConfirmCourseLotteryResultAndRejectOthersArgs = {
  input: ConfirmCourseLotteryResultAndRejectOthersInput;
};


export type MutationConfirmDeliveryNoteArgs = {
  input: ConfirmDeliveryNoteInput;
};


export type MutationConfirmGoodsReceiveNoteArgs = {
  input: ConfirmGoodsReceiveNoteInput;
};


export type MutationConfirmLessonEnrolmentArgs = {
  input: ConfirmCourseEnrolmentInput;
};


export type MutationConfirmPaymentArgs = {
  input: ConfirmPaymentInput;
};


export type MutationConfirmToAddTotpArgs = {
  input: ConfirmToAddTotpInput;
};


export type MutationConfirmWarehouseStockTakeArgs = {
  input: ConfirmWarehouseStockTakeInput;
};


export type MutationConvertToOrderArgs = {
  input: ConvertToOrderInput;
};


export type MutationConvertToOrderAndConfirmPaymentArgs = {
  input: ConvertToOrderAndConfirmPaymentInput;
};


export type MutationConvertToOrderAndOutstandingPaymentArgs = {
  input: ConvertToOrderAndOutstandingPaymentInput;
};


export type MutationCreateAccessPassArgs = {
  input: CreateAccessPassInput;
};


export type MutationCreateAccessPassOptionArgs = {
  input: CreateAccessPassOptionInput;
};


export type MutationCreateAcctProductCatArgs = {
  input: CreateAcctProductCatInput;
};


export type MutationCreateBlackoutArgs = {
  input: CreateBlackoutInput;
};


export type MutationCreateBonusPointEarningRuleArgs = {
  input: CreateBonusPointEarningRuleInput;
};


export type MutationCreateBonusPointEarningRuleCourseArgs = {
  input: CreateBonusPointEarningRuleCourseInput;
};


export type MutationCreateBonusPointEarningRuleFacilityBookingArgs = {
  input: CreateBonusPointEarningRuleFacilityBookingInput;
};


export type MutationCreateBonusPointEarningRuleLockerArgs = {
  input: CreateBonusPointEarningRuleLockerInput;
};


export type MutationCreateBonusPointEarningRuleMyEventArgs = {
  input: CreateBonusPointEarningRuleMyEventInput;
};


export type MutationCreateBonusPointEarningRuleNthOrderArgs = {
  input: CreateBonusPointEarningRuleNthOrderInput;
};


export type MutationCreateBonusPointEarningRuleProductArgs = {
  input: CreateBonusPointEarningRuleProductInput;
};


export type MutationCreateBonusPointItemTypeEarningRatioArgs = {
  input: CreateBonusPointItemTypeEarningRatioInput;
};


export type MutationCreateBonusPointRedeemPromotionGroupArgs = {
  input: CreateBonusPointRedeemPromotionGroupInput;
};


export type MutationCreateCheckInDeviceArgs = {
  input: CreateCheckInDeviceInput;
};


export type MutationCreateCoachArgs = {
  input: CreateUserInput;
};


export type MutationCreateCoachServiceArgs = {
  input: CreateCoachServiceInput;
};


export type MutationCreateCommitteeArgs = {
  input: CreateCommitteeInput;
};


export type MutationCreateCommitteeHistoryArgs = {
  input: CreateCommitteeHistoryInput;
};


export type MutationCreateCommitteePositionArgs = {
  input: CreateCommitteePositionInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateConvertToScrapedArgs = {
  input: CreateConvertToScrapedInput;
};


export type MutationCreateCouponPackageArgs = {
  input: CreateCouponPackageInput;
};


export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
};


export type MutationCreateCourseApplyQuotaPeriodArgs = {
  input: CreateCourseApplyQuotaPeriodInput;
};


export type MutationCreateCourseTypeArgs = {
  input: CreateCourseTypeInput;
};


export type MutationCreateCreditPackageArgs = {
  input: CreateCreditPackageInput;
};


export type MutationCreateCreditTypeArgs = {
  input: CreateCreditTypeInput;
};


export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


export type MutationCreateDocxTemplateArgs = {
  input: CreateDocxTemplateInput;
};


export type MutationCreateDriveTeamArgs = {
  input: CreateDriveTeamInput;
};


export type MutationCreateFabFloorplanArgs = {
  input: CreateFabFloorplanInput;
};


export type MutationCreateFabFloorplanPeriodArgs = {
  input: CreateFabFloorplanPeriodInput;
};


export type MutationCreateFabTableArgs = {
  input: CreateFabTableInput;
};


export type MutationCreateFacilityArgs = {
  input: CreateFacilityInput;
};


export type MutationCreateHolidayArgs = {
  input: CreateHolidayInput;
};


export type MutationCreateInterWarehouseInventoryTransferArgs = {
  input: CreateInterWarehouseInventoryTransferInput;
};


export type MutationCreateInterWarehouseInventoryTransferAtOnceArgs = {
  input: CreateInterWarehouseInventoryTransferAtOnceInput;
};


export type MutationCreateIntraWarehouseInventoryTransferArgs = {
  input: CreateIntraWarehouseInventoryTransferInput;
};


export type MutationCreateIntraWarehouseInventoryTransferAtOnceArgs = {
  input: CreateIntraWarehouseInventoryTransferAtOnceInput;
};


export type MutationCreateKwtdhcEventArgs = {
  input: CreateKwtdhcEventInput;
};


export type MutationCreateKwtdhcMemberFollowupArgs = {
  input: CreateKwtdhcMemberFollowupInput;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateLocationAreaArgs = {
  input: CreateLocationAreaInput;
};


export type MutationCreateLockerGroupArgs = {
  input: CreateLockerGroupInput;
};


export type MutationCreateLockerTypeArgs = {
  input: CreateLockerTypeInput;
};


export type MutationCreateMemberArgs = {
  input: CreateMemberInput;
};


export type MutationCreateMemberListArgs = {
  input: CreateMemberListInput;
};


export type MutationCreateMemberLotteryGroupScoreOverrideArgs = {
  input: CreateOverrideLotteryGroupScoreInput;
};


export type MutationCreateMembershipTypeArgs = {
  input: CreateMembershipTypeInput;
};


export type MutationCreateMyEventArgs = {
  input: CreateMyEventInput;
};


export type MutationCreateNewsArgs = {
  input: CreateNewsInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductCatArgs = {
  input: CreateProductCatInput;
};


export type MutationCreatePurchaseOrderArgs = {
  input: CreatePurchaseOrderInput;
};


export type MutationCreatePureStockOutArgs = {
  input: CreatePureStockOutInput;
};


export type MutationCreateRecurCourseArgs = {
  input: CreateRecurCourseInput;
};


export type MutationCreateRequestRefundPayoutArgs = {
  input: RequestRefundPayoutInput;
};


export type MutationCreateRoleTemplateArgs = {
  input: CreateRoleTemplateInput;
};


export type MutationCreateSportTypeArgs = {
  input: CreateSportTypeInput;
};


export type MutationCreateSportTypeGroupArgs = {
  input: CreateSportTypeGroupInput;
};


export type MutationCreateStaffMemberArgs = {
  input: CreateStaffMemberInput;
};


export type MutationCreateSwpTestCardQrCodeArgs = {
  input: CreateSwpTestCardQrCodeInput;
};


export type MutationCreateTextTemplateArgs = {
  input: CreateTextTemplateInput;
};


export type MutationCreateTimeSlotProgramArgs = {
  input: CreateTimeSlotProgramInput;
};


export type MutationCreateTimeSlotProgramGroupArgs = {
  input: CreateTimeSlotProgramGroupInput;
};


export type MutationCreateTrialMemberArgs = {
  input: CreateTrialMemberInput;
};


export type MutationCreateTrialMemberAndAddToCourseEnrolmentArgs = {
  input: CreateTrialMemberAndAddToCourseEnrolmentInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserCoachServiceRelArgs = {
  input: CreateUserCoachServiceRelInput;
};


export type MutationCreateUserProductGroupArgs = {
  input: CreateUserProductGroupInput;
};


export type MutationCreateWarehouseArgs = {
  input: CreateWarehouseInput;
};


export type MutationCreateWarehousePartitionArgs = {
  input: CreateWarehousePartitionInput;
};


export type MutationCreateWarehouseStockTakeArgs = {
  input: CreateWarehouseStockTakeInput;
};


export type MutationCreateWhatsappTemplateArgs = {
  input: CreateWhatsappTemplateInput;
};


export type MutationCreateWriteOffArgs = {
  input: CreateWriteOffInput;
};


export type MutationDeleteAccessPassArgs = {
  input: DeleteAccessPassInput;
};


export type MutationDeleteAccessPassFacilityAccessRelArgs = {
  input: DeleteAccessPassFacilityAccessRelInput;
};


export type MutationDeleteAccessPassOptionArgs = {
  input: DeleteAccessPassOptionInput;
};


export type MutationDeleteAccessPassToBonusPointEarningRuleArgs = {
  input: DeleteAccessPassToBonusPointEarningRuleInput;
};


export type MutationDeleteAcctProductCatArgs = {
  input: DeleteAcctProductCatInput;
};


export type MutationDeleteBlackoutArgs = {
  input: DeleteBlackoutInput;
};


export type MutationDeleteBonusPointEarningRuleArgs = {
  input: DeleteBonusPointEarningRuleInput;
};


export type MutationDeleteBonusPointEarningRuleCourseArgs = {
  input: DeleteBonusPointEarningRuleCourseInput;
};


export type MutationDeleteBonusPointEarningRuleFacilityBookingArgs = {
  input: DeleteBonusPointEarningRuleFacilityBookingInput;
};


export type MutationDeleteBonusPointEarningRuleLockerArgs = {
  input: DeleteBonusPointEarningRuleLockerInput;
};


export type MutationDeleteBonusPointEarningRuleMyEventArgs = {
  input: DeleteBonusPointEarningRuleMyEventInput;
};


export type MutationDeleteBonusPointEarningRuleNthOrderArgs = {
  input: DeleteBonusPointEarningRuleNthOrderInput;
};


export type MutationDeleteBonusPointEarningRuleProductArgs = {
  input: DeleteBonusPointEarningRuleProductInput;
};


export type MutationDeleteBonusPointItemTypeEarningRatioArgs = {
  input: DeleteBonusPointItemTypeEarningRatioInput;
};


export type MutationDeleteBookingArgs = {
  input: DeleteBookingInput;
};


export type MutationDeleteBookingActAsAdminArgs = {
  input: DeleteBookingActAsAdminInput;
};


export type MutationDeleteCheckInDeviceArgs = {
  input: DeleteCheckInDeviceInput;
};


export type MutationDeleteCoachArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteCoachSalaryContractTermsArgs = {
  input: DeleteCoachSalaryContractTermsInput;
};


export type MutationDeleteCoachSalaryReportArgs = {
  input: DeleteCoachSalaryReportInput;
};


export type MutationDeleteCoachSalaryReportCoachAdjustmentArgs = {
  input: DeleteCoachSalaryReportCoachAdjustmentInput;
};


export type MutationDeleteCoachServiceArgs = {
  input: DeleteCoachServiceInput;
};


export type MutationDeleteCoachTimeSlotArgs = {
  input: DeleteCoachTimeSlotInput;
};


export type MutationDeleteCommitteeArgs = {
  input: DeleteCommitteeInput;
};


export type MutationDeleteCommitteeHistoryArgs = {
  input: DeleteCommitteeHistoryInput;
};


export type MutationDeleteCommitteePositionArgs = {
  input: DeleteCommitteePositionInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type MutationDeleteCouponCodeToBonusPointEarningRuleArgs = {
  input: DeleteCouponCodeToBonusPointEarningRuleInput;
};


export type MutationDeleteCouponPackageArgs = {
  input: DeleteCouponPackageInput;
};


export type MutationDeleteCouponPackageCoachServiceRelArgs = {
  input: DeleteCouponPackageCoachServiceRelInput;
};


export type MutationDeleteCouponPackageFacilityRelArgs = {
  input: DeleteCouponPackageFacilityRelInput;
};


export type MutationDeleteCourseArgs = {
  input: DeleteCourseInput;
};


export type MutationDeleteCourseApplyQuotaPeriodArgs = {
  input: DeleteCourseApplyQuotaPeriodInput;
};


export type MutationDeleteCourseEnrolmentForTrialMemberArgs = {
  input: DeleteCourseEnrolmentForTrialMemberInput;
};


export type MutationDeleteCourseInvitationCodeArgs = {
  input: DeleteCourseInvitationCodeInput;
};


export type MutationDeleteCourseTypeArgs = {
  input: DeleteCourseTypeInput;
};


export type MutationDeleteCreditPackageArgs = {
  input: DeleteCreditPackageInput;
};


export type MutationDeleteCreditTypeArgs = {
  input: DeleteCreditTypeInput;
};


export type MutationDeleteDefaultFacilityFeeArgs = {
  input: DeleteDefaultFacilityFeeInput;
};


export type MutationDeleteDepartmentArgs = {
  input: DeleteDepartmentInput;
};


export type MutationDeleteDocxTemplateArgs = {
  input: DeleteDocxTemplateInput;
};


export type MutationDeleteDriveTeamArgs = {
  input: DeleteDriveTeamInput;
};


export type MutationDeleteFabFloorplanArgs = {
  input: DeleteFabFloorplanInput;
};


export type MutationDeleteFabFloorplanPeriodArgs = {
  input: DeleteFabFloorplanPeriodInput;
};


export type MutationDeleteFabTableArgs = {
  input: DeleteFabTableInput;
};


export type MutationDeleteFacilityAccessPassDependencyArgs = {
  input: DeleteFacilityAccessPassDependencyInput;
};


export type MutationDeleteFacilityAccessPassLeadTimeArgs = {
  input: DeleteFacilityAccessPassLeadTimeInput;
};


export type MutationDeleteFacilityAccessPassNoOfTimeslotArgs = {
  input: DeleteFacilityAccessPassNoOfTimeslotInput;
};


export type MutationDeleteFacilityBookingOnlyOpenWhenAllBookedExceptTimeslotArgs = {
  input: DeleteFacilityBookingOnlyOpenWhenAllBookedExceptTimeslotInput;
};


export type MutationDeleteFacilityFeeArgs = {
  input: DeleteFacilityFeeInput;
};


export type MutationDeleteHolidayArgs = {
  input: DeleteHolidayInput;
};


export type MutationDeleteKwtdhcEventArgs = {
  input: GetKwtdhcEventInput;
};


export type MutationDeleteKwtdhcMemberFollowupArgs = {
  input: DeleteKwtdhcMemberFollowupInput;
};


export type MutationDeleteLessonArgs = {
  input: DeleteLessonInput;
};


export type MutationDeleteLessonEnrolmentForTrialMemberArgs = {
  input: DeleteLessonEnrolmentForTrialMemberInput;
};


export type MutationDeleteLocationArgs = {
  input: DeleteLocationInput;
};


export type MutationDeleteLocationAreaArgs = {
  input: DeleteLocationAreaInput;
};


export type MutationDeleteLockerGroupArgs = {
  input: DeleteLockerGroupInput;
};


export type MutationDeleteLockerGroupFeeArgs = {
  input: DeleteLockerGroupFeeInput;
};


export type MutationDeleteLockerGroupWaitingListArgs = {
  input: DeleteLockerGroupWaitingListInput;
};


export type MutationDeleteLockerTypeArgs = {
  input: DeleteLockerTypeInput;
};


export type MutationDeleteMemberFromCourseMemberListArgs = {
  input: DeleteMemberFromCourseMemberListInput;
};


export type MutationDeleteMemberListArgs = {
  input: DeleteMemberListInput;
};


export type MutationDeleteMemberListAsCourseMemberListFromCourseArgs = {
  input: DeleteMemberListAsCourseMemberListFromCourseInput;
};


export type MutationDeleteMemberListAsRecurCourseMemberListFromCourseArgs = {
  input: DeleteMemberListAsRecurCourseMemberListFromCourseInput;
};


export type MutationDeleteMemberListMemberArgs = {
  input: DeleteMemberListMemberInput;
};


export type MutationDeleteMemberLotteryGroupScoreOverrideArgs = {
  input: DeleteOverrideLotteryGroupScoreInput;
};


export type MutationDeleteMemberRelationshipArgs = {
  input: DeleteMemberRelationshipInput;
};


export type MutationDeleteMembershipTypeArgs = {
  input: DeleteMembershipTypeInput;
};


export type MutationDeleteMiniSiteContentArgs = {
  input: DeleteMiniSiteContentInput;
};


export type MutationDeleteMyEventArgs = {
  input: DeleteMyEventInput;
};


export type MutationDeleteMyEventTicketSeatArgs = {
  input: DeleteMyEventTicketSeatInput;
};


export type MutationDeleteMyEventTicketTypeArgs = {
  input: DeleteMyEventTicketTypeInput;
};


export type MutationDeleteNewsArgs = {
  input: DeleteNewsInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};


export type MutationDeleteProductCatArgs = {
  input: DeleteProductCatInput;
};


export type MutationDeleteProductFromUserProductGroupArgs = {
  input: DeleteProductFromUserProductGroupInput;
};


export type MutationDeleteRecurCourseArgs = {
  input: DeleteRecurCourseInput;
};


export type MutationDeleteRoleTemplateArgs = {
  input: DeleteRoleTemplateInput;
};


export type MutationDeleteSettingArgs = {
  input: GetAdminSettingInput;
};


export type MutationDeleteSportTypeArgs = {
  input: DeleteSportTypeInput;
};


export type MutationDeleteSportTypeGroupArgs = {
  input: DeleteSportTypeGroupInput;
};


export type MutationDeleteSwpTestCardQrCodeArgs = {
  input: DeleteSwpTestCardQrCodeInput;
};


export type MutationDeleteTextTemplateArgs = {
  input: DeleteTextTemplateInput;
};


export type MutationDeleteTimeSlotProgramArgs = {
  input: DeleteTimeSlotProgramInput;
};


export type MutationDeleteTimeSlotProgramGroupArgs = {
  input: DeleteTimeSlotProgramGroupInput;
};


export type MutationDeleteTimeSlotProgramLocationArgs = {
  input: DeleteTimeSlotProgramLocationInput;
};


export type MutationDeleteTimeSlotProgramOpeningHourArgs = {
  input: DeleteTimeSlotProgramOpeningHourInput;
};


export type MutationDeleteTimeSlotProgramServiceTypeArgs = {
  input: DeleteTimeSlotProgramServiceTypeInput;
};


export type MutationDeleteTimeSlotProgramSummaryUserArgs = {
  input: DeleteTimeSlotProgramSummaryUserInput;
};


export type MutationDeleteTimeslotProgramGridHourArgs = {
  input: DeleteTimeslotProgramGridHourInput;
};


export type MutationDeleteTmpHoldBookingArgs = {
  input: DeleteTmpHoldBookingInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteUserCoachServiceRelArgs = {
  input: DeleteUserCoachServiceRelInput;
};


export type MutationDeleteUserProductGroupArgs = {
  input: DeleteUserProductGroupInput;
};


export type MutationDeleteWarehouseArgs = {
  input: DeleteWarehouseInput;
};


export type MutationDeleteWarehousePartitionArgs = {
  input: DeleteWarehousePartitionInput;
};


export type MutationDeleteWarehouseStockTakeArgs = {
  input: DeleteWarehouseStockTakeInput;
};


export type MutationDeptConfirmCoachSalaryReportArgs = {
  input: DeptConfirmCoachSalaryReportInput;
};


export type MutationDuplicateFacilityArgs = {
  input: DuplicateFacilityInput;
};


export type MutationDuplicateTimeSlotProgramArgs = {
  input: DuplicateTimeSlotProgramInput;
};


export type MutationFinanceApproveRefundPayoutArgs = {
  input: FinanceApproveRefundPayoutInput;
};


export type MutationFinanceConvertPgToNonPgRefundPayoutArgs = {
  input: ConvertPgToNonPgRefundPayoutInput;
};


export type MutationFinanceProcessGlobalPaymentRefundPayoutArgs = {
  input: ProcessGlobalPaymentRefundPayoutInput;
};


export type MutationFinanceRejectRefundPayoutRequestArgs = {
  input: RejectRefundPayoutRequestInput;
};


export type MutationForceDeleteMemberFaceFromTerminalArgs = {
  input: ForceDeleteMemberFaceFromTerminalInput;
};


export type MutationForceUploadMemberFaceToTerminalArgs = {
  input: ForceUploadMemberFaceToTerminalInput;
};


export type MutationForceVoidMyorderArgs = {
  input: UserVoidMyorderInput;
};


export type MutationGenerateCourseByRecurCourseArgs = {
  input: GenerateCourseByRecurCourseInput;
};


export type MutationGenerateStaffQrCodeArgs = {
  input: GenerateStaffQrCodeInput;
};


export type MutationGetAllMemberEnrolmentStatsArgs = {
  input: GetAllMemberEnrolmentStatsInput;
};


export type MutationGetBonusPointDailyReportArgs = {
  input: GetBonusPointReportDailyInput;
};


export type MutationGetCourseEnrolmentStatsArgs = {
  input: GetCourseEnrolmentStatsInput;
};


export type MutationGetCreditDailyReportArgs = {
  input: GetCreditReportDailyInput;
};


export type MutationGetOneCourseEnrolmentStatsArgs = {
  input: GetOneCourseEnrolmentStatsInput;
};


export type MutationGetOneMemberEnrolmentStatsArgs = {
  input: GetOneMemberEnrolmentStatsInput;
};


export type MutationHeldMyEventTicketSeatArgs = {
  input: HeldMyEventTicketSeatInput;
};


export type MutationHoldBookingToFacilityArgs = {
  input: GenericAddBookingToFacilityInput;
};


export type MutationImportMemberArgs = {
  input: ImportMemberInput;
};


export type MutationKwtdhcBatchImportMemberArgs = {
  input: KwtdhcBatchImportMemberInput;
};


export type MutationKwtdhcLoginByJwtArgs = {
  input: KwtdhcLoginByJwtInput;
};


export type MutationLessonCancelAttendanceArgs = {
  input: LessonCancelAttendanceInput;
};


export type MutationLessonTakeAttendanceArgs = {
  input: LessonTakeAttendanceInput;
};


export type MutationLoadInventoryToStockTakeArgs = {
  input: LoadInventoryToStockTakeInput;
};


export type MutationLoginByMemberNoArgs = {
  input: LoginByMemberNoInput;
};


export type MutationLoginByTimeSlotProgramReservationArgs = {
  input: LoginByTimeSlotProgramReservationInput;
};


export type MutationMachineLoginArgs = {
  input: LoginUserInput;
};


export type MutationMakeLockerAvailableArgs = {
  input: MakeLockerAvailableInput;
};


export type MutationMakeReturnShipmentArgs = {
  input: MakeReturnShipmentInput;
};


export type MutationMakeShipmentArgs = {
  input: MakeShipmentInput;
};


export type MutationManualAddAccessPassHistoryArgs = {
  input: ManualAddAccessPassHistoryInput;
};


export type MutationManualCheckInArgs = {
  input: MeManualCheckInInput;
};


export type MutationManualDeleteAccessPassHistoryArgs = {
  input: ManualDeleteAccessPassHistoryInput;
};


export type MutationManualOverrideMembershipInfoArgs = {
  input: ManualOverrideMembershipInfoInput;
};


export type MutationManualUpdateAccessPassHistoryArgs = {
  input: ManualUpdateAccessPassHistoryInput;
};


export type MutationMarkDriveDepositAsDonationArgs = {
  input: MarkDriveDepositAsDonationInput;
};


export type MutationMarkMsgQueueAsReadWithHashArgs = {
  input: MarkMsgQueueAsReadWithHashInput;
};


export type MutationMarkNonPgRefundPayoutCompletedArgs = {
  input: MarkNonPgRefundPayoutCompletedInput;
};


export type MutationMassAddLessonToCourseArgs = {
  input: MassAddLessonToCourseInput;
};


export type MutationMassUpdateLessonArgs = {
  input: MassUpdateLessonInput;
};


export type MutationMeAddAccessPassToCartArgs = {
  input: MeAddAccessPassToCartInput;
};


export type MutationMeAddBbsToCartArgs = {
  input: MeAddBbsToCartInput;
};


export type MutationMeAddBookingAndCoachToCartArgs = {
  input: MeAddBookingAndCoachToCartInput;
};


export type MutationMeAddBookmarkArgs = {
  input: MeAddBookmarkInput;
};


export type MutationMeAddCoachToExistingBookingArgs = {
  input: MeAddCoachToExistingBookingInput;
};


export type MutationMeAddCouponPackageToCartArgs = {
  input: MeAddCouponPackageToCartInput;
};


export type MutationMeAddCourseEnrolmentArgs = {
  input: MeAddCourseEnrolmentInput;
};


export type MutationMeAddCourseEnrolmentToCartArgs = {
  input: MeAddCourseEnrolmentToCartInput;
};


export type MutationMeAddCreditPackageToCartArgs = {
  input: MeAddCreditPackageToCartInput;
};


export type MutationMeAddDriveDepositToCartArgs = {
  input: MeAddDriveDepositToCartInput;
};


export type MutationMeAddFacilityBookingToCartArgs = {
  input: MeAddBookingToCartInput;
};


export type MutationMeAddLessonEnrolmentToCartArgs = {
  input: MeAddLessonEnrolmentToCartInput;
};


export type MutationMeAddLockerToCartArgs = {
  input: MeAddLockerToCartInput;
};


export type MutationMeAddLostCardToCartArgs = {
  input: MeAddLostCardToCartInput;
};


export type MutationMeAddMemberRelationshipRequestArgs = {
  input: MeAddMemberRelationshipRequestInput;
};


export type MutationMeAddMemberToWaitingListArgs = {
  input: MeAddMemberToWaitingList;
};


export type MutationMeAddMembershipToCartArgs = {
  input: MeAddMembershipToCartInput;
};


export type MutationMeAddMyEventEnrolmentToCartArgs = {
  input: MeAddMyEventEnrolmentToCartInput;
};


export type MutationMeAddMyfileToMemberArgs = {
  input: MeAddMyfileToMemberInput;
};


export type MutationMeAddProductToCartArgs = {
  input: MeAddProductToCartInput;
};


export type MutationMeAddTimeSlotProgramReservationArgs = {
  input: MeAddTimeSlotProgramReservationInput;
};


export type MutationMeApplyCouponToFacilityBookingArgs = {
  input: MeApplyCouponToFacilityBookingInput;
};


export type MutationMeApplyCouponToPrivateCoachArgs = {
  input: MeApplyCouponToPrivateCoachInput;
};


export type MutationMeCancelCourseEnrolmentArgs = {
  input: MeCancelCourseEnrolmentInput;
};


export type MutationMeCancelMyorderArgs = {
  input: MeCancelMyorderInput;
};


export type MutationMeCancelTimeSlotProgramReservationArgs = {
  input: MeCancelTimeSlotProgramReservationInput;
};


export type MutationMeCleanMemberSessionArgs = {
  input: MeCleanMemberSessionInput;
};


export type MutationMeClearCartArgs = {
  input: MeGetCartInput;
};


export type MutationMeConfirmToAddTotpArgs = {
  input: ConfirmToAddTotpInput;
};


export type MutationMeConvertToOrderArgs = {
  input: MeConvertToOrderInput;
};


export type MutationMeConvertToOrderAndGetStripeSessionUrlArgs = {
  input: MeConvertToOrderAndGetStripeSessionUrlInput;
};


export type MutationMeCreateTrialMemberArgs = {
  input: CreateTrialMemberInput;
};


export type MutationMeCreateTrialMemberAndAddCourseEnrolmentToCartArgs = {
  input: MeCreateTrialMemberAndAddCourseEnrolmentToCartInput;
};


export type MutationMeCreateTrialMemberAndAddLessonEnrolmentToCartArgs = {
  input: MeCreateTrialMemberAndAddLessonEnrolmentToCartInput;
};


export type MutationMeCreateTrialMemberAndAddToCourseEnrolmentArgs = {
  input: MeCreateTrialMemberAndAddToCourseEnrolmentInput;
};


export type MutationMeDeleteBookmarkArgs = {
  input: MeDeleteBookmarkInput;
};


export type MutationMeDeletePassKeyArgs = {
  input: DeletePassKeyInput;
};


export type MutationMeGetOtpArgs = {
  input: MeGetOtpInput;
};


export type MutationMeGetStripeSessionUrlArgs = {
  input: MeGetStripeSessionUrlInput;
};


export type MutationMeInitEshopMemberArgs = {
  input: MeUpdateEshopMemberInput;
};


export type MutationMeIsItemBookmarkedArgs = {
  input: MeIsItemBookmarkedInput;
};


export type MutationMeMarkMsgQueueAsReadArgs = {
  input: MeMarkMsgQueueAsReadInput;
};


export type MutationMePurgeMyfileFromMemberArgs = {
  input: MePurgeMyfileFromMemberInput;
};


export type MutationMeRegisterEshopMemberArgs = {
  input: MeRegisterEshopMemberInput;
};


export type MutationMeRemoveGpTokenArgs = {
  input: MeRemoveGpTokenInput;
};


export type MutationMeRemoveItemFromCartArgs = {
  input: MeRemoveItemFromCartInput;
};


export type MutationMeRemoveTotpArgs = {
  input: RemoveTotpInput;
};


export type MutationMeSetDefaultGpTokenArgs = {
  input: MeSetGpTokenDefaultInput;
};


export type MutationMeSubmitParQArgs = {
  input: MeSubmitParQInput;
};


export type MutationMeUpdateAccessPassHistoryAutoRenewArgs = {
  input: MeUpdateAccessPassHistoryAutoRenewInput;
};


export type MutationMeUpdateBbsCartArgs = {
  input: MeUpdateBbsCartInput;
};


export type MutationMeUpdateEshopMemberArgs = {
  input: MeUpdateEshopMemberInput;
};


export type MutationMeUpdateGuestArgs = {
  input: MeUpdateGuestInput;
};


export type MutationMeUpdateGuestAndCartArgs = {
  input: MeUpdateGuestAndCartInput;
};


export type MutationMeUpdateInboxStatusArgs = {
  input: MeUpdateInboxStatusInput;
};


export type MutationMeUpdateLockerHistoryAutoRenewArgs = {
  input: MeUpdateLockerHistoryAutoRenewInput;
};


export type MutationMeUpdateMemberArgs = {
  input: MeUpdateMemberInput;
};


export type MutationMeUpdateMemberImageFileArgs = {
  input: MeUpdateMemberImageFileInput;
};


export type MutationMeUpdateMemberRelationshipRequestArgs = {
  input: MeUpdateMemberRelationshipRequestInput;
};


export type MutationMeUpdateMyorderArgs = {
  input: UpdateMyorderInput;
};


export type MutationMeUpdateNotificationSubArgs = {
  input: UpdateNotificationSubInput;
};


export type MutationMeUpdateTimeSlotProgramReservationArgs = {
  input: MeUpdateTimeSlotProgramReservationInput;
};


export type MutationMeVerifyOtpArgs = {
  input: MeVerifyOtpInput;
};


export type MutationMemberLoginArgs = {
  input: LoginMemberInput;
};


export type MutationPurgeBannerFromAppArgs = {
  input: PurgeBannerFromAppInput;
};


export type MutationPurgeMyfileFromBonusPointRedeemPromotionGroupArgs = {
  input: PurgeMyfileFromBonusPointRedeemPromotionGroupInput;
};


export type MutationPurgeMyfileFromCouponPackageArgs = {
  input: PurgeMyfileFromCouponPackageInput;
};


export type MutationPurgeMyfileFromCourseArgs = {
  input: PurgeMyfileFromCourseInput;
};


export type MutationPurgeMyfileFromInventoryGroupArgs = {
  input: PurgeMyfileFromInventoryGroupInput;
};


export type MutationPurgeMyfileFromKwtdhcEventArgs = {
  input: PurgeMyfileFromKwtdhcEventInput;
};


export type MutationPurgeMyfileFromLockerGroupArgs = {
  input: PurgeMyfileFromLockerGroupInput;
};


export type MutationPurgeMyfileFromMemberArgs = {
  input: PurgeMyfileFromMemberInput;
};


export type MutationPurgeMyfileFromMyEventArgs = {
  input: PurgeMyfileFromMyEventInput;
};


export type MutationPurgeMyfileFromNewsArgs = {
  input: PurgeMyfileFromNewsInput;
};


export type MutationPurgeMyfileFromProductArgs = {
  input: PurgeMyfileFromProductInput;
};


export type MutationPurgeMyfileFromProductCatArgs = {
  input: PurgeMyfileFromProductCatInput;
};


export type MutationPurgeMyfileFromRecurCourseArgs = {
  input: PurgeMyfileFromRecurCourseInput;
};


export type MutationPurgeMyfileFromSportTypeArgs = {
  input: PurgeMyfileFromSportTypeInput;
};


export type MutationPurgeMyfileFromSportTypeGroupArgs = {
  input: PurgeMyfileFromSportTypeGroupInput;
};


export type MutationPurgeMyfileFromTimeSlotProgramGroupArgs = {
  input: PurgeMyfileFromTimeSlotProgramGroupInput;
};


export type MutationPurgeOriginalMyfileArgs = {
  input: PurgeGenericOriginalMyfileInput;
};


export type MutationRegenerateRefundPayoutLinkArgs = {
  input: RegenerateRefundPayoutLinkInput;
};


export type MutationRegisterMemberLoginKeyArgs = {
  input: RegisterMemberLoginKeyInput;
};


export type MutationRejectCourseEnrolmentArgs = {
  input: RejectCourseEnrolmentInput;
};


export type MutationRejectLessonEnrolmentArgs = {
  input: RejectLessonEnrolmentInput;
};


export type MutationRemoveAgreementFromLockerHistoryArgs = {
  input: RemoveAgreementFromLockerHistoryInput;
};


export type MutationRemoveItemFromCartArgs = {
  input: RemoveItemFromCartInput;
};


export type MutationRemoveProductFromWarehouseStockTakeArgs = {
  input: RemoveProductFromWarehouseStockTakeInput;
};


export type MutationReplaceDocxTemplateFileArgs = {
  input: ReplaceDocxTemplateFileInput;
};


export type MutationResetMemberPasswordArgs = {
  input: ResetMemberPasswordInput;
};


export type MutationResyncCourseAutoAddMemberListArgs = {
  input: ResyncCourseAutoAddMemberListInput;
};


export type MutationScaaExportCoachMonthlySalaryCsvToFtpArgs = {
  input: ScaaExportCoachMonthlySalaryCsvToFtpInput;
};


export type MutationSendAccessPassReminderArgs = {
  input: SendAccessPassReminderInput;
};


export type MutationSendDailySummaryMailArgs = {
  input: SendDailySummaryMailInput;
};


export type MutationSendLockerReminderArgs = {
  input: SendLockerReminderInput;
};


export type MutationSendTimeSlotProgramDailySummaryMailArgs = {
  input: SendTimeSlotProgramDailySummaryMailInput;
};


export type MutationSetDefaultGpTokenArgs = {
  input: SetGpTokenDefaultInput;
};


export type MutationSetupLockerArgs = {
  input: UpdateLockerInput;
};


export type MutationStaffLoginOnlyOnceArgs = {
  input: LoginMemberInput;
};


export type MutationSubmitRefundPayoutDetailArgs = {
  input: SubmitRefundPayoutDetailInput;
};


export type MutationSwapFabTablesArgs = {
  input: FabSwapTablesInput;
};


export type MutationTransferDocxTemplateToUserArgs = {
  input: TransferDocxTemplateToUserInput;
};


export type MutationTransferTextTemplateToUserArgs = {
  input: TransferTextTemplateToUserInput;
};


export type MutationTransferTmpHoldArgs = {
  input: TransferTmpHoldInput;
};


export type MutationUndoCloseInventoryRequestArgs = {
  input: UndoCloseInventoryRequestInput;
};


export type MutationUndoConfirmDeliveryNoteArgs = {
  input: UndoConfirmDeliveryNoteInput;
};


export type MutationUndoConfirmGoodsReceiveNoteArgs = {
  input: UndoConfirmGoodsReceiveNoteInput;
};


export type MutationUnheldMyEventTicketSeatArgs = {
  input: UnHeldMyEventTicketSeatInput;
};


export type MutationUpdateAccessPassArgs = {
  input: UpdateAccessPassInput;
};


export type MutationUpdateAccessPassFacilityAccessRelArgs = {
  input: UpdateAccessPassFacilityAccessRelInput;
};


export type MutationUpdateAccessPassHistoryAutoRenewArgs = {
  input: UpdateAccessPassHistoryAutoRenewInput;
};


export type MutationUpdateAccessPassHistoryForceNoRenewArgs = {
  input: UpdateAccessPassHistoryForceNoRenewInput;
};


export type MutationUpdateAccessPassOptionArgs = {
  input: UpdateAccessPassOptionInput;
};


export type MutationUpdateAcctProductCatArgs = {
  input: UpdateAcctProductCatInput;
};


export type MutationUpdateAgreeToReceiveStockTransferArgs = {
  input: UpdateAgreeToReceiveStockTransferInput;
};


export type MutationUpdateBlackoutArgs = {
  input: UpdateBlackoutInput;
};


export type MutationUpdateBonusPointEarningRuleArgs = {
  input: UpdateBonusPointEarningRuleInput;
};


export type MutationUpdateBonusPointEarningRuleAccessPassArgs = {
  input: UpdateBonusPointEarningRuleAccessPassInput;
};


export type MutationUpdateBonusPointEarningRuleCouponCodeArgs = {
  input: UpdateBonusPointEarningRuleCouponCodeInput;
};


export type MutationUpdateBonusPointEarningRuleCourseArgs = {
  input: UpdateBonusPointEarningRuleCourseInput;
};


export type MutationUpdateBonusPointEarningRuleFacilityBookingArgs = {
  input: UpdateBonusPointEarningRuleFacilityBookingInput;
};


export type MutationUpdateBonusPointEarningRuleLockerArgs = {
  input: UpdateBonusPointEarningRuleLockerInput;
};


export type MutationUpdateBonusPointEarningRuleMyEventArgs = {
  input: UpdateBonusPointEarningRuleMyEventInput;
};


export type MutationUpdateBonusPointEarningRuleNthOrderArgs = {
  input: UpdateBonusPointEarningRuleNthOrderInput;
};


export type MutationUpdateBonusPointEarningRuleProductArgs = {
  input: UpdateBonusPointEarningRuleProductInput;
};


export type MutationUpdateBonusPointItemTypeEarningRatioArgs = {
  input: UpdateBonusPointItemTypeEarningRatioInput;
};


export type MutationUpdateBonusPointRedeemPromotionGroupArgs = {
  input: UpdateBonusPointRedeemPromotionGroupInput;
};


export type MutationUpdateBookingMetaArgs = {
  input: UpdateBookingMetaInput;
};


export type MutationUpdateCheckInDeviceArgs = {
  input: UpdateCheckInDeviceInput;
};


export type MutationUpdateCoachArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateCoachEnableArgs = {
  input: UpdateUserEnableInput;
};


export type MutationUpdateCoachSalaryContractTermsArgs = {
  input: UpdateCoachSalaryContractTermsInput;
};


export type MutationUpdateCoachSalaryReportCoachAdjustmentArgs = {
  input: UpdateCoachSalaryReportCoachAdjustmentInput;
};


export type MutationUpdateCoachServiceArgs = {
  input: UpdateCoachServiceInput;
};


export type MutationUpdateCoachTimeslotArgs = {
  input: UpdateCoachTimeslotInput;
};


export type MutationUpdateCommitteeArgs = {
  input: UpdateCommitteeInput;
};


export type MutationUpdateCommitteeHistoryArgs = {
  input: UpdateCommitteeHistoryInput;
};


export type MutationUpdateCommitteePositionArgs = {
  input: UpdateCommitteePositionInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateCouponPackageArgs = {
  input: UpdateCouponPackageInput;
};


export type MutationUpdateCouponPackageFacilityRelArgs = {
  input: UpdateCouponPackageFacilityRelInput;
};


export type MutationUpdateCourseArgs = {
  input: UpdateCourseInput;
};


export type MutationUpdateCourseApplyQuotaPeriodArgs = {
  input: UpdateCourseApplyQuotaPeriodInput;
};


export type MutationUpdateCourseCoachListArgs = {
  input: UpdateCourseCoachListInput;
};


export type MutationUpdateCourseEnableArgs = {
  input: UpdateCourseEnableInput;
};


export type MutationUpdateCourseEnrolmentLotteryDrawPriorityArgs = {
  input: UpdateCourseEnrolmentLotteryDrawPriorityInput;
};


export type MutationUpdateCourseInvitationCodeArgs = {
  input: UpdateCourseInvitationCodeInput;
};


export type MutationUpdateCourseTypeArgs = {
  input: UpdateCourseTypeInput;
};


export type MutationUpdateCreditPackageArgs = {
  input: UpdateCreditPackageInput;
};


export type MutationUpdateCreditTypeArgs = {
  input: UpdateCreditTypeInput;
};


export type MutationUpdateDefaultFacilityFeeArgs = {
  input: UpdateDefaultFacilityFeeInput;
};


export type MutationUpdateDepartmentArgs = {
  input: UpdateDepartmentInput;
};


export type MutationUpdateDepositForfeitDateArgs = {
  input: UpdateDepositForfeitDateInput;
};


export type MutationUpdateDocxTemplateArgs = {
  input: UpdateDocxTemplateInput;
};


export type MutationUpdateDriveTeamArgs = {
  input: UpdateDriveTeamInput;
};


export type MutationUpdateDriveTeamForMemberArgs = {
  input: UpdateDriveTeamForMemberInput;
};


export type MutationUpdateDriveTeamForMyorderArgs = {
  input: UpdateDriveTeamForMyorderInput;
};


export type MutationUpdateDriveTeamMemberListArgs = {
  input: UpdateDriveTeamMemberListInput;
};


export type MutationUpdateFabFloorplanArgs = {
  input: UpdateFabFloorplanInput;
};


export type MutationUpdateFabFloorplanPeriodArgs = {
  input: UpdateFabFloorplanPeriodInput;
};


export type MutationUpdateFabFloorplanRequestArgs = {
  input: UpdateFabFloorplanRequestInput;
};


export type MutationUpdateFabTableArgs = {
  input: UpdateFabTableInput;
};


export type MutationUpdateFacilityArgs = {
  input: UpdateFacilityInput;
};


export type MutationUpdateFacilityAccessLogAccessPassOptionIdArgs = {
  input: UpdateFacilityAccessLogAccessPassOptionIdInput;
};


export type MutationUpdateFacilityAccessPassDependencyArgs = {
  input: UpdateFacilityAccessPassDependencyInput;
};


export type MutationUpdateFacilityAccessPassLeadTimeArgs = {
  input: UpdateFacilityAccessPassLeadTimeInput;
};


export type MutationUpdateFacilityAccessPassNoOfTimeslotArgs = {
  input: UpdateFacilityAccessPassNoOfTimeslotInput;
};


export type MutationUpdateFacilityEnableArgs = {
  input: UpdateFacilityEnableInput;
};


export type MutationUpdateFacilityFeeArgs = {
  input: UpdateFacilityFeeInput;
};


export type MutationUpdateFcmTokenToSessionArgs = {
  input: UpdateFcmTokenToSessionInput;
};


export type MutationUpdateGuestArgs = {
  input: UpdateMemberInput;
};


export type MutationUpdateGuestAndCartArgs = {
  input: UpdateGuestAndCartInput;
};


export type MutationUpdateHolidayArgs = {
  input: UpdateHolidayInput;
};


export type MutationUpdateInternalBookingArgs = {
  input: UpdateInternalBookingInput;
};


export type MutationUpdateInventoryTxGroupArgs = {
  input: UpdateInventoryTxGroupInput;
};


export type MutationUpdateKwtdhcEventArgs = {
  input: UpdateKwtdhcEventInput;
};


export type MutationUpdateKwtdhcMemberFollowupArgs = {
  input: UpdateKwtdhcMemberFollowupInput;
};


export type MutationUpdateLessonArgs = {
  input: UpdateLessonInput;
};


export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


export type MutationUpdateLocationAreaArgs = {
  input: UpdateLocationAreaInput;
};


export type MutationUpdateLockerArgs = {
  input: UserUpdateLockerInput;
};


export type MutationUpdateLockerGroupArgs = {
  input: UpdateLockerGroupInput;
};


export type MutationUpdateLockerGroupFeeArgs = {
  input: UpdateLockerGroupFeeInput;
};


export type MutationUpdateLockerHistoryAutoRenewArgs = {
  input: UpdateLockerHistoryAutoRenewInput;
};


export type MutationUpdateLockerHistoryForceNoRenewArgs = {
  input: UpdateLockerHistoryForceNoRenewInput;
};


export type MutationUpdateLockerStatusArgs = {
  input: UpdateLockerStatusInput;
};


export type MutationUpdateLockerTypeArgs = {
  input: UpdateLockerTypeInput;
};


export type MutationUpdateMemberArgs = {
  input: UpdateMemberInput;
};


export type MutationUpdateMemberImageFileArgs = {
  input: UpdateMemberImageFileInput;
};


export type MutationUpdateMemberListArgs = {
  input: UpdateMemberListInput;
};


export type MutationUpdateMemberListMemberArgs = {
  input: UpdateMemberListMemberInput;
};


export type MutationUpdateMemberLotteryGroupScoreOverrideArgs = {
  input: UpdateOverrideLotteryGroupScoreInput;
};


export type MutationUpdateMemberRelationshipRequestArgs = {
  input: UpdateMemberRelationshipRequestInput;
};


export type MutationUpdateMembershipTypeArgs = {
  input: UpdateMembershipTypeInput;
};


export type MutationUpdateMembershipTypeIdAndAddDonationArgs = {
  input: UpdateMembershipTypeIdAndAddDonationInput;
};


export type MutationUpdateMiniSiteContentArgs = {
  input: UpdateMiniSiteContentInput;
};


export type MutationUpdateMyEventArgs = {
  input: UpdateMyEventInput;
};


export type MutationUpdateMyEventFacilityListArgs = {
  input: UpdateMyEventFacilityListInput;
};


export type MutationUpdateMyEventTicketTypeArgs = {
  input: UpdateMyEventTicketTypeInput;
};


export type MutationUpdateMyEventWhiteListArgs = {
  input: UpdateMyEventWhiteListInput;
};


export type MutationUpdateMyorderArgs = {
  input: AnyUpdateMyorderInput;
};


export type MutationUpdateMyorderItemArgs = {
  input: UpdateMyorderItemInput;
};


export type MutationUpdateMyorderItemApcArgs = {
  input: UpdateMyorderItemApcInput;
};


export type MutationUpdateNewsArgs = {
  input: UpdateNewsInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductCatArgs = {
  input: UpdateProductCatInput;
};


export type MutationUpdateProductOrderingArgs = {
  input: UpdateProductOrderingInput;
};


export type MutationUpdateProductSubCatOrderingArgs = {
  input: UpdateProductSubCatOrderingInput;
};


export type MutationUpdateRecurCourseArgs = {
  input: UpdateRecurCourseInput;
};


export type MutationUpdateRecurCourseCoachListArgs = {
  input: UpdateRecurCourseCoachListInput;
};


export type MutationUpdateRecurCourseExceptionDateListArgs = {
  input: UpdateRecurCourseExceptDateListInput;
};


export type MutationUpdateRecurCourseFacilityListArgs = {
  input: UpdateRecurCourseFacilityListInput;
};


export type MutationUpdateRoleTemplateArgs = {
  input: UpdateRoleTemplateInput;
};


export type MutationUpdateSettingArgs = {
  input: UpdateAdminSettingInput;
};


export type MutationUpdateSportTypeArgs = {
  input: UpdateSportTypeInput;
};


export type MutationUpdateSportTypeGroupArgs = {
  input: UpdateSportTypeGroupInput;
};


export type MutationUpdateStaffMemberArgs = {
  input: UpdateStaffMemberInput;
};


export type MutationUpdateSwpFeeArgs = {
  input: UpdateSwpFeeInput;
};


export type MutationUpdateSwpSessionArgs = {
  input: UpdateSwpSessionInput;
};


export type MutationUpdateSwpTestCardQrCodeArgs = {
  input: UpdateSwpTestCardQrCodeInput;
};


export type MutationUpdateTextTemplateArgs = {
  input: UpdateTextTemplateInput;
};


export type MutationUpdateTimeSlotProgramArgs = {
  input: UpdateTimeSlotProgramInput;
};


export type MutationUpdateTimeSlotProgramDailySummaryArgs = {
  input: UpdateTimeSlotProgramDailySummaryInput;
};


export type MutationUpdateTimeSlotProgramGroupArgs = {
  input: UpdateTimeSlotProgramGroupInput;
};


export type MutationUpdateTimeSlotProgramLocationArgs = {
  input: UpdateTimeSlotProgramLocationInput;
};


export type MutationUpdateTimeSlotProgramOpeningHourArgs = {
  input: UpdateTimeSlotProgramOpeningHourInput;
};


export type MutationUpdateTimeSlotProgramReservationArgs = {
  input: UpdateTimeSlotProgramReservationInput;
};


export type MutationUpdateTimeSlotProgramReservationRemarkArgs = {
  input: UpdateTimeSlotProgramReservationRemarkInput;
};


export type MutationUpdateTimeSlotProgramServiceTypeArgs = {
  input: UpdateTimeSlotProgramServiceTypeInput;
};


export type MutationUpdateTimeslotProgramGridHourArgs = {
  input: UpdateTimeslotProgramGridHourInput;
};


export type MutationUpdateTrialMemberArgs = {
  input: UpdateTrialMemberInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserCoachServiceRelArgs = {
  input: UpdateUserCoachServiceRelInput;
};


export type MutationUpdateUserDeptListPerDomainArgs = {
  input: UpdateUserDeptListPerDomainInput;
};


export type MutationUpdateUserDeptListPerPermissionTypeArgs = {
  input: UpdateUserDeptListPerPermissionTypeInput;
};


export type MutationUpdateUserEnableArgs = {
  input: UpdateUserEnableInput;
};


export type MutationUpdateUserProductArgs = {
  input: UpdateUserProductInput;
};


export type MutationUpdateUserProductGroupArgs = {
  input: UpdateUserProductGroupInput;
};


export type MutationUpdateUserProductGroupListOrderIdArgs = {
  input: UpdateUserProductGroupListOrderIdInput;
};


export type MutationUpdateUserProductGroupProductOrderingArgs = {
  input: UpdateUserProductGroupProductOrderingInput;
};


export type MutationUpdateUserRoleListArgs = {
  input: UpdateUserRoleListInput;
};


export type MutationUpdateUserWarehouseListArgs = {
  input: UpdateUserWarehouseListInput;
};


export type MutationUpdateWarehouseArgs = {
  input: UpdateWarehouseInput;
};


export type MutationUpdateWarehousePartitionArgs = {
  input: UpdateWarehousePartitionInput;
};


export type MutationUpdateWarehouseStockTakeArgs = {
  input: UpdateWarehouseStockTakeInput;
};


export type MutationUpdateWhatsappSummaryArgs = {
  input: UpdateWhatsappSummaryInput;
};


export type MutationUpdateWhatsappTemplateArgs = {
  input: UpdateWhatsappTemplateInput;
};


export type MutationUserAddCourseEnrolmentArgs = {
  input: UserAddCourseEnrolmentInput;
};


export type MutationUserAddMemberToWaitingListArgs = {
  input: UserAddMemberToWaitingList;
};


export type MutationUserCleanUserSessionArgs = {
  input: UserCleanUserSessionInput;
};


export type MutationUserDeleteMemberParQArgs = {
  input: UserDeleteMemberParQInput;
};


export type MutationUserDeletePassKeyArgs = {
  input: DeletePassKeyInput;
};


export type MutationUserLoginArgs = {
  input: LoginUserInput;
};


export type MutationUserLoginByAzureSsoArgs = {
  input: LoginByAzureSsoInput;
};


export type MutationUserMarkMsgQueueAsReadArgs = {
  input: UserMarkMsgQueueAsReadInput;
};


export type MutationUserRemoveGpTokenArgs = {
  input: UserRemoveGpTokenInput;
};


export type MutationUserRemoveTotpArgs = {
  input: RemoveTotpInput;
};


export type MutationUserSubmitParQArgs = {
  input: UserSubmitParQInput;
};


export type MutationUserUpdateInboxStatusArgs = {
  input: UserUpdateInboxStatusInput;
};


export type MutationUserUpdateMemberParQArgs = {
  input: UserUpdateMemberParQInput;
};


export type MutationUserUpdateNotificationSubArgs = {
  input: UpdateNotificationSubInput;
};


export type MutationUserUpdateUserArgs = {
  input: MeUpdateUserInput;
};


export type MutationVoidBonusPointReceiptRegArgs = {
  input: VoidBonusPointReceiptRegInput;
};


export type MutationVoidMyorderArgs = {
  input: UserVoidMyorderInput;
};


export type MutationWebPushSubscriptionUpdateArgs = {
  input: WebPushSubscriptionUpdateInput;
};


export type MutationWithdrawCreditArgs = {
  input: WithdrawCreditInput;
};


export type MutationYldsaRegisterMemberLoginKeyArgs = {
  input: YldsaRegisterMemberLoginKeyInput;
};

export type MyEvent = {
  __typename?: 'MyEvent';
  ageCountYearOnly: Scalars['Boolean']['output'];
  asEventGroup: Scalars['Boolean']['output'];
  childEventList?: Maybe<Array<MyEvent>>;
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  dayOfWeek: Scalars['Float']['output'];
  dept?: Maybe<Department>;
  deptId: Scalars['Int']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  earlyBirdEndDateForGroup?: Maybe<Scalars['String']['output']>;
  earlyBirdEndDateForGuest?: Maybe<Scalars['String']['output']>;
  earlyBirdEndDateForMember?: Maybe<Scalars['String']['output']>;
  enableForWeb: Scalars['Boolean']['output'];
  enableGroupEnrol: Scalars['Boolean']['output'];
  enableGuestEnrol: Scalars['Boolean']['output'];
  enableMemberEnrol: Scalars['Boolean']['output'];
  enableWhiteList: Scalars['Boolean']['output'];
  endDateTime?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  enrolmentEndDateForGroup: Scalars['String']['output'];
  enrolmentEndDateForGuest: Scalars['String']['output'];
  enrolmentEndDateForMember: Scalars['String']['output'];
  enrolmentStartDateForGroup: Scalars['String']['output'];
  enrolmentStartDateForGuest: Scalars['String']['output'];
  enrolmentStartDateForMember: Scalars['String']['output'];
  facilityList?: Maybe<Array<Facility>>;
  facilityRemarkEn: Scalars['String']['output'];
  facilityRemarkSc: Scalars['String']['output'];
  facilityRemarkTc: Scalars['String']['output'];
  gender: FilterGender;
  gqlSummary?: Maybe<MyEventSummaryResGql>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isTeamMode: Scalars['Boolean']['output'];
  isTeamModePricePerHead: Scalars['Boolean']['output'];
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  maxAge: Scalars['Float']['output'];
  maxNoOfFemaleTeamMembers: Scalars['Int']['output'];
  maxNoOfMaleTeamMembers: Scalars['Int']['output'];
  maxNoOfTotalTeamMembers: Scalars['Int']['output'];
  minAge: Scalars['Float']['output'];
  minNoOfFemaleTeamMembers: Scalars['Int']['output'];
  minNoOfMaleTeamMembers: Scalars['Int']['output'];
  minNoOfTotalTeamMembers: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  parentMyEvent?: Maybe<MyEvent>;
  parentMyEventId?: Maybe<Scalars['Int']['output']>;
  photoList?: Maybe<Array<Myfile>>;
  posTicketTypeList?: Maybe<Array<MyEventTicketType>>;
  remarkEn: Scalars['String']['output'];
  remarkSc: Scalars['String']['output'];
  remarkTc: Scalars['String']['output'];
  requireTeamName: Scalars['Boolean']['output'];
  sortPriceMax: Scalars['Float']['output'];
  sortPriceMin: Scalars['Float']['output'];
  sortQuota: Scalars['Float']['output'];
  sortQuotaLeft: Scalars['Float']['output'];
  sportType?: Maybe<SportType>;
  sportTypeId?: Maybe<Scalars['Int']['output']>;
  startDateTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<MyEventSummaryResGql>;
  teamGenderType: TeamGenderType;
  ticketTypeList?: Maybe<Array<MyEventTicketType>>;
  updatedDate: Scalars['String']['output'];
  webTicketTypeList?: Maybe<Array<MyEventTicketType>>;
  whitelist?: Maybe<Array<FullMember>>;
  youtubeId: Scalars['String']['output'];
};

export type MyEventEnrolment = {
  __typename?: 'MyEventEnrolment';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEarlyBird: Scalars['Boolean']['output'];
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myEventTicketSeatId: Scalars['Int']['output'];
  myorder?: Maybe<Myorder>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  seat?: Maybe<MyEventTicketSeat>;
  status: EnrolmentStatus;
  teamMemberList?: Maybe<Array<MyEventTeamMember>>;
  teamName: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum MyEventSearchGender {
  Any = 'any',
  F = 'f',
  FemaleOnly = 'femaleOnly',
  M = 'm',
  MaleOnly = 'maleOnly',
  Mix = 'mix'
}

export type MyEventSummaryResGql = {
  __typename?: 'MyEventSummaryResGql';
  availabilityStatus: CourseAvailabilityStatus;
  groupEarlyBirdPrice: Scalars['Float']['output'];
  groupPrice: Scalars['Float']['output'];
  guestEarlyBirdPrice: Scalars['Float']['output'];
  guestPrice: Scalars['Float']['output'];
  isMemberInWhitelist: Scalars['Boolean']['output'];
  memberEarlyBirdPrice: Scalars['Float']['output'];
  memberPrice: Scalars['Float']['output'];
};

export type MyEventTeamMember = {
  __typename?: 'MyEventTeamMember';
  id: Scalars['Int']['output'];
  isCaptain: Scalars['Boolean']['output'];
  member?: Maybe<FullMember>;
  memberId: Scalars['Int']['output'];
  myEventEnrolmentId: Scalars['Int']['output'];
};

export type MyEventTicketSeat = {
  __typename?: 'MyEventTicketSeat';
  checkInDateTime?: Maybe<Scalars['String']['output']>;
  checkInDevice?: Maybe<CheckInDevice>;
  checkInDeviceId?: Maybe<Scalars['Int']['output']>;
  checkInMode?: Maybe<CheckInMode>;
  enrolment?: Maybe<MyEventEnrolment>;
  id: Scalars['Int']['output'];
  myEventEnrolmentId?: Maybe<Scalars['Int']['output']>;
  myEventTicketTypeId: Scalars['Int']['output'];
  seatNo: Scalars['Int']['output'];
  ticketType?: Maybe<MyEventTicketType>;
};

export type MyEventTicketType = {
  __typename?: 'MyEventTicketType';
  activeBonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  apcCatCodeForFee: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  bonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  defaultFeeForGroup: Scalars['Float']['output'];
  defaultFeeForGuest: Scalars['Float']['output'];
  defaultFeeForMember: Scalars['Float']['output'];
  earlyBirdDiscountAmtForGroup: Scalars['Float']['output'];
  earlyBirdDiscountAmtForGuest: Scalars['Float']['output'];
  earlyBirdDiscountAmtForMember: Scalars['Float']['output'];
  earlyBirdDiscountPercentForGroup: Scalars['Int']['output'];
  earlyBirdDiscountPercentForGuest: Scalars['Int']['output'];
  earlyBirdDiscountPercentForMember: Scalars['Int']['output'];
  gqlPriceSummary?: Maybe<MyEventTicketTypePriceSummaryResGql>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isFreeSeating: Scalars['Boolean']['output'];
  maxTicketsPerMember: Scalars['Int']['output'];
  minTicketsPerMember: Scalars['Int']['output'];
  myEvent?: Maybe<MyEvent>;
  myEventId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  priceSummary?: Maybe<MyEventTicketTypePriceSummaryResGql>;
  quota: Scalars['Int']['output'];
  seatList?: Maybe<Array<MyEventTicketSeat>>;
  seatListForWeb?: Maybe<Array<MyEventTicketSeat>>;
  sortQuotaLeft: Scalars['Int']['output'];
};

export type MyEventTicketTypePriceSummaryResGql = {
  __typename?: 'MyEventTicketTypePriceSummaryResGql';
  groupEarlyBirdPrice: Scalars['Float']['output'];
  groupPrice: Scalars['Float']['output'];
  guestEarlyBirdPrice: Scalars['Float']['output'];
  guestPrice: Scalars['Float']['output'];
  memberEarlyBirdPrice: Scalars['Float']['output'];
  memberPrice: Scalars['Float']['output'];
};

export type MySession = {
  __typename?: 'MySession';
  appBuildNo: Scalars['Int']['output'];
  appVersion: Scalars['String']['output'];
  browserName: Scalars['String']['output'];
  browserVersion: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  deviceModel: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  deviceVendor: Scalars['String']['output'];
  fcmToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ip: Scalars['String']['output'];
  isBiometric: Scalars['Boolean']['output'];
  jwtExpireAt: Scalars['String']['output'];
  lastActionDate: Scalars['String']['output'];
  memberId?: Maybe<Scalars['Int']['output']>;
  osName: Scalars['String']['output'];
  osVersion: Scalars['String']['output'];
  requirePasswordChange: Scalars['Boolean']['output'];
  requireTotp: Scalars['Boolean']['output'];
  totpId?: Maybe<Scalars['Int']['output']>;
  totpLastVerifiedDate?: Maybe<Scalars['String']['output']>;
  type: SessionType;
  ua: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
  webPushSubscription?: Maybe<Scalars['String']['output']>;
};

export type Myfile = {
  __typename?: 'Myfile';
  createdDate: Scalars['String']['output'];
  fileIdPath: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastModifyUserId: Scalars['Int']['output'];
  memberId?: Maybe<Scalars['Int']['output']>;
  mimetype: Scalars['String']['output'];
  myfileList?: Maybe<Array<Myfile>>;
  myfileType: MyfileType;
  orderId: Scalars['Float']['output'];
  originalId?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  presignedToken?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  sysFilename: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  url: Scalars['String']['output'];
  viewport?: Maybe<Scalars['Int']['output']>;
};

export enum MyfileType {
  AccessPassBannerPhotos = 'accessPassBannerPhotos',
  BonusPointBannerPhotos = 'bonusPointBannerPhotos',
  BonusPointRedeemPromotionGroupPhotos = 'bonusPointRedeemPromotionGroupPhotos',
  BonusPointRedeemPromotionGroupThumbnail = 'bonusPointRedeemPromotionGroupThumbnail',
  BookingTabletFooter = 'bookingTabletFooter',
  BookingTabletHeader = 'bookingTabletHeader',
  CouponPackageBannerPhotos = 'couponPackageBannerPhotos',
  CouponPackageCourseBtnImg = 'couponPackageCourseBtnImg',
  CouponPackageFacilityBtnImg = 'couponPackageFacilityBtnImg',
  CouponPackagePrivateCoachBtnImg = 'couponPackagePrivateCoachBtnImg',
  CouponPackageThumbnail = 'couponPackageThumbnail',
  CourseBannerPhotos = 'courseBannerPhotos',
  CourseCoachPhoto = 'courseCoachPhoto',
  CoursePhotos = 'coursePhotos',
  DocxTemplate = 'docxTemplate',
  EshopBannerPhotos = 'eshopBannerPhotos',
  FacilityBannerPhotos = 'facilityBannerPhotos',
  FacilityBookingFiles = 'facilityBookingFiles',
  FacilityBtnPhoto = 'facilityBtnPhoto',
  FacilityPhotos = 'facilityPhotos',
  HomepageBannerPhotos = 'homepageBannerPhotos',
  InventoryTxGroupFiles = 'inventoryTxGroupFiles',
  InventoryTxGroupImg = 'inventoryTxGroupImg',
  KwtdhcEventFile = 'kwtdhcEventFile',
  KwtdhcMemberImportCsv = 'kwtdhcMemberImportCsv',
  LockerAgreement = 'lockerAgreement',
  LockerGroupPhotos = 'lockerGroupPhotos',
  MemberIdProof = 'memberIdProof',
  MemberMyfile = 'memberMyfile',
  MemberParQSignature = 'memberParQSignature',
  MemberPhoto = 'memberPhoto',
  MiniSiteBanner = 'miniSiteBanner',
  MyEventBannerPhotos = 'myEventBannerPhotos',
  MyEventPhotos = 'myEventPhotos',
  MyorderFiles = 'myorderFiles',
  MyorderImg = 'myorderImg',
  NewsPhotos = 'newsPhotos',
  NewsThumbnail = 'newsThumbnail',
  PrivateCoachBannerPhotos = 'privateCoachBannerPhotos',
  ProductCatPhotos = 'productCatPhotos',
  ProductCatThumbnail = 'productCatThumbnail',
  ProductPhotos = 'productPhotos',
  ProductPrivateFiles = 'productPrivateFiles',
  ProductPrivateImg = 'productPrivateImg',
  ProductThumbnail = 'productThumbnail',
  RecurCourseCoachPhoto = 'recurCourseCoachPhoto',
  RecurCoursePhotos = 'recurCoursePhotos',
  SportTypeBtnPhoto = 'sportTypeBtnPhoto',
  SportTypeFacilityBtnPhoto = 'sportTypeFacilityBtnPhoto',
  SportTypeFacilityPhotos = 'sportTypeFacilityPhotos',
  SportTypeGroupBtnPhoto = 'sportTypeGroupBtnPhoto',
  SportTypeGroupPhotos = 'sportTypeGroupPhotos',
  SportTypePhotos = 'sportTypePhotos',
  TimeSlotProgramGroupBtnPhoto = 'timeSlotProgramGroupBtnPhoto',
  WaAudio = 'waAudio',
  WaDocument = 'waDocument',
  WaImage = 'waImage',
  WaSticker = 'waSticker',
  WaTemplateMedia = 'waTemplateMedia',
  WaVideo = 'waVideo'
}

export type Myorder = {
  __typename?: 'Myorder';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  address3: Scalars['String']['output'];
  address4: Scalars['String']['output'];
  address5: Scalars['String']['output'];
  addressCountryId?: Maybe<Scalars['Int']['output']>;
  bonusPointAfter: Scalars['Int']['output'];
  bonusPointBefore: Scalars['Int']['output'];
  cartType: CartType;
  couponCode: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  creditAfter: Scalars['Float']['output'];
  creditBefore: Scalars['Float']['output'];
  creditType?: Maybe<CreditType>;
  creditTypeId?: Maybe<Scalars['Int']['output']>;
  cutoffDate?: Maybe<Scalars['String']['output']>;
  deptTransferDept?: Maybe<Department>;
  deptTransferDeptId?: Maybe<Scalars['Int']['output']>;
  districtId?: Maybe<Scalars['Int']['output']>;
  driveDepositMemberId?: Maybe<Scalars['Int']['output']>;
  fileList?: Maybe<Array<Myfile>>;
  freightCost: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  imgList?: Maybe<Array<Myfile>>;
  internalRemarks: Scalars['String']['output'];
  invoiceNo: Scalars['String']['output'];
  isAllVirtual?: Maybe<Scalars['Boolean']['output']>;
  isAutoRenewOrder: Scalars['Boolean']['output'];
  isCouponCodeValid: Scalars['Boolean']['output'];
  isPhoneBooking: Scalars['Boolean']['output'];
  isSelfPickup: Scalars['Boolean']['output'];
  isTest: Scalars['Boolean']['output'];
  itemList?: Maybe<Array<MyorderItem>>;
  lang: Scalars['String']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  memberLocationId?: Maybe<Scalars['Int']['output']>;
  memberRemarks: Scalars['String']['output'];
  myorderDate?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  payAmount: Scalars['Float']['output'];
  paymentConfirmByUser?: Maybe<User>;
  paymentConfirmDate?: Maybe<Scalars['String']['output']>;
  paymentConfirmedByUserId?: Maybe<Scalars['Int']['output']>;
  paymentMethod: Scalars['String']['output'];
  paymentStatus: MyorderAllStatus;
  reference1: Scalars['String']['output'];
  reference2: Scalars['String']['output'];
  reference3: Scalars['String']['output'];
  reference4: Scalars['String']['output'];
  refundPayoutRequestList?: Maybe<Array<RefundPayoutRequest>>;
  refundPayoutStatus: RefundPayoutRequestStatus;
  refundStatus: MyorderAllStatus;
  sessionId?: Maybe<Scalars['Int']['output']>;
  shipmentConfirmByUserId?: Maybe<Scalars['Int']['output']>;
  shipmentDate?: Maybe<Scalars['String']['output']>;
  shippingStatus: MyorderAllStatus;
  status: MyorderAllStatus;
  subDistrictId?: Maybe<Scalars['Int']['output']>;
  sumPosDiscount: Scalars['Float']['output'];
  sumSubtotalPrice: Scalars['Float']['output'];
  totalBonusPointEarned: Scalars['Int']['output'];
  totalBonusPointSpent: Scalars['Int']['output'];
  totalCreditRefunded: Scalars['Float']['output'];
  totalCreditSpent: Scalars['Float']['output'];
  totalDiscount: Scalars['Float']['output'];
  totalPaymentGatewayRefundedAmount: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  transactionUuid?: Maybe<Scalars['String']['output']>;
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  voidByUserId?: Maybe<Scalars['Int']['output']>;
  voidDate?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<Warehouse>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
};

export enum MyorderAllStatus {
  Cancelled = 'cancelled',
  Cart = 'cart',
  Na = 'na',
  PartialRefunded = 'partialRefunded',
  PartialShipped = 'partialShipped',
  PartialTransferred = 'partialTransferred',
  PaymentConfirmed = 'paymentConfirmed',
  PaymentOutstanding = 'paymentOutstanding',
  PaymentPending = 'paymentPending',
  Processing = 'processing',
  Refunded = 'refunded',
  Shipped = 'shipped',
  Transferred = 'transferred',
  Voided = 'voided'
}

export type MyorderItem = {
  __typename?: 'MyorderItem';
  accessPass?: Maybe<AccessPass>;
  accessPassId?: Maybe<Scalars['Int']['output']>;
  accessPassOption?: Maybe<AccessPassOption>;
  accessPassOptionId?: Maybe<Scalars['Int']['output']>;
  apcCatCode: Scalars['String']['output'];
  apcCatCodeCost: Scalars['String']['output'];
  apcCatCodeMaterialFee: Scalars['String']['output'];
  apcCost?: Maybe<AcctProductCat>;
  apcFee?: Maybe<AcctProductCat>;
  apcMaterialFee?: Maybe<AcctProductCat>;
  bbsReferral: Scalars['String']['output'];
  bonusPointEarned: Scalars['Int']['output'];
  bonusPointEarningRule?: Maybe<BonusPointEarningRule>;
  bonusPointEarningRuleId?: Maybe<Scalars['Int']['output']>;
  bonusPointRedeemPromotionGroup?: Maybe<BonusPointRedeemPromotionGroup>;
  bonusPointRedeemPromotionGroupId?: Maybe<Scalars['Int']['output']>;
  bonusPointSpent: Scalars['Int']['output'];
  bonusPointUsageCount?: Maybe<Scalars['Int']['output']>;
  coach?: Maybe<User>;
  coachFacilityBooking?: Maybe<FacilityBooking>;
  coachId?: Maybe<Scalars['Int']['output']>;
  coachService?: Maybe<CoachService>;
  coachServiceId?: Maybe<Scalars['Int']['output']>;
  couponCode: Scalars['String']['output'];
  couponPackage?: Maybe<CouponPackage>;
  couponPackageId?: Maybe<Scalars['Int']['output']>;
  couponPackageInstance?: Maybe<CouponPackageInstance>;
  couponPackageInstanceId?: Maybe<Scalars['Int']['output']>;
  couponPackageInstanceUsageHistory?: Maybe<CouponPackageInstanceUsageHistory>;
  couponPackageInstanceUsageHistoryId?: Maybe<Scalars['Int']['output']>;
  couponUsed: Scalars['Int']['output'];
  course?: Maybe<Course>;
  courseEnrolment?: Maybe<CourseEnrolment>;
  courseId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  creditPackage?: Maybe<CreditPackage>;
  creditPackageId?: Maybe<Scalars['Int']['output']>;
  deposit?: Maybe<DepositHistory>;
  depositAmount: Scalars['Float']['output'];
  depositHistory?: Maybe<DepositHistory>;
  depositHistoryId?: Maybe<Scalars['Int']['output']>;
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  driveMember?: Maybe<FullMember>;
  driveMemberId?: Maybe<Scalars['Int']['output']>;
  driveScoreHistory?: Maybe<DriveScoreHistory>;
  driveTeam?: Maybe<DriveTeam>;
  driveTeamId?: Maybe<Scalars['Int']['output']>;
  facilityBooking?: Maybe<FacilityBooking>;
  frontendRemovable: Scalars['Boolean']['output'];
  holdCleanDateTime?: Maybe<Scalars['String']['output']>;
  holdUntilDateTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRenew: Scalars['Boolean']['output'];
  itemStatus?: Maybe<MyorderAllStatus>;
  itemType: MyorderItemType;
  lastRefundedByUserId?: Maybe<Scalars['Int']['output']>;
  lastRefundedDate?: Maybe<Scalars['String']['output']>;
  lessonEnrolmentList?: Maybe<Array<LessonEnrolment>>;
  listPrice?: Maybe<Scalars['Float']['output']>;
  locker?: Maybe<Locker>;
  lockerGroupFee?: Maybe<LockerGroupFee>;
  lockerGroupFeeId?: Maybe<Scalars['Int']['output']>;
  lockerHistory?: Maybe<LockerHistory>;
  lockerHistoryId?: Maybe<Scalars['Int']['output']>;
  lockerId?: Maybe<Scalars['Int']['output']>;
  lostCardNo?: Maybe<Scalars['Int']['output']>;
  mainMyorderItemId?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<FullMember>;
  memberId?: Maybe<Scalars['Int']['output']>;
  membership?: Maybe<MembershipType>;
  membershipTypeId?: Maybe<Scalars['Int']['output']>;
  myEventEnrolmentList?: Maybe<Array<MyEventEnrolment>>;
  myorder?: Maybe<Myorder>;
  myorderId: Scalars['Int']['output'];
  noOfNonPeakHourTimeslot: Scalars['Int']['output'];
  noOfPeakHourTimeslot: Scalars['Int']['output'];
  offlineProductRedeemStatus?: Maybe<OfflineProductRedeemStatus>;
  oldLocker?: Maybe<Locker>;
  oldLockerId?: Maybe<Scalars['Int']['output']>;
  posDiscount: Scalars['Float']['output'];
  posRemovable: Scalars['Boolean']['output'];
  posSubtotalPrice: Scalars['Float']['output'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']['output']>;
  productQty: Scalars['Int']['output'];
  qrCodeB64List?: Maybe<Array<Scalars['String']['output']>>;
  redeemEndDate?: Maybe<Scalars['String']['output']>;
  refBonusPointDiscount: Scalars['Float']['output'];
  refCouponDiscount: Scalars['Float']['output'];
  refEndDate?: Maybe<Scalars['String']['output']>;
  refProductDiscount: Scalars['Float']['output'];
  refStartDate?: Maybe<Scalars['String']['output']>;
  referOrg?: Maybe<Organization>;
  referralOrgId?: Maybe<Scalars['Int']['output']>;
  referredByMember?: Maybe<Member>;
  referredByMemberId?: Maybe<Scalars['Int']['output']>;
  refundByOrderItemList?: Maybe<Array<MyorderItem>>;
  refundForMyorderItemId?: Maybe<Scalars['Int']['output']>;
  refundLessonEnrolmentList?: Maybe<Array<LessonEnrolment>>;
  refundMyorder?: Maybe<Myorder>;
  refundMyorderItem?: Maybe<MyorderItem>;
  refundedAmount: Scalars['Float']['output'];
  refundedQty: Scalars['Float']['output'];
  refundedShippedQty: Scalars['Int']['output'];
  refundedUnshippedQty: Scalars['Int']['output'];
  returnAsScraped: Scalars['Boolean']['output'];
  returnQty: Scalars['Int']['output'];
  shippedQty: Scalars['Int']['output'];
  shippingStatus: MyorderAllStatus;
  subtotalPrice: Scalars['Float']['output'];
  totalMaterialFee: Scalars['Float']['output'];
  totalProductCost: Scalars['Float']['output'];
  unitPrice?: Maybe<Scalars['Float']['output']>;
  unshippedQty: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  yldsaOldCourseRefund?: Maybe<YldsaOldCourseRefund>;
};

export enum MyorderItemType {
  AccessPass = 'accessPass',
  AdvanceBookingCharge = 'advanceBookingCharge',
  BookingCoupon = 'bookingCoupon',
  BperNthOrderExtraBp = 'bperNthOrderExtraBP',
  CoachCoupon = 'coachCoupon',
  CouponPackage = 'couponPackage',
  CourseEnrolment = 'courseEnrolment',
  CreditPackage = 'creditPackage',
  Deposit = 'deposit',
  EventEnrolment = 'eventEnrolment',
  FacilityBooking = 'facilityBooking',
  FacilityBookingLateCharge = 'facilityBookingLateCharge',
  ForfeitDeposit = 'forfeitDeposit',
  LessonEnrolmentList = 'lessonEnrolmentList',
  Locker = 'locker',
  LostCard = 'lostCard',
  MemDriveDeposit = 'memDriveDeposit',
  MemDriveDonation = 'memDriveDonation',
  Membership = 'membership',
  PrivateCoach = 'privateCoach',
  Product = 'product',
  ProductRefund = 'productRefund',
  ProductReturn = 'productReturn',
  Refund = 'refund',
  RefundAdminFee = 'refundAdminFee',
  RefundDeposit = 'refundDeposit',
  ReturnLocker = 'returnLocker',
  SpendCredit = 'spendCredit',
  SwpFee = 'swpFee',
  WithdrawCredit = 'withdrawCredit',
  YldsaCourseAdminFee = 'yldsaCourseAdminFee',
  YldsaOldCourseRefund = 'yldsaOldCourseRefund'
}

export type News = {
  __typename?: 'News';
  contentEn: Scalars['String']['output'];
  contentSc: Scalars['String']['output'];
  contentTc: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUserId?: Maybe<Scalars['Int']['output']>;
  photoList?: Maybe<Array<Myfile>>;
  publishDateTime: Scalars['String']['output'];
  thumbnailPhoto?: Maybe<Array<Myfile>>;
  titleEn: Scalars['String']['output'];
  titleSc: Scalars['String']['output'];
  titleTc: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type NotificationSub = {
  __typename?: 'NotificationSub';
  appPush: Scalars['Boolean']['output'];
  createdDate: Scalars['String']['output'];
  deptList?: Maybe<Array<Department>>;
  email: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  memberId?: Maybe<Scalars['Int']['output']>;
  topic: NotificationTopic;
  updatedDate: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
  webPush: Scalars['Boolean']['output'];
};

export enum NotificationTopic {
  FacilityBookingNewRequest = 'facilityBookingNewRequest',
  FacilityBookingRequestAccepted = 'facilityBookingRequestAccepted',
  FacilityBookingRequestRejected = 'facilityBookingRequestRejected',
  MyOrderNewConfirmationPaymentAutoRenew = 'myOrderNewConfirmationPaymentAutoRenew',
  MyOrderNewConfirmationPaymentOnline = 'myOrderNewConfirmationPaymentOnline',
  MyOrderNewConfirmationPaymentPos = 'myOrderNewConfirmationPaymentPos',
  WarehouseConfirmReceiveResult = 'warehouseConfirmReceiveResult',
  WarehouseDnConfirm = 'warehouseDnConfirm',
  WarehouseDnNew = 'warehouseDnNew',
  WarehouseDnUndoConfirm = 'warehouseDnUndoConfirm',
  WarehouseDnUpdate = 'warehouseDnUpdate',
  WarehouseGrnConfirm = 'warehouseGrnConfirm',
  WarehouseGrnNew = 'warehouseGrnNew',
  WarehouseGrnUndoConfirm = 'warehouseGrnUndoConfirm',
  WarehouseGrnUpdate = 'warehouseGrnUpdate',
  WarehouseReqClose = 'warehouseReqClose',
  WarehouseReqCompleted = 'warehouseReqCompleted',
  WarehouseReqUndoClose = 'warehouseReqUndoClose',
  WarehouseReqUpdate = 'warehouseReqUpdate',
  WarehouseRequireConfirmReceive = 'warehouseRequireConfirmReceive',
  WhatsappReceived = 'whatsappReceived'
}

export enum OfflineProductRedeemStatus {
  Expired = 'expired',
  Na = 'na',
  Used = 'used',
  Valid = 'valid',
  Voided = 'voided'
}

export type OneAvailableCoachServiceAndCoachListResGql = {
  __typename?: 'OneAvailableCoachServiceAndCoachListResGql';
  coachList: Array<FullUser>;
  coachService: CoachService;
};

export type OneCheckPaymentGatewayLogRes = {
  __typename?: 'OneCheckPaymentGatewayLogRes';
  myorderDate?: Maybe<Scalars['String']['output']>;
  myorderId?: Maybe<Scalars['Float']['output']>;
  orderStatus: Scalars['String']['output'];
  paymentConfirmDate?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  possibleLogIdList: Array<Scalars['Float']['output']>;
  possibleMyorderIdList: Array<Scalars['Float']['output']>;
  refString: Scalars['String']['output'];
};

export type OneMemberEnrolmentStatsSummaryResGql = {
  __typename?: 'OneMemberEnrolmentStatsSummaryResGql';
  member: Member;
  memberEnrolmentStatsList: Array<MemberEnrolmentStats>;
  memberEnrolmentStatsSummary: MemberEnrolmentStats;
};

export type OrgInvitationCode = {
  __typename?: 'OrgInvitationCode';
  id: Scalars['Int']['output'];
  invitationCode: Scalars['String']['output'];
  org?: Maybe<Organization>;
  orgId?: Maybe<Scalars['Int']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  address3: Scalars['String']['output'];
  address4: Scalars['String']['output'];
  code: Scalars['String']['output'];
  contactList?: Maybe<Array<Contact>>;
  createdDate: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  rgb?: Maybe<Scalars['String']['output']>;
  subDistrict?: Maybe<SubDistrict>;
  subDistrictId?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type PartialPassKey = {
  __typename?: 'PartialPassKey';
  createdDate: Scalars['String']['output'];
  friendlyName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export enum PermissionType {
  AdHocStockIn = 'adHocStockIn',
  AddFileToInventoryRequest = 'addFileToInventoryRequest',
  AddPhotoToInventoryRequest = 'addPhotoToInventoryRequest',
  AgreeToReceive = 'agreeToReceive',
  CloseInventoryRequest = 'closeInventoryRequest',
  ConfirmDeliveryNote = 'confirmDeliveryNote',
  ConfirmGoodsReceiveNote = 'confirmGoodsReceiveNote',
  ConvertToScraped = 'convertToScraped',
  CreateInterWarehouseInventoryTransfer = 'createInterWarehouseInventoryTransfer',
  CreateInterWarehouseInventoryTransferAtOnce = 'createInterWarehouseInventoryTransferAtOnce',
  CreateIntraWarehouseInventoryTransfer = 'createIntraWarehouseInventoryTransfer',
  CreateIntraWarehouseInventoryTransferAtOnce = 'createIntraWarehouseInventoryTransferAtOnce',
  CreatePurchaseOrder = 'createPurchaseOrder',
  CreatePureStockOut = 'createPureStockOut',
  InventoryStockTake = 'inventoryStockTake',
  MakeOrderShipment = 'makeOrderShipment',
  Order = 'order',
  Read = 'read',
  UndoCloseInventoryRequest = 'undoCloseInventoryRequest',
  UndoConfirmDeliveryNote = 'undoConfirmDeliveryNote',
  UndoConfirmGoodsReceiveNote = 'undoConfirmGoodsReceiveNote',
  UpdateInventoryRequestDetails = 'updateInventoryRequestDetails',
  Write = 'write',
  WriteOff = 'writeOff'
}

export enum PhoneBookingStatusEnum {
  Expired = 'expired',
  Never = 'never',
  Valid = 'valid'
}

export type PhoneBookingStatusResGql = {
  __typename?: 'PhoneBookingStatusResGql';
  expiredDate?: Maybe<Scalars['String']['output']>;
  status: PhoneBookingStatusEnum;
};

export type PosSearchCourseCustomInput = {
  ageGroupList?: Array<SearchCourseAgeGroup>;
  code?: InputMaybe<Scalars['String']['input']>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  courseTypeIdList?: Array<Scalars['Int']['input']>;
  dayOfWeekList?: Array<Scalars['Int']['input']>;
  deptIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  effectiveStartDateBegin?: InputMaybe<Scalars['String']['input']>;
  effectiveStartDateEnd?: InputMaybe<Scalars['String']['input']>;
  enableForWeb?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  enrolmentEndDateForMemberBegin?: InputMaybe<Scalars['String']['input']>;
  enrolmentEndDateForMemberEnd?: InputMaybe<Scalars['String']['input']>;
  enrolmentType?: InputMaybe<CourseEnrolmentType>;
  gender?: CourseSearchGender;
  genderList?: Array<FilterGender>;
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isTrial?: Scalars['Boolean']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  locationAreaIdList?: Array<Scalars['Int']['input']>;
  locationIdList?: Array<Scalars['Int']['input']>;
  maxAge?: InputMaybe<Scalars['Float']['input']>;
  minAge?: InputMaybe<Scalars['Float']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: SearchCourseCustomOrderBy;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
  sportTypeGroupIdList?: Array<Scalars['Int']['input']>;
  sportTypeIdList?: Array<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  timeGroupList?: Array<SearchCourseTimeGroup>;
  trialInvitationCode?: Scalars['String']['input'];
  withQuotaOnly?: InputMaybe<Scalars['Boolean']['input']>;
  withWaitingList?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PosSearchMyEventCustomInput = {
  ageGroupList?: Array<SearchMyEventAgeGroup>;
  code?: InputMaybe<Scalars['String']['input']>;
  dayOfWeekList?: Array<Scalars['Int']['input']>;
  deptIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  enableForWeb?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  gender?: MyEventSearchGender;
  genderList?: Array<FilterGender>;
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  maxAge?: InputMaybe<Scalars['Float']['input']>;
  minAge?: InputMaybe<Scalars['Float']['input']>;
  myEventName?: InputMaybe<Scalars['String']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: SearchMyEventCustomOrderBy;
  pageNo?: Scalars['Int']['input'];
  parentMyEventId?: InputMaybe<Scalars['Int']['input']>;
  showAllForAdmin?: Scalars['Boolean']['input'];
  sportTypeGroupIdList?: Array<Scalars['Int']['input']>;
  sportTypeIdList?: Array<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  timeGroupList?: Array<SearchMyEventTimeGroup>;
  withQuotaOnly: Scalars['Boolean']['input'];
};

export type ProcessGlobalPaymentRefundPayoutInput = {
  refundPayoutRequestId: Scalars['Int']['input'];
};

export type Product = {
  __typename?: 'Product';
  activeBonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  allowPosOversell: Scalars['Boolean']['output'];
  allowWebOversell: Scalars['Boolean']['output'];
  apcCatCodeForCost: Scalars['String']['output'];
  apcCatCodeForFee: Scalars['String']['output'];
  apcCost?: Maybe<AcctProductCat>;
  apcFee?: Maybe<AcctProductCat>;
  barcode: Scalars['String']['output'];
  bonusPointRedeemPromotionGroupList?: Maybe<Array<BonusPointRedeemPromotionGroup>>;
  cost: Scalars['Float']['output'];
  createdDate: Scalars['String']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isNonWebOutOfStock: Scalars['Boolean']['output'];
  isOpenItem: Scalars['Boolean']['output'];
  isVirtual: Scalars['Boolean']['output'];
  isWebOutOfStock: Scalars['Boolean']['output'];
  loyaltyPoint: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  nonWebStockLevel: Scalars['Int']['output'];
  orderLevelPercentageFeeOrDiscount: Scalars['Int']['output'];
  photoList?: Maybe<Array<Myfile>>;
  posDiscountAmt: Scalars['Float']['output'];
  posDiscountPercent: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  privateFileList?: Maybe<Array<Myfile>>;
  productCatList?: Maybe<Array<ProductCat>>;
  redeemEndDate?: Maybe<Scalars['String']['output']>;
  redeemEndDaysAfterPurchase: Scalars['Int']['output'];
  requireOfflineRedemption: Scalars['Boolean']['output'];
  revenueDept?: Maybe<Department>;
  revenueDeptId: Scalars['Int']['output'];
  showInWeb: Scalars['Boolean']['output'];
  sku: Scalars['String']['output'];
  supplier: Scalars['String']['output'];
  tagList?: Maybe<Array<ProductTag>>;
  thumbnailPhoto?: Maybe<Array<Myfile>>;
  updatedDate: Scalars['String']['output'];
  warehouseInventoryList?: Maybe<Array<WarehouseInventory>>;
  webDiscountAmt: Scalars['Float']['output'];
  webDiscountPercent: Scalars['Int']['output'];
  webStockLevel: Scalars['Int']['output'];
};

export type ProductCat = {
  __typename?: 'ProductCat';
  createdDate: Scalars['String']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  parentProductCatId?: Maybe<Scalars['Int']['output']>;
  productList?: Maybe<Array<Product>>;
  showInWeb: Scalars['Boolean']['output'];
  thumbnailPhoto?: Maybe<Array<Myfile>>;
  updatedDate: Scalars['String']['output'];
};

export type ProductOrderingInput = {
  orderId: Scalars['Float']['input'];
  productId: Scalars['Float']['input'];
};

export type ProductTag = {
  __typename?: 'ProductTag';
  id: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
};

export type PurgeBannerFromAppInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeGenericOriginalMyfileInput = {
  myfileId: Scalars['Int']['input'];
  myfileType?: InputMaybe<MyfileType>;
};

export type PurgeMyfileFromBonusPointRedeemPromotionGroupInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromCouponPackageInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromCourseInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromInventoryGroupInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromKwtdhcEventInput = {
  kwtdhcEventId: Scalars['Int']['input'];
  myfileId: Scalars['Int']['input'];
};

export type PurgeMyfileFromLockerGroupInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromMemberInput = {
  memberId: Scalars['Int']['input'];
  myfileId: Scalars['Int']['input'];
};

export type PurgeMyfileFromMyEventInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromNewsInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromProductCatInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromProductInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromRecurCourseInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromSportTypeGroupInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromSportTypeInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type PurgeMyfileFromTimeSlotProgramGroupInput = {
  myfileId: Scalars['Int']['input'];
  myfileType: MyfileType;
};

export type Query = {
  __typename?: 'Query';
  MeGetRefundPayoutRequestByToken: RefundPayoutRequest;
  adminGetOrderPaymentMethodSummary: GetOrderPaymentMethodSummaryResGql;
  adminSearchUserSession: AdminSearchUserSessionResGql;
  checkMemberIdentity: CheckMemberIdentityResGql;
  checkMgmReferralCode: CheckMgmReferralCodeResGql;
  checkPaymentGatewayLog?: Maybe<CheckPaymentGatewayLogResGql>;
  clientGetFacilityBookingSummary: Array<GetFacilityBookingSummaryResGql>;
  clientSearchFacilityBooking: SearchFacilityBookingResGql;
  coachGetAvailableTimeslotByCoachAndFacility: FacilityBookingDailyTimeSlotResGql;
  coachGetCoach: FullUser;
  coachGetCoachRelatedItemList: GetCoachRelatedItemListResGql;
  coachGetCoachTimeslotSummary: GetCoachTimeslotSummaryResGql;
  coachGetLessonCoachQrCode: GetLessonCoachQrCodeResGql;
  coachGetLessonEnrolmentList: GetLessonEnrolmentListResGql;
  coachGetMember: FullMember;
  coachGetPrivateCoachApplicableCouponPackageInstanceList: Array<ApplicableCouponPackageInstanceResGql>;
  coachGetPrivateLessonList: GetUserPrivateLessonListResGql;
  coachGetUserCourseList: GetUserCourseListResGql;
  coachGetUserLessonList: GetUserLessonListResGql;
  coachSearchCoachTimeslot: SearchCoachTimeslotResGql;
  coachSearchMyorder: SearchMyorderResGql;
  customSearchLocker: Array<Locker>;
  deptGetCoachSalaryReportList: Array<CoachSalaryReport>;
  exportBbsOrderRaw: Scalars['Void']['output'];
  getAccessPass: AccessPass;
  getAccessPassExpiryList: Array<AccessPassHistory>;
  getAccessPassFacilityAccessRelList: Array<AccessPassFacilityAccessRel>;
  getAccessPassPurchaseList: Array<AccessPassPurchaseResGql>;
  getAcctProductCat: AcctProductCat;
  getAllCoachSalaryReportList: Array<CoachSalaryReport>;
  getAllMemberRelationshipList: GetAllMemberRelationshipListResGql;
  getApcSummary: GetApcSummaryResGql;
  getAvailableCoachAndCoachServiceByFacility: Array<FullUser>;
  getAvailableEquipment: Array<EquipmentWithBookingCountResGql>;
  getAvailableFabTableList: Array<FabTable>;
  getAvailableVenue: Array<Facility>;
  getBannerList: Array<Myfile>;
  getBlackout: FacilityBlackout;
  getBonusPointEarningRule: BonusPointEarningRule;
  getBonusPointItemTypeEarningRatio: BonusPointItemTypeEarningRatio;
  getBonusPointMovementReport: GetBonusPointMovementReportResGql;
  getBonusPointRedeemPromotionGroup: BonusPointRedeemPromotionGroup;
  getBookingListForVenueDisplay: Array<FacilityBooking>;
  getCart: Myorder;
  getCheckInDevice: CheckInDevice;
  getCoach: FullUser;
  getCoachSalaryReport: CoachSalaryReport;
  getCoachService: CoachService;
  getCoachTimeslotSummary: GetCoachTimeslotSummaryResGql;
  getCommittee: Committee;
  getCommitteeHistory: CommitteeHistory;
  getCommitteePosition: CommitteePosition;
  getConfirmGrnUserList: Array<User>;
  getContact: Contact;
  getCouponPackage: CouponPackage;
  getCouponPackageUsageMovementReport: GetCouponPackageUsageMovementReportResGql;
  getCourse: Course;
  getCourseApplyQuotaPeriod: CourseApplyQuotaPeriod;
  getCourseAttendanceSheetData: GetCourseAttendanceSheetDataResGql;
  getCourseCoachList: Array<CourseCoach>;
  getCourseEnrolmentResult: Array<GetCourseEnrolmentResultResGql>;
  getCourseLotteryResult: Array<Array<CourseEnrolment>>;
  getCourseMemberList: Array<CourseMemberList>;
  getCourseType: CourseType;
  getCreditMovementReport: GetCreditMovementReportResGql;
  getCreditPackage: CreditPackage;
  getCreditType: CreditType;
  getDefaultFacilityFeeList: Array<FacilityFee>;
  getDeliveryNote: DeliveryNote;
  getDeliveryNoteTx: DeliveryNoteTx;
  getDepartment: Department;
  getDepositBalance: GetDepositBalanceResGql;
  getDocxTemplate: DocxTemplate;
  getDocxTemplateList: Array<DocxTemplate>;
  getDriveMemberAlias: Scalars['String']['output'];
  getDriveStats: GetDriveStatsResGql;
  getDriveTeam: DriveTeam;
  getEffectiveBookingInfo: Array<GetEffectiveBookingInfoResGql>;
  getEffectiveFacilityLeadTimeForMember: GetFacilityEffectiveLeadTimeForMemberResGql;
  getEffectiveFacilityNoOfTimeslotForMember: GetFacilityEffectiveNoOfTimeslotForMemberResGql;
  getFabFloorplan: FabFloorplan;
  getFabFloorplanGrid: GetFabFloorplanGridResGql;
  getFabFloorplanGridData: Array<FabReservationTableRel>;
  getFabFloorplanGridV2: GetFabFloorplanGridV2ResGql;
  getFabReservation: FabReservation;
  getFabReservationRealTimeStats: GetFabReservationRealTimeStatsResGql;
  getFabReservationStatsPerDay: Array<FabReservationStatsPerDayOneDayResGql>;
  getFabReservationStatsPerMonth: Array<FabReservationStatsPerMonthOneMonthResGql>;
  getFabTableWithReservationList: Array<FabTable>;
  getFacility: Facility;
  getFacilityAccessLogAccessPassOptionIdListToUpdate: Array<AccessPassOption>;
  getFacilityAccessPassDependencyList: Array<FacilityAccessPassDependency>;
  getFacilityBookingApplicableCouponPackageInstanceList: Array<GetFacilityBookingApplicableCouponPackageInstanceListResGql>;
  getFacilityBookingSummary: Array<GetFacilityBookingSummaryResGql>;
  getFacilityFeeList: Array<FacilityFee>;
  getFacilityStatsDaily: Array<GetFacilityStatsDailyResGql>;
  getFreightCostSetting: FreightCostSettingResGql;
  getGoodsReceiveNote: GoodsReceiveNote;
  getGoodsReceiveNoteTx: GoodsReceiveNoteTx;
  getGpLog: GetGpLogResGql;
  getHoliday: Holiday;
  getInfoByMyorderQrCode?: Maybe<Scalars['Void']['output']>;
  getInfoByQuickQrCode?: Maybe<CheckInItemResGql>;
  getInternalBooking: GetInternalBookingResGql;
  getInventoryRequest: InventoryRequest;
  getInventoryRequestTx: InventoryRequestTx;
  getInventoryTxCount: InventoryTxCount;
  getInventoryTxGroup: InventoryTxGroup;
  getItemListToCheckIn: GetCheckInItemListResGql;
  getJob?: Maybe<KwtdhcBatchImportMemberJob>;
  getKpayNotifyLog: GetKpayNotifyLogResGql;
  getKwtdhcEvent: KwtdhcEvent;
  getKwtdhcMemberFollowup: KwtdhcMemberFollowup;
  getLastMembershipOrder?: Maybe<Myorder>;
  getLatestDepositHistoryList: Array<DepositHistory>;
  getLatestMemberAccessPassHistoryList: Array<AccessPassHistory>;
  getLessonCoachQrCode: GetLessonCoachQrCodeResGql;
  getLessonList: Array<Lesson>;
  getLocation: Location;
  getLocationArea: LocationArea;
  getLocker: Locker;
  getLockerDeptList: Array<Department>;
  getLockerExpiryList: Array<LockerHistory>;
  getLockerGroup: LockerGroup;
  getLockerList: Array<Locker>;
  getLockerType: LockerType;
  getLostCardHistory: Array<MyorderItem>;
  getLotteryGroupScore: Scalars['Int']['output'];
  getMember: Member;
  getMemberAccessPassHistory: SearchAccessPassHistoryResGql;
  getMemberActivityList: GetMemberActivityListResGql;
  getMemberCourseEnrolmentHistory: SearchCourseEnrolmentResGql;
  getMemberDepositHistory: SearchDepositHistoryResGql;
  getMemberDriveDepositHistory: SearchDriveDepositHistoryResGql;
  getMemberDriveScoreHistory: SearchDriveScoreHistoryResGql;
  getMemberDriveTeamList: Array<DriveTeam>;
  getMemberFacilityBookingHistory: SearchFacilityBookingResGql;
  getMemberFullInfo: FullMember;
  getMemberGpTokenList: Array<GpToken>;
  getMemberIdByMembershipNo: GetMemberIdByMembershipNoResGql;
  getMemberLessonEnrolmentHistory: SearchLessonEnrolmentResGql;
  getMemberList: MemberList;
  getMemberListAsCourseMemberList: Array<MemberListAsCourseMemberList>;
  getMemberListAsRecurCourseMemberList: Array<MemberListAsRecurCourseMemberList>;
  getMemberMembershipHistory: SearchMembershipHistoryResGql;
  getMemberMovement: GetMemberMovementResGql;
  getMemberMovementYear: GetMemberMovementYearResGql;
  getMemberMyorderHistory: SearchMyorderResGql;
  getMemberPhoneBookingStatus: PhoneBookingStatusResGql;
  getMemberProductRedeemOrder: SearchMyorderResGql;
  getMemberValidity: GetMemberValidityResGql;
  getMembershipHistory: GetMembershipHistoryResGql;
  getMembershipType: MembershipType;
  getMiniSiteContent: MiniSiteContent;
  getMsgQueue: MsgQueue;
  getMsgQueueByHash: MsgQueue;
  getMyEvent: MyEvent;
  getMyfileInfo: GetMyfileResGql;
  getMyorder: Myorder;
  getNews: News;
  getOrderPaymentMethodSummaryPerDay: GetOrderPaymentMethodSummaryPerDayResGql;
  getOrganization: Organization;
  getOrganizationTypeList: Array<Scalars['String']['output']>;
  getPeriodGroupNameList: Array<Scalars['String']['output']>;
  getPosCartFacilityTree: GetPosFacilityTreeResGql;
  getPrivateCoachApplicableCouponPackageInstanceList: Array<ApplicableCouponPackageInstanceResGql>;
  getProduct: Product;
  getProductCat: ProductCat;
  getProductInventoryLevelPerPartitionByDept: Array<WarehouseInventory>;
  getPublicMyfileInfo: GetMyfileResGql;
  getQrCodeForEnrolment: GetQuickQrCodeResGql;
  getQrCodeForReceipt: GetMyorderItemQrCodeResGql;
  getQrCodeForTimeSlotProgramReservation: GetQuickQrCodeResGql;
  getReceiptBookingQrCode: GetBookingQrCodeResGql;
  getRecurCourse: RecurCourse;
  getRefundPayoutRequest: RefundPayoutRequest;
  getRoleTemplate: RoleTemplate;
  getSalesReportItemTypePerDay: GetSalesReportItemTypePerDayResGql;
  getSalesReportItemTypePerDeptPerDay: GetSalesReportItemTypePerDeptPerDayResGql;
  getSalesReportItemTypePerDeptPerMonth: GetSalesReportItemTypePerDeptPerMonthResGql;
  getSalesReportItemTypePerMonth: GetSalesReportItemTypePerMonthResGql;
  getSalesReportPaymentMethodPerDay: GetSalesReportPaymentMethodPerDayResGql;
  getSalesReportPaymentMethodPerMonth: GetSalesReportPaymentMethodPerMonthResGql;
  getSelectionJson: GetSelectionJsonResGql;
  getSetting?: Maybe<AdminSetting>;
  getShippingReceipt: Scalars['Void']['output'];
  getSportType: SportType;
  getSportTypeGroup: SportTypeGroup;
  getSportTypeGroupListWithActiveCourseList: Array<SportTypeGroup>;
  getSportTypeListForAvailableCoachService: Array<SportType>;
  getSportTypeListWithActiveCourseList: Array<SportType>;
  getSwpFee: SwpFee;
  getSwpFeeList: Array<SwpFee>;
  getSwpSession: SwpSession;
  getSwpSessionList: Array<SwpSession>;
  getTennisOpenQuotaLeft: Array<Scalars['Int']['output']>;
  getTextTemplate: TextTemplate;
  getTextTemplateList: Array<TextTemplate>;
  getTimeSlotProgram: TimeSlotProgram;
  getTimeSlotProgramFullDayInfo: GetTimeSlotProgramFullDayResGql;
  getTimeSlotProgramGroup: TimeSlotProgramGroup;
  getTimeSlotProgramStats: GetTimeSlotProgramStatsResGql;
  getTimeSlotProgramSummary: GetTimeSlotProgramSummaryResGql;
  getTncSetting: TncSettingResGql;
  getTotpSecret: GetTotpSecretResGql;
  getUpgradableMembershipTypeList: Array<MembershipTypeWithExpiryDateResGql>;
  getUser: FullUser;
  getUserDeptListPerDomain: Array<UserDeptListResGql>;
  getUserDeptListPerPermissionType: Array<UserDeptListResGql>;
  getUserProductGroup: UserProductGroup;
  getUserWarehouseList: Array<Warehouse>;
  getUsername: GetUsernameResGql;
  getWarehouse: Warehouse;
  getWarehousePartition: WarehousePartition;
  getWarehouseStockTake: WarehouseStockTake;
  getWarehouseStockTakeDelta: Array<WarehouseStockTakeDeltaResGql>;
  getWebFacilitySportTypeList: Array<SportType>;
  getWebFacilityTreeByFacilityGroup: GetWebFacilityTreeByFacilityGroupResGql;
  guestGetAvailableCoachServiceAndCoach: GetAvailableCoachServiceAndCoachResGql;
  guestGetAvailableTimeslotByCoachAndFacility: FacilityBookingDailyTimeSlotResGql;
  guestGetCoachTimeslotSummary: GetCoachTimeslotSummaryResGql;
  guestGetMyEvent: MyEvent;
  guestGetUpgradableMembershipTypeList: Array<MembershipTypeWithExpiryDateResGql>;
  kwtdhcBatchImportMemberSearchBullQueue: KwtdhcBatchImportMemberSearchBullQueueResGql;
  manualCheckInAuth: ManualCheckInAuthResGql;
  meGetAccessPassPurchaseList: Array<AccessPassPurchaseResGql>;
  meGetAllMemberRelationshipList: GetAllMemberRelationshipListResGql;
  meGetBookmarkList: GetBookmarkListResGql;
  meGetCart: Myorder;
  meGetEffectiveBookingInfo: Array<GetEffectiveBookingInfoResGql>;
  meGetEffectiveFacilityLeadTimeForMember: GetFacilityEffectiveLeadTimeForMemberResGql;
  meGetEffectiveFacilityNoOfTimeslotForMember: GetFacilityEffectiveNoOfTimeslotForMemberResGql;
  meGetFacilityBookingApplicableCouponPackageInstanceList: Array<GetFacilityBookingApplicableCouponPackageInstanceListResGql>;
  meGetLatestDepositHistoryList: Array<DepositHistory>;
  meGetLatestMemberAccessPassHistoryList: Array<AccessPassHistory>;
  meGetLockerDeptList: Array<Department>;
  meGetLockerList: Array<Locker>;
  meGetMember: FullMember;
  meGetMemberAccessPassHistory: SearchAccessPassHistoryResGql;
  meGetMemberActivityList: GetMemberActivityListResGql;
  meGetMemberCourseEnrolmentHistory: SearchCourseEnrolmentResGql;
  meGetMemberDepositHistory: SearchDepositHistoryResGql;
  meGetMemberDriveDepositHistory: SearchDriveDepositHistoryResGql;
  meGetMemberDriveScoreHistory: SearchDriveScoreHistoryResGql;
  meGetMemberDriveTeamList: Array<DriveTeam>;
  meGetMemberFacilityBookingHistory: SearchFacilityBookingResGql;
  meGetMemberLessonEnrolmentHistory: SearchLessonEnrolmentResGql;
  meGetMemberMembershipHistory: SearchMembershipHistoryResGql;
  meGetMemberMyorderHistory: SearchMyorderResGql;
  meGetMemberPhoneBookingStatus: PhoneBookingStatusResGql;
  meGetMemberProductRedeemOrder: SearchMyorderResGql;
  meGetMsgQueue: MsgQueue;
  meGetMyorder: Myorder;
  meGetNoticationSubList: Array<NotificationSub>;
  meGetOwnSessionList: Array<MySession>;
  meGetPrivateCoachApplicableCouponPackageInstanceList: Array<ApplicableCouponPackageInstanceResGql>;
  meGetQrCode: GetMyorderItemQrCodeResGql;
  meGetQrCodeForEnrolment: GetQuickQrCodeResGql;
  meGetQrCodeForTimeSlotProgramReservation: GetQuickQrCodeResGql;
  meGetSelectionJson: GetSelectionJsonResGql;
  meGetTimeSlotProgramFullDayInfo: GetTimeSlotProgramFullDayResGql;
  meGetTotpSecret: GetTotpSecretResGql;
  meGetUnreadInboxCount: Scalars['Int']['output'];
  meGetUpgradableMembershipTypeList: Array<MembershipTypeWithExpiryDateResGql>;
  meSearchBonusPointReceiptReg: SearchBonusPointReceiptRegResGql;
  meSearchBonusPointRedeemPromotionGroup: SearchBonusPointRedeemPromotionGroupResGql;
  meSearchBonusPointTx: SearchBonusPointTxResGql;
  meSearchCoachService: SearchCoachServiceResGql;
  meSearchCouponPackage: SearchCouponPackageResGql;
  meSearchCouponPackageInstance: SearchCouponPackageInstanceResGql;
  meSearchCouponPackageInstanceUsageHistory: SearchCouponPackageInstanceUsageHistoryResGql;
  meSearchCourseEnrolment: SearchCourseEnrolmentResGql;
  meSearchCreditPackage: SearchCreditPackageResGql;
  meSearchCreditTx: SearchCreditTxResGql;
  meSearchInbox: SearchMsgQueueResGql;
  meSearchLockerGroup: SearchLockerGroupResGql;
  meSearchLockerHistory: SearchLockerHistoryResGql;
  meSearchMemberHdtBg: SearchMemberHdtBgResGql;
  meSearchMemberHdtBpHr: SearchMemberHdtBpHrResGql;
  meSearchMemberHdtBt: SearchMemberHdtBtResGql;
  meSearchMemberHdtBwBhBmi: SearchMemberHdtBwBhBmiResGql;
  meSearchMemberHdtSpo2Hr: SearchMemberHdtSpo2HrResGql;
  meSearchProduct: SearchProductResGql;
  meSearchProductCat: SearchProductCatResGql;
  meSearchTimeSlotProgram: SearchTimeSlotProgramResGql;
  meSearchTimeSlotProgramGroup: SearchTimeSlotProgramGroupResGql;
  meSearchTimeSlotProgramReservation: SearchTimeSlotProgramReservationResGql;
  memberGetMyfileInfo: GetMyfileResGql;
  mgmReferralCodeCheck: MgmReferralCodeCheckResGql;
  posSearchCourseCustom: SearchCourseResGql;
  posSearchMyEventCustom: SearchMyEventResGql;
  processBirthdayBonusPoint?: Maybe<Scalars['Void']['output']>;
  scaaGetMemCommissionReport: Array<ScaaGetMemCommissionReportResGql>;
  searchAccessPass: SearchAccessPassResGql;
  searchAccessPassHistory: SearchAccessPassHistoryResGql;
  searchAcctProductCat: SearchAcctProductCatResGql;
  searchAuditLog: SearchAuditLogResGql;
  searchBlackout: SearchBlackoutResGql;
  searchBonusPointEarningRule: SearchBonusPointEarningRuleResGql;
  searchBonusPointItemTypeEarningRatio: SearchBonusPointItemTypeEarningRatioResGql;
  searchBonusPointReceiptReg: SearchBonusPointReceiptRegResGql;
  searchBonusPointRedeemPromotionGroup: SearchBonusPointRedeemPromotionGroupResGql;
  searchBonusPointTx: SearchBonusPointTxResGql;
  searchCheckInDevice: SearchCheckInDeviceResGql;
  searchCoach: SearchUserResGql;
  searchCoachService: SearchCoachServiceResGql;
  searchCoachTimeslot: SearchCoachTimeslotResGql;
  searchCommittee: SearchCommitteeResGql;
  searchCommitteeHistory: SearchCommitteeHistoryResGql;
  searchCommitteePosition: SearchCommitteePositionResGql;
  searchContact: SearchContactResGql;
  searchCouponPackage: SearchCouponPackageResGql;
  searchCouponPackageInstance: SearchCouponPackageInstanceResGql;
  searchCouponPackageInstanceUsageHistory: SearchCouponPackageInstanceUsageHistoryResGql;
  searchCourse: SearchCourseResGql;
  searchCourseApplyQuotaPeriod: SearchCourseApplyQuotaPeriodResGql;
  searchCourseCustom: SearchCourseResGql;
  searchCourseEnrolment: SearchCourseEnrolmentResGql;
  searchCourseType: SearchCourseTypeResGql;
  searchCreditPackage: SearchCreditPackageResGql;
  searchCreditTx: SearchCreditTxResGql;
  searchCreditType: SearchCreditTypeResGql;
  searchDeliveryNote: SearchDeliveryNoteResGql;
  searchDepartment: SearchDepartmentResGql;
  searchDeposit: SearchDepositHistoryResGql;
  searchDocxTemplate: SearchDocxTemplateResGql;
  searchDriveDepositHistory: SearchDriveDepositHistoryResGql;
  searchDriveScoreHistory: SearchDriveScoreHistoryResGql;
  searchDriveTeam: SearchDriveTeamResGql;
  searchFabFloorplan: SearchFabFloorplanResGql;
  searchFabReservation: SearchFabReservationResGql;
  searchFacility: SearchFacilityResGql;
  searchFacilityAccessLog: SearchFacilityAccessLogResGql;
  searchFacilityBooking: SearchFacilityBookingResGql;
  searchGoodsReceiveNote: SearchGoodsReceiveNoteResGql;
  searchGpToken: SearchGpTokenResGql;
  searchHoliday: SearchHolidayResGql;
  searchInventoryRequestTx: SearchInventoryRequestTxResGql;
  searchInventoryTxCount: SearchInventoryTxCountResGql;
  searchInventoryTxGroup: SearchInventoryTxGroupResGql;
  searchKwtdhcEvent: SearchKwtdhcEventResGql;
  searchKwtdhcMemberFollowup: SearchKwtdhcMemberFollowupResGql;
  searchLesson: SearchLessonResGql;
  searchLessonCoach: SearchLessonCoachResGql;
  searchLessonEnrolment: SearchLessonEnrolmentResGql;
  searchLocation: SearchLocationResGql;
  searchLocationArea: SearchLocationAreaResGql;
  searchLockerGroup: SearchLockerGroupResGql;
  searchLockerHistory: SearchLockerHistoryResGql;
  searchLockerType: SearchLockerTypeResGql;
  searchMachine: SearchUserResGql;
  searchMember: SearchMemberResGql;
  searchMemberFacial: SearchMemberFacialResGql;
  searchMemberHdtBg: SearchMemberHdtBgResGql;
  searchMemberHdtBpHr: SearchMemberHdtBpHrResGql;
  searchMemberHdtBt: SearchMemberHdtBtResGql;
  searchMemberHdtBwBhBmi: SearchMemberHdtBwBhBmiResGql;
  searchMemberHdtSpo2Hr: SearchMemberHdtSpo2HrResGql;
  searchMemberList: SearchMemberListResGql;
  searchMemberLotteryGroupScoreOverride: SearchMemberLotteryGroupScoreOverrideResGql;
  searchMemberParQ: SearchMemberParQResGql;
  searchMembershipHistory: SearchMembershipHistoryResGql;
  searchMembershipType: SearchMembershipTypeResGql;
  searchMiniSiteContent: SearchMiniSiteContentResGql;
  searchMsgQueue: SearchMsgQueueResGql;
  searchMyEvent: SearchMyEventResGql;
  searchMyEventCustom: SearchMyEventResGql;
  searchMyorder: SearchMyorderResGql;
  searchMyorderItem: SearchMyorderItemResGql;
  searchNews: SearchNewsResGql;
  searchOrganization: SearchOrganizationResGql;
  searchProduct: SearchProductResGql;
  searchProductCat: SearchProductCatResGql;
  searchRecurCourse: SearchRecurCourseResGql;
  searchRefundPayoutRequest: SearchRefundPayoutRequestResGql;
  searchRoleTemplate: SearchRoleTemplateResGql;
  searchSportType: SearchSportTypeResGql;
  searchSportTypeGroup: SearchSportTypeGroupResGql;
  searchSwpAccessLog: SearchSwpAccessLogResGql;
  searchSwpTestCardQrCode: SearchDynamicQrCodeResGql;
  searchTextTemplate: SearchTextTemplateResGql;
  searchTimeSlotProgram: SearchTimeSlotProgramResGql;
  searchTimeSlotProgramGroup: SearchTimeSlotProgramGroupResGql;
  searchTimeSlotProgramReservation: SearchTimeSlotProgramReservationResGql;
  searchUser: SearchUserResGql;
  searchUserProductGroup: SearchUserProductGroupResGql;
  searchWarehouse: SearchWarehouseResGql;
  searchWarehouseBorrowSummary: SearchDeptBorrowSummaryResGql;
  searchWarehouseInventory: SearchWarehouseInventoryResGql;
  searchWarehousePartition: SearchWarehousePartitionResGql;
  searchWarehouseStockTake: SearchWarehouseStockTakeResGql;
  searchWhatsappMsgQueue: SearchMsgQueueResGql;
  searchWhatsappSummary: SearchWhatsappSummaryResGql;
  searchWhatsappTemplate: SearchWhatsappTemplateResGql;
  userGetMemberMsgQueue: MsgQueue;
  userGetMemberParQ: MemberParQ;
  userGetMsgQueue: MsgQueue;
  userGetNoticationSubList: Array<NotificationSub>;
  userGetOrderPaymentMethodSummary: GetOrderPaymentMethodSummaryResGql;
  userGetOwnSessionList: Array<MySession>;
  userGetPendingInternalBookingRequestCount: Scalars['Int']['output'];
  userGetUnreadInboxCount: Scalars['Int']['output'];
  userGetUser: FullUser;
  userGetUserDeptListPerDomain: Array<UserDeptListResGql>;
  userGetUserDeptListPerPermissionType: Array<UserDeptListResGql>;
  userGetUserManagedFacilityList: Array<Facility>;
  userGetUserWarehouseList: Array<Warehouse>;
  userGetWarehousePartitionListByPermission: Array<WarehousePartition>;
  userSearchInbox: SearchMsgQueueResGql;
  userSearchMemberMsgQueue: SearchMsgQueueResGql;
  userSearchMemberSession: UserSearchMemberSessionResGql;
  userSearchMsgQueue: SearchMsgQueueResGql;
  userSearchRefundPayoutRequest: SearchRefundPayoutRequestResGql;
  userSearchUser: SearchPartialUserResGql;
};


export type QueryMeGetRefundPayoutRequestByTokenArgs = {
  input: ValidateRefundPayoutAccessTokenInput;
};


export type QueryAdminGetOrderPaymentMethodSummaryArgs = {
  input: GetOrderPaymentMethodSummaryInput;
};


export type QueryAdminSearchUserSessionArgs = {
  input: AdminSearchUserSessionInput;
};


export type QueryCheckMemberIdentityArgs = {
  input: CheckMemberIdentityInput;
};


export type QueryCheckMgmReferralCodeArgs = {
  input: CheckMgmReferralCodeInput;
};


export type QueryCheckPaymentGatewayLogArgs = {
  input: CheckPaymentGatewayLogInput;
};


export type QueryClientGetFacilityBookingSummaryArgs = {
  input: GetFacilityBookingSummaryInput;
};


export type QueryClientSearchFacilityBookingArgs = {
  input: ClientSearchFacilityBookingInput;
};


export type QueryCoachGetAvailableTimeslotByCoachAndFacilityArgs = {
  input: CoachGetAvailableTimeslotByCoachAndFacilityInput;
};


export type QueryCoachGetCoachRelatedItemListArgs = {
  input: CoachGetCoachRelatedItemListInput;
};


export type QueryCoachGetCoachTimeslotSummaryArgs = {
  input: CoachGetCoachTimeslotSummaryInput;
};


export type QueryCoachGetLessonCoachQrCodeArgs = {
  input: CoachGetLessonCoachQrCodeInput;
};


export type QueryCoachGetLessonEnrolmentListArgs = {
  input: GetLessonEnrolmentListInput;
};


export type QueryCoachGetMemberArgs = {
  input: CoachGetMemberInput;
};


export type QueryCoachGetPrivateCoachApplicableCouponPackageInstanceListArgs = {
  input: GetPrivateCoachApplicableCouponPackageInstanceListInput;
};


export type QueryCoachGetPrivateLessonListArgs = {
  input: GetUserPrivateLessonListInput;
};


export type QueryCoachGetUserCourseListArgs = {
  input: CoachGetUserCourseListInput;
};


export type QueryCoachGetUserLessonListArgs = {
  input: CoachGetUserLessonListInput;
};


export type QueryCoachSearchCoachTimeslotArgs = {
  input: CoachSearchCoachTimeslotInput;
};


export type QueryCoachSearchMyorderArgs = {
  input: SearchMyorderInput;
};


export type QueryCustomSearchLockerArgs = {
  input: CustomSearchLockerInput;
};


export type QueryDeptGetCoachSalaryReportListArgs = {
  input: DeptGetCoachSalaryReportListInput;
};


export type QueryGetAccessPassArgs = {
  input: GetAccessPassInput;
};


export type QueryGetAccessPassExpiryListArgs = {
  input: GetAccessPassExpiryListInput;
};


export type QueryGetAccessPassFacilityAccessRelListArgs = {
  input: GetAccessPassFacilityAccessRelListInput;
};


export type QueryGetAccessPassPurchaseListArgs = {
  input: GetAccessPassPurchaseListInput;
};


export type QueryGetAcctProductCatArgs = {
  input: GetAcctProductCatInput;
};


export type QueryGetAllCoachSalaryReportListArgs = {
  input: GetAllCoachSalaryReportListInput;
};


export type QueryGetAllMemberRelationshipListArgs = {
  input: GetAllMemberRelationshipListInput;
};


export type QueryGetApcSummaryArgs = {
  input: GetApcSummaryInput;
};


export type QueryGetAvailableCoachAndCoachServiceByFacilityArgs = {
  input: GetAvailableCoachAndCoachServiceByFacilityForPosOrderInput;
};


export type QueryGetAvailableEquipmentArgs = {
  input: GetAvailableEquipmentInput;
};


export type QueryGetAvailableFabTableListArgs = {
  input: GetAvailableFabTableListInput;
};


export type QueryGetAvailableVenueArgs = {
  input: GetAvailableVenueInput;
};


export type QueryGetBannerListArgs = {
  input: GetBannerListInput;
};


export type QueryGetBlackoutArgs = {
  input: GetBlackoutInput;
};


export type QueryGetBonusPointEarningRuleArgs = {
  input: GetBonusPointEarningRuleInput;
};


export type QueryGetBonusPointItemTypeEarningRatioArgs = {
  input: GetBonusPointItemTypeEarningRatioInput;
};


export type QueryGetBonusPointMovementReportArgs = {
  input: GetBonusPointMovementReportInput;
};


export type QueryGetBonusPointRedeemPromotionGroupArgs = {
  input: GetBonusPointRedeemPromotionGroupInput;
};


export type QueryGetBookingListForVenueDisplayArgs = {
  input: GetBookingListForVenueDisplayInput;
};


export type QueryGetCartArgs = {
  input: GetCartInput;
};


export type QueryGetCheckInDeviceArgs = {
  input: GetCheckInDeviceInput;
};


export type QueryGetCoachArgs = {
  input: GetUserInput;
};


export type QueryGetCoachSalaryReportArgs = {
  input: GetCoachSalaryReportInput;
};


export type QueryGetCoachServiceArgs = {
  input: GetCoachServiceInput;
};


export type QueryGetCoachTimeslotSummaryArgs = {
  input: GetCoachTimeslotSummaryInput;
};


export type QueryGetCommitteeArgs = {
  input: GetCommitteeInput;
};


export type QueryGetCommitteeHistoryArgs = {
  input: GetCommitteeHistoryInput;
};


export type QueryGetCommitteePositionArgs = {
  input: GetCommitteePositionInput;
};


export type QueryGetConfirmGrnUserListArgs = {
  input: GetConfirmGrnUserListInput;
};


export type QueryGetContactArgs = {
  input: GetContactInput;
};


export type QueryGetCouponPackageArgs = {
  input: GetCouponPackageInput;
};


export type QueryGetCouponPackageUsageMovementReportArgs = {
  input: GetCouponPackageUsageMovementReportInput;
};


export type QueryGetCourseArgs = {
  input: GetCourseInput;
};


export type QueryGetCourseApplyQuotaPeriodArgs = {
  input: GetCourseApplyQuotaPeriodInput;
};


export type QueryGetCourseAttendanceSheetDataArgs = {
  input: GetCourseAttendanceSheetDataInput;
};


export type QueryGetCourseCoachListArgs = {
  input: GetCourseCoachListInput;
};


export type QueryGetCourseLotteryResultArgs = {
  input: GetCourseLotteryResultInput;
};


export type QueryGetCourseMemberListArgs = {
  input: GetCourseMemberListInput;
};


export type QueryGetCourseTypeArgs = {
  input: GetCourseTypeInput;
};


export type QueryGetCreditMovementReportArgs = {
  input: GetCreditMovementReportInput;
};


export type QueryGetCreditPackageArgs = {
  input: GetCreditPackageInput;
};


export type QueryGetCreditTypeArgs = {
  input: GetCreditTypeInput;
};


export type QueryGetDeliveryNoteArgs = {
  input: GetDeliveryNoteInput;
};


export type QueryGetDeliveryNoteTxArgs = {
  input: GetDeliveryNoteTxInput;
};


export type QueryGetDepartmentArgs = {
  input: GetDepartmentInput;
};


export type QueryGetDepositBalanceArgs = {
  input: GetDepositBalanceInput;
};


export type QueryGetDocxTemplateArgs = {
  input: GetDocxTemplateInput;
};


export type QueryGetDocxTemplateListArgs = {
  input: GetDocxTemplateListInput;
};


export type QueryGetDriveMemberAliasArgs = {
  input: GetDriveMemberAliasInput;
};


export type QueryGetDriveStatsArgs = {
  input: GetDriveStatsInput;
};


export type QueryGetDriveTeamArgs = {
  input: GetDriveTeamInput;
};


export type QueryGetEffectiveBookingInfoArgs = {
  input: GetEffectiveBookingInfoInput;
};


export type QueryGetEffectiveFacilityLeadTimeForMemberArgs = {
  input: GetFacilityEffectiveLeadTimeForMemberInput;
};


export type QueryGetEffectiveFacilityNoOfTimeslotForMemberArgs = {
  input: GetFacilityEffectiveNoOfTimeslotForMemberInput;
};


export type QueryGetFabFloorplanArgs = {
  input: GetFabFloorplanInput;
};


export type QueryGetFabFloorplanGridArgs = {
  input: GetFabFloorplanGridInput;
};


export type QueryGetFabFloorplanGridDataArgs = {
  input: GetFabFloorplanGridInput;
};


export type QueryGetFabFloorplanGridV2Args = {
  input: GetFabFloorplanGridInput;
};


export type QueryGetFabReservationArgs = {
  input: GetFabReservationInput;
};


export type QueryGetFabReservationRealTimeStatsArgs = {
  input: GetFabReservationRealTimeStatsInput;
};


export type QueryGetFabReservationStatsPerDayArgs = {
  input: GetFabReservationStatsPerDayInput;
};


export type QueryGetFabReservationStatsPerMonthArgs = {
  input: GetFabReservationStatsPerMonthInput;
};


export type QueryGetFabTableWithReservationListArgs = {
  input: GetFabTableWithReservationListInput;
};


export type QueryGetFacilityArgs = {
  input: GetFacilityInput;
};


export type QueryGetFacilityAccessLogAccessPassOptionIdListToUpdateArgs = {
  input: GetFacilityAccessLogAccessPassOptionIdListToUpdateInput;
};


export type QueryGetFacilityAccessPassDependencyListArgs = {
  input: GetFacilityAccessPassDependencyListInput;
};


export type QueryGetFacilityBookingApplicableCouponPackageInstanceListArgs = {
  input: GetFacilityBookingApplicableCouponPackageInstanceListInput;
};


export type QueryGetFacilityBookingSummaryArgs = {
  input: GetFacilityBookingSummaryInput;
};


export type QueryGetFacilityFeeListArgs = {
  input: GetFacilityFeeListInput;
};


export type QueryGetFacilityStatsDailyArgs = {
  input: GetFacilityStatsDailyInput;
};


export type QueryGetGoodsReceiveNoteArgs = {
  input: GetGoodsReceiveNoteInput;
};


export type QueryGetGoodsReceiveNoteTxArgs = {
  input: GetGoodsReceiveNoteTxInput;
};


export type QueryGetGpLogArgs = {
  input: GetGpLogInput;
};


export type QueryGetHolidayArgs = {
  input: GetHolidayInput;
};


export type QueryGetInfoByMyorderQrCodeArgs = {
  input: CheckInByMyorderQrCodeInput;
};


export type QueryGetInfoByQuickQrCodeArgs = {
  input: GetInfoByQuickQrCodeInput;
};


export type QueryGetInternalBookingArgs = {
  input: GetInternalBookingInput;
};


export type QueryGetInventoryRequestArgs = {
  input: GetInventoryRequestInput;
};


export type QueryGetInventoryRequestTxArgs = {
  input: GetInventoryRequestTxInput;
};


export type QueryGetInventoryTxCountArgs = {
  input: GetInventoryTxCountInput;
};


export type QueryGetInventoryTxGroupArgs = {
  input: GetInventoryTxGroupInput;
};


export type QueryGetJobArgs = {
  input: GetBullQueueJobGqlInput;
};


export type QueryGetKpayNotifyLogArgs = {
  input: GetKpayNotifyLogInput;
};


export type QueryGetKwtdhcEventArgs = {
  input: GetKwtdhcEventInput;
};


export type QueryGetKwtdhcMemberFollowupArgs = {
  input: GetKwtdhcMemberFollowupInput;
};


export type QueryGetLastMembershipOrderArgs = {
  input: GetLastMembershipOrderInput;
};


export type QueryGetLatestDepositHistoryListArgs = {
  input: GetLatestMemberDepositHistoryListInput;
};


export type QueryGetLatestMemberAccessPassHistoryListArgs = {
  input: GetLatestMemberAccessPassHistoryListInput;
};


export type QueryGetLessonCoachQrCodeArgs = {
  input: GetLessonCoachQrCodeInput;
};


export type QueryGetLessonListArgs = {
  input: GetLessonListInput;
};


export type QueryGetLocationArgs = {
  input: GetLocationInput;
};


export type QueryGetLocationAreaArgs = {
  input: GetLocationAreaInput;
};


export type QueryGetLockerArgs = {
  input: GetLockerInput;
};


export type QueryGetLockerExpiryListArgs = {
  input: GetLockerExpiryListInput;
};


export type QueryGetLockerGroupArgs = {
  input: GetLockerGroupInput;
};


export type QueryGetLockerListArgs = {
  input: GetLockerListInput;
};


export type QueryGetLockerTypeArgs = {
  input: GetLockerTypeInput;
};


export type QueryGetLostCardHistoryArgs = {
  input: GetLostCardHistoryInput;
};


export type QueryGetLotteryGroupScoreArgs = {
  input: GetLotteryGroupScoreInput;
};


export type QueryGetMemberArgs = {
  input: GetMemberInput;
};


export type QueryGetMemberAccessPassHistoryArgs = {
  input: GetMemberAccessPassHistoryInput;
};


export type QueryGetMemberActivityListArgs = {
  input: GetMemberActivityListInput;
};


export type QueryGetMemberCourseEnrolmentHistoryArgs = {
  input: GetMemberCourseEnrolmentHistoryInput;
};


export type QueryGetMemberDepositHistoryArgs = {
  input: GetMemberDepositHistoryInput;
};


export type QueryGetMemberDriveDepositHistoryArgs = {
  input: GetMemberDriveDepositHistoryInput;
};


export type QueryGetMemberDriveScoreHistoryArgs = {
  input: GetMemberDriveScoreHistoryInput;
};


export type QueryGetMemberDriveTeamListArgs = {
  input: GetMemberDriveTeamListInput;
};


export type QueryGetMemberFacilityBookingHistoryArgs = {
  input: GetMemberFacilityBookingHistoryInput;
};


export type QueryGetMemberFullInfoArgs = {
  input: GetMemberInput;
};


export type QueryGetMemberIdByMembershipNoArgs = {
  input: GetMemberIdByMembershipNoInput;
};


export type QueryGetMemberLessonEnrolmentHistoryArgs = {
  input: GetMemberLessonEnrolmentHistoryInput;
};


export type QueryGetMemberListArgs = {
  input: GetMemberListInput;
};


export type QueryGetMemberListAsCourseMemberListArgs = {
  input: GetMemberListAsCourseMemberListInput;
};


export type QueryGetMemberListAsRecurCourseMemberListArgs = {
  input: GetMemberListAsRecurCourseMemberListInput;
};


export type QueryGetMemberMembershipHistoryArgs = {
  input: GetMemberMembershipHistoryInput;
};


export type QueryGetMemberMovementArgs = {
  input: GetMemberMovementInput;
};


export type QueryGetMemberMovementYearArgs = {
  input: GetMemberMovementYearInput;
};


export type QueryGetMemberMyorderHistoryArgs = {
  input: GetMemberMyorderHistoryInput;
};


export type QueryGetMemberPhoneBookingStatusArgs = {
  input: GetMemberPhoneBookingStatusInput;
};


export type QueryGetMemberProductRedeemOrderArgs = {
  input: GetMemberProductRedeemOrderInput;
};


export type QueryGetMemberValidityArgs = {
  input: GetMemberValidityInput;
};


export type QueryGetMembershipHistoryArgs = {
  input: GetMembershipHistoryInput;
};


export type QueryGetMembershipTypeArgs = {
  input: GetMembershipTypeInput;
};


export type QueryGetMiniSiteContentArgs = {
  input: GetMiniSiteContentInput;
};


export type QueryGetMsgQueueArgs = {
  input: GetMsgQueueInput;
};


export type QueryGetMsgQueueByHashArgs = {
  input: GetMsgQueueByHashInput;
};


export type QueryGetMyEventArgs = {
  input: GetMyEventInput;
};


export type QueryGetMyfileInfoArgs = {
  input: GetMyfileInput;
};


export type QueryGetMyorderArgs = {
  input: GetMyorderInput;
};


export type QueryGetNewsArgs = {
  input: GetNewsInput;
};


export type QueryGetOrderPaymentMethodSummaryPerDayArgs = {
  input: GetOrderPaymentMethodSummaryPerDayInput;
};


export type QueryGetOrganizationArgs = {
  input: GetOrganizationInput;
};


export type QueryGetPosCartFacilityTreeArgs = {
  input: GetPosFacilityTreeInput;
};


export type QueryGetPrivateCoachApplicableCouponPackageInstanceListArgs = {
  input: GetPrivateCoachApplicableCouponPackageInstanceListInput;
};


export type QueryGetProductArgs = {
  input: GetProductInput;
};


export type QueryGetProductCatArgs = {
  input: GetProductCatInput;
};


export type QueryGetProductInventoryLevelPerPartitionByDeptArgs = {
  input: GetProductInventoryLevelPerPartitionByDeptInput;
};


export type QueryGetPublicMyfileInfoArgs = {
  input: MeGetMyfileInput;
};


export type QueryGetQrCodeForEnrolmentArgs = {
  input: GetCourseEnrolmentQrCodeInput;
};


export type QueryGetQrCodeForReceiptArgs = {
  input: GetMyorderItemQrCodeInput;
};


export type QueryGetQrCodeForTimeSlotProgramReservationArgs = {
  input: GetTimeSlotProgramReservationQrCodeInput;
};


export type QueryGetReceiptBookingQrCodeArgs = {
  input: GetBookingQrCodeInput;
};


export type QueryGetRecurCourseArgs = {
  input: GetRecurCourseInput;
};


export type QueryGetRefundPayoutRequestArgs = {
  input: GetRefundPayoutRequestInput;
};


export type QueryGetRoleTemplateArgs = {
  input: GetRoleTemplateInput;
};


export type QueryGetSalesReportItemTypePerDayArgs = {
  input: GetSalesReportItemTypePerDayInput;
};


export type QueryGetSalesReportItemTypePerDeptPerDayArgs = {
  input: GetSalesReportItemTypePerDeptPerDayInput;
};


export type QueryGetSalesReportItemTypePerDeptPerMonthArgs = {
  input: GetSalesReportItemTypePerDeptPerMonthInput;
};


export type QueryGetSalesReportItemTypePerMonthArgs = {
  input: GetSalesReportItemTypePerMonthInput;
};


export type QueryGetSalesReportPaymentMethodPerDayArgs = {
  input: GetSalesReportPaymentMethodPerDayInput;
};


export type QueryGetSalesReportPaymentMethodPerMonthArgs = {
  input: GetSalesReportPaymentMethodPerMonthInput;
};


export type QueryGetSettingArgs = {
  input: GetAdminSettingInput;
};


export type QueryGetShippingReceiptArgs = {
  input: GetReceiptInput;
};


export type QueryGetSportTypeArgs = {
  input: GetSportTypeInput;
};


export type QueryGetSportTypeGroupArgs = {
  input: GetSportTypeGroupInput;
};


export type QueryGetSportTypeGroupListWithActiveCourseListArgs = {
  input: GetSportTypeGroupListWithActiveCourseListInput;
};


export type QueryGetSportTypeListWithActiveCourseListArgs = {
  input: GetSportTypeListWithActiveCourseListInput;
};


export type QueryGetSwpFeeArgs = {
  input: GetSwpFeeInput;
};


export type QueryGetSwpSessionArgs = {
  input: GetSwpSessionInput;
};


export type QueryGetTextTemplateArgs = {
  input: GetTextTemplateInput;
};


export type QueryGetTextTemplateListArgs = {
  input: GetTextTemplateListInput;
};


export type QueryGetTimeSlotProgramArgs = {
  input: GetTimeSlotProgramInput;
};


export type QueryGetTimeSlotProgramFullDayInfoArgs = {
  input: GetTimeSlotProgramFullDayInfoInput;
};


export type QueryGetTimeSlotProgramGroupArgs = {
  input: GetTimeSlotProgramGroupInput;
};


export type QueryGetTimeSlotProgramStatsArgs = {
  input: GetTimeSlotProgramStatsInput;
};


export type QueryGetTimeSlotProgramSummaryArgs = {
  input: GetTimeSlotProgramSummaryInput;
};


export type QueryGetUpgradableMembershipTypeListArgs = {
  input: GetUpgradableMembershipTypeListInput;
};


export type QueryGetUserArgs = {
  input: GetUserInput;
};


export type QueryGetUserDeptListPerDomainArgs = {
  input: GetUserDeptListPerDomainInput;
};


export type QueryGetUserDeptListPerPermissionTypeArgs = {
  input: GetUserDeptListPerPermissionTypeInput;
};


export type QueryGetUserProductGroupArgs = {
  input: GetUserProductGroupInput;
};


export type QueryGetUserWarehouseListArgs = {
  input: GetUserWarehouseListInput;
};


export type QueryGetUsernameArgs = {
  input: GetUsernameInput;
};


export type QueryGetWarehouseArgs = {
  input: GetWarehouseInput;
};


export type QueryGetWarehousePartitionArgs = {
  input: GetWarehousePartitionInput;
};


export type QueryGetWarehouseStockTakeArgs = {
  input: GetWarehouseStockTakeInput;
};


export type QueryGetWarehouseStockTakeDeltaArgs = {
  input: GetWarehouseStockTakeDeltaInput;
};


export type QueryGuestGetAvailableCoachServiceAndCoachArgs = {
  input: GuestGetAvailableCoachServiceAndCoachInput;
};


export type QueryGuestGetAvailableTimeslotByCoachAndFacilityArgs = {
  input: GuestGetAvailableTimeslotByCoachAndFacilityInput;
};


export type QueryGuestGetCoachTimeslotSummaryArgs = {
  input: GuestGetCoachTimeslotSummaryInput;
};


export type QueryGuestGetMyEventArgs = {
  input: GetMyEventInput;
};


export type QueryGuestGetUpgradableMembershipTypeListArgs = {
  input: GuestGetUpgradableMembershipTypeListInput;
};


export type QueryKwtdhcBatchImportMemberSearchBullQueueArgs = {
  input: SearchBullQueueInput;
};


export type QueryManualCheckInAuthArgs = {
  input: ManualCheckInAuthInput;
};


export type QueryMeGetAccessPassPurchaseListArgs = {
  input: MeGetAccessPassPurchaseListInput;
};


export type QueryMeGetCartArgs = {
  input: MeGetCartInput;
};


export type QueryMeGetEffectiveBookingInfoArgs = {
  input: MeGetEffectiveBookingInfoInput;
};


export type QueryMeGetEffectiveFacilityLeadTimeForMemberArgs = {
  input: MeGetFacilityEffectiveLeadTimeForMemberInput;
};


export type QueryMeGetEffectiveFacilityNoOfTimeslotForMemberArgs = {
  input: MeGetFacilityEffectiveNoOfTimeslotForMemberInput;
};


export type QueryMeGetFacilityBookingApplicableCouponPackageInstanceListArgs = {
  input: GetFacilityBookingApplicableCouponPackageInstanceListInput;
};


export type QueryMeGetLatestDepositHistoryListArgs = {
  input: MeGetLatestMemberDepositHistoryListInput;
};


export type QueryMeGetLatestMemberAccessPassHistoryListArgs = {
  input: MeGetLatestMemberAccessPassHistoryListInput;
};


export type QueryMeGetLockerListArgs = {
  input: MeGetLockerListInput;
};


export type QueryMeGetMemberAccessPassHistoryArgs = {
  input: GetMemberAccessPassHistoryInput;
};


export type QueryMeGetMemberActivityListArgs = {
  input: MeGetMemberActivityListInput;
};


export type QueryMeGetMemberCourseEnrolmentHistoryArgs = {
  input: MeGetMemberCourseEnrolmentHistoryInput;
};


export type QueryMeGetMemberDepositHistoryArgs = {
  input: MeGetMemberDepositHistoryInput;
};


export type QueryMeGetMemberDriveDepositHistoryArgs = {
  input: GetMemberDriveDepositHistoryInput;
};


export type QueryMeGetMemberDriveScoreHistoryArgs = {
  input: MeGetMemberDriveScoreHistoryInput;
};


export type QueryMeGetMemberFacilityBookingHistoryArgs = {
  input: MeGetMemberFacilityBookingHistoryInput;
};


export type QueryMeGetMemberLessonEnrolmentHistoryArgs = {
  input: MeGetMemberLessonEnrolmentHistoryInput;
};


export type QueryMeGetMemberMembershipHistoryArgs = {
  input: MeGetMemberMembershipHistoryInput;
};


export type QueryMeGetMemberMyorderHistoryArgs = {
  input: MeGetMemberMyorderHistoryInput;
};


export type QueryMeGetMemberProductRedeemOrderArgs = {
  input: MeGetMemberProductRedeemOrderInput;
};


export type QueryMeGetMsgQueueArgs = {
  input: MeGetMsgQueueInput;
};


export type QueryMeGetMyorderArgs = {
  input: GetMyorderInput;
};


export type QueryMeGetPrivateCoachApplicableCouponPackageInstanceListArgs = {
  input: GetPrivateCoachApplicableCouponPackageInstanceListInput;
};


export type QueryMeGetQrCodeArgs = {
  input: MeGetMyorderItemQrCodeInput;
};


export type QueryMeGetQrCodeForEnrolmentArgs = {
  input: MeGetCourseEnrolmentQrCodeInput;
};


export type QueryMeGetQrCodeForTimeSlotProgramReservationArgs = {
  input: MeGetTimeSlotProgramReservationQrCodeInput;
};


export type QueryMeGetTimeSlotProgramFullDayInfoArgs = {
  input: GetTimeSlotProgramFullDayInfoInput;
};


export type QueryMeSearchBonusPointReceiptRegArgs = {
  input: SearchBonusPointReceiptRegInput;
};


export type QueryMeSearchBonusPointRedeemPromotionGroupArgs = {
  input: SearchBonusPointRedeemPromotionGroupInput;
};


export type QueryMeSearchBonusPointTxArgs = {
  input: SearchBonusPointTxInput;
};


export type QueryMeSearchCoachServiceArgs = {
  input: MeSearchCoachServiceInput;
};


export type QueryMeSearchCouponPackageArgs = {
  input: SearchCouponPackageInput;
};


export type QueryMeSearchCouponPackageInstanceArgs = {
  input: SearchCouponPackageInstanceInput;
};


export type QueryMeSearchCouponPackageInstanceUsageHistoryArgs = {
  input: SearchCouponPackageInstanceUsageHistoryInput;
};


export type QueryMeSearchCourseEnrolmentArgs = {
  input: SearchCourseEnrolmentInput;
};


export type QueryMeSearchCreditPackageArgs = {
  input: SearchCreditPackageInput;
};


export type QueryMeSearchCreditTxArgs = {
  input: SearchCreditTxInput;
};


export type QueryMeSearchInboxArgs = {
  input: SearchMsgQueueInput;
};


export type QueryMeSearchLockerGroupArgs = {
  input: SearchLockerGroupInput;
};


export type QueryMeSearchLockerHistoryArgs = {
  input: SearchLockerHistoryInput;
};


export type QueryMeSearchMemberHdtBgArgs = {
  input: SearchMemberHdtBgInput;
};


export type QueryMeSearchMemberHdtBpHrArgs = {
  input: SearchMemberHdtBpHrInput;
};


export type QueryMeSearchMemberHdtBtArgs = {
  input: SearchMemberHdtBtInput;
};


export type QueryMeSearchMemberHdtBwBhBmiArgs = {
  input: SearchMemberHdtBwBhBmiInput;
};


export type QueryMeSearchMemberHdtSpo2HrArgs = {
  input: SearchMemberHdtSpo2HrInput;
};


export type QueryMeSearchProductArgs = {
  input: MeSearchProductInput;
};


export type QueryMeSearchProductCatArgs = {
  input: MeSearchProductCatInput;
};


export type QueryMeSearchTimeSlotProgramArgs = {
  input: SearchTimeSlotProgramInput;
};


export type QueryMeSearchTimeSlotProgramGroupArgs = {
  input: SearchTimeSlotProgramGroupInput;
};


export type QueryMeSearchTimeSlotProgramReservationArgs = {
  input: SearchTimeSlotProgramReservationInput;
};


export type QueryMemberGetMyfileInfoArgs = {
  input: MeGetMyfileInput;
};


export type QueryMgmReferralCodeCheckArgs = {
  input: MgmReferralCodeCheckInput;
};


export type QueryPosSearchCourseCustomArgs = {
  input: PosSearchCourseCustomInput;
};


export type QueryPosSearchMyEventCustomArgs = {
  input: PosSearchMyEventCustomInput;
};


export type QueryScaaGetMemCommissionReportArgs = {
  input: ScaaGetMemCommissionReportInput;
};


export type QuerySearchAccessPassArgs = {
  input: SearchAccessPassInput;
};


export type QuerySearchAccessPassHistoryArgs = {
  input: SearchAccessPassHistoryInput;
};


export type QuerySearchAcctProductCatArgs = {
  input: SearchAcctProductCatInput;
};


export type QuerySearchAuditLogArgs = {
  input: SearchAuditLogInput;
};


export type QuerySearchBlackoutArgs = {
  input: SearchBlackoutInput;
};


export type QuerySearchBonusPointEarningRuleArgs = {
  input: SearchBonusPointEarningRuleInput;
};


export type QuerySearchBonusPointItemTypeEarningRatioArgs = {
  input: SearchBonusPointItemTypeEarningRatioInput;
};


export type QuerySearchBonusPointReceiptRegArgs = {
  input: SearchBonusPointReceiptRegInput;
};


export type QuerySearchBonusPointRedeemPromotionGroupArgs = {
  input: SearchBonusPointRedeemPromotionGroupInput;
};


export type QuerySearchBonusPointTxArgs = {
  input: SearchBonusPointTxInput;
};


export type QuerySearchCheckInDeviceArgs = {
  input: SearchCheckInDeviceInput;
};


export type QuerySearchCoachArgs = {
  input: SearchUserInput;
};


export type QuerySearchCoachServiceArgs = {
  input: SearchCoachServiceInput;
};


export type QuerySearchCoachTimeslotArgs = {
  input: SearchCoachTimeslotInput;
};


export type QuerySearchCommitteeArgs = {
  input: SearchCommitteeInput;
};


export type QuerySearchCommitteeHistoryArgs = {
  input: SearchCommitteeHistoryInput;
};


export type QuerySearchCommitteePositionArgs = {
  input: SearchCommitteePositionInput;
};


export type QuerySearchContactArgs = {
  input: SearchContactInput;
};


export type QuerySearchCouponPackageArgs = {
  input: SearchCouponPackageInput;
};


export type QuerySearchCouponPackageInstanceArgs = {
  input: SearchCouponPackageInstanceInput;
};


export type QuerySearchCouponPackageInstanceUsageHistoryArgs = {
  input: SearchCouponPackageInstanceUsageHistoryInput;
};


export type QuerySearchCourseArgs = {
  input: SearchCourseInput;
};


export type QuerySearchCourseApplyQuotaPeriodArgs = {
  input: SearchCourseApplyQuotaPeriodInput;
};


export type QuerySearchCourseCustomArgs = {
  input: SearchCourseCustomInput;
};


export type QuerySearchCourseEnrolmentArgs = {
  input: SearchCourseEnrolmentInput;
};


export type QuerySearchCourseTypeArgs = {
  input: SearchCourseTypeInput;
};


export type QuerySearchCreditPackageArgs = {
  input: SearchCreditPackageInput;
};


export type QuerySearchCreditTxArgs = {
  input: SearchCreditTxInput;
};


export type QuerySearchCreditTypeArgs = {
  input: SearchCreditTypeInput;
};


export type QuerySearchDeliveryNoteArgs = {
  input: SearchDeliveryNoteInput;
};


export type QuerySearchDepartmentArgs = {
  input: SearchDepartmentInput;
};


export type QuerySearchDepositArgs = {
  input: SearchDepositHistoryInput;
};


export type QuerySearchDocxTemplateArgs = {
  input: SearchDocxTemplateInput;
};


export type QuerySearchDriveDepositHistoryArgs = {
  input: SearchDriveDepositHistoryInput;
};


export type QuerySearchDriveScoreHistoryArgs = {
  input: SearchDriveScoreHistoryInput;
};


export type QuerySearchDriveTeamArgs = {
  input: SearchDriveTeamInput;
};


export type QuerySearchFabFloorplanArgs = {
  input: SearchFabFloorplanInput;
};


export type QuerySearchFabReservationArgs = {
  input: SearchFabReservationInput;
};


export type QuerySearchFacilityArgs = {
  input: SearchFacilityInput;
};


export type QuerySearchFacilityAccessLogArgs = {
  input: SearchFacilityAccessLogInput;
};


export type QuerySearchFacilityBookingArgs = {
  input: SearchFacilityBookingInput;
};


export type QuerySearchGoodsReceiveNoteArgs = {
  input: SearchGoodsReceiveNoteInput;
};


export type QuerySearchGpTokenArgs = {
  input: SearchGpTokenInput;
};


export type QuerySearchHolidayArgs = {
  input: SearchHolidayInput;
};


export type QuerySearchInventoryRequestTxArgs = {
  input: SearchInventoryRequestTxInput;
};


export type QuerySearchInventoryTxCountArgs = {
  input: SearchInventoryTxCountInput;
};


export type QuerySearchInventoryTxGroupArgs = {
  input: SearchInventoryTxGroupInput;
};


export type QuerySearchKwtdhcEventArgs = {
  input: SearchKwtdhcEventInput;
};


export type QuerySearchKwtdhcMemberFollowupArgs = {
  input: SearchKwtdhcMemberFollowupInput;
};


export type QuerySearchLessonArgs = {
  input: SearchLessonInput;
};


export type QuerySearchLessonCoachArgs = {
  input: SearchLessonCoachInput;
};


export type QuerySearchLessonEnrolmentArgs = {
  input: SearchLessonEnrolmentInput;
};


export type QuerySearchLocationArgs = {
  input: SearchLocationInput;
};


export type QuerySearchLocationAreaArgs = {
  input: SearchLocationAreaInput;
};


export type QuerySearchLockerGroupArgs = {
  input: SearchLockerGroupInput;
};


export type QuerySearchLockerHistoryArgs = {
  input: SearchLockerHistoryInput;
};


export type QuerySearchLockerTypeArgs = {
  input: SearchLockerTypeInput;
};


export type QuerySearchMachineArgs = {
  input: SearchUserInput;
};


export type QuerySearchMemberArgs = {
  input: SearchMemberInput;
};


export type QuerySearchMemberFacialArgs = {
  input: SearchMemberFacialInput;
};


export type QuerySearchMemberHdtBgArgs = {
  input: SearchMemberHdtBgInput;
};


export type QuerySearchMemberHdtBpHrArgs = {
  input: SearchMemberHdtBpHrInput;
};


export type QuerySearchMemberHdtBtArgs = {
  input: SearchMemberHdtBtInput;
};


export type QuerySearchMemberHdtBwBhBmiArgs = {
  input: SearchMemberHdtBwBhBmiInput;
};


export type QuerySearchMemberHdtSpo2HrArgs = {
  input: SearchMemberHdtSpo2HrInput;
};


export type QuerySearchMemberListArgs = {
  input: SearchMemberListInput;
};


export type QuerySearchMemberLotteryGroupScoreOverrideArgs = {
  input: SearchMemberLotteryGroupScoreOverrideInput;
};


export type QuerySearchMemberParQArgs = {
  input: SearchMemberParQInput;
};


export type QuerySearchMembershipHistoryArgs = {
  input: SearchMembershipHistoryInput;
};


export type QuerySearchMembershipTypeArgs = {
  input: SearchMembershipTypeInput;
};


export type QuerySearchMiniSiteContentArgs = {
  input: SearchMiniSiteContentInput;
};


export type QuerySearchMsgQueueArgs = {
  input: SearchMsgQueueInput;
};


export type QuerySearchMyEventArgs = {
  input: SearchMyEventInput;
};


export type QuerySearchMyEventCustomArgs = {
  input: SearchMyEventCustomInput;
};


export type QuerySearchMyorderArgs = {
  input: SearchMyorderInput;
};


export type QuerySearchMyorderItemArgs = {
  input: SearchMyorderItemInput;
};


export type QuerySearchNewsArgs = {
  input: SearchNewsInput;
};


export type QuerySearchOrganizationArgs = {
  input: SearchOrganizationInput;
};


export type QuerySearchProductArgs = {
  input: SearchProductInput;
};


export type QuerySearchProductCatArgs = {
  input: SearchProductCatInput;
};


export type QuerySearchRecurCourseArgs = {
  input: SearchRecurCourseInput;
};


export type QuerySearchRefundPayoutRequestArgs = {
  input: SearchRefundPayoutRequestInput;
};


export type QuerySearchRoleTemplateArgs = {
  input: SearchRoleTemplateInput;
};


export type QuerySearchSportTypeArgs = {
  input: SearchSportTypeInput;
};


export type QuerySearchSportTypeGroupArgs = {
  input: SearchSportTypeGroupInput;
};


export type QuerySearchSwpAccessLogArgs = {
  input: SearchSwpAccessLogInput;
};


export type QuerySearchSwpTestCardQrCodeArgs = {
  input: SearchDynamicQrCodeInput;
};


export type QuerySearchTextTemplateArgs = {
  input: SearchTextTemplateInput;
};


export type QuerySearchTimeSlotProgramArgs = {
  input: SearchTimeSlotProgramInput;
};


export type QuerySearchTimeSlotProgramGroupArgs = {
  input: SearchTimeSlotProgramGroupInput;
};


export type QuerySearchTimeSlotProgramReservationArgs = {
  input: SearchTimeSlotProgramReservationInput;
};


export type QuerySearchUserArgs = {
  input: SearchUserInput;
};


export type QuerySearchUserProductGroupArgs = {
  input: SearchUserProductGroupInput;
};


export type QuerySearchWarehouseArgs = {
  input: SearchWarehouseInput;
};


export type QuerySearchWarehouseBorrowSummaryArgs = {
  input: SearchDeptBorrowSummaryInput;
};


export type QuerySearchWarehouseInventoryArgs = {
  input: SearchWarehouseInventoryInput;
};


export type QuerySearchWarehousePartitionArgs = {
  input: SearchWarehousePartitionInput;
};


export type QuerySearchWarehouseStockTakeArgs = {
  input: SearchWarehouseStockTakeInput;
};


export type QuerySearchWhatsappMsgQueueArgs = {
  input: SearchMsgQueueInput;
};


export type QuerySearchWhatsappSummaryArgs = {
  input: SearchWhatsappSummaryInput;
};


export type QuerySearchWhatsappTemplateArgs = {
  input: SearchWhatsappTemplateInput;
};


export type QueryUserGetMemberMsgQueueArgs = {
  input: GetMemberMsgQueueInput;
};


export type QueryUserGetMemberParQArgs = {
  input: UserGetMemberParQInput;
};


export type QueryUserGetMsgQueueArgs = {
  input: UserGetMsgQueueInput;
};


export type QueryUserGetOrderPaymentMethodSummaryArgs = {
  input: UserGetOrderPaymentMethodSummaryInput;
};


export type QueryUserGetUserDeptListPerDomainArgs = {
  input: UserGetUserDeptListPerDomainInput;
};


export type QueryUserGetUserDeptListPerPermissionTypeArgs = {
  input: UserGetUserDeptListPerPermissionTypeInput;
};


export type QueryUserGetWarehousePartitionListByPermissionArgs = {
  input: UserGetWarehousePartitionListByPermissionInput;
};


export type QueryUserSearchInboxArgs = {
  input: SearchMsgQueueInput;
};


export type QueryUserSearchMemberMsgQueueArgs = {
  input: SearchMemberMsgQueueInput;
};


export type QueryUserSearchMemberSessionArgs = {
  input: UserSearchMemberSessionInput;
};


export type QueryUserSearchMsgQueueArgs = {
  input: SearchMsgQueueInput;
};


export type QueryUserSearchRefundPayoutRequestArgs = {
  input: SearchRefundPayoutRequestInput;
};


export type QueryUserSearchUserArgs = {
  input: SearchUserInput;
};

export type QueryCondAccessPassHistoryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondAccessPassInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondAcctProductCatInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondAuditLogInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondBlackoutInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondBonusPointEarningRuleInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondBonusPointItemTypeEarningRatioInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondBonusPointReceiptRegInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondBonusPointRedeemPromotionGroupInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondBonusPointTxInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCheckInDeviceInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCoachServiceInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCoachTimeslotInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCommitteeHistoryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCommitteeInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCommitteePositionInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondContactInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCouponPackageInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCouponPackageInstanceInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCouponPackageInstanceUsageHistoryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCourseApplyQuotaPeriodInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCourseEnrolmentInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCourseInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCourseTypeInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCreditPackageInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCreditTxInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondCreditTypeInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondDeliveryNoteInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondDepartmentInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondDepositInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondDeptBorrowSummaryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondDocxTemplateInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondDriveDepositHistoryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondDriveScoreHistoryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondDriveTeamInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondDynamicQrCodeInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondFabFloorplanInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondFabReservationInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondFacilityAccessLogInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondFacilityBookingInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondFacilityInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondGoodsReceiveNoteInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondGpTokenInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondHolidayInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondInventoryRequestTxInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondInventoryTxCountInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondInventoryTxGroupInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondKwtdhcEventInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondKwtdhcMemberFollowupInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondLessonCoachInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondLessonEnrolmentInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondLessonInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondLocationAreaInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondLocationInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondLockerGroupInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondLockerHistoryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondLockerTypeInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberFacialInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberHdtBgInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberHdtBpHrInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberHdtBtInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberHdtBwBhBmiInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberHdtSpo2HrInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberListInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberLotteryGroupScoreOverrideInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberParQInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMemberSessionInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMembershipHistoryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMembershipTypeInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMiniSiteContentInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMsgQueueInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMyEventInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMySessionInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMyorderInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondMyorderItemInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondNewsInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export enum QueryCondOperatorEnum {
  Between = 'between',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  Like = 'like',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
  NotBetween = 'notBetween',
  NotIn = 'notIn',
  NotLike = 'notLike'
}

export type QueryCondOrganizationInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondProductCatInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondProductInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondRecurCourseInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondRefundPayoutRequestInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondRoleTemplateInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondSportTypeGroupInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondSportTypeInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondSwpAccessLogInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondTextTemplateInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondTimeSlotProgramGroupInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondTimeSlotProgramInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondTimeSlotProgramReservationInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondUserInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondUserProductGroupInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondWarehouseInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondWarehouseInventoryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondWarehousePartitionInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondWarehouseStockTakeInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondWhatsappSummaryInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCondWhatsappTemplateInput = {
  field: Scalars['String']['input'];
  operator: QueryCondOperatorEnum;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryOrderByAccessPassHistoryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByAccessPassInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByAcctProductCatInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByAuditLogInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByBlackoutInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByBonusPointEarningRuleInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByBonusPointItemTypeEarningRatioInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByBonusPointReceiptRegInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByBonusPointRedeemPromotionGroupInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByBonusPointTxInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCheckInDeviceInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCoachServiceInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCoachTimeslotInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCommitteeHistoryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCommitteeInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCommitteePositionInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByContactInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCouponPackageInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCouponPackageInstanceInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCouponPackageInstanceUsageHistoryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCourseApplyQuotaPeriodInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCourseEnrolmentInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCourseInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCourseTypeInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCreditPackageInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCreditTxInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByCreditTypeInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByDeliveryNoteInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByDepartmentInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByDepositInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByDeptBorrowSummaryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByDocxTemplateInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByDriveDepositHistoryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByDriveScoreHistoryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByDriveTeamInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByDynamicQrCodeInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByFabFloorplanInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByFabReservationInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByFacilityAccessLogInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByFacilityBookingInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByFacilityInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByGoodsReceiveNoteInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByGpTokenInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByHolidayInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByInventoryRequestTxInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByInventoryTxCountInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByInventoryTxGroupInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByKwtdhcEventInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByKwtdhcMemberFollowupInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByLessonCoachInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByLessonEnrolmentInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByLessonInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByLocationAreaInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByLocationInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByLockerGroupInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByLockerHistoryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByLockerTypeInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberFacialInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberHdtBgInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberHdtBpHrInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberHdtBtInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberHdtBwBhBmiInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberHdtSpo2HrInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberListInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberLotteryGroupScoreOverrideInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberParQInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMemberSessionInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMembershipHistoryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMembershipTypeInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMiniSiteContentInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMsgQueueInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMyEventInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMySessionInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMyorderInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByMyorderItemInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByNewsInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByOrganizationInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByProductCatInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByProductInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByRecurCourseInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByRefundPayoutRequestInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByRoleTemplateInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderBySportTypeGroupInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderBySportTypeInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderBySwpAccessLogInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByTextTemplateInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByTimeSlotProgramGroupInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByTimeSlotProgramInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByTimeSlotProgramReservationInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export enum QueryOrderByTypeEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type QueryOrderByUserInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByUserProductGroupInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByWarehouseInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByWarehouseInventoryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByWarehousePartitionInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByWarehouseStockTakeInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByWhatsappSummaryInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type QueryOrderByWhatsappTemplateInput = {
  field: Scalars['String']['input'];
  orderBy: QueryOrderByTypeEnum;
};

export type RecurCourse = {
  __typename?: 'RecurCourse';
  accessPassDependencyList?: Maybe<Array<AccessPass>>;
  allowFeeAutoRecalEvenWithEnrolment: Scalars['Boolean']['output'];
  apcCatCodeForFee: Scalars['String']['output'];
  apcCatCodeForMaterial: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  apcMaterial?: Maybe<AcctProductCat>;
  aspenCategoryCode: Scalars['String']['output'];
  aspenPrepaidCategoryCode: Scalars['String']['output'];
  coachInternalRemark: Scalars['String']['output'];
  coachPhoto?: Maybe<Array<Myfile>>;
  coachRemarkEn: Scalars['String']['output'];
  coachRemarkSc: Scalars['String']['output'];
  coachRemarkTc: Scalars['String']['output'];
  courseList?: Maybe<Array<Course>>;
  courseType?: Maybe<CourseType>;
  courseTypeId: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptId: Scalars['Int']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  earlyBirdDiscountAmtForGroup: Scalars['Float']['output'];
  earlyBirdDiscountAmtForMember: Scalars['Float']['output'];
  earlyBirdDiscountPercentForGroup: Scalars['Float']['output'];
  earlyBirdDiscountPercentForMember: Scalars['Float']['output'];
  enableFeeAutoRecalAfterUpdate: Scalars['Boolean']['output'];
  enableGroupEnrol: Scalars['Boolean']['output'];
  enableMemberEnrol: Scalars['Boolean']['output'];
  enableNoShowPenalty: Scalars['Boolean']['output'];
  enablePriorityEnrolmentForLastCourseMember: Scalars['Boolean']['output'];
  endTime?: Maybe<Scalars['String']['output']>;
  enrolmentType: CourseEnrolmentType;
  exceptDateList?: Maybe<Array<RecurCourseExceptDateList>>;
  facilityCostPerLesson: Scalars['Float']['output'];
  facilityList?: Maybe<Array<Facility>>;
  facilityRemarkEn: Scalars['String']['output'];
  facilityRemarkSc: Scalars['String']['output'];
  facilityRemarkTc: Scalars['String']['output'];
  feeType: RecurCourseFeeType;
  fixCalendarDayForEarlyBirdGroupEnrolment?: Maybe<Scalars['Int']['output']>;
  fixCalendarDayForEarlyBirdMemberEnrolment?: Maybe<Scalars['Int']['output']>;
  fixCalendarDayForGroupEnrolment?: Maybe<Scalars['Int']['output']>;
  fixCalendarDayForMemberEnrolment?: Maybe<Scalars['Int']['output']>;
  fixCalendarDayForPriorityEnrolment?: Maybe<Scalars['Int']['output']>;
  fixedAmountFeeForGroup: Scalars['Float']['output'];
  fixedAmountFeeForMember: Scalars['Float']['output'];
  fixedFacilityCost: Scalars['Float']['output'];
  fixedMaterialCost: Scalars['Float']['output'];
  fri: Scalars['Boolean']['output'];
  gender: FilterGender;
  id: Scalars['Int']['output'];
  isSkipPublicHoliday: Scalars['Boolean']['output'];
  lastModifyUserId: Scalars['Int']['output'];
  leadNoOfDaysEarlyBirdForGroup: Scalars['Int']['output'];
  leadNoOfDaysEarlyBirdForMember: Scalars['Int']['output'];
  leadNoOfDaysEnrolmentForGroup: Scalars['Int']['output'];
  leadNoOfDaysEnrolmentForMember: Scalars['Int']['output'];
  leadNoOfDaysForCancelCourseAlert?: Maybe<Scalars['Int']['output']>;
  leadNoOfDaysForPriorityEnrolment: Scalars['Int']['output'];
  lessonFeeForGroup: Scalars['Float']['output'];
  lessonFeeForMember: Scalars['Float']['output'];
  lessonRemark: Scalars['String']['output'];
  limitEnrolPeriodInDefaultTimeslotOnly?: Maybe<Scalars['Boolean']['output']>;
  lotteryGroupName: Scalars['String']['output'];
  materialCostPerLesson: Scalars['Float']['output'];
  maxAge: Scalars['Float']['output'];
  maxNoOfEnrolment: Scalars['Int']['output'];
  minAge: Scalars['Float']['output'];
  minNoOfEnrolment: Scalars['Int']['output'];
  mon: Scalars['Boolean']['output'];
  overrideTimeDescEn: Scalars['String']['output'];
  overrideTimeDescSc: Scalars['String']['output'];
  overrideTimeDescTc: Scalars['String']['output'];
  photoList?: Maybe<Array<Myfile>>;
  prefixNameEn: Scalars['String']['output'];
  prefixNameSc: Scalars['String']['output'];
  prefixNameTc: Scalars['String']['output'];
  recurBy: RecurCourseRecurBy;
  recurCourseApplyQuotaPeriodLinkList?: Maybe<Array<RecurCourseApplyQuotaPeriodLink>>;
  recurCourseCoachList?: Maybe<Array<RecurCourseCoach>>;
  recurFixedNoOfLesson: Scalars['Int']['output'];
  recurNoOfCalendarMonths: Scalars['Int']['output'];
  remarkEn: Scalars['String']['output'];
  remarkSc: Scalars['String']['output'];
  remarkTc: Scalars['String']['output'];
  requireParQ: Scalars['Boolean']['output'];
  sat: Scalars['Boolean']['output'];
  showEnrolmentResultToPublic: Scalars['Boolean']['output'];
  sportType?: Maybe<SportType>;
  sportTypeId: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  suffixCode: Scalars['String']['output'];
  sun: Scalars['Boolean']['output'];
  thu: Scalars['Boolean']['output'];
  tue: Scalars['Boolean']['output'];
  uniformOption: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  webDiscountAmtForMember: Scalars['Float']['output'];
  webDiscountPercentForMember: Scalars['Float']['output'];
  wed: Scalars['Boolean']['output'];
  yldsaStandardCourseRule: Scalars['Boolean']['output'];
  youtubeId: Scalars['String']['output'];
};

export type RecurCourseApplyQuotaPeriodLink = {
  __typename?: 'RecurCourseApplyQuotaPeriodLink';
  courseApplyQuotaPeriod?: Maybe<CourseApplyQuotaPeriod>;
  id: Scalars['Int']['output'];
  recurCourse?: Maybe<RecurCourse>;
};

export type RecurCourseCoach = {
  __typename?: 'RecurCourseCoach';
  coach?: Maybe<User>;
  coachId: Scalars['Int']['output'];
  coachSalaryContractTerms?: Maybe<CoachSalaryContractTerms>;
  coachSalaryContractTermsId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  recurCourseId: Scalars['Int']['output'];
};

export type RecurCourseExceptDateList = {
  __typename?: 'RecurCourseExceptDateList';
  exceptDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  recurCourseId: Scalars['Int']['output'];
};

export enum RecurCourseFeeType {
  CalculateByNoOfLessons = 'calculateByNoOfLessons',
  FixedAmount = 'fixedAmount'
}

export enum RecurCourseRecurBy {
  ByCalendarMonth = 'byCalendarMonth',
  FixedNoOfLessons = 'fixedNoOfLessons'
}

export type RefundPayoutAccessToken = {
  __typename?: 'RefundPayoutAccessToken';
  createdDate: Scalars['String']['output'];
  expiryDateTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  issuedByUser?: Maybe<User>;
  issuedByUserId?: Maybe<Scalars['Int']['output']>;
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  lastSentDateTime?: Maybe<Scalars['String']['output']>;
  refundPayoutRequest?: Maybe<RefundPayoutRequest>;
  refundPayoutRequestId: Scalars['Int']['output'];
  revokedDateTime?: Maybe<Scalars['String']['output']>;
  sendCount: Scalars['Int']['output'];
  tokenHash: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  usedDateTime?: Maybe<Scalars['String']['output']>;
};

export type RefundPayoutDetail = {
  __typename?: 'RefundPayoutDetail';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  address3: Scalars['String']['output'];
  address4: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']['output']>;
  fpsAccountName: Scalars['String']['output'];
  fpsAccountNo: Scalars['String']['output'];
  fpsBankCode: Scalars['String']['output'];
  fpsEmail: Scalars['String']['output'];
  fpsId: Scalars['String']['output'];
  fpsMobileNo: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['Int']['output']>;
  memberConfirmedDateTime?: Maybe<Scalars['String']['output']>;
  payoutMethod: RefundPayoutMethod;
  refundPayoutRequest?: Maybe<RefundPayoutRequest>;
  refundPayoutRequestId: Scalars['Int']['output'];
  subDistrict?: Maybe<SubDistrict>;
  subDistrictId?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['String']['output'];
};

export enum RefundPayoutMethod {
  Cheque = 'cheque',
  Fps = 'fps'
}

export type RefundPayoutRequest = {
  __typename?: 'RefundPayoutRequest';
  ceoApprovedByUser?: Maybe<User>;
  ceoApprovedByUserId?: Maybe<Scalars['Int']['output']>;
  ceoApprovedDateTime?: Maybe<Scalars['String']['output']>;
  ceoRemark: Scalars['String']['output'];
  createByUser?: Maybe<User>;
  createdByUserId: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  financeApprovedByUser?: Maybe<User>;
  financeApprovedByUserId?: Maybe<Scalars['Int']['output']>;
  financeApprovedDateTime?: Maybe<Scalars['String']['output']>;
  financeRemark: Scalars['String']['output'];
  gpRefundLogList?: Maybe<Array<GpRefundLog>>;
  id: Scalars['Int']['output'];
  isAutoRenewOrder: Scalars['Boolean']['output'];
  isPaymentGateway: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  paymentGateway: Scalars['String']['output'];
  processedByUser?: Maybe<User>;
  processedByUserId?: Maybe<Scalars['Int']['output']>;
  processedDateTime?: Maybe<Scalars['String']['output']>;
  refundMyorder?: Maybe<Myorder>;
  refundMyorderId: Scalars['Int']['output'];
  refundPayoutAccessTokenList?: Maybe<Array<RefundPayoutAccessToken>>;
  refundPayoutDetail?: Maybe<RefundPayoutDetail>;
  rejectedByUser?: Maybe<User>;
  rejectedByUserId?: Maybe<Scalars['Int']['output']>;
  rejectedDateTime?: Maybe<Scalars['String']['output']>;
  rejectedReason: Scalars['String']['output'];
  requestReason: Scalars['String']['output'];
  requestStatus: RefundPayoutRequestStatus;
  requestedAmount: Scalars['Float']['output'];
  result: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export enum RefundPayoutRequestStatus {
  CeoApproved = 'ceoApproved',
  CeoPending = 'ceoPending',
  CeoRejected = 'ceoRejected',
  Completed = 'completed',
  Failed = 'failed',
  FinanceApproved = 'financeApproved',
  FinanceRejected = 'financeRejected',
  MemberPayoutInfoPending = 'memberPayoutInfoPending',
  Na = 'na',
  ReadyToProcess = 'readyToProcess',
  Requested = 'requested'
}

export type RegCheckInDeviceResGql = {
  __typename?: 'RegCheckInDeviceResGql';
  checkInDevice?: Maybe<CheckInDevice>;
  jwt?: Maybe<Scalars['String']['output']>;
};

export type RegenerateRefundPayoutLinkInput = {
  refundPayoutRequestId: Scalars['Int']['input'];
};

export type RegisterMemberLoginKeyInput = {
  birthDate: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName: Scalars['String']['input'];
  hkid?: InputMaybe<Scalars['String']['input']>;
  membershipNo?: InputMaybe<Scalars['String']['input']>;
  mobileTel: Scalars['String']['input'];
  mobileTelAreaCode: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export type RejectCourseEnrolmentInput = {
  courseId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type RejectLessonEnrolmentInput = {
  courseId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type RejectRefundPayoutRequestInput = {
  reason: Scalars['String']['input'];
  refundPayoutRequestId: Scalars['Int']['input'];
};

export enum RelationshipType {
  Child = 'child',
  Parent = 'parent',
  Spouse = 'spouse'
}

export type RemoveAgreementFromLockerHistoryInput = {
  agreementMyfileId: Scalars['Int']['input'];
  lockerHistoryId: Scalars['Int']['input'];
};

export type RemoveGpTokenPairInput = {
  gpTokenId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type RemoveItemFromCartInput = {
  cartType: CartType;
  memberId?: InputMaybe<Scalars['Float']['input']>;
  myorderId?: InputMaybe<Scalars['Int']['input']>;
  myorderItemId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Float']['input']>;
};

export type RemoveProductFromWarehouseStockTakeInput = {
  warehouseStockTakeId: Scalars['Int']['input'];
  warehouseStockTakeProductId: Scalars['Int']['input'];
};

export type RemoveTotpInput = {
  totpId: Scalars['Float']['input'];
};

export type ReplaceDocxTemplateFileInput = {
  id: Scalars['Int']['input'];
  uploadFileInput: UploadFileInput;
};

export type RequestRefundPayoutInput = {
  refundMyorderId: Scalars['Int']['input'];
  requestReason: Scalars['String']['input'];
};

export type ResetMemberPasswordInput = {
  memberId: Scalars['Int']['input'];
};

export type ResetMemberPasswordResGql = {
  __typename?: 'ResetMemberPasswordResGql';
  newPassword: Scalars['String']['output'];
};

export type ResyncCourseAutoAddMemberListInput = {
  courseId: Scalars['Int']['input'];
};

export type ReturnShipmentInput = {
  myorderItemId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
  returnAsScraped: Scalars['Boolean']['input'];
  warehousePartitionId?: InputMaybe<Scalars['Int']['input']>;
};

export type RoleTemplate = {
  __typename?: 'RoleTemplate';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nonStandardDeptRelList?: Maybe<Array<RoleTemplateDepartmentRel>>;
  orderDeptRelList?: Maybe<Array<RoleTemplateDepartmentRel>>;
  readDeptRelList?: Maybe<Array<RoleTemplateDepartmentRel>>;
  roleList?: Maybe<Array<RoleTemplateUserRole>>;
  updatedDate: Scalars['String']['output'];
  warehouseList?: Maybe<Array<Warehouse>>;
  writeDeptRelList?: Maybe<Array<RoleTemplateDepartmentRel>>;
};

export type RoleTemplateDepartmentRel = {
  __typename?: 'RoleTemplateDepartmentRel';
  department?: Maybe<Department>;
  deptId: Scalars['Int']['output'];
  domain: UserDeptListDomain;
  id: Scalars['Int']['output'];
  permissionType: PermissionType;
  roleTemplateId: Scalars['Int']['output'];
};

export type RoleTemplateUserRole = {
  __typename?: 'RoleTemplateUserRole';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  roleName: Scalars['String']['output'];
  roleTemplateId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export enum SalaryType {
  CourseSalary = 'courseSalary',
  HourlySalary = 'hourlySalary',
  LessonSalary = 'lessonSalary',
  None = 'none',
  PercentageOfLessonGrossProfit = 'percentageOfLessonGrossProfit'
}

export enum SalesChannel {
  App = 'app',
  Pos = 'pos',
  Web = 'web'
}

export type SalesReportItemTypePerDay = {
  __typename?: 'SalesReportItemTypePerDay';
  cutoffDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  itemType?: Maybe<Scalars['String']['output']>;
  myorderStatus: MyorderAllStatus;
  totalAmt: Scalars['Float']['output'];
  totalQty: Scalars['Int']['output'];
  warehouseId?: Maybe<Scalars['Int']['output']>;
};

export type SalesReportItemTypePerDayOneDayResGql = {
  __typename?: 'SalesReportItemTypePerDayOneDayResGql';
  cutoffDate: Scalars['String']['output'];
  net?: Maybe<SalesReportItemTypePerDay>;
  paymentConfirmedList: Array<SalesReportItemTypePerDay>;
  paymentConfirmedTotal?: Maybe<SalesReportItemTypePerDay>;
  refundedList: Array<SalesReportItemTypePerDay>;
  refundedTotal?: Maybe<SalesReportItemTypePerDay>;
  transferredList: Array<SalesReportItemTypePerDay>;
  transferredTotal?: Maybe<SalesReportItemTypePerDay>;
};

export type SalesReportItemTypePerDayOneWarehouseResGql = {
  __typename?: 'SalesReportItemTypePerDayOneWarehouseResGql';
  dataList: Array<SalesReportItemTypePerDayOneDayResGql>;
  warehouse?: Maybe<Warehouse>;
};

export type SalesReportItemTypePerDeptPerDay = {
  __typename?: 'SalesReportItemTypePerDeptPerDay';
  channel?: Maybe<SalesChannel>;
  cutoffDate: Scalars['String']['output'];
  deptId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  itemType?: Maybe<MyorderItemType>;
  myorderStatus: MyorderAllStatus;
  totalAmt: Scalars['Float']['output'];
  totalQty: Scalars['Int']['output'];
};

export type SalesReportItemTypePerDeptPerDayOneDayChannelResGql = {
  __typename?: 'SalesReportItemTypePerDeptPerDayOneDayChannelResGql';
  channel?: Maybe<SalesChannel>;
  dataList: Array<SalesReportItemTypePerDeptPerDay>;
};

export type SalesReportItemTypePerDeptPerDayOneDayChannelTotalResGql = {
  __typename?: 'SalesReportItemTypePerDeptPerDayOneDayChannelTotalResGql';
  channel?: Maybe<SalesChannel>;
  data?: Maybe<SalesReportItemTypePerDeptPerDay>;
};

export type SalesReportItemTypePerDeptPerDayOneDayResGql = {
  __typename?: 'SalesReportItemTypePerDeptPerDayOneDayResGql';
  cutoffDate: Scalars['String']['output'];
  netList: Array<SalesReportItemTypePerDeptPerDayOneDayChannelResGql>;
  paymentConfirmedList: Array<SalesReportItemTypePerDeptPerDayOneDayChannelResGql>;
  paymentConfirmedTotalList: Array<SalesReportItemTypePerDeptPerDayOneDayChannelTotalResGql>;
  refundedList: Array<SalesReportItemTypePerDeptPerDayOneDayChannelResGql>;
  refundedTotalList: Array<SalesReportItemTypePerDeptPerDayOneDayChannelTotalResGql>;
  transferredList: Array<SalesReportItemTypePerDeptPerDayOneDayChannelResGql>;
  transferredTotalList: Array<SalesReportItemTypePerDeptPerDayOneDayChannelTotalResGql>;
};

export type SalesReportItemTypePerDeptPerDayOneDeptResGql = {
  __typename?: 'SalesReportItemTypePerDeptPerDayOneDeptResGql';
  dataList: Array<SalesReportItemTypePerDeptPerDayOneDayResGql>;
  department?: Maybe<Department>;
};

export type SalesReportItemTypePerDeptPerMonth = {
  __typename?: 'SalesReportItemTypePerDeptPerMonth';
  channel?: Maybe<SalesChannel>;
  deptId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  itemType?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  myorderStatus: MyorderAllStatus;
  totalAmt: Scalars['Float']['output'];
  totalQty: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type SalesReportItemTypePerDeptPerMonthOneDeptResGql = {
  __typename?: 'SalesReportItemTypePerDeptPerMonthOneDeptResGql';
  dataList: Array<SalesReportItemTypePerDeptPerMonthOneMonthResGql>;
  department?: Maybe<Department>;
};

export type SalesReportItemTypePerDeptPerMonthOneMonthChannelResGql = {
  __typename?: 'SalesReportItemTypePerDeptPerMonthOneMonthChannelResGql';
  channel?: Maybe<SalesChannel>;
  dataList: Array<SalesReportItemTypePerDeptPerMonth>;
};

export type SalesReportItemTypePerDeptPerMonthOneMonthChannelTotalResGql = {
  __typename?: 'SalesReportItemTypePerDeptPerMonthOneMonthChannelTotalResGql';
  channel?: Maybe<SalesChannel>;
  data?: Maybe<SalesReportItemTypePerDeptPerMonth>;
};

export type SalesReportItemTypePerDeptPerMonthOneMonthResGql = {
  __typename?: 'SalesReportItemTypePerDeptPerMonthOneMonthResGql';
  month: Scalars['Float']['output'];
  netList: Array<SalesReportItemTypePerDeptPerMonthOneMonthChannelResGql>;
  paymentConfirmedList: Array<SalesReportItemTypePerDeptPerMonthOneMonthChannelResGql>;
  paymentConfirmedTotalList: Array<SalesReportItemTypePerDeptPerMonthOneMonthChannelTotalResGql>;
  refundedList: Array<SalesReportItemTypePerDeptPerMonthOneMonthChannelResGql>;
  refundedTotalList: Array<SalesReportItemTypePerDeptPerMonthOneMonthChannelTotalResGql>;
  transferredList: Array<SalesReportItemTypePerDeptPerMonthOneMonthChannelResGql>;
  transferredTotalList: Array<SalesReportItemTypePerDeptPerMonthOneMonthChannelTotalResGql>;
  year: Scalars['Float']['output'];
};

export type SalesReportItemTypePerMonth = {
  __typename?: 'SalesReportItemTypePerMonth';
  id: Scalars['Int']['output'];
  itemType?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  myorderStatus: MyorderAllStatus;
  totalAmt: Scalars['Float']['output'];
  totalQty: Scalars['Int']['output'];
  warehouseId?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export type SalesReportItemTypePerMonthOneMonthResGql = {
  __typename?: 'SalesReportItemTypePerMonthOneMonthResGql';
  month: Scalars['Float']['output'];
  net?: Maybe<SalesReportItemTypePerMonth>;
  paymentConfirmedList: Array<SalesReportItemTypePerMonth>;
  paymentConfirmedTotal?: Maybe<SalesReportItemTypePerMonth>;
  refundedList: Array<SalesReportItemTypePerMonth>;
  refundedTotal?: Maybe<SalesReportItemTypePerMonth>;
  transferredList: Array<SalesReportItemTypePerMonth>;
  transferredTotal?: Maybe<SalesReportItemTypePerMonth>;
  year: Scalars['Float']['output'];
};

export type SalesReportItemTypePerMonthOneWarehouseResGql = {
  __typename?: 'SalesReportItemTypePerMonthOneWarehouseResGql';
  dataList: Array<SalesReportItemTypePerMonthOneMonthResGql>;
  warehouse?: Maybe<Warehouse>;
};

export type SalesReportPaymentMethodPerDay = {
  __typename?: 'SalesReportPaymentMethodPerDay';
  cutoffDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  myorderStatus: MyorderAllStatus;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  totalAmt: Scalars['Float']['output'];
  totalQty: Scalars['Float']['output'];
  warehouseId?: Maybe<Scalars['Float']['output']>;
};

export type SalesReportPaymentMethodPerDayOneDayResGql = {
  __typename?: 'SalesReportPaymentMethodPerDayOneDayResGql';
  cutoffDate: Scalars['String']['output'];
  net?: Maybe<SalesReportPaymentMethodPerDay>;
  paymentConfirmedList: Array<SalesReportPaymentMethodPerDay>;
  paymentConfirmedTotal?: Maybe<SalesReportPaymentMethodPerDay>;
  refundedList: Array<SalesReportPaymentMethodPerDay>;
  refundedTotal?: Maybe<SalesReportPaymentMethodPerDay>;
  transferredList: Array<SalesReportPaymentMethodPerDay>;
  transferredTotal?: Maybe<SalesReportPaymentMethodPerDay>;
};

export type SalesReportPaymentMethodPerDayOneWarehouseResGql = {
  __typename?: 'SalesReportPaymentMethodPerDayOneWarehouseResGql';
  dataList: Array<SalesReportPaymentMethodPerDayOneDayResGql>;
  warehouse?: Maybe<Warehouse>;
};

export type SalesReportPaymentMethodPerMonth = {
  __typename?: 'SalesReportPaymentMethodPerMonth';
  id: Scalars['Int']['output'];
  month?: Maybe<Scalars['Float']['output']>;
  myorderStatus: MyorderAllStatus;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  totalAmt: Scalars['Float']['output'];
  totalQty: Scalars['Float']['output'];
  warehouseId?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Float']['output'];
};

export type SalesReportPaymentMethodPerMonthOneMonthResGql = {
  __typename?: 'SalesReportPaymentMethodPerMonthOneMonthResGql';
  month: Scalars['Float']['output'];
  net?: Maybe<SalesReportPaymentMethodPerMonth>;
  paymentConfirmedList: Array<SalesReportPaymentMethodPerMonth>;
  paymentConfirmedTotal?: Maybe<SalesReportPaymentMethodPerMonth>;
  refundedList: Array<SalesReportPaymentMethodPerMonth>;
  refundedTotal?: Maybe<SalesReportPaymentMethodPerMonth>;
  transferredList: Array<SalesReportPaymentMethodPerMonth>;
  transferredTotal?: Maybe<SalesReportPaymentMethodPerMonth>;
  year: Scalars['Float']['output'];
};

export type SalesReportPaymentMethodPerMonthOneWarehouseResGql = {
  __typename?: 'SalesReportPaymentMethodPerMonthOneWarehouseResGql';
  dataList: Array<SalesReportPaymentMethodPerMonthOneMonthResGql>;
  warehouse?: Maybe<Warehouse>;
};

export type ScaaExportCoachMonthlySalaryCsvToFtpInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type ScaaGetMemCommissionReportInput = {
  endCutoffDate: Scalars['String']['input'];
  forceRecal?: Scalars['Boolean']['input'];
  startCutoffDate: Scalars['String']['input'];
};

export type ScaaGetMemCommissionReportPerItemResGql = {
  __typename?: 'ScaaGetMemCommissionReportPerItemResGql';
  itemType?: Maybe<MyorderItemType>;
  totalAmt: Scalars['Float']['output'];
  totalQty: Scalars['Int']['output'];
};

export type ScaaGetMemCommissionReportResGql = {
  __typename?: 'ScaaGetMemCommissionReportResGql';
  department: Department;
  offlineDataList: Array<ScaaGetMemCommissionReportPerItemResGql>;
  onlineDataList: Array<ScaaGetMemCommissionReportPerItemResGql>;
};

export type SearchAccessPassHistoryInput = {
  andCondList?: Array<QueryCondAccessPassHistoryInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondAccessPassHistoryInput>;
  orderBy?: InputMaybe<QueryOrderByAccessPassHistoryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByAccessPassHistoryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchAccessPassHistoryResGql = {
  __typename?: 'SearchAccessPassHistoryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<AccessPassHistory>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchAccessPassInput = {
  andCondList?: Array<QueryCondAccessPassInput>;
  forDepositBalance?: Scalars['Boolean']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondAccessPassInput>;
  orderBy?: InputMaybe<QueryOrderByAccessPassInput>;
  orderByList?: InputMaybe<Array<QueryOrderByAccessPassInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchAccessPassResGql = {
  __typename?: 'SearchAccessPassResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<AccessPass>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchAcctProductCatInput = {
  andCondList?: Array<QueryCondAcctProductCatInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondAcctProductCatInput>;
  orderBy?: InputMaybe<QueryOrderByAcctProductCatInput>;
  orderByList?: InputMaybe<Array<QueryOrderByAcctProductCatInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchAcctProductCatResGql = {
  __typename?: 'SearchAcctProductCatResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<AcctProductCat>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchAuditLogInput = {
  andCondList?: Array<QueryCondAuditLogInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondAuditLogInput>;
  orderBy?: InputMaybe<QueryOrderByAuditLogInput>;
  orderByList?: InputMaybe<Array<QueryOrderByAuditLogInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchAuditLogResGql = {
  __typename?: 'SearchAuditLogResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<AuditLog>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchBlackoutInput = {
  andCondList?: Array<QueryCondBlackoutInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondBlackoutInput>;
  orderBy?: InputMaybe<QueryOrderByBlackoutInput>;
  orderByList?: InputMaybe<Array<QueryOrderByBlackoutInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchBlackoutResGql = {
  __typename?: 'SearchBlackoutResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<FacilityBlackout>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchBonusPointEarningRuleInput = {
  andCondList?: Array<QueryCondBonusPointEarningRuleInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondBonusPointEarningRuleInput>;
  orderBy?: InputMaybe<QueryOrderByBonusPointEarningRuleInput>;
  orderByList?: InputMaybe<Array<QueryOrderByBonusPointEarningRuleInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchBonusPointEarningRuleResGql = {
  __typename?: 'SearchBonusPointEarningRuleResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<BonusPointEarningRule>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchBonusPointItemTypeEarningRatioInput = {
  andCondList?: Array<QueryCondBonusPointItemTypeEarningRatioInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondBonusPointItemTypeEarningRatioInput>;
  orderBy?: InputMaybe<QueryOrderByBonusPointItemTypeEarningRatioInput>;
  orderByList?: InputMaybe<Array<QueryOrderByBonusPointItemTypeEarningRatioInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchBonusPointItemTypeEarningRatioResGql = {
  __typename?: 'SearchBonusPointItemTypeEarningRatioResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<BonusPointItemTypeEarningRatio>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchBonusPointReceiptRegInput = {
  andCondList?: Array<QueryCondBonusPointReceiptRegInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondBonusPointReceiptRegInput>;
  orderBy?: InputMaybe<QueryOrderByBonusPointReceiptRegInput>;
  orderByList?: InputMaybe<Array<QueryOrderByBonusPointReceiptRegInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchBonusPointReceiptRegResGql = {
  __typename?: 'SearchBonusPointReceiptRegResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<BonusPointReceiptReg>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchBonusPointRedeemPromotionGroupInput = {
  andCondList?: Array<QueryCondBonusPointRedeemPromotionGroupInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondBonusPointRedeemPromotionGroupInput>;
  orderBy?: InputMaybe<QueryOrderByBonusPointRedeemPromotionGroupInput>;
  orderByList?: InputMaybe<Array<QueryOrderByBonusPointRedeemPromotionGroupInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchBonusPointRedeemPromotionGroupResGql = {
  __typename?: 'SearchBonusPointRedeemPromotionGroupResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<BonusPointRedeemPromotionGroup>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchBonusPointTxInput = {
  andCondList?: Array<QueryCondBonusPointTxInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondBonusPointTxInput>;
  orderBy?: InputMaybe<QueryOrderByBonusPointTxInput>;
  orderByList?: InputMaybe<Array<QueryOrderByBonusPointTxInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchBonusPointTxResGql = {
  __typename?: 'SearchBonusPointTxResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<BonusPointTx>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchBullQueueInput = {
  noOfItemsPerPage?: Scalars['Int']['input'];
  pageNo?: Scalars['Int']['input'];
  statusList?: Array<BullQueueStatus>;
};

export type SearchCheckInDeviceInput = {
  andCondList?: Array<QueryCondCheckInDeviceInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCheckInDeviceInput>;
  orderBy?: InputMaybe<QueryOrderByCheckInDeviceInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCheckInDeviceInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCheckInDeviceResGql = {
  __typename?: 'SearchCheckInDeviceResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CheckInDevice>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCoachServiceInput = {
  andCondList?: Array<QueryCondCoachServiceInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCoachServiceInput>;
  orderBy?: InputMaybe<QueryOrderByCoachServiceInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCoachServiceInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCoachServiceResGql = {
  __typename?: 'SearchCoachServiceResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CoachService>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCoachTimeslotInput = {
  andCondList?: Array<QueryCondCoachTimeslotInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCoachTimeslotInput>;
  orderBy?: InputMaybe<QueryOrderByCoachTimeslotInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCoachTimeslotInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCoachTimeslotResGql = {
  __typename?: 'SearchCoachTimeslotResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CoachTimeslot>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCommitteeHistoryInput = {
  andCondList?: Array<QueryCondCommitteeHistoryInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCommitteeHistoryInput>;
  orderBy?: InputMaybe<QueryOrderByCommitteeHistoryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCommitteeHistoryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCommitteeHistoryResGql = {
  __typename?: 'SearchCommitteeHistoryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CommitteeHistory>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCommitteeInput = {
  andCondList?: Array<QueryCondCommitteeInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCommitteeInput>;
  orderBy?: InputMaybe<QueryOrderByCommitteeInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCommitteeInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCommitteePositionInput = {
  andCondList?: Array<QueryCondCommitteePositionInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCommitteePositionInput>;
  orderBy?: InputMaybe<QueryOrderByCommitteePositionInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCommitteePositionInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCommitteePositionResGql = {
  __typename?: 'SearchCommitteePositionResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CommitteePosition>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCommitteeResGql = {
  __typename?: 'SearchCommitteeResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Committee>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchContactInput = {
  andCondList?: Array<QueryCondContactInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondContactInput>;
  orderBy?: InputMaybe<QueryOrderByContactInput>;
  orderByList?: InputMaybe<Array<QueryOrderByContactInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchContactResGql = {
  __typename?: 'SearchContactResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Contact>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCouponPackageInput = {
  andCondList?: Array<QueryCondCouponPackageInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCouponPackageInput>;
  orderBy?: InputMaybe<QueryOrderByCouponPackageInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCouponPackageInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCouponPackageInstanceInput = {
  andCondList?: Array<QueryCondCouponPackageInstanceInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCouponPackageInstanceInput>;
  orderBy?: InputMaybe<QueryOrderByCouponPackageInstanceInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCouponPackageInstanceInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCouponPackageInstanceResGql = {
  __typename?: 'SearchCouponPackageInstanceResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CouponPackageInstance>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCouponPackageInstanceUsageHistoryInput = {
  andCondList?: Array<QueryCondCouponPackageInstanceUsageHistoryInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCouponPackageInstanceUsageHistoryInput>;
  orderBy?: InputMaybe<QueryOrderByCouponPackageInstanceUsageHistoryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCouponPackageInstanceUsageHistoryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCouponPackageInstanceUsageHistoryResGql = {
  __typename?: 'SearchCouponPackageInstanceUsageHistoryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CouponPackageInstanceUsageHistory>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCouponPackageResGql = {
  __typename?: 'SearchCouponPackageResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CouponPackage>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum SearchCourseAgeGroup {
  Adult = 'adult',
  Kids = 'kids',
  Toddler = 'toddler',
  Youth = 'youth'
}

export type SearchCourseApplyQuotaPeriodInput = {
  andCondList?: Array<QueryCondCourseApplyQuotaPeriodInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCourseApplyQuotaPeriodInput>;
  orderBy?: InputMaybe<QueryOrderByCourseApplyQuotaPeriodInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCourseApplyQuotaPeriodInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCourseApplyQuotaPeriodResGql = {
  __typename?: 'SearchCourseApplyQuotaPeriodResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CourseApplyQuotaPeriod>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCourseCustomInput = {
  ageGroupList?: Array<SearchCourseAgeGroup>;
  code?: InputMaybe<Scalars['String']['input']>;
  courseName?: InputMaybe<Scalars['String']['input']>;
  courseTypeIdList?: Array<Scalars['Int']['input']>;
  dayOfWeekList?: Array<Scalars['Int']['input']>;
  deptIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  effectiveStartDateBegin?: InputMaybe<Scalars['String']['input']>;
  effectiveStartDateEnd?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  enrolmentEndDateForMemberBegin?: InputMaybe<Scalars['String']['input']>;
  enrolmentEndDateForMemberEnd?: InputMaybe<Scalars['String']['input']>;
  enrolmentType?: InputMaybe<CourseEnrolmentType>;
  gender?: CourseSearchGender;
  genderList?: Array<FilterGender>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isTrial?: Scalars['Boolean']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  locationAreaIdList?: Array<Scalars['Int']['input']>;
  locationIdList?: Array<Scalars['Int']['input']>;
  maxAge?: InputMaybe<Scalars['Float']['input']>;
  minAge?: InputMaybe<Scalars['Float']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: SearchCourseCustomOrderBy;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
  sportTypeGroupIdList?: Array<Scalars['Int']['input']>;
  sportTypeIdList?: Array<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  timeGroupList?: Array<SearchCourseTimeGroup>;
  trialInvitationCode?: Scalars['String']['input'];
  withQuotaOnly?: InputMaybe<Scalars['Boolean']['input']>;
  withWaitingList?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SearchCourseCustomOrderBy {
  Age = 'age',
  Code = 'code',
  Date = 'date',
  DateAsc = 'dateAsc',
  DateDesc = 'dateDesc',
  FeatureOrderId = 'featureOrderId',
  IdAsc = 'idAsc',
  IdDesc = 'idDesc',
  PriceAsc = 'priceAsc',
  PriceDesc = 'priceDesc',
  QuotaAsc = 'quotaAsc',
  QuotaDesc = 'quotaDesc',
  Time = 'time'
}

export type SearchCourseEnrolmentInput = {
  andCondList?: Array<QueryCondCourseEnrolmentInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCourseEnrolmentInput>;
  orderBy?: InputMaybe<QueryOrderByCourseEnrolmentInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCourseEnrolmentInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCourseEnrolmentResGql = {
  __typename?: 'SearchCourseEnrolmentResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CourseEnrolment>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCourseInput = {
  andCondList?: Array<QueryCondCourseInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCourseInput>;
  orderBy?: InputMaybe<QueryOrderByCourseInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCourseInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCourseResGql = {
  __typename?: 'SearchCourseResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Course>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum SearchCourseTimeGroup {
  AfterWork = 'afterWork',
  Afternoon = 'afternoon',
  Morning = 'morning'
}

export type SearchCourseTypeInput = {
  andCondList?: Array<QueryCondCourseTypeInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCourseTypeInput>;
  orderBy?: InputMaybe<QueryOrderByCourseTypeInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCourseTypeInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCourseTypeResGql = {
  __typename?: 'SearchCourseTypeResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CourseType>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCreditPackageInput = {
  andCondList?: Array<QueryCondCreditPackageInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCreditPackageInput>;
  orderBy?: InputMaybe<QueryOrderByCreditPackageInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCreditPackageInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCreditPackageResGql = {
  __typename?: 'SearchCreditPackageResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CreditPackage>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCreditTxInput = {
  andCondList?: Array<QueryCondCreditTxInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCreditTxInput>;
  orderBy?: InputMaybe<QueryOrderByCreditTxInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCreditTxInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCreditTxResGql = {
  __typename?: 'SearchCreditTxResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CreditTx>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCreditTypeInput = {
  andCondList?: Array<QueryCondCreditTypeInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondCreditTypeInput>;
  orderBy?: InputMaybe<QueryOrderByCreditTypeInput>;
  orderByList?: InputMaybe<Array<QueryOrderByCreditTypeInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchCreditTypeResGql = {
  __typename?: 'SearchCreditTypeResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<CreditType>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchDeliveryNoteInput = {
  andCondList?: Array<QueryCondDeliveryNoteInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondDeliveryNoteInput>;
  orderBy?: InputMaybe<QueryOrderByDeliveryNoteInput>;
  orderByList?: InputMaybe<Array<QueryOrderByDeliveryNoteInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchDeliveryNoteResGql = {
  __typename?: 'SearchDeliveryNoteResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<DeliveryNote>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchDepartmentInput = {
  andCondList?: Array<QueryCondDepartmentInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondDepartmentInput>;
  orderBy?: InputMaybe<QueryOrderByDepartmentInput>;
  orderByList?: InputMaybe<Array<QueryOrderByDepartmentInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
  withWarehouseOnly?: Scalars['Boolean']['input'];
};

export type SearchDepartmentResGql = {
  __typename?: 'SearchDepartmentResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Department>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchDepositHistoryInput = {
  andCondList?: Array<QueryCondDepositInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondDepositInput>;
  orderBy?: InputMaybe<QueryOrderByDepositInput>;
  orderByList?: InputMaybe<Array<QueryOrderByDepositInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchDepositHistoryResGql = {
  __typename?: 'SearchDepositHistoryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<DepositHistory>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchDeptBorrowSummaryInput = {
  andCondList?: Array<QueryCondDeptBorrowSummaryInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondDeptBorrowSummaryInput>;
  orderBy?: InputMaybe<QueryOrderByDeptBorrowSummaryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByDeptBorrowSummaryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchDeptBorrowSummaryResGql = {
  __typename?: 'SearchDeptBorrowSummaryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<DeptBorrowSummary>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchDocxTemplateInput = {
  andCondList?: Array<QueryCondDocxTemplateInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondDocxTemplateInput>;
  orderBy?: InputMaybe<QueryOrderByDocxTemplateInput>;
  orderByList?: InputMaybe<Array<QueryOrderByDocxTemplateInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchDocxTemplateResGql = {
  __typename?: 'SearchDocxTemplateResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<DocxTemplate>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchDriveDepositHistoryInput = {
  andCondList?: Array<QueryCondDriveDepositHistoryInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondDriveDepositHistoryInput>;
  orderBy?: InputMaybe<QueryOrderByDriveDepositHistoryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByDriveDepositHistoryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchDriveDepositHistoryResGql = {
  __typename?: 'SearchDriveDepositHistoryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<DriveDepositHistory>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchDriveScoreHistoryInput = {
  andCondList?: Array<QueryCondDriveScoreHistoryInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondDriveScoreHistoryInput>;
  orderBy?: InputMaybe<QueryOrderByDriveScoreHistoryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByDriveScoreHistoryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchDriveScoreHistoryResGql = {
  __typename?: 'SearchDriveScoreHistoryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<DriveScoreHistory>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchDriveTeamInput = {
  andCondList?: Array<QueryCondDriveTeamInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondDriveTeamInput>;
  orderBy?: InputMaybe<QueryOrderByDriveTeamInput>;
  orderByList?: InputMaybe<Array<QueryOrderByDriveTeamInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchDriveTeamResGql = {
  __typename?: 'SearchDriveTeamResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<DriveTeam>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchDynamicQrCodeInput = {
  andCondList?: Array<QueryCondDynamicQrCodeInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondDynamicQrCodeInput>;
  orderBy?: InputMaybe<QueryOrderByDynamicQrCodeInput>;
  orderByList?: InputMaybe<Array<QueryOrderByDynamicQrCodeInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchDynamicQrCodeResGql = {
  __typename?: 'SearchDynamicQrCodeResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<DynamicQrCode>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchFabFloorplanInput = {
  andCondList?: Array<QueryCondFabFloorplanInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondFabFloorplanInput>;
  orderBy?: InputMaybe<QueryOrderByFabFloorplanInput>;
  orderByList?: InputMaybe<Array<QueryOrderByFabFloorplanInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchFabFloorplanResGql = {
  __typename?: 'SearchFabFloorplanResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<FabFloorplan>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchFabReservationInput = {
  andCondList?: Array<QueryCondFabReservationInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondFabReservationInput>;
  orderBy?: InputMaybe<QueryOrderByFabReservationInput>;
  orderByList?: InputMaybe<Array<QueryOrderByFabReservationInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchFabReservationResGql = {
  __typename?: 'SearchFabReservationResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<FabReservation>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchFacilityAccessLogInput = {
  andCondList?: Array<QueryCondFacilityAccessLogInput>;
  inDateRange?: InputMaybe<Array<Scalars['String']['input']>>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondFacilityAccessLogInput>;
  orderBy?: InputMaybe<QueryOrderByFacilityAccessLogInput>;
  orderByList?: InputMaybe<Array<QueryOrderByFacilityAccessLogInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
  userManagedFacilityOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchFacilityAccessLogResGql = {
  __typename?: 'SearchFacilityAccessLogResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<FacilityAccessLog>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchFacilityBookingInput = {
  andCondList?: Array<QueryCondFacilityBookingInput>;
  inDateRange?: InputMaybe<Array<Scalars['String']['input']>>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondFacilityBookingInput>;
  orderBy?: InputMaybe<QueryOrderByFacilityBookingInput>;
  orderByList?: InputMaybe<Array<QueryOrderByFacilityBookingInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
  userManagedFacilityOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchFacilityBookingResGql = {
  __typename?: 'SearchFacilityBookingResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<FacilityBooking>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchFacilityInput = {
  andCondList?: Array<QueryCondFacilityInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondFacilityInput>;
  orderBy?: InputMaybe<QueryOrderByFacilityInput>;
  orderByList?: InputMaybe<Array<QueryOrderByFacilityInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchFacilityResGql = {
  __typename?: 'SearchFacilityResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Facility>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchGoodsReceiveNoteInput = {
  andCondList?: Array<QueryCondGoodsReceiveNoteInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondGoodsReceiveNoteInput>;
  orderBy?: InputMaybe<QueryOrderByGoodsReceiveNoteInput>;
  orderByList?: InputMaybe<Array<QueryOrderByGoodsReceiveNoteInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchGoodsReceiveNoteResGql = {
  __typename?: 'SearchGoodsReceiveNoteResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<GoodsReceiveNote>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchGpTokenInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  andCondList?: Array<QueryCondGpTokenInput>;
  contactableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondGpTokenInput>;
  orderBy?: InputMaybe<QueryOrderByGpTokenInput>;
  orderByList?: InputMaybe<Array<QueryOrderByGpTokenInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchGpTokenResGql = {
  __typename?: 'SearchGpTokenResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<GpToken>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchHolidayInput = {
  andCondList?: Array<QueryCondHolidayInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondHolidayInput>;
  orderBy?: InputMaybe<QueryOrderByHolidayInput>;
  orderByList?: InputMaybe<Array<QueryOrderByHolidayInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchHolidayResGql = {
  __typename?: 'SearchHolidayResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Holiday>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchInventoryRequestTxInput = {
  andCondList?: Array<QueryCondInventoryRequestTxInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondInventoryRequestTxInput>;
  orderBy?: InputMaybe<QueryOrderByInventoryRequestTxInput>;
  orderByList?: InputMaybe<Array<QueryOrderByInventoryRequestTxInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchInventoryRequestTxResGql = {
  __typename?: 'SearchInventoryRequestTxResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<InventoryRequestTx>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchInventoryTxCountInput = {
  andCondList?: Array<QueryCondInventoryTxCountInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondInventoryTxCountInput>;
  orderBy?: InputMaybe<QueryOrderByInventoryTxCountInput>;
  orderByList?: InputMaybe<Array<QueryOrderByInventoryTxCountInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchInventoryTxCountResGql = {
  __typename?: 'SearchInventoryTxCountResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<InventoryTxCount>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchInventoryTxGroupInput = {
  andCondList?: Array<QueryCondInventoryTxGroupInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondInventoryTxGroupInput>;
  orderBy?: InputMaybe<QueryOrderByInventoryTxGroupInput>;
  orderByList?: InputMaybe<Array<QueryOrderByInventoryTxGroupInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchInventoryTxGroupResGql = {
  __typename?: 'SearchInventoryTxGroupResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<InventoryTxGroup>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchKwtdhcEventInput = {
  andCondList?: Array<QueryCondKwtdhcEventInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondKwtdhcEventInput>;
  orderBy?: InputMaybe<QueryOrderByKwtdhcEventInput>;
  orderByList?: InputMaybe<Array<QueryOrderByKwtdhcEventInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchKwtdhcEventResGql = {
  __typename?: 'SearchKwtdhcEventResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<KwtdhcEvent>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchKwtdhcMemberFollowupInput = {
  andCondList?: Array<QueryCondKwtdhcMemberFollowupInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondKwtdhcMemberFollowupInput>;
  orderBy?: InputMaybe<QueryOrderByKwtdhcMemberFollowupInput>;
  orderByList?: InputMaybe<Array<QueryOrderByKwtdhcMemberFollowupInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchKwtdhcMemberFollowupResGql = {
  __typename?: 'SearchKwtdhcMemberFollowupResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<KwtdhcMemberFollowup>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchLessonCoachInput = {
  andCondList?: Array<QueryCondLessonCoachInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondLessonCoachInput>;
  orderBy?: InputMaybe<QueryOrderByLessonCoachInput>;
  orderByList?: InputMaybe<Array<QueryOrderByLessonCoachInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchLessonCoachResGql = {
  __typename?: 'SearchLessonCoachResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<LessonCoach>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchLessonEnrolmentInput = {
  andCondList?: Array<QueryCondLessonEnrolmentInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondLessonEnrolmentInput>;
  orderBy?: InputMaybe<QueryOrderByLessonEnrolmentInput>;
  orderByList?: InputMaybe<Array<QueryOrderByLessonEnrolmentInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchLessonEnrolmentResGql = {
  __typename?: 'SearchLessonEnrolmentResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<LessonEnrolment>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchLessonInput = {
  andCondList?: Array<QueryCondLessonInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondLessonInput>;
  orderBy?: InputMaybe<QueryOrderByLessonInput>;
  orderByList?: InputMaybe<Array<QueryOrderByLessonInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchLessonResGql = {
  __typename?: 'SearchLessonResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Lesson>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchLocationAreaInput = {
  andCondList?: Array<QueryCondLocationAreaInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondLocationAreaInput>;
  orderBy?: InputMaybe<QueryOrderByLocationAreaInput>;
  orderByList?: InputMaybe<Array<QueryOrderByLocationAreaInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchLocationAreaResGql = {
  __typename?: 'SearchLocationAreaResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<LocationArea>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchLocationInput = {
  andCondList?: Array<QueryCondLocationInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondLocationInput>;
  orderBy?: InputMaybe<QueryOrderByLocationInput>;
  orderByList?: InputMaybe<Array<QueryOrderByLocationInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchLocationResGql = {
  __typename?: 'SearchLocationResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Location>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchLockerGroupInput = {
  andCondList?: Array<QueryCondLockerGroupInput>;
  forDepositBalance?: Scalars['Boolean']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondLockerGroupInput>;
  orderBy?: InputMaybe<QueryOrderByLockerGroupInput>;
  orderByList?: InputMaybe<Array<QueryOrderByLockerGroupInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchLockerGroupResGql = {
  __typename?: 'SearchLockerGroupResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<LockerGroup>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchLockerHistoryInput = {
  andCondList?: Array<QueryCondLockerHistoryInput>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondLockerHistoryInput>;
  orderBy?: InputMaybe<QueryOrderByLockerHistoryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByLockerHistoryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type SearchLockerHistoryResGql = {
  __typename?: 'SearchLockerHistoryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<LockerHistory>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchLockerTypeInput = {
  andCondList?: Array<QueryCondLockerTypeInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondLockerTypeInput>;
  orderBy?: InputMaybe<QueryOrderByLockerTypeInput>;
  orderByList?: InputMaybe<Array<QueryOrderByLockerTypeInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchLockerTypeResGql = {
  __typename?: 'SearchLockerTypeResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<LockerType>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberFacialInput = {
  andCondList?: Array<QueryCondMemberFacialInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberFacialInput>;
  orderBy?: InputMaybe<QueryOrderByMemberFacialInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberFacialInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberFacialResGql = {
  __typename?: 'SearchMemberFacialResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MemberFacial>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberHdtBgInput = {
  andCondList?: Array<QueryCondMemberHdtBgInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberHdtBgInput>;
  orderBy?: InputMaybe<QueryOrderByMemberHdtBgInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberHdtBgInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberHdtBgResGql = {
  __typename?: 'SearchMemberHdtBgResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MemberHdtBg>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberHdtBpHrInput = {
  andCondList?: Array<QueryCondMemberHdtBpHrInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberHdtBpHrInput>;
  orderBy?: InputMaybe<QueryOrderByMemberHdtBpHrInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberHdtBpHrInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberHdtBpHrResGql = {
  __typename?: 'SearchMemberHdtBpHrResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MemberHdtBpHr>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberHdtBtInput = {
  andCondList?: Array<QueryCondMemberHdtBtInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberHdtBtInput>;
  orderBy?: InputMaybe<QueryOrderByMemberHdtBtInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberHdtBtInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberHdtBtResGql = {
  __typename?: 'SearchMemberHdtBtResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MemberHdtBt>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberHdtBwBhBmiInput = {
  andCondList?: Array<QueryCondMemberHdtBwBhBmiInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberHdtBwBhBmiInput>;
  orderBy?: InputMaybe<QueryOrderByMemberHdtBwBhBmiInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberHdtBwBhBmiInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberHdtBwBhBmiResGql = {
  __typename?: 'SearchMemberHdtBwBhBmiResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MemberHdtBwBhBmi>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberHdtSpo2HrInput = {
  andCondList?: Array<QueryCondMemberHdtSpo2HrInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberHdtSpo2HrInput>;
  orderBy?: InputMaybe<QueryOrderByMemberHdtSpo2HrInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberHdtSpo2HrInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberHdtSpo2HrResGql = {
  __typename?: 'SearchMemberHdtSpo2HrResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MemberHdtSpo2Hr>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  andCondList?: Array<QueryCondMemberInput>;
  contactableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hdtCaptureEndDate?: InputMaybe<Scalars['String']['input']>;
  hdtCaptureStartDate?: InputMaybe<Scalars['String']['input']>;
  newOrOldMembershipNo?: InputMaybe<Scalars['String']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberInput>;
  orderBy?: InputMaybe<QueryOrderByMemberInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
  withValidParQOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchMemberListInput = {
  andCondList?: Array<QueryCondMemberListInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberListInput>;
  orderBy?: InputMaybe<QueryOrderByMemberListInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberListInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberListResGql = {
  __typename?: 'SearchMemberListResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MemberList>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberLotteryGroupScoreOverrideInput = {
  andCondList?: Array<QueryCondMemberLotteryGroupScoreOverrideInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberLotteryGroupScoreOverrideInput>;
  orderBy?: InputMaybe<QueryOrderByMemberLotteryGroupScoreOverrideInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberLotteryGroupScoreOverrideInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberLotteryGroupScoreOverrideResGql = {
  __typename?: 'SearchMemberLotteryGroupScoreOverrideResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MemberLotteryGroupScoreOverride>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberMsgQueueInput = {
  andCondList?: Array<QueryCondMsgQueueInput>;
  memberId: Scalars['Int']['input'];
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMsgQueueInput>;
  orderBy?: InputMaybe<QueryOrderByMsgQueueInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMsgQueueInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberParQInput = {
  andCondList?: Array<QueryCondMemberParQInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberParQInput>;
  orderBy?: InputMaybe<QueryOrderByMemberParQInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberParQInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMemberParQResGql = {
  __typename?: 'SearchMemberParQResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MemberParQ>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMemberResGql = {
  __typename?: 'SearchMemberResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Member>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMembershipHistoryInput = {
  andCondList?: Array<QueryCondMembershipHistoryInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMembershipHistoryInput>;
  orderBy?: InputMaybe<QueryOrderByMembershipHistoryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMembershipHistoryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMembershipHistoryResGql = {
  __typename?: 'SearchMembershipHistoryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MembershipHistory>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMembershipTypeInput = {
  andCondList?: Array<QueryCondMembershipTypeInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMembershipTypeInput>;
  orderBy?: InputMaybe<QueryOrderByMembershipTypeInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMembershipTypeInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMembershipTypeResGql = {
  __typename?: 'SearchMembershipTypeResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MembershipType>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMiniSiteContentInput = {
  andCondList?: Array<QueryCondMiniSiteContentInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMiniSiteContentInput>;
  orderBy?: InputMaybe<QueryOrderByMiniSiteContentInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMiniSiteContentInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMiniSiteContentResGql = {
  __typename?: 'SearchMiniSiteContentResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MiniSiteContent>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMsgQueueInput = {
  andCondList?: Array<QueryCondMsgQueueInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMsgQueueInput>;
  orderBy?: InputMaybe<QueryOrderByMsgQueueInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMsgQueueInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMsgQueueResGql = {
  __typename?: 'SearchMsgQueueResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MsgQueue>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum SearchMyEventAgeGroup {
  Adult = 'adult',
  Kids = 'kids',
  Toddler = 'toddler',
  Youth = 'youth'
}

export type SearchMyEventCustomInput = {
  ageGroupList?: Array<SearchMyEventAgeGroup>;
  code?: InputMaybe<Scalars['String']['input']>;
  dayOfWeekList?: Array<Scalars['Int']['input']>;
  deptIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  gender?: MyEventSearchGender;
  genderList?: Array<FilterGender>;
  maxAge?: InputMaybe<Scalars['Float']['input']>;
  minAge?: InputMaybe<Scalars['Float']['input']>;
  myEventName?: InputMaybe<Scalars['String']['input']>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orderBy: SearchMyEventCustomOrderBy;
  pageNo?: Scalars['Int']['input'];
  parentMyEventId?: InputMaybe<Scalars['Int']['input']>;
  showAllForAdmin?: Scalars['Boolean']['input'];
  sportTypeGroupIdList?: Array<Scalars['Int']['input']>;
  sportTypeIdList?: Array<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  timeGroupList?: Array<SearchMyEventTimeGroup>;
  withQuotaOnly: Scalars['Boolean']['input'];
};

export enum SearchMyEventCustomOrderBy {
  Age = 'age',
  Code = 'code',
  Date = 'date',
  OrderIdAsc = 'orderIdAsc',
  OrderIdDesc = 'orderIdDesc',
  PriceAsc = 'priceAsc',
  PriceDesc = 'priceDesc',
  QuotaAsc = 'quotaAsc',
  QuotaDesc = 'quotaDesc',
  Time = 'time'
}

export type SearchMyEventInput = {
  andCondList?: Array<QueryCondMyEventInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMyEventInput>;
  orderBy?: InputMaybe<QueryOrderByMyEventInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMyEventInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMyEventResGql = {
  __typename?: 'SearchMyEventResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MyEvent>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum SearchMyEventTimeGroup {
  AfterWork = 'afterWork',
  Afternoon = 'afternoon',
  Morning = 'morning'
}

export type SearchMyorderInput = {
  andCondList?: Array<QueryCondMyorderInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMyorderInput>;
  orderBy?: InputMaybe<QueryOrderByMyorderInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMyorderInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMyorderItemInput = {
  andCondList?: Array<QueryCondMyorderItemInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMyorderItemInput>;
  orderBy?: InputMaybe<QueryOrderByMyorderItemInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMyorderItemInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchMyorderItemResGql = {
  __typename?: 'SearchMyorderItemResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MyorderItem>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMyorderResGql = {
  __typename?: 'SearchMyorderResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Myorder>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchNewsInput = {
  andCondList?: Array<QueryCondNewsInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondNewsInput>;
  orderBy?: InputMaybe<QueryOrderByNewsInput>;
  orderByList?: InputMaybe<Array<QueryOrderByNewsInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchNewsResGql = {
  __typename?: 'SearchNewsResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<News>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchOrganizationInput = {
  andCondList?: Array<QueryCondOrganizationInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondOrganizationInput>;
  orderBy?: InputMaybe<QueryOrderByOrganizationInput>;
  orderByList?: InputMaybe<Array<QueryOrderByOrganizationInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchOrganizationResGql = {
  __typename?: 'SearchOrganizationResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Organization>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchPartialUserResGql = {
  __typename?: 'SearchPartialUserResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<User>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchProductCatInput = {
  andCondList?: Array<QueryCondProductCatInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondProductCatInput>;
  orderBy?: InputMaybe<QueryOrderByProductCatInput>;
  orderByList?: InputMaybe<Array<QueryOrderByProductCatInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchProductCatResGql = {
  __typename?: 'SearchProductCatResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<ProductCat>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchProductInput = {
  andCondList?: Array<QueryCondProductInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondProductInput>;
  orderBy?: InputMaybe<QueryOrderByProductInput>;
  orderByList?: InputMaybe<Array<QueryOrderByProductInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchProductResGql = {
  __typename?: 'SearchProductResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Product>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchRecurCourseInput = {
  andCondList?: Array<QueryCondRecurCourseInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondRecurCourseInput>;
  orderBy?: InputMaybe<QueryOrderByRecurCourseInput>;
  orderByList?: InputMaybe<Array<QueryOrderByRecurCourseInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchRecurCourseResGql = {
  __typename?: 'SearchRecurCourseResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<RecurCourse>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchRefundPayoutRequestInput = {
  andCondList?: Array<QueryCondRefundPayoutRequestInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondRefundPayoutRequestInput>;
  orderBy?: InputMaybe<QueryOrderByRefundPayoutRequestInput>;
  orderByList?: InputMaybe<Array<QueryOrderByRefundPayoutRequestInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchRefundPayoutRequestResGql = {
  __typename?: 'SearchRefundPayoutRequestResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<RefundPayoutRequest>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchRoleTemplateInput = {
  andCondList?: Array<QueryCondRoleTemplateInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondRoleTemplateInput>;
  orderBy?: InputMaybe<QueryOrderByRoleTemplateInput>;
  orderByList?: InputMaybe<Array<QueryOrderByRoleTemplateInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchRoleTemplateResGql = {
  __typename?: 'SearchRoleTemplateResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<RoleTemplate>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchSportTypeGroupInput = {
  andCondList?: Array<QueryCondSportTypeGroupInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondSportTypeGroupInput>;
  orderBy?: InputMaybe<QueryOrderBySportTypeGroupInput>;
  orderByList?: InputMaybe<Array<QueryOrderBySportTypeGroupInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchSportTypeGroupResGql = {
  __typename?: 'SearchSportTypeGroupResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<SportTypeGroup>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchSportTypeInput = {
  andCondList?: Array<QueryCondSportTypeInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondSportTypeInput>;
  orderBy?: InputMaybe<QueryOrderBySportTypeInput>;
  orderByList?: InputMaybe<Array<QueryOrderBySportTypeInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchSportTypeResGql = {
  __typename?: 'SearchSportTypeResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<SportType>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchSwpAccessLogInput = {
  andCondList?: Array<QueryCondSwpAccessLogInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondSwpAccessLogInput>;
  orderBy?: InputMaybe<QueryOrderBySwpAccessLogInput>;
  orderByList?: InputMaybe<Array<QueryOrderBySwpAccessLogInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchSwpAccessLogResGql = {
  __typename?: 'SearchSwpAccessLogResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<SwpAccessLog>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchTextTemplateInput = {
  andCondList?: Array<QueryCondTextTemplateInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondTextTemplateInput>;
  orderBy?: InputMaybe<QueryOrderByTextTemplateInput>;
  orderByList?: InputMaybe<Array<QueryOrderByTextTemplateInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchTextTemplateResGql = {
  __typename?: 'SearchTextTemplateResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<TextTemplate>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchTimeSlotProgramGroupInput = {
  andCondList?: Array<QueryCondTimeSlotProgramGroupInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondTimeSlotProgramGroupInput>;
  orderBy?: InputMaybe<QueryOrderByTimeSlotProgramGroupInput>;
  orderByList?: InputMaybe<Array<QueryOrderByTimeSlotProgramGroupInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchTimeSlotProgramGroupResGql = {
  __typename?: 'SearchTimeSlotProgramGroupResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<TimeSlotProgramGroup>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchTimeSlotProgramInput = {
  andCondList?: Array<QueryCondTimeSlotProgramInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondTimeSlotProgramInput>;
  orderBy?: InputMaybe<QueryOrderByTimeSlotProgramInput>;
  orderByList?: InputMaybe<Array<QueryOrderByTimeSlotProgramInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchTimeSlotProgramResGql = {
  __typename?: 'SearchTimeSlotProgramResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<TimeSlotProgram>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchTimeSlotProgramReservationInput = {
  andCondList?: Array<QueryCondTimeSlotProgramReservationInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondTimeSlotProgramReservationInput>;
  orderBy?: InputMaybe<QueryOrderByTimeSlotProgramReservationInput>;
  orderByList?: InputMaybe<Array<QueryOrderByTimeSlotProgramReservationInput>>;
  pageNo?: Scalars['Int']['input'];
  serviceTypeIdList?: InputMaybe<Array<Scalars['Float']['input']>>;
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchTimeSlotProgramReservationResGql = {
  __typename?: 'SearchTimeSlotProgramReservationResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<TimeSlotProgramReservation>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchUserInput = {
  andCondList?: Array<QueryCondUserInput>;
  hasRole?: InputMaybe<Array<Scalars['String']['input']>>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  notHasRole?: InputMaybe<Array<Scalars['String']['input']>>;
  orCondList?: Array<QueryCondUserInput>;
  orderBy?: InputMaybe<QueryOrderByUserInput>;
  orderByList?: InputMaybe<Array<QueryOrderByUserInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchUserProductGroupInput = {
  andCondList?: Array<QueryCondUserProductGroupInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondUserProductGroupInput>;
  orderBy?: InputMaybe<QueryOrderByUserProductGroupInput>;
  orderByList?: InputMaybe<Array<QueryOrderByUserProductGroupInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchUserProductGroupResGql = {
  __typename?: 'SearchUserProductGroupResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<UserProductGroup>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchUserResGql = {
  __typename?: 'SearchUserResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<FullUser>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchWarehouseInput = {
  andCondList?: Array<QueryCondWarehouseInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondWarehouseInput>;
  orderBy?: InputMaybe<QueryOrderByWarehouseInput>;
  orderByList?: InputMaybe<Array<QueryOrderByWarehouseInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchWarehouseInventoryInput = {
  andCondList?: Array<QueryCondWarehouseInventoryInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondWarehouseInventoryInput>;
  orderBy?: InputMaybe<QueryOrderByWarehouseInventoryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByWarehouseInventoryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchWarehouseInventoryResGql = {
  __typename?: 'SearchWarehouseInventoryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<WarehouseInventory>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchWarehousePartitionInput = {
  andCondList?: Array<QueryCondWarehousePartitionInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondWarehousePartitionInput>;
  orderBy?: InputMaybe<QueryOrderByWarehousePartitionInput>;
  orderByList?: InputMaybe<Array<QueryOrderByWarehousePartitionInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchWarehousePartitionResGql = {
  __typename?: 'SearchWarehousePartitionResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<WarehousePartition>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchWarehouseResGql = {
  __typename?: 'SearchWarehouseResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<Warehouse>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchWarehouseStockTakeInput = {
  andCondList?: Array<QueryCondWarehouseStockTakeInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondWarehouseStockTakeInput>;
  orderBy?: InputMaybe<QueryOrderByWarehouseStockTakeInput>;
  orderByList?: InputMaybe<Array<QueryOrderByWarehouseStockTakeInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchWarehouseStockTakeResGql = {
  __typename?: 'SearchWarehouseStockTakeResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<WarehouseStockTake>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchWhatsappSummaryInput = {
  andCondList?: Array<QueryCondWhatsappSummaryInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondWhatsappSummaryInput>;
  orderBy?: InputMaybe<QueryOrderByWhatsappSummaryInput>;
  orderByList?: InputMaybe<Array<QueryOrderByWhatsappSummaryInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchWhatsappSummaryResGql = {
  __typename?: 'SearchWhatsappSummaryResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<WhatsappSummary>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchWhatsappTemplateInput = {
  andCondList?: Array<QueryCondWhatsappTemplateInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondWhatsappTemplateInput>;
  orderBy?: InputMaybe<QueryOrderByWhatsappTemplateInput>;
  orderByList?: InputMaybe<Array<QueryOrderByWhatsappTemplateInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type SearchWhatsappTemplateResGql = {
  __typename?: 'SearchWhatsappTemplateResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<WhatsappTemplate>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SendAccessPassReminderInput = {
  accessPassHistoryIdList: Array<Scalars['Int']['input']>;
  msgPlatform: MsgPlatform;
};

export type SendDailySummaryMailInput = {
  targetDate?: InputMaybe<Scalars['String']['input']>;
};

export type SendLockerReminderInput = {
  lockerHistoryIdList: Array<Scalars['Int']['input']>;
  msgPlatform: MsgPlatform;
};

export type SendTimeSlotProgramDailySummaryMailInput = {
  targetDate?: InputMaybe<Scalars['String']['input']>;
};

export enum SessionType {
  Normal = 'normal',
  OnlyOneDevice = 'onlyOneDevice',
  ViaBiometric = 'viaBiometric'
}

export type SetGpTokenDefaultInput = {
  gpTokenId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export enum ShareTo {
  All = 'all',
  Dept = 'dept',
  Private = 'private'
}

export type ShipmentInput = {
  myorderItemId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
  warehousePartitionId?: InputMaybe<Scalars['Int']['input']>;
};

export type SportType = {
  __typename?: 'SportType';
  btnPhoto?: Maybe<Array<Myfile>>;
  createdDate: Scalars['String']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  externalLink: Scalars['String']['output'];
  facilityBtnPhoto?: Maybe<Array<Myfile>>;
  facilityList?: Maybe<Array<Facility>>;
  facilityPhotoList?: Maybe<Array<Myfile>>;
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  photoList?: Maybe<Array<Myfile>>;
  shortCode: Scalars['String']['output'];
  sportTypeGroup?: Maybe<SportTypeGroup>;
  sportTypeGroupId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  webFacilityList?: Maybe<Array<Facility>>;
  youtubeId: Scalars['String']['output'];
};

export type SportTypeGroup = {
  __typename?: 'SportTypeGroup';
  activeSportTypeList?: Maybe<Array<SportType>>;
  btnPhoto?: Maybe<Array<Myfile>>;
  createdDate: Scalars['String']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  externalLink: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  photoList?: Maybe<Array<Myfile>>;
  shortCode: Scalars['String']['output'];
  sportTypeList?: Maybe<Array<SportType>>;
  updatedDate: Scalars['String']['output'];
  youtubeId: Scalars['String']['output'];
};


export type SportTypeGroupActiveSportTypeListArgs = {
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export enum StudentStatus {
  MaxAgeReached = 'maxAgeReached',
  StudentIdExpired = 'studentIdExpired',
  Valid = 'valid'
}

export type SubDistrict = {
  __typename?: 'SubDistrict';
  districtId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
};

export type SubmitRefundPayoutDetailInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  fpsAccountName?: InputMaybe<Scalars['String']['input']>;
  fpsAccountNo?: InputMaybe<Scalars['String']['input']>;
  fpsBankCode?: InputMaybe<Scalars['String']['input']>;
  fpsEmail?: InputMaybe<Scalars['String']['input']>;
  fpsId?: InputMaybe<Scalars['String']['input']>;
  fpsMobileNo?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  payoutMethod: RefundPayoutMethod;
  refundPayoutRequestId: Scalars['Int']['input'];
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
};

export type SwpAccessLog = {
  __typename?: 'SwpAccessLog';
  accessDateTime: Scalars['String']['output'];
  fee: Scalars['Float']['output'];
  gateCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['Int']['output']>;
  myorderItem?: Maybe<MyorderItem>;
  myorderItemId?: Maybe<Scalars['Int']['output']>;
  swpFee?: Maybe<SwpFee>;
  swpFeeId?: Maybe<Scalars['Int']['output']>;
  swpSession?: Maybe<SwpSession>;
  swpSessionId: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type SwpFee = {
  __typename?: 'SwpFee';
  accessPass?: Maybe<AccessPass>;
  accessPassId?: Maybe<Scalars['Int']['output']>;
  apcCatCodeForFee: Scalars['String']['output'];
  apcFee?: Maybe<AcctProductCat>;
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  fee: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
};

export type SwpSession = {
  __typename?: 'SwpSession';
  code: Scalars['String']['output'];
  dayType: WeekdayType;
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  monthlyPassStartTime: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  startTime: Scalars['String']['output'];
};

export enum TeamGenderType {
  Custom = 'custom',
  FemaleDouble = 'femaleDouble',
  FemaleSingle = 'femaleSingle',
  MaleDouble = 'maleDouble',
  MaleSingle = 'maleSingle',
  MixDouble = 'mixDouble',
  Na = 'na'
}

export type TextTemplate = {
  __typename?: 'TextTemplate';
  createdDate: Scalars['String']['output'];
  docType: Scalars['String']['output'];
  htmlContent: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  msgPlatform: MsgPlatform;
  name: Scalars['String']['output'];
  plainContent: Scalars['String']['output'];
  shareTo: ShareTo;
  title: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  waBodyDataMapping?: Maybe<Scalars['String']['output']>;
  waButtonDataMapping?: Maybe<Scalars['String']['output']>;
  waHeaderDataMapping?: Maybe<Scalars['String']['output']>;
  waMediaDataMapping: Scalars['String']['output'];
  waMediaDataUrl: Scalars['String']['output'];
  waTemplateId?: Maybe<Scalars['String']['output']>;
  waTemplateMediaFile?: Maybe<Myfile>;
  whatsappTemplate?: Maybe<WhatsappTemplate>;
};

export type TimeSlotProgram = {
  __typename?: 'TimeSlotProgram';
  ageCalcType: AgeCalcType;
  allTimeSlotProgramServiceTypeList: Array<TimeSlotProgramServiceType>;
  allowMultiReservation: Scalars['Boolean']['output'];
  applicableEndDate?: Maybe<Scalars['String']['output']>;
  applicableStartDate?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  customStringLabel01En: Scalars['String']['output'];
  customStringLabel01Sc: Scalars['String']['output'];
  customStringLabel01Tc: Scalars['String']['output'];
  customStringLabel02En: Scalars['String']['output'];
  customStringLabel02Sc: Scalars['String']['output'];
  customStringLabel02Tc: Scalars['String']['output'];
  customStringLabel03En: Scalars['String']['output'];
  customStringLabel03Sc: Scalars['String']['output'];
  customStringLabel03Tc: Scalars['String']['output'];
  customStringLabel04En: Scalars['String']['output'];
  customStringLabel04Sc: Scalars['String']['output'];
  customStringLabel04Tc: Scalars['String']['output'];
  customStringLabel05En: Scalars['String']['output'];
  customStringLabel05Sc: Scalars['String']['output'];
  customStringLabel05Tc: Scalars['String']['output'];
  customStringLabel06En: Scalars['String']['output'];
  customStringLabel06Sc: Scalars['String']['output'];
  customStringLabel06Tc: Scalars['String']['output'];
  customStringLabel07En: Scalars['String']['output'];
  customStringLabel07Sc: Scalars['String']['output'];
  customStringLabel07Tc: Scalars['String']['output'];
  customStringLabel08En: Scalars['String']['output'];
  customStringLabel08Sc: Scalars['String']['output'];
  customStringLabel08Tc: Scalars['String']['output'];
  customStringLabel09En: Scalars['String']['output'];
  customStringLabel09Sc: Scalars['String']['output'];
  customStringLabel09Tc: Scalars['String']['output'];
  customStringLabel10En: Scalars['String']['output'];
  customStringLabel10Sc: Scalars['String']['output'];
  customStringLabel10Tc: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptId: Scalars['Int']['output'];
  descEn: Scalars['String']['output'];
  descSc: Scalars['String']['output'];
  descTc: Scalars['String']['output'];
  enableForWeb: Scalars['Boolean']['output'];
  endDate: Scalars['String']['output'];
  gender: FilterGender;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isMemberOnly: Scalars['Boolean']['output'];
  isNoIdentityCheckMode: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  maxAge: Scalars['Float']['output'];
  maxNoOfServiceTypesPerReservation: Scalars['Int']['output'];
  maxQuota: Scalars['Int']['output'];
  minAge: Scalars['Float']['output'];
  minNoOfServiceTypesPerReservation: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  posNoOfDaysAfterTodayToEndReserve: Scalars['Int']['output'];
  posNoOfDaysAfterTodayToStartReserve: Scalars['Int']['output'];
  posNoOfDaysToCancel: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  timeSlotMins: Scalars['Int']['output'];
  timeSlotProgramGridHourList: Array<TimeslotProgramGridHour>;
  timeSlotProgramGroup?: Maybe<TimeSlotProgramGroup>;
  timeSlotProgramGroupId?: Maybe<Scalars['Int']['output']>;
  timeSlotProgramLocationList: Array<TimeSlotProgramLocation>;
  timeSlotProgramOpeningHourList: Array<TimeSlotProgramOpeningHour>;
  timeSlotProgramServiceTypeList: Array<TimeSlotProgramServiceType>;
  timeSlotProgramSummaryUserList: Array<TimeSlotProgramSummaryUser>;
  tnc: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  webNoOfDaysAfterTodayToEndReserve: Scalars['Int']['output'];
  webNoOfDaysAfterTodayToStartReserve: Scalars['Int']['output'];
  webNoOfDaysToCancel: Scalars['Int']['output'];
};

export type TimeSlotProgramDailyInfo = {
  __typename?: 'TimeSlotProgramDailyInfo';
  dailyQuotaLeft: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  reservationList: Array<TimeSlotProgramTimeSlotInfo>;
  timeSlotInfoList: Array<TimeSlotProgramTimeSlotInfo>;
};

export type TimeSlotProgramGroup = {
  __typename?: 'TimeSlotProgramGroup';
  btnPhoto?: Maybe<Array<Myfile>>;
  createdDate: Scalars['String']['output'];
  disableForWeb: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  updatedDate: Scalars['String']['output'];
};

export type TimeSlotProgramLocation = {
  __typename?: 'TimeSlotProgramLocation';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastModifyUser?: Maybe<FullUser>;
  lastModifyUserId: Scalars['Int']['output'];
  locationQuota: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  quotaPerDay: Scalars['Int']['output'];
  reservationList?: Maybe<Array<TimeSlotProgramReservation>>;
  timeSlotProgramId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type TimeSlotProgramLocationSummaryInfo = {
  __typename?: 'TimeSlotProgramLocationSummaryInfo';
  summaryList: Array<TimeSlotProgramSummary>;
  timeSlotProgramLocation: TimeSlotProgramLocation;
};

export type TimeSlotProgramOpeningHour = {
  __typename?: 'TimeSlotProgramOpeningHour';
  createdDate: Scalars['String']['output'];
  dayList: Array<Scalars['String']['output']>;
  dayType: WeekdayType;
  disableForWeb: Scalars['Boolean']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Float']['output'];
  startTime: Scalars['String']['output'];
  timeSlotProgramId: Scalars['Int']['output'];
  timeSlotProgramLocation?: Maybe<TimeSlotProgramLocation>;
  timeSlotProgramLocationId: Scalars['Int']['output'];
  timeslotQuota: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type TimeSlotProgramReservation = {
  __typename?: 'TimeSlotProgramReservation';
  checkInDateTime?: Maybe<Scalars['String']['output']>;
  checkInDeviceId?: Maybe<Scalars['Int']['output']>;
  checkInMode?: Maybe<CheckInMode>;
  checkInUser?: Maybe<User>;
  checkInUserId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['String']['output'];
  customString01: Scalars['String']['output'];
  customString02: Scalars['String']['output'];
  customString03: Scalars['String']['output'];
  customString04: Scalars['String']['output'];
  customString05: Scalars['String']['output'];
  customString06: Scalars['String']['output'];
  customString07: Scalars['String']['output'];
  customString08: Scalars['String']['output'];
  customString09: Scalars['String']['output'];
  customString10: Scalars['String']['output'];
  endDateTime: Scalars['String']['output'];
  hkid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isReminderSent: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  member?: Maybe<Member>;
  memberId: Scalars['Int']['output'];
  passport?: Maybe<Scalars['String']['output']>;
  refMembershipNo: Scalars['String']['output'];
  remark: Scalars['String']['output'];
  startDateTime: Scalars['String']['output'];
  status: TimeSlotProgramReservationStatus;
  timeSlotProgram?: Maybe<TimeSlotProgram>;
  timeSlotProgramId: Scalars['Int']['output'];
  timeSlotProgramLocation?: Maybe<TimeSlotProgramLocation>;
  timeSlotProgramLocationId: Scalars['Int']['output'];
  timeSlotProgramReservationServiceTypeRelList: Array<TimeSlotProgramReservationServiceTypeRel>;
  timeSlotProgramServiceTypeList: Array<TimeSlotProgramServiceType>;
  updatedDate: Scalars['String']['output'];
};

export type TimeSlotProgramReservationServiceTypeRel = {
  __typename?: 'TimeSlotProgramReservationServiceTypeRel';
  id: Scalars['Int']['output'];
  timeSlotProgramReservation?: Maybe<TimeSlotProgramReservation>;
  timeSlotProgramReservationId: Scalars['Int']['output'];
  timeSlotProgramServiceType?: Maybe<TimeSlotProgramServiceType>;
  timeSlotProgramServiceTypeId: Scalars['Int']['output'];
};

export enum TimeSlotProgramReservationStatus {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Held = 'held',
  Released = 'released'
}

export type TimeSlotProgramServiceType = {
  __typename?: 'TimeSlotProgramServiceType';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<FullUser>;
  lastModifyUserId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  timeSlotProgram?: Maybe<TimeSlotProgram>;
  timeSlotProgramId: Scalars['Int']['output'];
  timeSlotProgramReservationList?: Maybe<Array<TimeSlotProgramReservation>>;
  updatedDate: Scalars['String']['output'];
};

export type TimeSlotProgramStatsRow = {
  __typename?: 'TimeSlotProgramStatsRow';
  date?: Maybe<Scalars['String']['output']>;
  noOfEnrolmentPerServiceList: Array<Scalars['Int']['output']>;
};

export type TimeSlotProgramSummary = {
  __typename?: 'TimeSlotProgramSummary';
  createdDate: Scalars['String']['output'];
  dailyQuotaLeft: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  summaryDate: Scalars['String']['output'];
  timeSlotLeft: Scalars['Int']['output'];
  timeSlotLeftAfternoon: Scalars['Int']['output'];
  timeSlotLeftMorning: Scalars['Int']['output'];
  timeSlotLeftNight: Scalars['Int']['output'];
  timeSlotProgram?: Maybe<TimeSlotProgram>;
  timeSlotProgramId: Scalars['Int']['output'];
  timeSlotProgramLocation?: Maybe<TimeSlotProgramLocation>;
  timeSlotProgramLocationId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type TimeSlotProgramSummaryUser = {
  __typename?: 'TimeSlotProgramSummaryUser';
  createdDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  timeSlotProgramId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type TimeSlotProgramTimeSlotInfo = {
  __typename?: 'TimeSlotProgramTimeSlotInfo';
  endTime: Scalars['String']['output'];
  noOfReservation: Scalars['Int']['output'];
  quotaLeft: Scalars['Int']['output'];
  quotaMax: Scalars['Int']['output'];
  reservationList: Array<TimeSlotProgramReservation>;
  startTime: Scalars['String']['output'];
};

export type TimeslotProgramGridHour = {
  __typename?: 'TimeslotProgramGridHour';
  createdDate: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
  timeSlotProgramId: Scalars['Int']['output'];
  timeSlotProgramLocation?: Maybe<TimeSlotProgramLocation>;
  timeSlotProgramLocationId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
};

export type TimeslotResGql = {
  __typename?: 'TimeslotResGql';
  endDateTime: Scalars['String']['output'];
  error: Scalars['String']['output'];
  result: Scalars['Boolean']['output'];
  startDateTime: Scalars['String']['output'];
};

export type TimeslotUnitResGql = {
  __typename?: 'TimeslotUnitResGql';
  course?: Maybe<Course>;
  endDateTime: Scalars['String']['output'];
  facility?: Maybe<Facility>;
  startDateTime: Scalars['String']['output'];
};

export type TncSettingResGql = {
  __typename?: 'TncSettingResGql';
  accessPassTncContentEn: Scalars['String']['output'];
  accessPassTncContentSc: Scalars['String']['output'];
  accessPassTncContentTc: Scalars['String']['output'];
  accessPassTncTitleEn: Scalars['String']['output'];
  accessPassTncTitleSc: Scalars['String']['output'];
  accessPassTncTitleTc: Scalars['String']['output'];
  additionalTncContentEn: Scalars['String']['output'];
  additionalTncContentSc: Scalars['String']['output'];
  additionalTncContentTc: Scalars['String']['output'];
  additionalTncTitleEn: Scalars['String']['output'];
  additionalTncTitleSc: Scalars['String']['output'];
  additionalTncTitleTc: Scalars['String']['output'];
  courseTncContentEn: Scalars['String']['output'];
  courseTncContentSc: Scalars['String']['output'];
  courseTncContentTc: Scalars['String']['output'];
  courseTncTitleEn: Scalars['String']['output'];
  courseTncTitleSc: Scalars['String']['output'];
  courseTncTitleTc: Scalars['String']['output'];
  eventTncEn: Scalars['String']['output'];
  eventTncSc: Scalars['String']['output'];
  eventTncTc: Scalars['String']['output'];
  globalTncEn: Scalars['String']['output'];
  globalTncSc: Scalars['String']['output'];
  globalTncTc: Scalars['String']['output'];
  redeemPromotionTncEn: Scalars['String']['output'];
  redeemPromotionTncSc: Scalars['String']['output'];
  redeemPromotionTncTc: Scalars['String']['output'];
};

export type Totp = {
  __typename?: 'Totp';
  createdDate: Scalars['String']['output'];
  friendlyName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  memberId?: Maybe<Scalars['Int']['output']>;
  secret: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type TransferDocxTemplateToUserInput = {
  docxTemplateIdList: Array<Scalars['Int']['input']>;
  fromUserId: Scalars['Int']['input'];
  toUserId: Scalars['Int']['input'];
};

export type TransferTextTemplateToUserInput = {
  fromUserId: Scalars['Int']['input'];
  textTemplateIdList: Array<Scalars['Int']['input']>;
  toUserId: Scalars['Int']['input'];
};

export type TransferTmpHoldInput = {
  bonusPointRedeemPromotionGroupId?: InputMaybe<Scalars['Int']['input']>;
  checkCoachFreeslot?: Scalars['Boolean']['input'];
  coachFee?: InputMaybe<Scalars['Float']['input']>;
  coachId?: InputMaybe<Scalars['Int']['input']>;
  coachServiceId?: InputMaybe<Scalars['Int']['input']>;
  endDateTime: Scalars['String']['input'];
  eventCode?: InputMaybe<Scalars['String']['input']>;
  facilityBookingId: Scalars['Int']['input'];
  facilityId: Scalars['Int']['input'];
  ignoreAccessPassDependency?: Scalars['Boolean']['input'];
  ignoreLeadTimeCheck?: Scalars['Boolean']['input'];
  ignoreMemberConflictCheck?: Scalars['Boolean']['input'];
  ignoreNoOfTimeslotCheck?: Scalars['Boolean']['input'];
  ignoreNoSameDayBookingRule?: Scalars['Boolean']['input'];
  ignoreNoSameTimeBookingRule?: Scalars['Boolean']['input'];
  ignoreOutstandingOrderCheck?: Scalars['Boolean']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type TwoWayInventoryRequestTxInput = {
  inWarehousePartitionId: Scalars['Int']['input'];
  isBorrowOut: Scalars['Boolean']['input'];
  isReturnBorrow: Scalars['Boolean']['input'];
  isScraped: Scalars['Boolean']['input'];
  outWarehousePartitionId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  qty: Scalars['Int']['input'];
};

export type UnHeldMyEventTicketSeatInput = {
  endSeatNo: Scalars['Int']['input'];
  myEventId: Scalars['Int']['input'];
  myEventTicketTypeId: Scalars['Int']['input'];
  startSeatNo: Scalars['Int']['input'];
};

export type UndoCloseInventoryRequestInput = {
  inventoryRequestId: Scalars['Int']['input'];
};

export type UndoConfirmDeliveryNoteInput = {
  dnTxGroupId: Scalars['Int']['input'];
};

export type UndoConfirmGoodsReceiveNoteInput = {
  grnTxGroupId: Scalars['Int']['input'];
};

export type UpdateAccessPassFacilityAccessRelInput = {
  accessPassId: Scalars['Int']['input'];
  dayType: WeekdayType;
  endTime: Scalars['String']['input'];
  facilityId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

export type UpdateAccessPassHistoryAutoRenewInput = {
  accessPassHistoryId: Scalars['Int']['input'];
  autoRenewNextAccessPassOptionId?: InputMaybe<Scalars['Int']['input']>;
  enableAutoRenew: Scalars['Boolean']['input'];
  memberId: Scalars['Int']['input'];
};

export type UpdateAccessPassHistoryForceNoRenewInput = {
  accessPassHistoryId: Scalars['Int']['input'];
  forceNoRenew: Scalars['Boolean']['input'];
};

export type UpdateAccessPassInput = {
  allowedNoOfDaysToRenew: Scalars['Int']['input'];
  aspenId: Scalars['String']['input'];
  deposit: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isFamilyPackage: Scalars['Boolean']['input'];
  isWebEnable: Scalars['Boolean']['input'];
  mainAccessPassId?: InputMaybe<Scalars['Int']['input']>;
  maxAge: Scalars['Int']['input'];
  maxNoOfMembersPerPass: Scalars['Int']['input'];
  minAge: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfDaysToForfeitDeposit: Scalars['Int']['input'];
  renewGracePeriodNoOfDays: Scalars['Int']['input'];
  swpModeBlockEndDate?: InputMaybe<Scalars['String']['input']>;
  swpModeBlockStartDate?: InputMaybe<Scalars['String']['input']>;
  tncEn: Scalars['String']['input'];
  tncSc: Scalars['String']['input'];
  tncTc: Scalars['String']['input'];
};

export type UpdateAccessPassOptionInput = {
  accessPassId: Scalars['Int']['input'];
  allowAutoRenew: Scalars['Boolean']['input'];
  apcCatCodeForDeposit: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForForfeitDeposit: Scalars['String']['input'];
  apcCatCodeForRefundDeposit: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  ignoreMembershipDiscount: Scalars['Boolean']['input'];
  initPrice: Scalars['Float']['input'];
  isEnable: Scalars['Boolean']['input'];
  isStudentOnly: Scalars['Boolean']['input'];
  maxNoOfFacilityAccessPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfFacilityAccessPerMonth?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfFacilityAccessPerPeriod?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfFacilityAccessPerYear?: InputMaybe<Scalars['Int']['input']>;
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  newFreeCouponPackageId?: InputMaybe<Scalars['Int']['input']>;
  newFreeCreditPackageId?: InputMaybe<Scalars['Int']['input']>;
  noOfDaysToDoAutoRenew: Scalars['Int']['input'];
  noOfDaysToSendAutoRenewNotification: Scalars['Int']['input'];
  noOfDaysToSendRenewReminder: Scalars['Int']['input'];
  orderId: Scalars['Float']['input'];
  renewFreeCouponPackageId?: InputMaybe<Scalars['Int']['input']>;
  renewFreeCreditPackageId?: InputMaybe<Scalars['Int']['input']>;
  renewPrice: Scalars['Float']['input'];
  validNoOfDay: Scalars['Int']['input'];
  validNoOfMonth: Scalars['Float']['input'];
  validNoOfYear: Scalars['Int']['input'];
};

export type UpdateAcctProductCatInput = {
  acctDesc: Scalars['String']['input'];
  apcAccountNo: Scalars['String']['input'];
  apcCode: Scalars['String']['input'];
  apcProjCode: Scalars['String']['input'];
  apcRevcCode: Scalars['String']['input'];
  apcType: Scalars['String']['input'];
  desc: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateAdminSettingInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateAgreeToReceiveStockTransferInput = {
  agreeToReceive: Scalars['Boolean']['input'];
  autoPhysicalTransferForIntra?: Scalars['Boolean']['input'];
  reqTxGroupId: Scalars['Int']['input'];
  throwNonCriticalBorrowCheckError?: Scalars['Boolean']['input'];
};

export type UpdateBlackoutInput = {
  eventCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameSc?: InputMaybe<Scalars['String']['input']>;
  nameTc?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBonusPointEarningRuleAccessPassInput = {
  accessPassId?: InputMaybe<Scalars['Int']['input']>;
  accessPassOptionId?: InputMaybe<Scalars['Int']['input']>;
  bonusPointEarningRatio: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  type: BonusPointEarningRuleAccessPassType;
};

export type UpdateBonusPointEarningRuleCouponCodeInput = {
  couponCode: Scalars['String']['input'];
  globalQuota?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  memberQuota?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBonusPointEarningRuleCourseInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  courseId?: InputMaybe<Scalars['Int']['input']>;
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  sportTypeGroupId?: InputMaybe<Scalars['Int']['input']>;
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  type: BonusPointEarningRuleCourseType;
};

export type UpdateBonusPointEarningRuleFacilityBookingInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  bookingEndDate?: InputMaybe<Scalars['String']['input']>;
  bookingStartDate?: InputMaybe<Scalars['String']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  type: BonusPointEarningRuleFacilityBookingType;
};

export type UpdateBonusPointEarningRuleInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  enableCouponCode: Scalars['Boolean']['input'];
  endDate: Scalars['String']['input'];
  globalQuota?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  memberQuota?: InputMaybe<Scalars['Int']['input']>;
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  refBonusPointEarningRatio: Scalars['Int']['input'];
  refExtraBonusPointAmount: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
  tncEn: Scalars['String']['input'];
  tncSc: Scalars['String']['input'];
  tncTc: Scalars['String']['input'];
};

export type UpdateBonusPointEarningRuleLockerInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  type: BonusPointEarningRuleLockerType;
};

export type UpdateBonusPointEarningRuleMyEventInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  myEventId?: InputMaybe<Scalars['Int']['input']>;
  sportTypeGroupId?: InputMaybe<Scalars['Int']['input']>;
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBonusPointEarningRuleNthOrderInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  extraBonusPointAmount: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  nthOrder: Scalars['Int']['input'];
};

export type UpdateBonusPointEarningRuleProductInput = {
  bonusPointEarningRatio: Scalars['Int']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  extraBonusPointAmount: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  productCatId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBonusPointItemTypeEarningRatioInput = {
  earningRatio?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  myorderItemType: MyorderItemType;
};

export type UpdateBonusPointRedeemPromotionGroupInput = {
  accessPassOptionIdList: Array<Scalars['Int']['input']>;
  additionalMoneyRequired: Scalars['Int']['input'];
  bonusPointRequired: Scalars['Int']['input'];
  courseIdList: Array<Scalars['Int']['input']>;
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  facilityInputList: Array<BonusPointRedeemPromotionGroupFacilityInput>;
  globalQuota: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  memberQuota: Scalars['Int']['input'];
  myEventTicketTypeIdList: Array<Scalars['Int']['input']>;
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  productIdList: Array<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
};

export type UpdateBookingMetaInput = {
  eventCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCheckInDeviceInput = {
  appUuid: Scalars['String']['input'];
  facilityIdList: Array<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCoachSalaryContractTermsInput = {
  deptId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  salaryType: SalaryType;
  salaryValue: Scalars['Float']['input'];
};

export type UpdateCoachSalaryReportCoachAdjustmentInput = {
  adjustment: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type UpdateCoachServiceInput = {
  apcCatCodeForFee: Scalars['String']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  facilityIdList: Array<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isWebEnabled: Scalars['Boolean']['input'];
  minNoOfLessonsRequired: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfMembersPerLesson: Scalars['Int']['input'];
  noOfMinsPerLesson: Scalars['Int']['input'];
  revenueDeptId: Scalars['Int']['input'];
  sportTypeId: Scalars['Int']['input'];
};

export type UpdateCoachTimeslotInput = {
  endDateTime: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isFree: Scalars['Boolean']['input'];
  remark: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type UpdateCommitteeHistoryInput = {
  endDate: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
  positionId: Scalars['Int']['input'];
  remark: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type UpdateCommitteeInput = {
  aspenId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
};

export type UpdateCommitteePositionInput = {
  aspenId: Scalars['String']['input'];
  committeeId: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
};

export type UpdateContactInput = {
  chineseName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender: FilterGender;
  givenName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  languagePreference: LanguagePreference;
  mobileTel: Scalars['String']['input'];
  mobileTelAreaCode: Scalars['String']['input'];
  officeTel: Scalars['String']['input'];
  officeTelAreaCode: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
  remark: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UpdateCouponPackageFacilityRelInput = {
  id: Scalars['Int']['input'];
  noOfCouponsPerTimeslotForNormalHour: Scalars['Int']['input'];
  noOfCouponsPerTimeslotForPeakHour: Scalars['Int']['input'];
};

export type UpdateCouponPackageInput = {
  accessPassDependencyIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  acctCatCode: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  couponType: CouponType;
  deptId: Scalars['Int']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  discountAmt: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isWebEnable: Scalars['Boolean']['input'];
  listPrice: Scalars['Float']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfCoupons: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  tncEn: Scalars['String']['input'];
  tncSc: Scalars['String']['input'];
  tncTc: Scalars['String']['input'];
  validNoOfDays: Scalars['Int']['input'];
};

export type UpdateCourseApplyQuotaPeriodInput = {
  applyQuota: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  monthPerPeriod: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCourseCoachInput = {
  coachId: Scalars['Int']['input'];
  coachSalaryContractTermsId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCourseCoachListInput = {
  courseCoachList: Array<UpdateCourseCoachInput>;
  id: Scalars['Int']['input'];
};

export type UpdateCourseEnableInput = {
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
};

export type UpdateCourseEnrolmentLotteryDrawPriorityInput = {
  courseId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  lotteryDrawPriority: LotteryDrawPriority;
};

export type UpdateCourseInput = {
  accessPassDependencyIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  allowFeeAutoRecalEvenWithEnrolment: Scalars['Boolean']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForMaterial: Scalars['String']['input'];
  aspenCategoryCode: Scalars['String']['input'];
  aspenPrepaidCategoryCode: Scalars['String']['input'];
  cancelCourseAlertDate?: InputMaybe<Scalars['String']['input']>;
  coachInternalRemark: Scalars['String']['input'];
  coachRemarkEn: Scalars['String']['input'];
  coachRemarkSc: Scalars['String']['input'];
  coachRemarkTc: Scalars['String']['input'];
  code: Scalars['String']['input'];
  courseApplyQuotaPeriodIdList?: Array<Scalars['Int']['input']>;
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
  defaultFeeForGroup: Scalars['Float']['input'];
  defaultFeeForMember: Scalars['Float']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  earlyBirdDiscountAmtForGroup: Scalars['Float']['input'];
  earlyBirdDiscountAmtForMember: Scalars['Float']['input'];
  earlyBirdDiscountPercentForGroup: Scalars['Int']['input'];
  earlyBirdDiscountPercentForMember: Scalars['Int']['input'];
  earlyBirdEndDateForGroup?: InputMaybe<Scalars['String']['input']>;
  earlyBirdEndDateForMember?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['String']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['String']['input']>;
  enableAccessPassDependency: Scalars['Boolean']['input'];
  enableFeeAutoRecalAfterUpdate: Scalars['Boolean']['input'];
  enableForWeb: Scalars['Boolean']['input'];
  enableGroupEnrol: Scalars['Boolean']['input'];
  enableMemberEnrol: Scalars['Boolean']['input'];
  enableNoShowPenalty: Scalars['Boolean']['input'];
  enablePriorityByCode: Scalars['Boolean']['input'];
  enablePriorityEnrolmentForLastCourseMember: Scalars['Boolean']['input'];
  enableWhiteList: Scalars['Boolean']['input'];
  enrolmentEndDateForGroup: Scalars['String']['input'];
  enrolmentEndDateForMember: Scalars['String']['input'];
  enrolmentStartDateForGroup: Scalars['String']['input'];
  enrolmentStartDateForMember: Scalars['String']['input'];
  enrolmentStartDateForPriority?: InputMaybe<Scalars['String']['input']>;
  enrolmentType: CourseEnrolmentType;
  facilityCost: Scalars['Float']['input'];
  facilityRemarkEn: Scalars['String']['input'];
  facilityRemarkSc: Scalars['String']['input'];
  facilityRemarkTc: Scalars['String']['input'];
  featureOrderId: Scalars['Float']['input'];
  feeType: CourseFeeType;
  fixedMaterialCost: Scalars['Float']['input'];
  gender: FilterGender;
  id: Scalars['Int']['input'];
  internalRemarks: Scalars['String']['input'];
  isEnable: Scalars['Boolean']['input'];
  isTrial: Scalars['Boolean']['input'];
  lessonDaysCountAsEarlyBird?: InputMaybe<Scalars['Int']['input']>;
  lessonDaysForNormalEnrolmentForGroup: Scalars['Int']['input'];
  lessonDaysForNormalEnrolmentForMember: Scalars['Int']['input'];
  lessonDaysForPriorityEnrolment: Scalars['Int']['input'];
  lessonFeeForGroupForAutoRecal: Scalars['Float']['input'];
  lessonFeeForMemberForAutoRecal: Scalars['Float']['input'];
  lessonPreviousEnrolledDaysCountAsPriority: Scalars['Int']['input'];
  lessonSelectionType: LessonSelectionType;
  limitEnrolPeriodInDefaultTimeslotOnly?: InputMaybe<Scalars['Boolean']['input']>;
  lotteryDrawDate?: InputMaybe<Scalars['String']['input']>;
  lotteryGroupName: Scalars['String']['input'];
  loyaltyPoint: Scalars['Int']['input'];
  materialCostPerLesson: Scalars['Float']['input'];
  maxAge: Scalars['Float']['input'];
  maxNoOfEnrolment: Scalars['Int']['input'];
  minAge: Scalars['Float']['input'];
  minNoOfEnrolledLessons?: InputMaybe<Scalars['Int']['input']>;
  minNoOfEnrolment: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  overrideTimeDescEn: Scalars['String']['input'];
  overrideTimeDescSc: Scalars['String']['input'];
  overrideTimeDescTc: Scalars['String']['input'];
  payTrialFeeOnline: Scalars['Boolean']['input'];
  recurCourseId?: InputMaybe<Scalars['Int']['input']>;
  remarkEn: Scalars['String']['input'];
  remarkSc: Scalars['String']['input'];
  remarkTc: Scalars['String']['input'];
  requireParQ: Scalars['Boolean']['input'];
  showEnrolmentResultToPublic: Scalars['Boolean']['input'];
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  uniformOption: Scalars['String']['input'];
  webDiscountAmtForMember: Scalars['Float']['input'];
  webDiscountPercentForMember: Scalars['Int']['input'];
  yldsaStandardCourseRule: Scalars['Boolean']['input'];
  youtubeId: Scalars['String']['input'];
};

export type UpdateCourseInvitationCodeInput = {
  courseOrgInvitationCodeRelId: Scalars['Int']['input'];
  invitationCode: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCourseTypeInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  enableMiniSite: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  miniSiteSlug: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  shortCode: Scalars['String']['input'];
};

export type UpdateCreditPackageInput = {
  apcCatCodeForFee: Scalars['String']['input'];
  creditAmount: Scalars['Float']['input'];
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  deptId: Scalars['Int']['input'];
  expiryDays: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isWebEnable: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  sku: Scalars['String']['input'];
};

export type UpdateCreditTypeInput = {
  code: Scalars['String']['input'];
  defaultExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  myorderItemTypeList?: InputMaybe<Array<MyorderItemType>>;
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
};

export type UpdateDefaultFacilityFeeInput = {
  dayType: WeekdayType;
  disableForWeb: Scalars['Boolean']['input'];
  endTime: Scalars['String']['input'];
  feeForDept: Scalars['Float']['input'];
  feeForGroup: Scalars['Float']['input'];
  feeForMember: Scalars['Float']['input'];
  feeForRegBody: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  isPeakHour: Scalars['Boolean']['input'];
  orderId: Scalars['Float']['input'];
  startTime: Scalars['String']['input'];
};

export type UpdateDepartmentInput = {
  aspenId: Scalars['String']['input'];
  bonusPointReceiptRegRatio: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  forReceiptReg: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  receiveOrderEmail: Scalars['Boolean']['input'];
  shortCode: Scalars['String']['input'];
  telNo: Scalars['String']['input'];
};

export type UpdateDepositForfeitDateInput = {
  depositHistoryId: Scalars['Int']['input'];
  newForfeitDate: Scalars['String']['input'];
};

export type UpdateDocxTemplateInput = {
  docType: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  shareTo: ShareTo;
};

export type UpdateDriveTeamForMemberInput = {
  memberId: Scalars['Int']['input'];
  newDriveMemberId: Scalars['Int']['input'];
  newDriveTeamId: Scalars['Int']['input'];
};

export type UpdateDriveTeamForMyorderInput = {
  myorderId: Scalars['Int']['input'];
  newDriveMemberId: Scalars['Int']['input'];
  newDriveTeamId: Scalars['Int']['input'];
};

export type UpdateDriveTeamInput = {
  code: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  lastModifyUserId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateDriveTeamMemberListInput = {
  id: Scalars['Int']['input'];
  leaderId?: InputMaybe<Scalars['Int']['input']>;
  memberIdList: Array<Scalars['Int']['input']>;
};

export type UpdateFabFloorplanInput = {
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type UpdateFabFloorplanPeriodInput = {
  defaultMealMins: Scalars['Int']['input'];
  defaultTimeslotMins: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  mustBookWholePeriod: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type UpdateFabFloorplanRequestInput = {
  fabFloorplanId: Scalars['Int']['input'];
  request1en: Scalars['String']['input'];
  request1sc: Scalars['String']['input'];
  request1tc: Scalars['String']['input'];
  request2en: Scalars['String']['input'];
  request2sc: Scalars['String']['input'];
  request2tc: Scalars['String']['input'];
  request3en: Scalars['String']['input'];
  request3sc: Scalars['String']['input'];
  request3tc: Scalars['String']['input'];
  request4en: Scalars['String']['input'];
  request4sc: Scalars['String']['input'];
  request4tc: Scalars['String']['input'];
  request5en: Scalars['String']['input'];
  request5sc: Scalars['String']['input'];
  request5tc: Scalars['String']['input'];
  request6en: Scalars['String']['input'];
  request6sc: Scalars['String']['input'];
  request6tc: Scalars['String']['input'];
  request7en: Scalars['String']['input'];
  request7sc: Scalars['String']['input'];
  request7tc: Scalars['String']['input'];
  request8en: Scalars['String']['input'];
  request8sc: Scalars['String']['input'];
  request8tc: Scalars['String']['input'];
  request9en: Scalars['String']['input'];
  request9sc: Scalars['String']['input'];
  request9tc: Scalars['String']['input'];
};

export type UpdateFabReservationTableRelInput = {
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  fabTableId: Scalars['Int']['input'];
  noOfSeats: Scalars['Float']['input'];
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  tableStatus: FabReservationStatus;
};

export type UpdateFabTableInput = {
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  noOfSeats: Scalars['Int']['input'];
  shape: FabTableShape;
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type UpdateFacilityAccessLogAccessPassOptionIdInput = {
  accessPassOptionId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateFacilityAccessPassDependencyInput = {
  accessPassId: Scalars['Int']['input'];
  dayType: WeekdayType;
  endTime: Scalars['String']['input'];
  facilityId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

export type UpdateFacilityAccessPassLeadTimeInput = {
  id: Scalars['Int']['input'];
  maxLeadTimeInDays: Scalars['Int']['input'];
  minLeadTimeInDays: Scalars['Int']['input'];
};

export type UpdateFacilityAccessPassNoOfTimeslotInput = {
  id: Scalars['Int']['input'];
  maxNoOfTimeslot: Scalars['Int']['input'];
  maxNoOfTimeslotForPeakHour: Scalars['Int']['input'];
  minNoOfTimeslot: Scalars['Int']['input'];
};

export type UpdateFacilityEnableInput = {
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
};

export type UpdateFacilityFeeInput = {
  accessPassId?: InputMaybe<Scalars['Int']['input']>;
  dayList?: Array<Scalars['String']['input']>;
  dayType: WeekdayType;
  disableForWeb: Scalars['Boolean']['input'];
  endTime: Scalars['String']['input'];
  facilityId: Scalars['Int']['input'];
  feeForDept: Scalars['Float']['input'];
  feeForGroup: Scalars['Float']['input'];
  feeForMember: Scalars['Float']['input'];
  feeForRegBody: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  isPeakHour: Scalars['Boolean']['input'];
  orderId: Scalars['Float']['input'];
  startTime: Scalars['String']['input'];
};

export type UpdateFacilityInput = {
  accessPassDependencyIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  advanceBookingChargeRule?: InputMaybe<Scalars['Boolean']['input']>;
  allowInternalBooking?: InputMaybe<Scalars['Boolean']['input']>;
  apcCatCodeForAdvanceBookingCharge: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForLateCharge: Scalars['String']['input'];
  aspenId?: InputMaybe<Scalars['String']['input']>;
  availableToFacilityIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  customType?: InputMaybe<Scalars['String']['input']>;
  defaultFeeForDept?: InputMaybe<Scalars['Float']['input']>;
  defaultFeeForGroup?: InputMaybe<Scalars['Float']['input']>;
  defaultFeeForMember?: InputMaybe<Scalars['Float']['input']>;
  defaultFeeForRegBody?: InputMaybe<Scalars['Float']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  descEn?: InputMaybe<Scalars['String']['input']>;
  descSc?: InputMaybe<Scalars['String']['input']>;
  descTc?: InputMaybe<Scalars['String']['input']>;
  enableForWeb?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  equipmentIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  facilityGroupCode?: InputMaybe<Scalars['String']['input']>;
  gridDisplayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  ignoreLeadTimeCheckInPos?: InputMaybe<Scalars['Boolean']['input']>;
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifyUserId?: InputMaybe<Scalars['Int']['input']>;
  locationAreaId: Scalars['Int']['input'];
  managerIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfTimeslot?: InputMaybe<Scalars['Int']['input']>;
  maxNoOfTimeslotForPeakHour?: InputMaybe<Scalars['Int']['input']>;
  minLeadTimeInDays?: InputMaybe<Scalars['Int']['input']>;
  minNoOfTimeslot?: InputMaybe<Scalars['Int']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameSc?: InputMaybe<Scalars['String']['input']>;
  nameTc?: InputMaybe<Scalars['String']['input']>;
  noSameDayBookingRule?: InputMaybe<Scalars['Boolean']['input']>;
  noSameTimeBookingRule?: InputMaybe<Scalars['Boolean']['input']>;
  onlyOpenWhenAllBookedFacilityIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  openForMemberBooking?: InputMaybe<Scalars['Boolean']['input']>;
  openForUserBooking?: InputMaybe<Scalars['Boolean']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  refCapacity?: InputMaybe<Scalars['String']['input']>;
  relatedFacilityIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  requiredNoOfMembers?: InputMaybe<Scalars['Int']['input']>;
  revenueDeptId?: InputMaybe<Scalars['Int']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  systemType?: InputMaybe<FacilitySystemType>;
  timeSlotMins?: InputMaybe<Scalars['Int']['input']>;
  youtubeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFcmTokenToSessionInput = {
  appBuildNo: Scalars['Int']['input'];
  appVersion: Scalars['String']['input'];
  fcmToken: Scalars['String']['input'];
};

export type UpdateGuestAndCartInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cartType: CartType;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  driveMemberId?: InputMaybe<Scalars['Int']['input']>;
  driveTeamId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  loginMobile?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  membershipTypeId: Scalars['Int']['input'];
  mgmReferralCode: Scalars['String']['input'];
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGuestAndCartResGql = {
  __typename?: 'UpdateGuestAndCartResGql';
  member: FullMember;
  myorder: Myorder;
};

export type UpdateHolidayInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  icalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameSc?: InputMaybe<Scalars['String']['input']>;
  nameTc?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInternalBookingInput = {
  dto: AddBookingToMultiFacilityInput;
  parentBookingId: Scalars['Int']['input'];
};

export type UpdateInventoryTxGroupInput = {
  inventoryTxGroupId: Scalars['Int']['input'];
  userRemark: Scalars['String']['input'];
};

export type UpdateKwtdhcEventInput = {
  annualHrfa: Scalars['Int']['input'];
  attendance: Scalars['Int']['input'];
  ccdcEnrolment: Scalars['Int']['input'];
  ccdcPreEnrolment: Scalars['Int']['input'];
  centerLocation: Scalars['String']['input'];
  collaborativeWith: Scalars['String']['input'];
  eventDate?: InputMaybe<Scalars['String']['input']>;
  eventEndTime?: InputMaybe<Scalars['String']['input']>;
  eventStartTime?: InputMaybe<Scalars['String']['input']>;
  firstHrfa: Scalars['Int']['input'];
  flu: Scalars['Int']['input'];
  hpv: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  method: Scalars['String']['input'];
  name: Scalars['String']['input'];
  otherVaccination: Scalars['Int']['input'];
  outreachLocation: Scalars['String']['input'];
  outreachType: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  pneumococcal: Scalars['Int']['input'];
  remark: Scalars['String']['input'];
  types: Scalars['String']['input'];
  zoster: Scalars['Int']['input'];
};

export type UpdateKwtdhcMemberFollowupInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isFollowUpAlready: Scalars['Boolean']['input'];
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
  remark: Scalars['String']['input'];
};

export type UpdateLessonInput = {
  coachIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  courseId: Scalars['Int']['input'];
  endDateTime: Scalars['String']['input'];
  facilityIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  ignoreCoachConflict?: Scalars['Boolean']['input'];
  ignoreFacilityConflict?: Scalars['Boolean']['input'];
  isCancelled: Scalars['Boolean']['input'];
  isEnable: Scalars['Boolean']['input'];
  lessonId: Scalars['Int']['input'];
  makeupLessonId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['String']['input'];
};

export type UpdateLocationAreaInput = {
  id: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  phone: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type UpdateLocationInput = {
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type UpdateLockerGroupFeeInput = {
  allowAutoRenew: Scalars['Boolean']['input'];
  apcCatCodeForDeposit: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForForfeitDeposit: Scalars['String']['input'];
  apcCatCodeForRefundDeposit: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  lockerGroupId: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfDay: Scalars['Int']['input'];
  noOfDaysToDoAutoRenew: Scalars['Int']['input'];
  noOfDaysToSendAutoRenewNotification: Scalars['Int']['input'];
  noOfDaysToSendRenewReminder: Scalars['Int']['input'];
  noOfMonth: Scalars['Int']['input'];
  noOfYear: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
  renewPrice: Scalars['Float']['input'];
};

export type UpdateLockerGroupInput = {
  accessPassDependencyIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  allowedNoOfDaysToRenew: Scalars['Int']['input'];
  column: Scalars['Int']['input'];
  countDayAsWorkingDays: Scalars['Boolean']['input'];
  deposit: Scalars['Float']['input'];
  depositAcctCode: Scalars['String']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  gender: FilterGender;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isWebEnable: Scalars['Boolean']['input'];
  locationAreaId?: InputMaybe<Scalars['Int']['input']>;
  lockerTypeId?: InputMaybe<Scalars['Int']['input']>;
  nameEn: Scalars['String']['input'];
  namePos: Scalars['String']['input'];
  nameReceipt: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  noOfDaysToForfeitDeposit: Scalars['Int']['input'];
  renewGracePeriodNoOfDays: Scalars['Int']['input'];
  rentalAcctCode: Scalars['String']['input'];
  row: Scalars['Int']['input'];
  shortCode: Scalars['String']['input'];
};

export type UpdateLockerHistoryAutoRenewInput = {
  autoRenewNextLockerGroupFeeId?: InputMaybe<Scalars['Int']['input']>;
  enableAutoRenew: Scalars['Boolean']['input'];
  lockerHistoryId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type UpdateLockerHistoryForceNoRenewInput = {
  forceNoRenew: Scalars['Boolean']['input'];
  lockerHistoryId: Scalars['Int']['input'];
};

export type UpdateLockerInput = {
  id: Scalars['Int']['input'];
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isWebEnable?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  remark: Scalars['String']['input'];
};

export type UpdateLockerStatusInput = {
  id: Scalars['Int']['input'];
  status: LockerStatus;
};

export type UpdateLockerTypeInput = {
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  shortCode: Scalars['String']['input'];
};

export type UpdateMemberImageFileInput = {
  image: UploadImageInput;
  imageType: MyfileType;
  memberId: Scalars['Int']['input'];
};

export type UpdateMemberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  ageGroup?: InputMaybe<AgeGroup>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  aspenSeqNo?: InputMaybe<Scalars['String']['input']>;
  autoRenewNoOfTrial?: InputMaybe<Scalars['Int']['input']>;
  autoRenewNotificationSentDateTime?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cardIssueDate?: InputMaybe<Scalars['String']['input']>;
  cardLostNo?: InputMaybe<Scalars['Int']['input']>;
  cardReplacementNo?: InputMaybe<Scalars['Float']['input']>;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableMemberLogin?: InputMaybe<Scalars['Boolean']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  isAddressIncorrect?: InputMaybe<Scalars['Boolean']['input']>;
  isAddressIncorrectDate?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklistedDate?: InputMaybe<Scalars['String']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidentialDate?: InputMaybe<Scalars['String']['input']>;
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  isDeceasedDate?: InputMaybe<Scalars['String']['input']>;
  isImmigrated?: InputMaybe<Scalars['Boolean']['input']>;
  isImmigratedDate?: InputMaybe<Scalars['String']['input']>;
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspendedDate?: InputMaybe<Scalars['String']['input']>;
  joinDate?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  lastModifyUserId?: InputMaybe<Scalars['Int']['input']>;
  lastValidMembershipStartDate?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveReferralId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveTeamId?: InputMaybe<Scalars['Int']['input']>;
  membershipNo?: InputMaybe<Scalars['String']['input']>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  photoMyfileId?: InputMaybe<Scalars['Int']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  proofMyfileId?: InputMaybe<Scalars['Int']['input']>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requireReview?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMemberListInput = {
  deptId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  remark: Scalars['String']['input'];
  whitelistMsgEn: Scalars['String']['input'];
  whitelistMsgSc: Scalars['String']['input'];
  whitelistMsgTc: Scalars['String']['input'];
};

export type UpdateMemberListMemberInput = {
  id: Scalars['Int']['input'];
  memberListId: Scalars['Int']['input'];
  remark: Scalars['String']['input'];
};

export type UpdateMemberRelationshipRequestInput = {
  isApprove: Scalars['Boolean']['input'];
  memberId: Scalars['Int']['input'];
  relatedMemberId: Scalars['Int']['input'];
  relationshipId: Scalars['Int']['input'];
};

export type UpdateMembershipTypeIdAndAddDonationInput = {
  myorderItemId: Scalars['Int']['input'];
  newMembershipTypeId: Scalars['Int']['input'];
};

export type UpdateMembershipTypeInput = {
  allowedNoOfDaysToRenew?: InputMaybe<Scalars['Int']['input']>;
  apcCatCodeForFee: Scalars['String']['input'];
  apcCatCodeForRenew: Scalars['String']['input'];
  aspenId?: InputMaybe<Scalars['String']['input']>;
  canApplyOnline?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  initPrice?: InputMaybe<Scalars['Float']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxAgeToWaiveStudentIdCheck?: InputMaybe<Scalars['Int']['input']>;
  membershipNoPrefix?: InputMaybe<Scalars['String']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameSc?: InputMaybe<Scalars['String']['input']>;
  nameTc?: InputMaybe<Scalars['String']['input']>;
  nextSerialNo?: InputMaybe<Scalars['Int']['input']>;
  orderDiscountPercent?: InputMaybe<Scalars['Int']['input']>;
  printNameEn?: InputMaybe<Scalars['String']['input']>;
  printNameSc?: InputMaybe<Scalars['String']['input']>;
  printNameTc?: InputMaybe<Scalars['String']['input']>;
  renewPrice?: InputMaybe<Scalars['Float']['input']>;
  validNoOfDay?: InputMaybe<Scalars['Int']['input']>;
  validNoOfMonth?: InputMaybe<Scalars['Int']['input']>;
  validNoOfYear?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMiniSiteContentInput = {
  courseTypeId: Scalars['Int']['input'];
  htmlContentEn: Scalars['String']['input'];
  htmlContentSc: Scalars['String']['input'];
  htmlContentTc: Scalars['String']['input'];
  sportGroupId?: InputMaybe<Scalars['Int']['input']>;
  sportId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMyEventFacilityListInput = {
  facilityIdList: Array<Scalars['Int']['input']>;
  ignoreAllBookingConflict?: InputMaybe<Scalars['Boolean']['input']>;
  myEventId: Scalars['Int']['input'];
};

export type UpdateMyEventInput = {
  ageCountYearOnly: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  deptId: Scalars['Int']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  earlyBirdEndDateForGroup?: InputMaybe<Scalars['String']['input']>;
  earlyBirdEndDateForGuest?: InputMaybe<Scalars['String']['input']>;
  earlyBirdEndDateForMember?: InputMaybe<Scalars['String']['input']>;
  enableForWeb: Scalars['Boolean']['input'];
  enableGroupEnrol: Scalars['Boolean']['input'];
  enableGuestEnrol: Scalars['Boolean']['input'];
  enableMemberEnrol: Scalars['Boolean']['input'];
  enableWhiteList: Scalars['Boolean']['input'];
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  enrolmentEndDateForGroup: Scalars['String']['input'];
  enrolmentEndDateForGuest: Scalars['String']['input'];
  enrolmentEndDateForMember: Scalars['String']['input'];
  enrolmentStartDateForGroup: Scalars['String']['input'];
  enrolmentStartDateForGuest: Scalars['String']['input'];
  enrolmentStartDateForMember: Scalars['String']['input'];
  facilityRemarkEn: Scalars['String']['input'];
  facilityRemarkSc: Scalars['String']['input'];
  facilityRemarkTc: Scalars['String']['input'];
  gender: FilterGender;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isTeamMode: Scalars['Boolean']['input'];
  isTeamModePricePerHead: Scalars['Boolean']['input'];
  maxAge: Scalars['Float']['input'];
  maxNoOfFemaleTeamMembers: Scalars['Int']['input'];
  maxNoOfMaleTeamMembers: Scalars['Int']['input'];
  maxNoOfTotalTeamMembers: Scalars['Int']['input'];
  minAge: Scalars['Float']['input'];
  minNoOfFemaleTeamMembers: Scalars['Int']['input'];
  minNoOfMaleTeamMembers: Scalars['Int']['input'];
  minNoOfTotalTeamMembers: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  parentMyEventId?: InputMaybe<Scalars['Int']['input']>;
  remarkEn: Scalars['String']['input'];
  remarkSc: Scalars['String']['input'];
  remarkTc: Scalars['String']['input'];
  requireTeamName: Scalars['Boolean']['input'];
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  teamGenderType: TeamGenderType;
  youtubeId: Scalars['String']['input'];
};

export type UpdateMyEventTicketTypeInput = {
  apcCatCodeForFee: Scalars['String']['input'];
  defaultFeeForGroup: Scalars['Float']['input'];
  defaultFeeForGuest: Scalars['Float']['input'];
  defaultFeeForMember: Scalars['Float']['input'];
  earlyBirdDiscountAmtForGroup: Scalars['Float']['input'];
  earlyBirdDiscountAmtForGuest: Scalars['Float']['input'];
  earlyBirdDiscountAmtForMember: Scalars['Float']['input'];
  earlyBirdDiscountPercentForGroup: Scalars['Int']['input'];
  earlyBirdDiscountPercentForGuest: Scalars['Int']['input'];
  earlyBirdDiscountPercentForMember: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isFreeSeating: Scalars['Boolean']['input'];
  maxTicketsPerMember: Scalars['Int']['input'];
  minTicketsPerMember: Scalars['Int']['input'];
  myEventId: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type UpdateMyEventWhiteListInput = {
  id: Scalars['Int']['input'];
  memberIdList: Array<Scalars['Int']['input']>;
};

export type UpdateMyorderInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  deptTransferDeptId?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  internalRemarks?: InputMaybe<Scalars['String']['input']>;
  isPhoneBooking?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfPickup?: InputMaybe<Scalars['Boolean']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  memberRemarks?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  totalCreditSpent?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMyorderItemApcInput = {
  apcCatCode: Scalars['String']['input'];
  apcCatCodeCost: Scalars['String']['input'];
  apcCatCodeMaterialFee: Scalars['String']['input'];
  myorderItemId: Scalars['Int']['input'];
};

export type UpdateMyorderItemInput = {
  descEn?: InputMaybe<Scalars['String']['input']>;
  myorderId: Scalars['Int']['input'];
  myorderItemId: Scalars['Int']['input'];
  posDiscount?: InputMaybe<Scalars['Float']['input']>;
  posSubtotalPrice?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productQty?: InputMaybe<Scalars['Int']['input']>;
  shippedQty?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNewsInput = {
  contentEn: Scalars['String']['input'];
  contentSc: Scalars['String']['input'];
  contentTc: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  publishDateTime: Scalars['String']['input'];
  titleEn: Scalars['String']['input'];
  titleSc: Scalars['String']['input'];
  titleTc: Scalars['String']['input'];
};

export type UpdateNotificationSubInput = {
  inputList: Array<UpdateNotificationSubOneInput>;
};

export type UpdateNotificationSubOneInput = {
  appPush: Scalars['Boolean']['input'];
  deptIdList: Array<Scalars['Int']['input']>;
  email: Scalars['Boolean']['input'];
  topic: NotificationTopic;
  webPush: Scalars['Boolean']['input'];
};

export type UpdateOnePermissionDeptListInput = {
  deptIdList: Array<Scalars['Int']['input']>;
  permissionType: PermissionType;
};

export type UpdateOnePermissionTypeUserDeptListInput = {
  permissionType: PermissionType;
  updateDtoList: Array<UpdateOneUserDeptListInput>;
};

export type UpdateOneUserDeptListInput = {
  deptIdList: Array<Scalars['Int']['input']>;
  domain: UserDeptListDomain;
};

export type UpdateOrganizationInput = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  address3: Scalars['String']['input'];
  address4: Scalars['String']['input'];
  code: Scalars['String']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  rgb?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};

export type UpdateOverrideLotteryGroupScoreInput = {
  id: Scalars['Int']['input'];
  score?: Scalars['Int']['input'];
};

export type UpdateProductCatInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  parentProductCatId?: InputMaybe<Scalars['Int']['input']>;
  showInWeb: Scalars['Boolean']['input'];
};

export type UpdateProductInput = {
  allowPosOversell: Scalars['Boolean']['input'];
  allowWebOversell: Scalars['Boolean']['input'];
  apcCatCodeForCost: Scalars['String']['input'];
  apcCatCodeForFee: Scalars['String']['input'];
  barcode: Scalars['String']['input'];
  cost: Scalars['Float']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isOpenItem: Scalars['Boolean']['input'];
  isVirtual: Scalars['Boolean']['input'];
  loyaltyPoint: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderLevelPercentageFeeOrDiscount: Scalars['Int']['input'];
  posDiscountAmt: Scalars['Float']['input'];
  posDiscountPercent: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
  productCatIdList: Array<Scalars['Int']['input']>;
  redeemEndDate?: InputMaybe<Scalars['String']['input']>;
  redeemEndDaysAfterPurchase: Scalars['Int']['input'];
  requireOfflineRedemption: Scalars['Boolean']['input'];
  revenueDeptId: Scalars['Int']['input'];
  showInWeb: Scalars['Boolean']['input'];
  sku: Scalars['String']['input'];
  supplier: Scalars['String']['input'];
  tagList: Array<Scalars['String']['input']>;
  webDiscountAmt: Scalars['Float']['input'];
  webDiscountPercent: Scalars['Int']['input'];
};

export type UpdateProductOrderingInput = {
  productCatId: Scalars['Int']['input'];
  productIdList: Array<Scalars['Int']['input']>;
};

export type UpdateProductSubCatOrderingInput = {
  productCatId?: InputMaybe<Scalars['Int']['input']>;
  subProductCatIdList: Array<Scalars['Int']['input']>;
};

export type UpdateRecurCourseCoachInput = {
  coachId: Scalars['Int']['input'];
  coachSalaryContractTermsId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRecurCourseCoachListInput = {
  id: Scalars['Int']['input'];
  recurCourseCoachList: Array<UpdateRecurCourseCoachInput>;
};

export type UpdateRecurCourseExceptDateListInput = {
  id: Scalars['Int']['input'];
  recurCourseExceptDateList: Array<Scalars['String']['input']>;
};

export type UpdateRecurCourseFacilityListInput = {
  facilityIdList: Array<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateRecurCourseInput = {
  accessPassDependencyIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  allowFeeAutoRecalEvenWithEnrolment?: InputMaybe<Scalars['Boolean']['input']>;
  apcCatCodeForFee?: InputMaybe<Scalars['String']['input']>;
  apcCatCodeForMaterial?: InputMaybe<Scalars['String']['input']>;
  aspenCategoryCode?: InputMaybe<Scalars['String']['input']>;
  aspenPrepaidCategoryCode?: InputMaybe<Scalars['String']['input']>;
  coachInternalRemark?: InputMaybe<Scalars['String']['input']>;
  coachRemarkEn?: InputMaybe<Scalars['String']['input']>;
  coachRemarkSc?: InputMaybe<Scalars['String']['input']>;
  coachRemarkTc?: InputMaybe<Scalars['String']['input']>;
  courseTypeId?: InputMaybe<Scalars['Int']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  descEn?: InputMaybe<Scalars['String']['input']>;
  descSc?: InputMaybe<Scalars['String']['input']>;
  descTc?: InputMaybe<Scalars['String']['input']>;
  earlyBirdDiscountAmtForGroup?: InputMaybe<Scalars['Float']['input']>;
  earlyBirdDiscountAmtForMember?: InputMaybe<Scalars['Float']['input']>;
  earlyBirdDiscountPercentForGroup?: InputMaybe<Scalars['Float']['input']>;
  earlyBirdDiscountPercentForMember?: InputMaybe<Scalars['Float']['input']>;
  enableFeeAutoRecalAfterUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  enableGroupEnrol?: InputMaybe<Scalars['Boolean']['input']>;
  enableMemberEnrol?: InputMaybe<Scalars['Boolean']['input']>;
  enableNoShowPenalty?: InputMaybe<Scalars['Boolean']['input']>;
  enablePriorityEnrolmentForLastCourseMember?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  enrolmentType?: InputMaybe<CourseEnrolmentType>;
  facilityCostPerLesson?: InputMaybe<Scalars['Float']['input']>;
  facilityRemarkEn?: InputMaybe<Scalars['String']['input']>;
  facilityRemarkSc?: InputMaybe<Scalars['String']['input']>;
  facilityRemarkTc?: InputMaybe<Scalars['String']['input']>;
  feeType?: InputMaybe<RecurCourseFeeType>;
  fixCalendarDayForEarlyBirdGroupEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixCalendarDayForEarlyBirdMemberEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixCalendarDayForGroupEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixCalendarDayForMemberEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixCalendarDayForPriorityEnrolment?: InputMaybe<Scalars['Int']['input']>;
  fixedAmountFeeForGroup?: InputMaybe<Scalars['Float']['input']>;
  fixedAmountFeeForMember?: InputMaybe<Scalars['Float']['input']>;
  fixedFacilityCost?: InputMaybe<Scalars['Float']['input']>;
  fixedMaterialCost?: InputMaybe<Scalars['Float']['input']>;
  fri?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<FilterGender>;
  id: Scalars['Int']['input'];
  isSkipPublicHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  leadNoOfDaysEarlyBirdForGroup?: InputMaybe<Scalars['Int']['input']>;
  leadNoOfDaysEarlyBirdForMember?: InputMaybe<Scalars['Int']['input']>;
  leadNoOfDaysEnrolmentForGroup?: InputMaybe<Scalars['Int']['input']>;
  leadNoOfDaysEnrolmentForMember?: InputMaybe<Scalars['Int']['input']>;
  leadNoOfDaysForCancelCourseAlert?: InputMaybe<Scalars['Int']['input']>;
  leadNoOfDaysForPriorityEnrolment?: InputMaybe<Scalars['Int']['input']>;
  lessonFeeForGroup?: InputMaybe<Scalars['Float']['input']>;
  lessonFeeForMember?: InputMaybe<Scalars['Float']['input']>;
  lessonRemark?: InputMaybe<Scalars['String']['input']>;
  limitEnrolPeriodInDefaultTimeslotOnly?: InputMaybe<Scalars['Boolean']['input']>;
  lotteryGroupName?: InputMaybe<Scalars['String']['input']>;
  materialCostPerLesson?: InputMaybe<Scalars['Float']['input']>;
  maxAge?: InputMaybe<Scalars['Float']['input']>;
  maxNoOfEnrolment?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Float']['input']>;
  minNoOfEnrolment?: InputMaybe<Scalars['Int']['input']>;
  mon?: InputMaybe<Scalars['Boolean']['input']>;
  overrideTimeDescEn?: InputMaybe<Scalars['String']['input']>;
  overrideTimeDescSc?: InputMaybe<Scalars['String']['input']>;
  overrideTimeDescTc?: InputMaybe<Scalars['String']['input']>;
  prefixNameEn?: InputMaybe<Scalars['String']['input']>;
  prefixNameSc?: InputMaybe<Scalars['String']['input']>;
  prefixNameTc?: InputMaybe<Scalars['String']['input']>;
  recurBy?: InputMaybe<RecurCourseRecurBy>;
  recurCourseApplyQuotaPeriodIdList?: Array<Scalars['Int']['input']>;
  recurFixedNoOfLesson?: InputMaybe<Scalars['Int']['input']>;
  recurNoOfCalendarMonths?: InputMaybe<Scalars['Int']['input']>;
  remarkEn?: InputMaybe<Scalars['String']['input']>;
  remarkSc?: InputMaybe<Scalars['String']['input']>;
  remarkTc?: InputMaybe<Scalars['String']['input']>;
  requireParQ?: InputMaybe<Scalars['Boolean']['input']>;
  sat?: InputMaybe<Scalars['Boolean']['input']>;
  showEnrolmentResultToPublic?: InputMaybe<Scalars['Boolean']['input']>;
  sportTypeId?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  suffixCode?: InputMaybe<Scalars['String']['input']>;
  sun?: InputMaybe<Scalars['Boolean']['input']>;
  thu?: InputMaybe<Scalars['Boolean']['input']>;
  tue?: InputMaybe<Scalars['Boolean']['input']>;
  uniformOption?: InputMaybe<Scalars['String']['input']>;
  webDiscountAmtForMember?: InputMaybe<Scalars['Float']['input']>;
  webDiscountPercentForMember?: InputMaybe<Scalars['Float']['input']>;
  wed?: InputMaybe<Scalars['Boolean']['input']>;
  yldsaStandardCourseRule?: InputMaybe<Scalars['Boolean']['input']>;
  youtubeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoleTemplateInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  roleNameList: Array<Scalars['String']['input']>;
  updateDeptDtoList: Array<UpdateOnePermissionTypeUserDeptListInput>;
  warehouseIdList: Array<Scalars['Int']['input']>;
};

export type UpdateSportTypeGroupInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  externalLink: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  shortCode: Scalars['String']['input'];
  youtubeId: Scalars['String']['input'];
};

export type UpdateSportTypeInput = {
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  externalLink: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  shortCode: Scalars['String']['input'];
  sportTypeGroupId: Scalars['Int']['input'];
  youtubeId: Scalars['String']['input'];
};

export type UpdateStaffMemberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  aspenSeqNo?: InputMaybe<Scalars['String']['input']>;
  autoRenewNoOfTrial?: InputMaybe<Scalars['Int']['input']>;
  autoRenewNotificationSentDateTime?: InputMaybe<Scalars['String']['input']>;
  cardIssueDate?: InputMaybe<Scalars['String']['input']>;
  cardLostNo?: InputMaybe<Scalars['Int']['input']>;
  cardReplacementNo?: InputMaybe<Scalars['Float']['input']>;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableMemberLogin?: InputMaybe<Scalars['Boolean']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName: Scalars['String']['input'];
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isAddressIncorrect?: InputMaybe<Scalars['Boolean']['input']>;
  isAddressIncorrectDate?: InputMaybe<Scalars['String']['input']>;
  isBlacklisted?: InputMaybe<Scalars['Boolean']['input']>;
  isBlacklistedDate?: InputMaybe<Scalars['String']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidentialDate?: InputMaybe<Scalars['String']['input']>;
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  isDeceasedDate?: InputMaybe<Scalars['String']['input']>;
  isImmigrated?: InputMaybe<Scalars['Boolean']['input']>;
  isImmigratedDate?: InputMaybe<Scalars['String']['input']>;
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspendedDate?: InputMaybe<Scalars['String']['input']>;
  joinDate?: InputMaybe<Scalars['String']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  lastValidMembershipStartDate?: InputMaybe<Scalars['String']['input']>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  loginMobile?: InputMaybe<Scalars['String']['input']>;
  memDriveDepositTotal?: InputMaybe<Scalars['Float']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveReferralId?: InputMaybe<Scalars['Int']['input']>;
  membershipDriveTeamId?: InputMaybe<Scalars['Int']['input']>;
  membershipNo?: InputMaybe<Scalars['String']['input']>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  photoMyfileId?: InputMaybe<Scalars['Int']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  proofMyfileId?: InputMaybe<Scalars['Int']['input']>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requireReview?: InputMaybe<Scalars['Boolean']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSwpFeeInput = {
  accessPassId?: InputMaybe<Scalars['Int']['input']>;
  apcCatCodeForFee: Scalars['String']['input'];
  fee: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
};

export type UpdateSwpSessionInput = {
  code: Scalars['String']['input'];
  dayType: WeekdayType;
  endTime: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  monthlyPassStartTime: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  startTime: Scalars['String']['input'];
};

export type UpdateSwpTestCardQrCodeInput = {
  id: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
  validUntilDateTime: Scalars['String']['input'];
};

export type UpdateTextTemplateInput = {
  docType: Scalars['String']['input'];
  htmlContent: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  msgPlatform: MsgPlatform;
  name: Scalars['String']['input'];
  plainContent: Scalars['String']['input'];
  shareTo: ShareTo;
  title: Scalars['String']['input'];
  waBodyDataMapping?: InputMaybe<Scalars['String']['input']>;
  waButtonDataMapping?: InputMaybe<Scalars['String']['input']>;
  waHeaderDataMapping?: InputMaybe<Scalars['String']['input']>;
  waMediaDataMapping: Scalars['String']['input'];
  waMediaDataUrl: Scalars['String']['input'];
  waTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTimeSlotProgramDailySummaryInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  timeSlotProgramId: Scalars['Int']['input'];
};

export type UpdateTimeSlotProgramGroupInput = {
  disableForWeb: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
};

export type UpdateTimeSlotProgramInput = {
  ageCalcType: AgeCalcType;
  customStringLabel01En: Scalars['String']['input'];
  customStringLabel01Sc: Scalars['String']['input'];
  customStringLabel01Tc: Scalars['String']['input'];
  customStringLabel02En: Scalars['String']['input'];
  customStringLabel02Sc: Scalars['String']['input'];
  customStringLabel02Tc: Scalars['String']['input'];
  customStringLabel03En: Scalars['String']['input'];
  customStringLabel03Sc: Scalars['String']['input'];
  customStringLabel03Tc: Scalars['String']['input'];
  customStringLabel04En: Scalars['String']['input'];
  customStringLabel04Sc: Scalars['String']['input'];
  customStringLabel04Tc: Scalars['String']['input'];
  customStringLabel05En: Scalars['String']['input'];
  customStringLabel05Sc: Scalars['String']['input'];
  customStringLabel05Tc: Scalars['String']['input'];
  customStringLabel06En: Scalars['String']['input'];
  customStringLabel06Sc: Scalars['String']['input'];
  customStringLabel06Tc: Scalars['String']['input'];
  customStringLabel07En: Scalars['String']['input'];
  customStringLabel07Sc: Scalars['String']['input'];
  customStringLabel07Tc: Scalars['String']['input'];
  customStringLabel08En: Scalars['String']['input'];
  customStringLabel08Sc: Scalars['String']['input'];
  customStringLabel08Tc: Scalars['String']['input'];
  customStringLabel09En: Scalars['String']['input'];
  customStringLabel09Sc: Scalars['String']['input'];
  customStringLabel09Tc: Scalars['String']['input'];
  customStringLabel10En: Scalars['String']['input'];
  customStringLabel10Sc: Scalars['String']['input'];
  customStringLabel10Tc: Scalars['String']['input'];
  deptId: Scalars['Int']['input'];
  descEn: Scalars['String']['input'];
  descSc: Scalars['String']['input'];
  descTc: Scalars['String']['input'];
  enableForWeb: Scalars['Boolean']['input'];
  endDate: Scalars['String']['input'];
  gender: FilterGender;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isMemberOnly: Scalars['Boolean']['input'];
  isNoIdentityCheckMode: Scalars['Boolean']['input'];
  maxAge: Scalars['Float']['input'];
  maxNoOfServiceTypesPerReservation: Scalars['Int']['input'];
  maxQuota: Scalars['Int']['input'];
  minAge: Scalars['Float']['input'];
  minNoOfServiceTypesPerReservation: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  posNoOfDaysAfterTodayToEndReserve: Scalars['Int']['input'];
  posNoOfDaysAfterTodayToStartReserve: Scalars['Int']['input'];
  posNoOfDaysToCancel: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
  timeSlotMins: Scalars['Int']['input'];
  timeSlotProgramGroupId?: InputMaybe<Scalars['Int']['input']>;
  tnc: Scalars['String']['input'];
  webNoOfDaysAfterTodayToEndReserve: Scalars['Int']['input'];
  webNoOfDaysAfterTodayToStartReserve: Scalars['Int']['input'];
  webNoOfDaysToCancel: Scalars['Int']['input'];
};

export type UpdateTimeSlotProgramLocationInput = {
  id: Scalars['Int']['input'];
  locationQuota: Scalars['Int']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  quotaPerDay: Scalars['Int']['input'];
};

export type UpdateTimeSlotProgramOpeningHourInput = {
  dayList: Array<Scalars['String']['input']>;
  dayType: WeekdayType;
  disableForWeb: Scalars['Boolean']['input'];
  endTime: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  orderId: Scalars['Float']['input'];
  startTime: Scalars['String']['input'];
  timeSlotProgramLocationId: Scalars['Int']['input'];
  timeslotQuota: Scalars['Int']['input'];
};

export type UpdateTimeSlotProgramReservationInput = {
  customString01: Scalars['String']['input'];
  customString02: Scalars['String']['input'];
  customString03: Scalars['String']['input'];
  customString04: Scalars['String']['input'];
  customString05: Scalars['String']['input'];
  customString06: Scalars['String']['input'];
  customString07: Scalars['String']['input'];
  customString08: Scalars['String']['input'];
  customString09: Scalars['String']['input'];
  customString10: Scalars['String']['input'];
  endDateTime: Scalars['String']['input'];
  ignoreAgeCheck?: Scalars['Boolean']['input'];
  memberId: Scalars['Int']['input'];
  oldReservationId: Scalars['Int']['input'];
  refMembershipNo: Scalars['String']['input'];
  remark: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  timeSlotProgramLocationId: Scalars['Int']['input'];
  timeSlotProgramServiceTypeIdList?: Array<Scalars['Int']['input']>;
};

export type UpdateTimeSlotProgramReservationRemarkInput = {
  remark: Scalars['String']['input'];
  reservationId: Scalars['Int']['input'];
};

export type UpdateTimeSlotProgramServiceTypeInput = {
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
};

export type UpdateTimeslotProgramGridHourInput = {
  endTime: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  timeSlotProgramLocationId: Scalars['Int']['input'];
};

export type UpdateTrialMemberInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  address5?: InputMaybe<Scalars['String']['input']>;
  addressCountryId?: InputMaybe<Scalars['Int']['input']>;
  allowToSelfCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  autoRenewNoOfTrial?: InputMaybe<Scalars['Int']['input']>;
  autoRenewNotificationSentDateTime?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  chineseName?: InputMaybe<Scalars['String']['input']>;
  customString01?: InputMaybe<Scalars['String']['input']>;
  customString02?: InputMaybe<Scalars['String']['input']>;
  customString03?: InputMaybe<Scalars['String']['input']>;
  customString04?: InputMaybe<Scalars['String']['input']>;
  customString05?: InputMaybe<Scalars['String']['input']>;
  customString06?: InputMaybe<Scalars['String']['input']>;
  customString07?: InputMaybe<Scalars['String']['input']>;
  customString08?: InputMaybe<Scalars['String']['input']>;
  customString09?: InputMaybe<Scalars['String']['input']>;
  customString10?: InputMaybe<Scalars['String']['input']>;
  disableNoShowPenaltyUntilDate?: InputMaybe<Scalars['String']['input']>;
  districtId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyTel?: InputMaybe<Scalars['String']['input']>;
  emergencyTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  enableAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  favouriteSportId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<FilterGender>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hkid?: InputMaybe<Scalars['String']['input']>;
  hkidPartial?: InputMaybe<Scalars['String']['input']>;
  homeTel?: InputMaybe<Scalars['String']['input']>;
  homeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  languagePreference?: InputMaybe<LanguagePreference>;
  lastValidMembershipStartDate?: InputMaybe<Scalars['String']['input']>;
  memberLocationId?: InputMaybe<Scalars['Int']['input']>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  mobileTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  msgPlatform?: InputMaybe<MsgPlatform>;
  nationalityId?: InputMaybe<Scalars['Int']['input']>;
  officeTel?: InputMaybe<Scalars['String']['input']>;
  officeTelAreaCode?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  printFormat?: InputMaybe<MemberNamePrintFormat>;
  pushReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  referralOrgId?: InputMaybe<Scalars['Int']['input']>;
  searchKey?: InputMaybe<Scalars['String']['input']>;
  smsReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  studentExpiryDate?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
  subscribeNews?: InputMaybe<Scalars['Boolean']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserCoachServiceRelInput = {
  coachFee: Scalars['Float']['input'];
  coachSalaryContractTermsId?: InputMaybe<Scalars['Int']['input']>;
  coachServiceId: Scalars['Int']['input'];
  isWebEnabled: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type UpdateUserDeptListPerDomainInput = {
  domain: UserDeptListDomain;
  updateDtoList: Array<UpdateOnePermissionDeptListInput>;
  userId: Scalars['Int']['input'];
};

export type UpdateUserDeptListPerPermissionTypeInput = {
  permissionType: PermissionType;
  updateDtoList: Array<UpdateOneUserDeptListInput>;
  userId: Scalars['Int']['input'];
};

export type UpdateUserEnableInput = {
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
};

export type UpdateUserInput = {
  aspenUserCode?: InputMaybe<Scalars['String']['input']>;
  coachAllowSameTimeslotBooking?: InputMaybe<Scalars['Boolean']['input']>;
  coachRemarkEn?: InputMaybe<Scalars['String']['input']>;
  coachRemarkSc?: InputMaybe<Scalars['String']['input']>;
  coachRemarkTc?: InputMaybe<Scalars['String']['input']>;
  coachTimeslotEndTime?: InputMaybe<Scalars['String']['input']>;
  coachTimeslotMins?: InputMaybe<Scalars['Int']['input']>;
  coachTimeslotStartTime?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  defaultReceiptName?: InputMaybe<Scalars['String']['input']>;
  deptId?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isEquipmentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  isSuspensedDueToWrongPassword?: InputMaybe<Scalars['Boolean']['input']>;
  isVenueTeam?: InputMaybe<Scalars['Boolean']['input']>;
  languagePreference?: InputMaybe<LanguagePreference>;
  mobileTel?: InputMaybe<Scalars['String']['input']>;
  monthlySalary?: InputMaybe<Scalars['Float']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  ssoMapping?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['Float']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProductGroupInput = {
  column: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  row: Scalars['Int']['input'];
};

export type UpdateUserProductGroupListOrderIdInput = {
  userProductGroupIdList: Array<Scalars['Int']['input']>;
};

export type UpdateUserProductGroupProductOrderingInput = {
  id: Scalars['Int']['input'];
  productOrderingList: Array<ProductOrderingInput>;
};

export type UpdateUserProductInput = {
  icon: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateUserRoleListInput = {
  id: Scalars['Int']['input'];
  userRoleList: Array<Scalars['String']['input']>;
};

export type UpdateUserWarehouseListInput = {
  userId: Scalars['Int']['input'];
  warehouseIdList: Array<Scalars['Int']['input']>;
};

export type UpdateWarehouseInput = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  address3: Scalars['String']['input'];
  address4: Scalars['String']['input'];
  cutoffTime: Scalars['String']['input'];
  districtId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  isPosEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWarehousePartitionInput = {
  code: Scalars['String']['input'];
  deptId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
  nameEn: Scalars['String']['input'];
  nameSc: Scalars['String']['input'];
  nameTc: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWarehouseStockTakeInput = {
  deptId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  remark: Scalars['String']['input'];
};

export type UpdateWhatsappSummaryInput = {
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  markAllAsRead?: InputMaybe<Scalars['Boolean']['input']>;
  waId: Scalars['String']['input'];
};

export type UpdateWhatsappTemplateInput = {
  id: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type UploadFileInput = {
  b64Content: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  url?: Scalars['String']['input'];
};

export type UploadImageInput = {
  b64Content: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  url?: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  aspenUserCode: Scalars['String']['output'];
  coachFee: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type UserAddCourseEnrolmentInput = {
  courseId: Scalars['Int']['input'];
  enrolMemberId: Scalars['Int']['input'];
  forceAdd?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreAgeCheck?: Scalars['Boolean']['input'];
  ignoreDateCheck?: Scalars['Boolean']['input'];
  ignoreMemberRelationship: Scalars['Boolean']['input'];
  ignoreMemberScheduleConflict: Scalars['Boolean']['input'];
  lessonIdList?: InputMaybe<Array<Scalars['Int']['input']>>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  myorderItemId?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
  uniformOption: Scalars['String']['input'];
};

export type UserAddMemberToWaitingList = {
  courseId: Scalars['Int']['input'];
  enrolMemberId: Scalars['Int']['input'];
  ignoreAgeCheck?: Scalars['Boolean']['input'];
  ignoreDateCheck?: Scalars['Boolean']['input'];
  ignoreMemberRelationship: Scalars['Boolean']['input'];
  ignoreMemberScheduleConflict: Scalars['Boolean']['input'];
  memberId: Scalars['Int']['input'];
};

export type UserCleanUserSessionInput = {
  sessionIdList?: Array<Scalars['Int']['input']>;
};

export type UserCoachServiceRel = {
  __typename?: 'UserCoachServiceRel';
  coach?: Maybe<User>;
  coachFee: Scalars['Float']['output'];
  coachSalaryContractTerms?: Maybe<CoachSalaryContractTerms>;
  coachSalaryContractTermsId?: Maybe<Scalars['Int']['output']>;
  coachService?: Maybe<CoachService>;
  coachServiceId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isWebEnabled: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
};

export type UserDeleteMemberParQInput = {
  id: Scalars['Int']['input'];
};

export enum UserDeptListDomain {
  AccessPass = 'accessPass',
  Coach = 'coach',
  CoachSalaryReport = 'coachSalaryReport',
  CoachService = 'coachService',
  CouponPackage = 'couponPackage',
  Course = 'course',
  CreditPackage = 'creditPackage',
  Deposit = 'deposit',
  Facility = 'facility',
  Inventory = 'inventory',
  Locker = 'locker',
  MemberList = 'memberList',
  Myevent = 'myevent',
  Organization = 'organization',
  Product = 'product',
  TimeSlotProgram = 'timeSlotProgram'
}

export type UserDeptListResGql = {
  __typename?: 'UserDeptListResGql';
  deptList: Array<Department>;
  domain: UserDeptListDomain;
  permissionType: PermissionType;
};

export type UserGetMemberParQInput = {
  id: Scalars['Int']['input'];
};

export type UserGetMsgQueueInput = {
  id: Scalars['Int']['input'];
};

export type UserGetOrderPaymentMethodSummaryInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UserGetUserDeptListPerDomainInput = {
  domain: UserDeptListDomain;
};

export type UserGetUserDeptListPerPermissionTypeInput = {
  permissionType: PermissionType;
};

export type UserGetWarehousePartitionListByPermissionInput = {
  excludeNullDept: Scalars['Boolean']['input'];
  excludeSystem: Scalars['Boolean']['input'];
  permissionType: PermissionType;
};

export type UserMarkMsgQueueAsReadInput = {
  msgQueueId: Scalars['Int']['input'];
};

export type UserProduct = {
  __typename?: 'UserProduct';
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Float']['output'];
  product?: Maybe<Product>;
  productId: Scalars['Int']['output'];
  userProductGroupId: Scalars['Int']['output'];
};

export type UserProductGroup = {
  __typename?: 'UserProductGroup';
  column: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  row: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  userProductList?: Maybe<Array<UserProduct>>;
};

export type UserRemoveGpTokenInput = {
  deletedReason: Scalars['String']['input'];
  htmlContent: Scalars['String']['input'];
  msgPlatform: MsgPlatform;
  plainContent: Scalars['String']['input'];
  title: Scalars['String']['input'];
  tokenPairList: Array<RemoveGpTokenPairInput>;
};

export type UserRole = {
  __typename?: 'UserRole';
  id: Scalars['Int']['output'];
  roleName: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type UserRoleResGql = {
  __typename?: 'UserRoleResGql';
  desc: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requireOther?: Maybe<Array<Scalars['String']['output']>>;
};

export type UserRoleSettingResGql = {
  __typename?: 'UserRoleSettingResGql';
  categoryName: Scalars['String']['output'];
  roleList: Array<UserRoleResGql>;
};

export type UserSearchMemberSessionInput = {
  andCondList?: Array<QueryCondMemberSessionInput>;
  noOfItemsPerPage?: Scalars['Int']['input'];
  orCondList?: Array<QueryCondMemberSessionInput>;
  orderBy?: InputMaybe<QueryOrderByMemberSessionInput>;
  orderByList?: InputMaybe<Array<QueryOrderByMemberSessionInput>>;
  pageNo?: Scalars['Int']['input'];
  showAllForAdmin?: Scalars['Boolean']['input'];
};

export type UserSearchMemberSessionResGql = {
  __typename?: 'UserSearchMemberSessionResGql';
  currentPageNo: Scalars['Int']['output'];
  itemList: Array<MySession>;
  totalNum: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type UserSubmitParQInput = {
  d1: Scalars['Boolean']['input'];
  internalRemark: Scalars['String']['input'];
  memberId: Scalars['Int']['input'];
  q1: Scalars['Boolean']['input'];
  q2: Scalars['Boolean']['input'];
  q3: Scalars['Boolean']['input'];
  q4: Scalars['Boolean']['input'];
  q5: Scalars['Boolean']['input'];
  q6: Scalars['Boolean']['input'];
  q7: Scalars['Boolean']['input'];
  remark: Scalars['String']['input'];
  signature: UploadImageInput;
};

export type UserUpdateInboxStatusInput = {
  action: InboxAction;
  idList: Array<Scalars['Int']['input']>;
};

export type UserUpdateLockerInput = {
  id: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  remark: Scalars['String']['input'];
};

export type UserUpdateMemberParQInput = {
  id: Scalars['Int']['input'];
  internalRemark: Scalars['String']['input'];
  rejectUntilDate?: InputMaybe<Scalars['String']['input']>;
  remark: Scalars['String']['input'];
  status: MemberParQStatus;
  validUntilDate?: InputMaybe<Scalars['String']['input']>;
};

export type UserVoidMyorderInput = {
  id: Scalars['Int']['input'];
  reference1?: InputMaybe<Scalars['String']['input']>;
  reference2?: InputMaybe<Scalars['String']['input']>;
  reference3?: InputMaybe<Scalars['String']['input']>;
  reference4?: InputMaybe<Scalars['String']['input']>;
};

export type UserWarehouse = {
  __typename?: 'UserWarehouse';
  id: Scalars['Int']['output'];
  user?: Maybe<FullUser>;
  userId: Scalars['Int']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['Int']['output'];
};

export type ValidateRefundPayoutAccessTokenInput = {
  refundPayoutRequestId: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};

export type VoidBonusPointReceiptRegInput = {
  id: Scalars['Int']['input'];
};

export enum WaMessageTypesEnum {
  Audio = 'audio',
  Contacts = 'contacts',
  Document = 'document',
  Image = 'image',
  Interactive = 'interactive',
  Location = 'location',
  Reaction = 'reaction',
  Sticker = 'sticker',
  Template = 'template',
  Text = 'text',
  Unsupported = 'unsupported',
  Video = 'video'
}

export enum WaStatusEnum {
  Delivered = 'delivered',
  Failed = 'failed',
  Read = 'read',
  Sent = 'sent'
}

export type Warehouse = {
  __typename?: 'Warehouse';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  address3: Scalars['String']['output'];
  address4: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  cutoffTime: Scalars['String']['output'];
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isPosEnabled: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subDistrict?: Maybe<SubDistrict>;
  subDistrictId?: Maybe<Scalars['Int']['output']>;
  sysPartition?: Maybe<WarehousePartition>;
  sysPartitionId: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  warehousePartitionList?: Maybe<Array<WarehousePartition>>;
};

export type WarehouseInventory = {
  __typename?: 'WarehouseInventory';
  createdDate: Scalars['String']['output'];
  holdQty: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pendingInQty: Scalars['Int']['output'];
  pendingOutQty: Scalars['Int']['output'];
  physicalQty: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productId: Scalars['Int']['output'];
  scrapedHoldQty: Scalars['Int']['output'];
  scrapedPendingInQty: Scalars['Int']['output'];
  scrapedPendingOutQty: Scalars['Int']['output'];
  scrapedPhysicalQty: Scalars['Int']['output'];
  scrapedUsableQty: Scalars['Int']['output'];
  updatedDate: Scalars['String']['output'];
  usableQty: Scalars['Int']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
  warehousePartition?: Maybe<WarehousePartition>;
  warehousePartitionId?: Maybe<Scalars['Int']['output']>;
};

export type WarehousePartition = {
  __typename?: 'WarehousePartition';
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  dept?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEnable: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  nameEn: Scalars['String']['output'];
  nameSc: Scalars['String']['output'];
  nameTc: Scalars['String']['output'];
  parentWarehousePartition?: Maybe<WarehousePartition>;
  parentWarehousePartitionId?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
};

export type WarehouseStockTake = {
  __typename?: 'WarehouseStockTake';
  canDelete: Scalars['Boolean']['output'];
  canModifyStockTakeProductList: Scalars['Boolean']['output'];
  createdDate: Scalars['String']['output'];
  department?: Maybe<Department>;
  deptId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  inventoryTxGroup?: Maybe<InventoryTxGroup>;
  inventoryTxGroupId: Scalars['Int']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  isVoided: Scalars['Boolean']['output'];
  lastModifyUser?: Maybe<User>;
  lastModifyUserId: Scalars['Int']['output'];
  remark: Scalars['String']['output'];
  updatedDate: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['Int']['output'];
  warehouseStockTakeProductList?: Maybe<Array<WarehouseStockTakeProduct>>;
};

export type WarehouseStockTakeDeltaResGql = {
  __typename?: 'WarehouseStockTakeDeltaResGql';
  curQty: Scalars['Int']['output'];
  curScrapedQty: Scalars['Int']['output'];
  inputQty: Scalars['Int']['output'];
  inputScrapedQty: Scalars['Int']['output'];
  product: Product;
  warehousePartition: WarehousePartition;
};

export type WarehouseStockTakeProduct = {
  __typename?: 'WarehouseStockTakeProduct';
  id: Scalars['Int']['output'];
  normalQty: Scalars['Int']['output'];
  normalQtyBefore?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Product>;
  productId: Scalars['Int']['output'];
  scrapedQty: Scalars['Int']['output'];
  scrapedQtyBefore?: Maybe<Scalars['Int']['output']>;
  tmpForGenCheck: Scalars['Boolean']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['Int']['output'];
  warehouseInventory?: Maybe<WarehouseInventory>;
  warehousePartition?: Maybe<WarehousePartition>;
  warehousePartitionId: Scalars['Int']['output'];
  warehouseStockTake?: Maybe<WarehouseStockTake>;
  warehouseStockTakeId: Scalars['Int']['output'];
};

export type WebPushSubscriptionKeysInput = {
  auth: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type WebPushSubscriptionUpdateInput = {
  endpoint: Scalars['String']['input'];
  keys: WebPushSubscriptionKeysInput;
};

export enum WeekdayType {
  Fri = 'Fri',
  FriExceptHoliday = 'FriExceptHoliday',
  FriToSat = 'FriToSat',
  FriToSatExceptHoliday = 'FriToSatExceptHoliday',
  Mon = 'Mon',
  MonExceptHoliday = 'MonExceptHoliday',
  MonToFri = 'MonToFri',
  MonToFriExceptHoliday = 'MonToFriExceptHoliday',
  MonToSun = 'MonToSun',
  MonToThr = 'MonToThr',
  MonToThrExceptHoliday = 'MonToThrExceptHoliday',
  MonWedFri = 'MonWedFri',
  MonWedFriExceptHoliday = 'MonWedFriExceptHoliday',
  NonHoliday = 'NonHoliday',
  Sat = 'Sat',
  SatExceptHoliday = 'SatExceptHoliday',
  SatSun = 'SatSun',
  SatSunHoliday = 'SatSunHoliday',
  SpecifyDays = 'SpecifyDays',
  Sun = 'Sun',
  SunExceptHoliday = 'SunExceptHoliday',
  Thu = 'Thu',
  ThuExceptHoliday = 'ThuExceptHoliday',
  Tue = 'Tue',
  TueExceptHoliday = 'TueExceptHoliday',
  TueThuSat = 'TueThuSat',
  TueThuSatExceptHoliday = 'TueThuSatExceptHoliday',
  Wed = 'Wed',
  WedExceptHoliday = 'WedExceptHoliday'
}

export type WhatsappSummary = {
  __typename?: 'WhatsappSummary';
  id: Scalars['Int']['output'];
  isHidden: Scalars['Boolean']['output'];
  isPinned: Scalars['Boolean']['output'];
  lastMessage: Scalars['String']['output'];
  lastMessageDate: Scalars['String']['output'];
  lastReceiveDate?: Maybe<Scalars['String']['output']>;
  profileName: Scalars['String']['output'];
  unreadCount: Scalars['Int']['output'];
  waBsuId: Scalars['String']['output'];
  waId: Scalars['String']['output'];
};

export type WhatsappTemplate = {
  __typename?: 'WhatsappTemplate';
  businessAccountId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rawData: Scalars['String']['output'];
  status: Scalars['String']['output'];
  waTemplateId: Scalars['String']['output'];
};

export type WithdrawCreditInput = {
  creditTypeId?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['Int']['input'];
  paymentMethod: Scalars['String']['input'];
  withdrawAmount: Scalars['Int']['input'];
};

export type YldsaOldCourseRefund = {
  __typename?: 'YldsaOldCourseRefund';
  id: Scalars['Int']['output'];
  myorderItemId: Scalars['Int']['output'];
  oldCourseCode: Scalars['String']['output'];
  oldYearMonth: Scalars['String']['output'];
};

export type YldsaRegisterMemberLoginKeyInput = {
  birthDate: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  membershipNo: Scalars['String']['input'];
  mobileTel: Scalars['String']['input'];
  password: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export type SearchAccessPassQueryVariables = Exact<{
  input: SearchAccessPassInput;
}>;


export type SearchAccessPassQuery = { __typename?: 'Query', searchAccessPass: { __typename?: 'SearchAccessPassResGql', itemList: Array<{ __typename?: 'AccessPass', id: number, nameTc: string, nameSc: string, nameEn: string, tncTc: string, tncSc: string, tncEn: string, minAge: number, maxAge: number }> } };

export type MeGetAccessPassPurchaseListQueryVariables = Exact<{
  input: MeGetAccessPassPurchaseListInput;
}>;


export type MeGetAccessPassPurchaseListQuery = { __typename?: 'Query', meGetAccessPassPurchaseList: Array<{ __typename?: 'AccessPassPurchaseResGql', accessPass: { __typename?: 'AccessPass', id: number, nameTc: string, nameSc: string, nameEn: string, tncTc: string, tncSc: string, tncEn: string, minAge: number, maxAge: number }, purchaseInfoList: Array<{ __typename?: 'AccessPassOptionPurchaseResGql', canNew: boolean, newStartDate?: string | null, newEndDate?: string | null, initPrice: number, canRenew: boolean, renewStartDate?: string | null, renewEndDate?: string | null, renewPrice: number, requiredDeposit: number, cannotNewReasonDesc: string, cannotRenewReasonDesc: string, accessPassOption?: { __typename?: 'AccessPassOption', id: number, nameTc: string, nameSc: string, nameEn: string } | null }> }> };

export type AccessPassSimpleFragment = { __typename?: 'AccessPass', id: number, nameTc: string, nameSc: string, nameEn: string, tncTc: string, tncSc: string, tncEn: string, minAge: number, maxAge: number };

export type AccessPassOptionSimpleFragment = { __typename?: 'AccessPassOption', id: number, nameTc: string, nameSc: string, nameEn: string };

export type AccessPassPurchaseListFragment = { __typename?: 'AccessPassPurchaseResGql', accessPass: { __typename?: 'AccessPass', id: number, nameTc: string, nameSc: string, nameEn: string, tncTc: string, tncSc: string, tncEn: string, minAge: number, maxAge: number }, purchaseInfoList: Array<{ __typename?: 'AccessPassOptionPurchaseResGql', canNew: boolean, newStartDate?: string | null, newEndDate?: string | null, initPrice: number, canRenew: boolean, renewStartDate?: string | null, renewEndDate?: string | null, renewPrice: number, requiredDeposit: number, cannotNewReasonDesc: string, cannotRenewReasonDesc: string, accessPassOption?: { __typename?: 'AccessPassOption', id: number, nameTc: string, nameSc: string, nameEn: string } | null }> };

export type AccessPassOptionPurchaseInfoFragment = { __typename?: 'AccessPassOptionPurchaseResGql', canNew: boolean, newStartDate?: string | null, newEndDate?: string | null, initPrice: number, canRenew: boolean, renewStartDate?: string | null, renewEndDate?: string | null, renewPrice: number, requiredDeposit: number, cannotNewReasonDesc: string, cannotRenewReasonDesc: string, accessPassOption?: { __typename?: 'AccessPassOption', id: number, nameTc: string, nameSc: string, nameEn: string } | null };

export type MeSearchCreditPackageQueryVariables = Exact<{
  input: SearchCreditPackageInput;
}>;


export type MeSearchCreditPackageQuery = { __typename?: 'Query', meSearchCreditPackage: { __typename?: 'SearchCreditPackageResGql', itemList: Array<{ __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> } };

export type CreditPackageSimpleFragment = { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null };

export type ClientGetFacilityBookingSummaryQueryVariables = Exact<{
  input: GetFacilityBookingSummaryInput;
}>;


export type ClientGetFacilityBookingSummaryQuery = { __typename?: 'Query', clientGetFacilityBookingSummary: Array<{ __typename?: 'GetFacilityBookingSummaryResGql', displayDate: string, facilityBookingDailyTimeSlotDtoList: Array<{ __typename?: 'FacilityBookingDailyTimeSlotResGql', gridDisplayName: string, timeslotInfoList: Array<{ __typename?: 'FacilityBookingTimeslotResGql', fee: number, isFree: boolean, isPeakHour: boolean, startDateTime: string, endDateTime: string }> }> }> };

export type MeGetEffectiveFacilityLeadTimeForMemberQueryVariables = Exact<{
  input: MeGetFacilityEffectiveLeadTimeForMemberInput;
}>;


export type MeGetEffectiveFacilityLeadTimeForMemberQuery = { __typename?: 'Query', meGetEffectiveFacilityLeadTimeForMember: { __typename?: 'GetFacilityEffectiveLeadTimeForMemberResGql', minLeadTimeInDays: number, maxLeadTimeInDays: number } };

export type FacilitySimpleFragment = { __typename?: 'Facility', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string };

export type FacilityListFragment = { __typename?: 'Facility', id: number, enableForWeb: boolean, shortCode: string, nameEn: string, nameTc: string, nameSc: string, startTime: string, endTime: string, timeSlotMins: number, minNoOfTimeslot: number, maxNoOfTimeslot: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string } | null };

export type FacilityBookingSummaryFragment = { __typename?: 'GetFacilityBookingSummaryResGql', displayDate: string, facilityBookingDailyTimeSlotDtoList: Array<{ __typename?: 'FacilityBookingDailyTimeSlotResGql', gridDisplayName: string, timeslotInfoList: Array<{ __typename?: 'FacilityBookingTimeslotResGql', fee: number, isFree: boolean, isPeakHour: boolean, startDateTime: string, endDateTime: string }> }> };

export type FacilityBookingTimeslotFragment = { __typename?: 'FacilityBookingTimeslotResGql', fee: number, isFree: boolean, isPeakHour: boolean, startDateTime: string, endDateTime: string };

export type SearchLocationQueryVariables = Exact<{
  input: SearchLocationInput;
}>;


export type SearchLocationQuery = { __typename?: 'Query', searchLocation: { __typename?: 'SearchLocationResGql', totalNum: number, itemList: Array<{ __typename?: 'Location', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationAreaList?: Array<{ __typename?: 'LocationArea', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationId: number, orderId: number, location?: { __typename?: 'Location', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null, facilityList?: Array<{ __typename?: 'Facility', id: number, enableForWeb: boolean, shortCode: string, nameEn: string, nameTc: string, nameSc: string, startTime: string, endTime: string, timeSlotMins: number, minNoOfTimeslot: number, maxNoOfTimeslot: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string } | null }> | null }> | null }> } };

export type SearchLocationAreaQueryVariables = Exact<{
  input: SearchLocationAreaInput;
}>;


export type SearchLocationAreaQuery = { __typename?: 'Query', searchLocationArea: { __typename?: 'SearchLocationAreaResGql', totalNum: number, itemList: Array<{ __typename?: 'LocationArea', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationId: number, orderId: number, location?: { __typename?: 'Location', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null, facilityList?: Array<{ __typename?: 'Facility', id: number, enableForWeb: boolean, shortCode: string, nameEn: string, nameTc: string, nameSc: string, startTime: string, endTime: string, timeSlotMins: number, minNoOfTimeslot: number, maxNoOfTimeslot: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string } | null }> | null }> } };

export type LocationSimpleFragment = { __typename?: 'Location', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string };

export type LocationDetailsFragment = { __typename?: 'Location', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationAreaList?: Array<{ __typename?: 'LocationArea', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationId: number, orderId: number, location?: { __typename?: 'Location', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null, facilityList?: Array<{ __typename?: 'Facility', id: number, enableForWeb: boolean, shortCode: string, nameEn: string, nameTc: string, nameSc: string, startTime: string, endTime: string, timeSlotMins: number, minNoOfTimeslot: number, maxNoOfTimeslot: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string } | null }> | null }> | null };

export type LocationAreaSimpleFragment = { __typename?: 'LocationArea', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationId: number };

export type LocationAreaDetailsFragment = { __typename?: 'LocationArea', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationId: number, orderId: number, location?: { __typename?: 'Location', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null, facilityList?: Array<{ __typename?: 'Facility', id: number, enableForWeb: boolean, shortCode: string, nameEn: string, nameTc: string, nameSc: string, startTime: string, endTime: string, timeSlotMins: number, minNoOfTimeslot: number, maxNoOfTimeslot: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string } | null }> | null };

export type GetSelectionJsonQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelectionJsonQuery = { __typename?: 'Query', getSelectionJson: { __typename?: 'GetSelectionJsonResGql', sportTypeList: Array<{ __typename?: 'SportType', id: number, nameEn: string, nameTc: string, nameSc: string }>, countryList: Array<{ __typename?: 'Country', id: number, nameTc: string, nameSc: string, nameEn: string }>, districtList: Array<{ __typename?: 'District', id: number, nameTc: string, nameSc: string, nameEn: string, memberLocationId: number, subDistrictList?: Array<{ __typename?: 'SubDistrict', id: number, nameTc: string, nameSc: string, nameEn: string }> | null }>, locationList: Array<{ __typename?: 'MemberLocation', id: number, nameTc: string, nameSc: string, nameEn: string }>, facilityLocationList: Array<{ __typename?: 'Location', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationAreaList?: Array<{ __typename?: 'LocationArea', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationId: number, orderId: number, location?: { __typename?: 'Location', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null, facilityList?: Array<{ __typename?: 'Facility', id: number, enableForWeb: boolean, shortCode: string, nameEn: string, nameTc: string, nameSc: string, startTime: string, endTime: string, timeSlotMins: number, minNoOfTimeslot: number, maxNoOfTimeslot: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string } | null }> | null }> | null }> } };

export type MeGetMemberSimpleQueryVariables = Exact<{ [key: string]: never; }>;


export type MeGetMemberSimpleQuery = { __typename?: 'Query', meGetMember: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } };

export type MeGetOwnSessionListQueryVariables = Exact<{ [key: string]: never; }>;


export type MeGetOwnSessionListQuery = { __typename?: 'Query', meGetOwnSessionList: Array<{ __typename?: 'MySession', id: number, browserName: string, osName: string, createdDate: string, lastActionDate: string }> };

export type MeGetLatestMemberAccessPassHistoryListQueryVariables = Exact<{
  input: MeGetLatestMemberAccessPassHistoryListInput;
}>;


export type MeGetLatestMemberAccessPassHistoryListQuery = { __typename?: 'Query', meGetLatestMemberAccessPassHistoryList: Array<{ __typename?: 'AccessPassHistory', id: number, startDate: string, endDate: string, enableAutoRenew: boolean, autoRenewNextAccessPassOptionId?: number | null, accessPass?: { __typename?: 'AccessPass', id: number, nameTc: string, nameSc: string, nameEn: string, enabledOptionList: Array<{ __typename?: 'AccessPassOption', id: number, allowAutoRenew: boolean, nameTc: string, nameSc: string, nameEn: string }> } | null, accessPassOption?: { __typename?: 'AccessPassOption', id: number, nameTc: string, nameSc: string, nameEn: string } | null }> };

export type MeGetMemberFacilityBookingHistoryQueryVariables = Exact<{
  input: MeGetMemberFacilityBookingHistoryInput;
}>;


export type MeGetMemberFacilityBookingHistoryQuery = { __typename?: 'Query', meGetMemberFacilityBookingHistory: { __typename?: 'SearchFacilityBookingResGql', itemList: Array<{ __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, checkInDeviceId?: number | null, checkInMode?: CheckInMode | null, checkInDateTime?: string | null, myorderItemId?: number | null, facility?: { __typename?: 'Facility', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null, myorder?: { __typename?: 'Myorder', id: number, status: MyorderAllStatus, myorderDate?: string | null } | null }> } };

export type CreateGuestMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateGuestMutation = { __typename?: 'Mutation', createGuest: { __typename?: 'LoginMemberResGql', accessToken: string, requireTotp: boolean, member: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } } };

export type MeInitEshopMemberMutationVariables = Exact<{
  input: MeUpdateEshopMemberInput;
}>;


export type MeInitEshopMemberMutation = { __typename?: 'Mutation', meInitEshopMember: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } };

export type MemberLoginMutationVariables = Exact<{
  input: LoginMemberInput;
}>;


export type MemberLoginMutation = { __typename?: 'Mutation', memberLogin: { __typename?: 'LoginMemberResGql', accessToken: string, requireTotp: boolean, member: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } } };

export type AuthSessionWithTotpMutationVariables = Exact<{
  input: AuthSessionWithTotpInput;
}>;


export type AuthSessionWithTotpMutation = { __typename?: 'Mutation', authSessionWithTotp: { __typename?: 'AuthSessionWithTotpResGql', accessToken: string } };

export type RegisterMemberLoginKeyMutationVariables = Exact<{
  input: RegisterMemberLoginKeyInput;
}>;


export type RegisterMemberLoginKeyMutation = { __typename?: 'Mutation', registerMemberLoginKey: { __typename?: 'FullMember', id: number, membershipNo: string } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: any | null };

export type MeUpdateMemberMutationVariables = Exact<{
  input: MeUpdateMemberInput;
}>;


export type MeUpdateMemberMutation = { __typename?: 'Mutation', meUpdateMember: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } };

export type MeCleanMemberSessionMutationVariables = Exact<{
  input: MeCleanMemberSessionInput;
}>;


export type MeCleanMemberSessionMutation = { __typename?: 'Mutation', meCleanMemberSession?: any | null };

export type MeGetOtpMutationVariables = Exact<{
  input: MeGetOtpInput;
}>;


export type MeGetOtpMutation = { __typename?: 'Mutation', meGetOtp?: any | null };

export type MeVerifyOtpMutationVariables = Exact<{
  input: MeVerifyOtpInput;
}>;


export type MeVerifyOtpMutation = { __typename?: 'Mutation', meVerifyOtp?: any | null };

export type MemberSimpleFragment = { __typename?: 'Member', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null };

export type FullMemberSimpleFragment = { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null };

export type MemberCreditBalanceSimpleFragment = { __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null };

export type CreditTypeSimpleFragment = { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> };

export type MySessionSimpleFragment = { __typename?: 'MySession', id: number, browserName: string, osName: string, createdDate: string, lastActionDate: string };

export type SelectionJsonFragment = { __typename?: 'GetSelectionJsonResGql', sportTypeList: Array<{ __typename?: 'SportType', id: number, nameEn: string, nameTc: string, nameSc: string }>, countryList: Array<{ __typename?: 'Country', id: number, nameTc: string, nameSc: string, nameEn: string }>, districtList: Array<{ __typename?: 'District', id: number, nameTc: string, nameSc: string, nameEn: string, memberLocationId: number, subDistrictList?: Array<{ __typename?: 'SubDistrict', id: number, nameTc: string, nameSc: string, nameEn: string }> | null }>, locationList: Array<{ __typename?: 'MemberLocation', id: number, nameTc: string, nameSc: string, nameEn: string }>, facilityLocationList: Array<{ __typename?: 'Location', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationAreaList?: Array<{ __typename?: 'LocationArea', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string, locationId: number, orderId: number, location?: { __typename?: 'Location', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null, facilityList?: Array<{ __typename?: 'Facility', id: number, enableForWeb: boolean, shortCode: string, nameEn: string, nameTc: string, nameSc: string, startTime: string, endTime: string, timeSlotMins: number, minNoOfTimeslot: number, maxNoOfTimeslot: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string } | null }> | null }> | null }> };

export type CountrySimpleFragment = { __typename?: 'Country', id: number, nameTc: string, nameSc: string, nameEn: string };

export type DistrictSimpleFragment = { __typename?: 'District', id: number, nameTc: string, nameSc: string, nameEn: string, memberLocationId: number, subDistrictList?: Array<{ __typename?: 'SubDistrict', id: number, nameTc: string, nameSc: string, nameEn: string }> | null };

export type SubDistrictSimpleFragment = { __typename?: 'SubDistrict', id: number, nameTc: string, nameSc: string, nameEn: string };

export type MemberLocationSimpleFragment = { __typename?: 'MemberLocation', id: number, nameTc: string, nameSc: string, nameEn: string };

export type AccessPassHistorySimpleFragment = { __typename?: 'AccessPassHistory', id: number, startDate: string, endDate: string, enableAutoRenew: boolean, autoRenewNextAccessPassOptionId?: number | null, accessPass?: { __typename?: 'AccessPass', id: number, nameTc: string, nameSc: string, nameEn: string, enabledOptionList: Array<{ __typename?: 'AccessPassOption', id: number, allowAutoRenew: boolean, nameTc: string, nameSc: string, nameEn: string }> } | null, accessPassOption?: { __typename?: 'AccessPassOption', id: number, nameTc: string, nameSc: string, nameEn: string } | null };

export type FacilityBookingSimpleFragment = { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, checkInDeviceId?: number | null, checkInMode?: CheckInMode | null, checkInDateTime?: string | null, myorderItemId?: number | null, facility?: { __typename?: 'Facility', id: number, shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null, myorder?: { __typename?: 'Myorder', id: number, status: MyorderAllStatus, myorderDate?: string | null } | null };

export type GetBannerListQueryVariables = Exact<{
  input: GetBannerListInput;
}>;


export type GetBannerListQuery = { __typename?: 'Query', getBannerList: Array<{ __typename?: 'Myfile', id: number, fileIdPath: string, sysFilename: string, myfileList?: Array<{ __typename?: 'Myfile', viewport?: number | null, fileIdPath: string, sysFilename: string }> | null }> };

export type MemberGetMyfileInfoQueryVariables = Exact<{
  input: MeGetMyfileInput;
}>;


export type MemberGetMyfileInfoQuery = { __typename?: 'Query', memberGetMyfileInfo: { __typename?: 'GetMyfileResGql', presignedUrl?: string | null, mimetype: string, data?: string | null } };

export type MePurgeMyfileFromMemberMutationVariables = Exact<{
  input: MePurgeMyfileFromMemberInput;
}>;


export type MePurgeMyfileFromMemberMutation = { __typename?: 'Mutation', mePurgeMyfileFromMember?: any | null };

export type MyfileSimpleFragment = { __typename?: 'Myfile', id: number, fileIdPath: string, sysFilename: string, myfileList?: Array<{ __typename?: 'Myfile', viewport?: number | null, fileIdPath: string, sysFilename: string }> | null };

export type MyfileResFragment = { __typename?: 'GetMyfileResGql', presignedUrl?: string | null, mimetype: string, data?: string | null };

export type MeGetCartQueryVariables = Exact<{
  input: MeGetCartInput;
}>;


export type MeGetCartQuery = { __typename?: 'Query', meGetCart: { __typename?: 'Myorder', id: number, status: MyorderAllStatus, cartType: CartType, isAllVirtual?: boolean | null, isSelfPickup: boolean, address1: string, address2: string, address3: string, memberLocationId?: number | null, districtId?: number | null, subDistrictId?: number | null, totalPrice: number, freightCost: number, payAmount: number, deptTransferDeptId?: number | null, updatedDate: string, paymentMethod: string, memberRemarks: string, paymentStatus: MyorderAllStatus, myorderDate?: string | null, paymentConfirmDate?: string | null, shipmentDate?: string | null, totalDiscount: number, totalBonusPointEarned: number, totalBonusPointSpent: number, bonusPointBefore: number, bonusPointAfter: number, totalCreditSpent: number, totalCreditRefunded: number, creditBefore: number, creditAfter: number, couponCode: string, isCouponCodeValid: boolean, creditTypeId?: number | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, itemType: MyorderItemType, bonusPointRedeemPromotionGroupId?: number | null, listPrice?: number | null, subtotalPrice: number, posDiscount: number, unshippedQty: number, descEn: string, frontendRemovable: boolean, productQty: number, unitPrice?: number | null, refStartDate?: string | null, refEndDate?: string | null, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, lostCardNo?: number | null, bonusPointEarned: number, bonusPointSpent: number, refBonusPointDiscount: number, membershipTypeId?: number | null, membership?: { __typename?: 'MembershipType', nameEn: string, nameTc: string, nameSc: string } | null, driveTeam?: { __typename?: 'DriveTeam', code: string, name: string } | null, driveMember?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, referOrg?: { __typename?: 'Organization', code: string, nameEn: string, nameTc: string, nameSc: string } | null, courseEnrolment?: { __typename?: 'CourseEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, remarkTc: string, remarkSc: string, remarkEn: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string, isTrial: boolean } | null } | null, lessonEnrolmentList?: Array<{ __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null }> | null, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, coachService?: { __typename?: 'CoachService', nameEn: string, nameTc: string, nameSc: string } | null, coach?: { __typename?: 'User', displayName: string } | null, facilityBooking?: { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, facility?: { __typename?: 'Facility', id: number, nameEn: string, nameTc: string, nameSc: string, requiredNoOfMembers: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string, location?: { __typename?: 'Location', nameEn: string, nameTc: string, nameSc: string } | null } | null } | null, otherMemberList?: Array<{ __typename?: 'Member', id: number, membershipNo: string }> | null } | null, myEventEnrolmentList?: Array<{ __typename?: 'MyEventEnrolment', teamName: string, teamMemberList?: Array<{ __typename?: 'MyEventTeamMember', isCaptain: boolean, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null }> | null, seat?: { __typename?: 'MyEventTicketSeat', seatNo: number, ticketType?: { __typename?: 'MyEventTicketType', prefix: string, nameEn: string, nameTc: string, nameSc: string, isFreeSeating: boolean, myEvent?: { __typename?: 'MyEvent', code: string, nameEn: string, nameTc: string, nameSc: string, isTeamMode: boolean } | null } | null } | null }> | null, locker?: { __typename?: 'Locker', label: string, lockerGroup?: { __typename?: 'LockerGroup', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null } | null, lockerGroupFee?: { __typename?: 'LockerGroupFee', nameEn: string, nameTc: string, nameSc: string } | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string, isVirtual: boolean, allowWebOversell: boolean, webStockLevel: number, requireOfflineRedemption: boolean } | null, accessPass?: { __typename?: 'AccessPass', nameEn: string, nameTc: string, nameSc: string } | null, accessPassOption?: { __typename?: 'AccessPassOption', nameEn: string, nameTc: string, nameSc: string } | null, couponPackage?: { __typename?: 'CouponPackage', id: number, couponType: CouponType, sku: string, nameEn: string, nameTc: string, nameSc: string, noOfCoupons: number, validNoOfDays: number } | null, creditPackage?: { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } | null }> | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } };

export type MeGetMyorderQueryVariables = Exact<{
  input: GetMyorderInput;
}>;


export type MeGetMyorderQuery = { __typename?: 'Query', meGetMyorder: { __typename?: 'Myorder', id: number, status: MyorderAllStatus, cartType: CartType, isAllVirtual?: boolean | null, isSelfPickup: boolean, address1: string, address2: string, address3: string, memberLocationId?: number | null, districtId?: number | null, subDistrictId?: number | null, totalPrice: number, freightCost: number, payAmount: number, deptTransferDeptId?: number | null, updatedDate: string, paymentMethod: string, memberRemarks: string, paymentStatus: MyorderAllStatus, myorderDate?: string | null, paymentConfirmDate?: string | null, shipmentDate?: string | null, totalDiscount: number, totalBonusPointEarned: number, totalBonusPointSpent: number, bonusPointBefore: number, bonusPointAfter: number, totalCreditSpent: number, totalCreditRefunded: number, creditBefore: number, creditAfter: number, couponCode: string, isCouponCodeValid: boolean, creditTypeId?: number | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, itemType: MyorderItemType, bonusPointRedeemPromotionGroupId?: number | null, listPrice?: number | null, subtotalPrice: number, posDiscount: number, unshippedQty: number, descEn: string, frontendRemovable: boolean, productQty: number, unitPrice?: number | null, refStartDate?: string | null, refEndDate?: string | null, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, lostCardNo?: number | null, bonusPointEarned: number, bonusPointSpent: number, refBonusPointDiscount: number, membershipTypeId?: number | null, membership?: { __typename?: 'MembershipType', nameEn: string, nameTc: string, nameSc: string } | null, driveTeam?: { __typename?: 'DriveTeam', code: string, name: string } | null, driveMember?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, referOrg?: { __typename?: 'Organization', code: string, nameEn: string, nameTc: string, nameSc: string } | null, courseEnrolment?: { __typename?: 'CourseEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, remarkTc: string, remarkSc: string, remarkEn: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string, isTrial: boolean } | null } | null, lessonEnrolmentList?: Array<{ __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null }> | null, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, coachService?: { __typename?: 'CoachService', nameEn: string, nameTc: string, nameSc: string } | null, coach?: { __typename?: 'User', displayName: string } | null, facilityBooking?: { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, facility?: { __typename?: 'Facility', id: number, nameEn: string, nameTc: string, nameSc: string, requiredNoOfMembers: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string, location?: { __typename?: 'Location', nameEn: string, nameTc: string, nameSc: string } | null } | null } | null, otherMemberList?: Array<{ __typename?: 'Member', id: number, membershipNo: string }> | null } | null, myEventEnrolmentList?: Array<{ __typename?: 'MyEventEnrolment', teamName: string, teamMemberList?: Array<{ __typename?: 'MyEventTeamMember', isCaptain: boolean, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null }> | null, seat?: { __typename?: 'MyEventTicketSeat', seatNo: number, ticketType?: { __typename?: 'MyEventTicketType', prefix: string, nameEn: string, nameTc: string, nameSc: string, isFreeSeating: boolean, myEvent?: { __typename?: 'MyEvent', code: string, nameEn: string, nameTc: string, nameSc: string, isTeamMode: boolean } | null } | null } | null }> | null, locker?: { __typename?: 'Locker', label: string, lockerGroup?: { __typename?: 'LockerGroup', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null } | null, lockerGroupFee?: { __typename?: 'LockerGroupFee', nameEn: string, nameTc: string, nameSc: string } | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string, isVirtual: boolean, allowWebOversell: boolean, webStockLevel: number, requireOfflineRedemption: boolean } | null, accessPass?: { __typename?: 'AccessPass', nameEn: string, nameTc: string, nameSc: string } | null, accessPassOption?: { __typename?: 'AccessPassOption', nameEn: string, nameTc: string, nameSc: string } | null, couponPackage?: { __typename?: 'CouponPackage', id: number, couponType: CouponType, sku: string, nameEn: string, nameTc: string, nameSc: string, noOfCoupons: number, validNoOfDays: number } | null, creditPackage?: { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } | null }> | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } };

export type MeGetMemberMyorderHistoryQueryVariables = Exact<{
  input: MeGetMemberMyorderHistoryInput;
}>;


export type MeGetMemberMyorderHistoryQuery = { __typename?: 'Query', meGetMemberMyorderHistory: { __typename?: 'SearchMyorderResGql', totalNum: number, itemList: Array<{ __typename?: 'Myorder', id: number, status: MyorderAllStatus, shippingStatus: MyorderAllStatus, payAmount: number, myorderDate?: string | null, paymentConfirmDate?: string | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, shippedQty: number, unshippedQty: number, productQty: number, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string } | null }> | null }> } };

export type GetFreightCostSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFreightCostSettingQuery = { __typename?: 'Query', getFreightCostSetting: { __typename?: 'FreightCostSettingResGql', allowShipping: boolean, allowSelfPickup: boolean } };

export type GetTncSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTncSettingQuery = { __typename?: 'Query', getTncSetting: { __typename?: 'TncSettingResGql', globalTncEn: string, globalTncTc: string, globalTncSc: string, redeemPromotionTncEn: string, redeemPromotionTncTc: string, redeemPromotionTncSc: string } };

export type GetKpayNotifyLogQueryVariables = Exact<{
  input: GetKpayNotifyLogInput;
}>;


export type GetKpayNotifyLogQuery = { __typename?: 'Query', getKpayNotifyLog: { __typename?: 'GetKpayNotifyLogResGql', transactionState?: number | null, transactionStateDesc: string } };

export type MeAddAccessPassToCartMutationVariables = Exact<{
  input: MeAddAccessPassToCartInput;
}>;


export type MeAddAccessPassToCartMutation = { __typename?: 'Mutation', meAddAccessPassToCart: { __typename?: 'Myorder', id: number } };

export type MeAddFacilityBookingToCartMutationVariables = Exact<{
  input: MeAddBookingToCartInput;
}>;


export type MeAddFacilityBookingToCartMutation = { __typename?: 'Mutation', meAddFacilityBookingToCart: { __typename?: 'Myorder', id: number, status: MyorderAllStatus, cartType: CartType, isAllVirtual?: boolean | null, isSelfPickup: boolean, address1: string, address2: string, address3: string, memberLocationId?: number | null, districtId?: number | null, subDistrictId?: number | null, totalPrice: number, freightCost: number, payAmount: number, deptTransferDeptId?: number | null, updatedDate: string, paymentMethod: string, memberRemarks: string, paymentStatus: MyorderAllStatus, myorderDate?: string | null, paymentConfirmDate?: string | null, shipmentDate?: string | null, totalDiscount: number, totalBonusPointEarned: number, totalBonusPointSpent: number, bonusPointBefore: number, bonusPointAfter: number, totalCreditSpent: number, totalCreditRefunded: number, creditBefore: number, creditAfter: number, couponCode: string, isCouponCodeValid: boolean, creditTypeId?: number | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, itemType: MyorderItemType, bonusPointRedeemPromotionGroupId?: number | null, listPrice?: number | null, subtotalPrice: number, posDiscount: number, unshippedQty: number, descEn: string, frontendRemovable: boolean, productQty: number, unitPrice?: number | null, refStartDate?: string | null, refEndDate?: string | null, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, lostCardNo?: number | null, bonusPointEarned: number, bonusPointSpent: number, refBonusPointDiscount: number, membershipTypeId?: number | null, membership?: { __typename?: 'MembershipType', nameEn: string, nameTc: string, nameSc: string } | null, driveTeam?: { __typename?: 'DriveTeam', code: string, name: string } | null, driveMember?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, referOrg?: { __typename?: 'Organization', code: string, nameEn: string, nameTc: string, nameSc: string } | null, courseEnrolment?: { __typename?: 'CourseEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, remarkTc: string, remarkSc: string, remarkEn: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string, isTrial: boolean } | null } | null, lessonEnrolmentList?: Array<{ __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null }> | null, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, coachService?: { __typename?: 'CoachService', nameEn: string, nameTc: string, nameSc: string } | null, coach?: { __typename?: 'User', displayName: string } | null, facilityBooking?: { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, facility?: { __typename?: 'Facility', id: number, nameEn: string, nameTc: string, nameSc: string, requiredNoOfMembers: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string, location?: { __typename?: 'Location', nameEn: string, nameTc: string, nameSc: string } | null } | null } | null, otherMemberList?: Array<{ __typename?: 'Member', id: number, membershipNo: string }> | null } | null, myEventEnrolmentList?: Array<{ __typename?: 'MyEventEnrolment', teamName: string, teamMemberList?: Array<{ __typename?: 'MyEventTeamMember', isCaptain: boolean, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null }> | null, seat?: { __typename?: 'MyEventTicketSeat', seatNo: number, ticketType?: { __typename?: 'MyEventTicketType', prefix: string, nameEn: string, nameTc: string, nameSc: string, isFreeSeating: boolean, myEvent?: { __typename?: 'MyEvent', code: string, nameEn: string, nameTc: string, nameSc: string, isTeamMode: boolean } | null } | null } | null }> | null, locker?: { __typename?: 'Locker', label: string, lockerGroup?: { __typename?: 'LockerGroup', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null } | null, lockerGroupFee?: { __typename?: 'LockerGroupFee', nameEn: string, nameTc: string, nameSc: string } | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string, isVirtual: boolean, allowWebOversell: boolean, webStockLevel: number, requireOfflineRedemption: boolean } | null, accessPass?: { __typename?: 'AccessPass', nameEn: string, nameTc: string, nameSc: string } | null, accessPassOption?: { __typename?: 'AccessPassOption', nameEn: string, nameTc: string, nameSc: string } | null, couponPackage?: { __typename?: 'CouponPackage', id: number, couponType: CouponType, sku: string, nameEn: string, nameTc: string, nameSc: string, noOfCoupons: number, validNoOfDays: number } | null, creditPackage?: { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } | null }> | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } };

export type MeAddCreditPackageToCartMutationVariables = Exact<{
  input: MeAddCreditPackageToCartInput;
}>;


export type MeAddCreditPackageToCartMutation = { __typename?: 'Mutation', meAddCreditPackageToCart: { __typename?: 'Myorder', id: number, status: MyorderAllStatus, cartType: CartType, isAllVirtual?: boolean | null, isSelfPickup: boolean, address1: string, address2: string, address3: string, memberLocationId?: number | null, districtId?: number | null, subDistrictId?: number | null, totalPrice: number, freightCost: number, payAmount: number, deptTransferDeptId?: number | null, updatedDate: string, paymentMethod: string, memberRemarks: string, paymentStatus: MyorderAllStatus, myorderDate?: string | null, paymentConfirmDate?: string | null, shipmentDate?: string | null, totalDiscount: number, totalBonusPointEarned: number, totalBonusPointSpent: number, bonusPointBefore: number, bonusPointAfter: number, totalCreditSpent: number, totalCreditRefunded: number, creditBefore: number, creditAfter: number, couponCode: string, isCouponCodeValid: boolean, creditTypeId?: number | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, itemType: MyorderItemType, bonusPointRedeemPromotionGroupId?: number | null, listPrice?: number | null, subtotalPrice: number, posDiscount: number, unshippedQty: number, descEn: string, frontendRemovable: boolean, productQty: number, unitPrice?: number | null, refStartDate?: string | null, refEndDate?: string | null, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, lostCardNo?: number | null, bonusPointEarned: number, bonusPointSpent: number, refBonusPointDiscount: number, membershipTypeId?: number | null, membership?: { __typename?: 'MembershipType', nameEn: string, nameTc: string, nameSc: string } | null, driveTeam?: { __typename?: 'DriveTeam', code: string, name: string } | null, driveMember?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, referOrg?: { __typename?: 'Organization', code: string, nameEn: string, nameTc: string, nameSc: string } | null, courseEnrolment?: { __typename?: 'CourseEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, remarkTc: string, remarkSc: string, remarkEn: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string, isTrial: boolean } | null } | null, lessonEnrolmentList?: Array<{ __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null }> | null, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, coachService?: { __typename?: 'CoachService', nameEn: string, nameTc: string, nameSc: string } | null, coach?: { __typename?: 'User', displayName: string } | null, facilityBooking?: { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, facility?: { __typename?: 'Facility', id: number, nameEn: string, nameTc: string, nameSc: string, requiredNoOfMembers: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string, location?: { __typename?: 'Location', nameEn: string, nameTc: string, nameSc: string } | null } | null } | null, otherMemberList?: Array<{ __typename?: 'Member', id: number, membershipNo: string }> | null } | null, myEventEnrolmentList?: Array<{ __typename?: 'MyEventEnrolment', teamName: string, teamMemberList?: Array<{ __typename?: 'MyEventTeamMember', isCaptain: boolean, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null }> | null, seat?: { __typename?: 'MyEventTicketSeat', seatNo: number, ticketType?: { __typename?: 'MyEventTicketType', prefix: string, nameEn: string, nameTc: string, nameSc: string, isFreeSeating: boolean, myEvent?: { __typename?: 'MyEvent', code: string, nameEn: string, nameTc: string, nameSc: string, isTeamMode: boolean } | null } | null } | null }> | null, locker?: { __typename?: 'Locker', label: string, lockerGroup?: { __typename?: 'LockerGroup', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null } | null, lockerGroupFee?: { __typename?: 'LockerGroupFee', nameEn: string, nameTc: string, nameSc: string } | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string, isVirtual: boolean, allowWebOversell: boolean, webStockLevel: number, requireOfflineRedemption: boolean } | null, accessPass?: { __typename?: 'AccessPass', nameEn: string, nameTc: string, nameSc: string } | null, accessPassOption?: { __typename?: 'AccessPassOption', nameEn: string, nameTc: string, nameSc: string } | null, couponPackage?: { __typename?: 'CouponPackage', id: number, couponType: CouponType, sku: string, nameEn: string, nameTc: string, nameSc: string, noOfCoupons: number, validNoOfDays: number } | null, creditPackage?: { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } | null }> | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } };

export type MeRemoveItemFromCartMutationVariables = Exact<{
  input: MeRemoveItemFromCartInput;
}>;


export type MeRemoveItemFromCartMutation = { __typename?: 'Mutation', meRemoveItemFromCart: { __typename?: 'Myorder', id: number, status: MyorderAllStatus, cartType: CartType, isAllVirtual?: boolean | null, isSelfPickup: boolean, address1: string, address2: string, address3: string, memberLocationId?: number | null, districtId?: number | null, subDistrictId?: number | null, totalPrice: number, freightCost: number, payAmount: number, deptTransferDeptId?: number | null, updatedDate: string, paymentMethod: string, memberRemarks: string, paymentStatus: MyorderAllStatus, myorderDate?: string | null, paymentConfirmDate?: string | null, shipmentDate?: string | null, totalDiscount: number, totalBonusPointEarned: number, totalBonusPointSpent: number, bonusPointBefore: number, bonusPointAfter: number, totalCreditSpent: number, totalCreditRefunded: number, creditBefore: number, creditAfter: number, couponCode: string, isCouponCodeValid: boolean, creditTypeId?: number | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, itemType: MyorderItemType, bonusPointRedeemPromotionGroupId?: number | null, listPrice?: number | null, subtotalPrice: number, posDiscount: number, unshippedQty: number, descEn: string, frontendRemovable: boolean, productQty: number, unitPrice?: number | null, refStartDate?: string | null, refEndDate?: string | null, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, lostCardNo?: number | null, bonusPointEarned: number, bonusPointSpent: number, refBonusPointDiscount: number, membershipTypeId?: number | null, membership?: { __typename?: 'MembershipType', nameEn: string, nameTc: string, nameSc: string } | null, driveTeam?: { __typename?: 'DriveTeam', code: string, name: string } | null, driveMember?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, referOrg?: { __typename?: 'Organization', code: string, nameEn: string, nameTc: string, nameSc: string } | null, courseEnrolment?: { __typename?: 'CourseEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, remarkTc: string, remarkSc: string, remarkEn: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string, isTrial: boolean } | null } | null, lessonEnrolmentList?: Array<{ __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null }> | null, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, coachService?: { __typename?: 'CoachService', nameEn: string, nameTc: string, nameSc: string } | null, coach?: { __typename?: 'User', displayName: string } | null, facilityBooking?: { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, facility?: { __typename?: 'Facility', id: number, nameEn: string, nameTc: string, nameSc: string, requiredNoOfMembers: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string, location?: { __typename?: 'Location', nameEn: string, nameTc: string, nameSc: string } | null } | null } | null, otherMemberList?: Array<{ __typename?: 'Member', id: number, membershipNo: string }> | null } | null, myEventEnrolmentList?: Array<{ __typename?: 'MyEventEnrolment', teamName: string, teamMemberList?: Array<{ __typename?: 'MyEventTeamMember', isCaptain: boolean, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null }> | null, seat?: { __typename?: 'MyEventTicketSeat', seatNo: number, ticketType?: { __typename?: 'MyEventTicketType', prefix: string, nameEn: string, nameTc: string, nameSc: string, isFreeSeating: boolean, myEvent?: { __typename?: 'MyEvent', code: string, nameEn: string, nameTc: string, nameSc: string, isTeamMode: boolean } | null } | null } | null }> | null, locker?: { __typename?: 'Locker', label: string, lockerGroup?: { __typename?: 'LockerGroup', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null } | null, lockerGroupFee?: { __typename?: 'LockerGroupFee', nameEn: string, nameTc: string, nameSc: string } | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string, isVirtual: boolean, allowWebOversell: boolean, webStockLevel: number, requireOfflineRedemption: boolean } | null, accessPass?: { __typename?: 'AccessPass', nameEn: string, nameTc: string, nameSc: string } | null, accessPassOption?: { __typename?: 'AccessPassOption', nameEn: string, nameTc: string, nameSc: string } | null, couponPackage?: { __typename?: 'CouponPackage', id: number, couponType: CouponType, sku: string, nameEn: string, nameTc: string, nameSc: string, noOfCoupons: number, validNoOfDays: number } | null, creditPackage?: { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } | null }> | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } };

export type MeUpdateMyorderMutationVariables = Exact<{
  input: UpdateMyorderInput;
}>;


export type MeUpdateMyorderMutation = { __typename?: 'Mutation', meUpdateMyorder: { __typename?: 'Myorder', id: number, status: MyorderAllStatus, cartType: CartType, isAllVirtual?: boolean | null, isSelfPickup: boolean, address1: string, address2: string, address3: string, memberLocationId?: number | null, districtId?: number | null, subDistrictId?: number | null, totalPrice: number, freightCost: number, payAmount: number, deptTransferDeptId?: number | null, updatedDate: string, paymentMethod: string, memberRemarks: string, paymentStatus: MyorderAllStatus, myorderDate?: string | null, paymentConfirmDate?: string | null, shipmentDate?: string | null, totalDiscount: number, totalBonusPointEarned: number, totalBonusPointSpent: number, bonusPointBefore: number, bonusPointAfter: number, totalCreditSpent: number, totalCreditRefunded: number, creditBefore: number, creditAfter: number, couponCode: string, isCouponCodeValid: boolean, creditTypeId?: number | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, itemType: MyorderItemType, bonusPointRedeemPromotionGroupId?: number | null, listPrice?: number | null, subtotalPrice: number, posDiscount: number, unshippedQty: number, descEn: string, frontendRemovable: boolean, productQty: number, unitPrice?: number | null, refStartDate?: string | null, refEndDate?: string | null, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, lostCardNo?: number | null, bonusPointEarned: number, bonusPointSpent: number, refBonusPointDiscount: number, membershipTypeId?: number | null, membership?: { __typename?: 'MembershipType', nameEn: string, nameTc: string, nameSc: string } | null, driveTeam?: { __typename?: 'DriveTeam', code: string, name: string } | null, driveMember?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, referOrg?: { __typename?: 'Organization', code: string, nameEn: string, nameTc: string, nameSc: string } | null, courseEnrolment?: { __typename?: 'CourseEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, remarkTc: string, remarkSc: string, remarkEn: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string, isTrial: boolean } | null } | null, lessonEnrolmentList?: Array<{ __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null }> | null, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, coachService?: { __typename?: 'CoachService', nameEn: string, nameTc: string, nameSc: string } | null, coach?: { __typename?: 'User', displayName: string } | null, facilityBooking?: { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, facility?: { __typename?: 'Facility', id: number, nameEn: string, nameTc: string, nameSc: string, requiredNoOfMembers: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string, location?: { __typename?: 'Location', nameEn: string, nameTc: string, nameSc: string } | null } | null } | null, otherMemberList?: Array<{ __typename?: 'Member', id: number, membershipNo: string }> | null } | null, myEventEnrolmentList?: Array<{ __typename?: 'MyEventEnrolment', teamName: string, teamMemberList?: Array<{ __typename?: 'MyEventTeamMember', isCaptain: boolean, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null }> | null, seat?: { __typename?: 'MyEventTicketSeat', seatNo: number, ticketType?: { __typename?: 'MyEventTicketType', prefix: string, nameEn: string, nameTc: string, nameSc: string, isFreeSeating: boolean, myEvent?: { __typename?: 'MyEvent', code: string, nameEn: string, nameTc: string, nameSc: string, isTeamMode: boolean } | null } | null } | null }> | null, locker?: { __typename?: 'Locker', label: string, lockerGroup?: { __typename?: 'LockerGroup', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null } | null, lockerGroupFee?: { __typename?: 'LockerGroupFee', nameEn: string, nameTc: string, nameSc: string } | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string, isVirtual: boolean, allowWebOversell: boolean, webStockLevel: number, requireOfflineRedemption: boolean } | null, accessPass?: { __typename?: 'AccessPass', nameEn: string, nameTc: string, nameSc: string } | null, accessPassOption?: { __typename?: 'AccessPassOption', nameEn: string, nameTc: string, nameSc: string } | null, couponPackage?: { __typename?: 'CouponPackage', id: number, couponType: CouponType, sku: string, nameEn: string, nameTc: string, nameSc: string, noOfCoupons: number, validNoOfDays: number } | null, creditPackage?: { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } | null }> | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } };

export type MeClearCartMutationVariables = Exact<{
  input: MeGetCartInput;
}>;


export type MeClearCartMutation = { __typename?: 'Mutation', meClearCart?: any | null };

export type MeConvertToOrderMutationVariables = Exact<{
  input: MeConvertToOrderInput;
}>;


export type MeConvertToOrderMutation = { __typename?: 'Mutation', meConvertToOrder: { __typename?: 'Myorder', id: number } };

export type MeApplyCouponToFacilityBookingMutationVariables = Exact<{
  input: MeApplyCouponToFacilityBookingInput;
}>;


export type MeApplyCouponToFacilityBookingMutation = { __typename?: 'Mutation', meApplyCouponToFacilityBooking: { __typename?: 'Myorder', id: number } };

export type MeCancelMyorderMutationVariables = Exact<{
  input: MeCancelMyorderInput;
}>;


export type MeCancelMyorderMutation = { __typename?: 'Mutation', meCancelMyorder: { __typename?: 'Myorder', id: number, status: MyorderAllStatus, cartType: CartType, isAllVirtual?: boolean | null, isSelfPickup: boolean, address1: string, address2: string, address3: string, memberLocationId?: number | null, districtId?: number | null, subDistrictId?: number | null, totalPrice: number, freightCost: number, payAmount: number, deptTransferDeptId?: number | null, updatedDate: string, paymentMethod: string, memberRemarks: string, paymentStatus: MyorderAllStatus, myorderDate?: string | null, paymentConfirmDate?: string | null, shipmentDate?: string | null, totalDiscount: number, totalBonusPointEarned: number, totalBonusPointSpent: number, bonusPointBefore: number, bonusPointAfter: number, totalCreditSpent: number, totalCreditRefunded: number, creditBefore: number, creditAfter: number, couponCode: string, isCouponCodeValid: boolean, creditTypeId?: number | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, itemType: MyorderItemType, bonusPointRedeemPromotionGroupId?: number | null, listPrice?: number | null, subtotalPrice: number, posDiscount: number, unshippedQty: number, descEn: string, frontendRemovable: boolean, productQty: number, unitPrice?: number | null, refStartDate?: string | null, refEndDate?: string | null, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, lostCardNo?: number | null, bonusPointEarned: number, bonusPointSpent: number, refBonusPointDiscount: number, membershipTypeId?: number | null, membership?: { __typename?: 'MembershipType', nameEn: string, nameTc: string, nameSc: string } | null, driveTeam?: { __typename?: 'DriveTeam', code: string, name: string } | null, driveMember?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, referOrg?: { __typename?: 'Organization', code: string, nameEn: string, nameTc: string, nameSc: string } | null, courseEnrolment?: { __typename?: 'CourseEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, remarkTc: string, remarkSc: string, remarkEn: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string, isTrial: boolean } | null } | null, lessonEnrolmentList?: Array<{ __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null }> | null, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, coachService?: { __typename?: 'CoachService', nameEn: string, nameTc: string, nameSc: string } | null, coach?: { __typename?: 'User', displayName: string } | null, facilityBooking?: { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, facility?: { __typename?: 'Facility', id: number, nameEn: string, nameTc: string, nameSc: string, requiredNoOfMembers: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string, location?: { __typename?: 'Location', nameEn: string, nameTc: string, nameSc: string } | null } | null } | null, otherMemberList?: Array<{ __typename?: 'Member', id: number, membershipNo: string }> | null } | null, myEventEnrolmentList?: Array<{ __typename?: 'MyEventEnrolment', teamName: string, teamMemberList?: Array<{ __typename?: 'MyEventTeamMember', isCaptain: boolean, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null }> | null, seat?: { __typename?: 'MyEventTicketSeat', seatNo: number, ticketType?: { __typename?: 'MyEventTicketType', prefix: string, nameEn: string, nameTc: string, nameSc: string, isFreeSeating: boolean, myEvent?: { __typename?: 'MyEvent', code: string, nameEn: string, nameTc: string, nameSc: string, isTeamMode: boolean } | null } | null } | null }> | null, locker?: { __typename?: 'Locker', label: string, lockerGroup?: { __typename?: 'LockerGroup', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null } | null, lockerGroupFee?: { __typename?: 'LockerGroupFee', nameEn: string, nameTc: string, nameSc: string } | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string, isVirtual: boolean, allowWebOversell: boolean, webStockLevel: number, requireOfflineRedemption: boolean } | null, accessPass?: { __typename?: 'AccessPass', nameEn: string, nameTc: string, nameSc: string } | null, accessPassOption?: { __typename?: 'AccessPassOption', nameEn: string, nameTc: string, nameSc: string } | null, couponPackage?: { __typename?: 'CouponPackage', id: number, couponType: CouponType, sku: string, nameEn: string, nameTc: string, nameSc: string, noOfCoupons: number, validNoOfDays: number } | null, creditPackage?: { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } | null }> | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } };

export type MyorderListFragment = { __typename?: 'Myorder', id: number, status: MyorderAllStatus, shippingStatus: MyorderAllStatus, payAmount: number, myorderDate?: string | null, paymentConfirmDate?: string | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, shippedQty: number, unshippedQty: number, productQty: number, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string } | null }> | null };

export type MyorderDetailsFragment = { __typename?: 'Myorder', id: number, status: MyorderAllStatus, cartType: CartType, isAllVirtual?: boolean | null, isSelfPickup: boolean, address1: string, address2: string, address3: string, memberLocationId?: number | null, districtId?: number | null, subDistrictId?: number | null, totalPrice: number, freightCost: number, payAmount: number, deptTransferDeptId?: number | null, updatedDate: string, paymentMethod: string, memberRemarks: string, paymentStatus: MyorderAllStatus, myorderDate?: string | null, paymentConfirmDate?: string | null, shipmentDate?: string | null, totalDiscount: number, totalBonusPointEarned: number, totalBonusPointSpent: number, bonusPointBefore: number, bonusPointAfter: number, totalCreditSpent: number, totalCreditRefunded: number, creditBefore: number, creditAfter: number, couponCode: string, isCouponCodeValid: boolean, creditTypeId?: number | null, itemList?: Array<{ __typename?: 'MyorderItem', id: number, itemType: MyorderItemType, bonusPointRedeemPromotionGroupId?: number | null, listPrice?: number | null, subtotalPrice: number, posDiscount: number, unshippedQty: number, descEn: string, frontendRemovable: boolean, productQty: number, unitPrice?: number | null, refStartDate?: string | null, refEndDate?: string | null, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, lostCardNo?: number | null, bonusPointEarned: number, bonusPointSpent: number, refBonusPointDiscount: number, membershipTypeId?: number | null, membership?: { __typename?: 'MembershipType', nameEn: string, nameTc: string, nameSc: string } | null, driveTeam?: { __typename?: 'DriveTeam', code: string, name: string } | null, driveMember?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, referOrg?: { __typename?: 'Organization', code: string, nameEn: string, nameTc: string, nameSc: string } | null, courseEnrolment?: { __typename?: 'CourseEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, remarkTc: string, remarkSc: string, remarkEn: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string, isTrial: boolean } | null } | null, lessonEnrolmentList?: Array<{ __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null }> | null, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, coachService?: { __typename?: 'CoachService', nameEn: string, nameTc: string, nameSc: string } | null, coach?: { __typename?: 'User', displayName: string } | null, facilityBooking?: { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, facility?: { __typename?: 'Facility', id: number, nameEn: string, nameTc: string, nameSc: string, requiredNoOfMembers: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string, location?: { __typename?: 'Location', nameEn: string, nameTc: string, nameSc: string } | null } | null } | null, otherMemberList?: Array<{ __typename?: 'Member', id: number, membershipNo: string }> | null } | null, myEventEnrolmentList?: Array<{ __typename?: 'MyEventEnrolment', teamName: string, teamMemberList?: Array<{ __typename?: 'MyEventTeamMember', isCaptain: boolean, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null }> | null, seat?: { __typename?: 'MyEventTicketSeat', seatNo: number, ticketType?: { __typename?: 'MyEventTicketType', prefix: string, nameEn: string, nameTc: string, nameSc: string, isFreeSeating: boolean, myEvent?: { __typename?: 'MyEvent', code: string, nameEn: string, nameTc: string, nameSc: string, isTeamMode: boolean } | null } | null } | null }> | null, locker?: { __typename?: 'Locker', label: string, lockerGroup?: { __typename?: 'LockerGroup', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null } | null, lockerGroupFee?: { __typename?: 'LockerGroupFee', nameEn: string, nameTc: string, nameSc: string } | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string, isVirtual: boolean, allowWebOversell: boolean, webStockLevel: number, requireOfflineRedemption: boolean } | null, accessPass?: { __typename?: 'AccessPass', nameEn: string, nameTc: string, nameSc: string } | null, accessPassOption?: { __typename?: 'AccessPassOption', nameEn: string, nameTc: string, nameSc: string } | null, couponPackage?: { __typename?: 'CouponPackage', id: number, couponType: CouponType, sku: string, nameEn: string, nameTc: string, nameSc: string, noOfCoupons: number, validNoOfDays: number } | null, creditPackage?: { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } | null }> | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null };

export type MyorderItemDetailsFragment = { __typename?: 'MyorderItem', id: number, itemType: MyorderItemType, bonusPointRedeemPromotionGroupId?: number | null, listPrice?: number | null, subtotalPrice: number, posDiscount: number, unshippedQty: number, descEn: string, frontendRemovable: boolean, productQty: number, unitPrice?: number | null, refStartDate?: string | null, refEndDate?: string | null, redeemEndDate?: string | null, offlineProductRedeemStatus?: OfflineProductRedeemStatus | null, lostCardNo?: number | null, bonusPointEarned: number, bonusPointSpent: number, refBonusPointDiscount: number, membershipTypeId?: number | null, membership?: { __typename?: 'MembershipType', nameEn: string, nameTc: string, nameSc: string } | null, driveTeam?: { __typename?: 'DriveTeam', code: string, name: string } | null, driveMember?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, referOrg?: { __typename?: 'Organization', code: string, nameEn: string, nameTc: string, nameSc: string } | null, courseEnrolment?: { __typename?: 'CourseEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, remarkTc: string, remarkSc: string, remarkEn: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string, isTrial: boolean } | null } | null, lessonEnrolmentList?: Array<{ __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null }> | null, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null, coachService?: { __typename?: 'CoachService', nameEn: string, nameTc: string, nameSc: string } | null, coach?: { __typename?: 'User', displayName: string } | null, facilityBooking?: { __typename?: 'FacilityBooking', id: number, startDateTime: string, endDateTime: string, facility?: { __typename?: 'Facility', id: number, nameEn: string, nameTc: string, nameSc: string, requiredNoOfMembers: number, locationArea?: { __typename?: 'LocationArea', nameEn: string, nameTc: string, nameSc: string, location?: { __typename?: 'Location', nameEn: string, nameTc: string, nameSc: string } | null } | null } | null, otherMemberList?: Array<{ __typename?: 'Member', id: number, membershipNo: string }> | null } | null, myEventEnrolmentList?: Array<{ __typename?: 'MyEventEnrolment', teamName: string, teamMemberList?: Array<{ __typename?: 'MyEventTeamMember', isCaptain: boolean, member?: { __typename?: 'FullMember', id: number, surname: string, givenName: string, chineseName: string, membershipNo: string, membershipTypeId?: number | null, address1: string, address2: string, address3: string, districtId?: number | null, subDistrictId?: number | null, memberLocationId?: number | null, birthDate: string, hkid?: string | null, passport?: string | null, passportExpiryDate?: string | null, email?: string | null, nationalityId?: number | null, title: string, gender?: FilterGender | null, mobileTel: string, memberCreditBalanceList?: Array<{ __typename?: 'MemberCreditBalance', id: number, balance: number, creditTypeId?: number | null, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null }> | null } | null }> | null, seat?: { __typename?: 'MyEventTicketSeat', seatNo: number, ticketType?: { __typename?: 'MyEventTicketType', prefix: string, nameEn: string, nameTc: string, nameSc: string, isFreeSeating: boolean, myEvent?: { __typename?: 'MyEvent', code: string, nameEn: string, nameTc: string, nameSc: string, isTeamMode: boolean } | null } | null } | null }> | null, locker?: { __typename?: 'Locker', label: string, lockerGroup?: { __typename?: 'LockerGroup', shortCode: string, nameEn: string, nameTc: string, nameSc: string } | null } | null, lockerGroupFee?: { __typename?: 'LockerGroupFee', nameEn: string, nameTc: string, nameSc: string } | null, product?: { __typename?: 'Product', id: number, sku: string, nameEn: string, nameTc: string, nameSc: string, isVirtual: boolean, allowWebOversell: boolean, webStockLevel: number, requireOfflineRedemption: boolean } | null, accessPass?: { __typename?: 'AccessPass', nameEn: string, nameTc: string, nameSc: string } | null, accessPassOption?: { __typename?: 'AccessPassOption', nameEn: string, nameTc: string, nameSc: string } | null, couponPackage?: { __typename?: 'CouponPackage', id: number, couponType: CouponType, sku: string, nameEn: string, nameTc: string, nameSc: string, noOfCoupons: number, validNoOfDays: number } | null, creditPackage?: { __typename?: 'CreditPackage', id: number, creditTypeId?: number | null, sku: string, nameTc: string, nameSc: string, nameEn: string, creditAmount: number, price: number, creditType?: { __typename?: 'CreditType', id: number, code: string, nameTc: string, nameSc: string, nameEn: string, myorderItemTypeList: Array<{ __typename?: 'CreditTypeMyorderItemType', myorderItemType: MyorderItemType }> } | null } | null };

export type MyorderItemLessonEnrolmentFragment = { __typename?: 'LessonEnrolment', uniformOption: string, course?: { __typename?: 'Course', code: string, nameEn: string, nameTc: string, nameSc: string, overrideTimeDescEn: string, overrideTimeDescTc: string, overrideTimeDescSc: string } | null, lesson?: { __typename?: 'Lesson', startDateTime: string, endDateTime: string } | null };

export type FreightCostSettingFragment = { __typename?: 'FreightCostSettingResGql', allowShipping: boolean, allowSelfPickup: boolean };

export type TncSettingFragment = { __typename?: 'TncSettingResGql', globalTncEn: string, globalTncTc: string, globalTncSc: string, redeemPromotionTncEn: string, redeemPromotionTncTc: string, redeemPromotionTncSc: string };

export type KpayNotifyLogFragment = { __typename?: 'GetKpayNotifyLogResGql', transactionState?: number | null, transactionStateDesc: string };

export type SearchNewsQueryVariables = Exact<{
  input: SearchNewsInput;
}>;


export type SearchNewsQuery = { __typename?: 'Query', searchNews: { __typename?: 'SearchNewsResGql', itemList: Array<{ __typename?: 'News', id: number, titleEn: string, titleTc: string, titleSc: string, publishDateTime: string }> } };

export type GetNewsQueryVariables = Exact<{
  input: GetNewsInput;
}>;


export type GetNewsQuery = { __typename?: 'Query', getNews: { __typename?: 'News', titleEn: string, titleTc: string, titleSc: string, contentEn: string, contentTc: string, contentSc: string, publishDateTime: string, photoList?: Array<{ __typename?: 'Myfile', id: number, fileIdPath: string, sysFilename: string, myfileList?: Array<{ __typename?: 'Myfile', viewport?: number | null, fileIdPath: string, sysFilename: string }> | null }> | null } };

export type NewsSimpleFragment = { __typename?: 'News', id: number, titleEn: string, titleTc: string, titleSc: string, publishDateTime: string };

export type NewsDetailsFragment = { __typename?: 'News', titleEn: string, titleTc: string, titleSc: string, contentEn: string, contentTc: string, contentSc: string, publishDateTime: string, photoList?: Array<{ __typename?: 'Myfile', id: number, fileIdPath: string, sysFilename: string, myfileList?: Array<{ __typename?: 'Myfile', viewport?: number | null, fileIdPath: string, sysFilename: string }> | null }> | null };

export type SportTypeSimpleFragment = { __typename?: 'SportType', id: number, nameEn: string, nameTc: string, nameSc: string };

export const AccessPassSimpleFragmentDoc = gql`
    fragment accessPassSimple on AccessPass {
  id
  nameTc
  nameSc
  nameEn
  tncTc
  tncSc
  tncEn
  minAge
  maxAge
}
    `;
export const AccessPassOptionSimpleFragmentDoc = gql`
    fragment accessPassOptionSimple on AccessPassOption {
  id
  nameTc
  nameSc
  nameEn
}
    `;
export const AccessPassOptionPurchaseInfoFragmentDoc = gql`
    fragment accessPassOptionPurchaseInfo on AccessPassOptionPurchaseResGql {
  canNew
  newStartDate
  newEndDate
  initPrice
  canRenew
  renewStartDate
  renewEndDate
  renewPrice
  requiredDeposit
  cannotNewReasonDesc
  cannotRenewReasonDesc
  accessPassOption {
    ...accessPassOptionSimple
  }
}
    ${AccessPassOptionSimpleFragmentDoc}`;
export const AccessPassPurchaseListFragmentDoc = gql`
    fragment accessPassPurchaseList on AccessPassPurchaseResGql {
  accessPass {
    ...accessPassSimple
  }
  purchaseInfoList {
    ...accessPassOptionPurchaseInfo
  }
}
    ${AccessPassSimpleFragmentDoc}
${AccessPassOptionPurchaseInfoFragmentDoc}`;
export const FacilityBookingTimeslotFragmentDoc = gql`
    fragment facilityBookingTimeslot on FacilityBookingTimeslotResGql {
  fee
  isFree
  isPeakHour
  startDateTime
  endDateTime
}
    `;
export const FacilityBookingSummaryFragmentDoc = gql`
    fragment facilityBookingSummary on GetFacilityBookingSummaryResGql {
  displayDate
  facilityBookingDailyTimeSlotDtoList {
    gridDisplayName
    timeslotInfoList {
      ...facilityBookingTimeslot
    }
  }
}
    ${FacilityBookingTimeslotFragmentDoc}`;
export const LocationSimpleFragmentDoc = gql`
    fragment locationSimple on Location {
  id
  shortCode
  nameEn
  nameTc
  nameSc
}
    `;
export const LocationAreaSimpleFragmentDoc = gql`
    fragment locationAreaSimple on LocationArea {
  id
  shortCode
  nameEn
  nameTc
  nameSc
  locationId
}
    `;
export const MemberSimpleFragmentDoc = gql`
    fragment memberSimple on Member {
  id
  surname
  givenName
  chineseName
  membershipNo
  membershipTypeId
}
    `;
export const MySessionSimpleFragmentDoc = gql`
    fragment mySessionSimple on MySession {
  id
  browserName
  osName
  createdDate
  lastActionDate
}
    `;
export const SportTypeSimpleFragmentDoc = gql`
    fragment sportTypeSimple on SportType {
  id
  nameEn
  nameTc
  nameSc
}
    `;
export const CountrySimpleFragmentDoc = gql`
    fragment countrySimple on Country {
  id
  nameTc
  nameSc
  nameEn
}
    `;
export const SubDistrictSimpleFragmentDoc = gql`
    fragment subDistrictSimple on SubDistrict {
  id
  nameTc
  nameSc
  nameEn
}
    `;
export const DistrictSimpleFragmentDoc = gql`
    fragment districtSimple on District {
  id
  nameTc
  nameSc
  nameEn
  memberLocationId
  subDistrictList {
    ...subDistrictSimple
  }
}
    ${SubDistrictSimpleFragmentDoc}`;
export const MemberLocationSimpleFragmentDoc = gql`
    fragment memberLocationSimple on MemberLocation {
  id
  nameTc
  nameSc
  nameEn
}
    `;
export const FacilityListFragmentDoc = gql`
    fragment facilityList on Facility {
  id
  enableForWeb
  shortCode
  nameEn
  nameTc
  nameSc
  startTime
  endTime
  timeSlotMins
  minNoOfTimeslot
  maxNoOfTimeslot
  locationArea {
    nameEn
    nameTc
    nameSc
  }
}
    `;
export const LocationAreaDetailsFragmentDoc = gql`
    fragment locationAreaDetails on LocationArea {
  id
  shortCode
  nameEn
  nameTc
  nameSc
  locationId
  orderId
  location {
    shortCode
    nameEn
    nameTc
    nameSc
  }
  facilityList {
    ...facilityList
  }
}
    ${FacilityListFragmentDoc}`;
export const LocationDetailsFragmentDoc = gql`
    fragment locationDetails on Location {
  id
  shortCode
  nameEn
  nameTc
  nameSc
  locationAreaList {
    ...locationAreaDetails
  }
}
    ${LocationAreaDetailsFragmentDoc}`;
export const SelectionJsonFragmentDoc = gql`
    fragment selectionJson on GetSelectionJsonResGql {
  sportTypeList {
    ...sportTypeSimple
  }
  countryList {
    ...countrySimple
  }
  districtList {
    ...districtSimple
  }
  locationList {
    ...memberLocationSimple
  }
  facilityLocationList {
    ...locationDetails
  }
}
    ${SportTypeSimpleFragmentDoc}
${CountrySimpleFragmentDoc}
${DistrictSimpleFragmentDoc}
${MemberLocationSimpleFragmentDoc}
${LocationDetailsFragmentDoc}`;
export const AccessPassHistorySimpleFragmentDoc = gql`
    fragment accessPassHistorySimple on AccessPassHistory {
  id
  startDate
  endDate
  enableAutoRenew
  autoRenewNextAccessPassOptionId
  accessPass {
    id
    nameTc
    nameSc
    nameEn
    enabledOptionList {
      id
      allowAutoRenew
      nameTc
      nameSc
      nameEn
    }
  }
  accessPassOption {
    ...accessPassOptionSimple
  }
}
    ${AccessPassOptionSimpleFragmentDoc}`;
export const FacilitySimpleFragmentDoc = gql`
    fragment facilitySimple on Facility {
  id
  shortCode
  nameEn
  nameTc
  nameSc
}
    `;
export const FacilityBookingSimpleFragmentDoc = gql`
    fragment facilityBookingSimple on FacilityBooking {
  id
  startDateTime
  endDateTime
  checkInDeviceId
  checkInMode
  checkInDateTime
  myorderItemId
  facility {
    ...facilitySimple
  }
  myorder {
    id
    status
    myorderDate
  }
}
    ${FacilitySimpleFragmentDoc}`;
export const MyfileResFragmentDoc = gql`
    fragment myfileRes on GetMyfileResGql {
  presignedUrl
  mimetype
  data
}
    `;
export const MyorderListFragmentDoc = gql`
    fragment myorderList on Myorder {
  id
  status
  shippingStatus
  payAmount
  myorderDate
  paymentConfirmDate
  itemList {
    id
    shippedQty
    unshippedQty
    productQty
    redeemEndDate
    offlineProductRedeemStatus
    product {
      id
      sku
      nameEn
      nameTc
      nameSc
    }
  }
}
    `;
export const CreditTypeSimpleFragmentDoc = gql`
    fragment creditTypeSimple on CreditType {
  id
  code
  nameTc
  nameSc
  nameEn
  myorderItemTypeList {
    myorderItemType
  }
}
    `;
export const MemberCreditBalanceSimpleFragmentDoc = gql`
    fragment memberCreditBalanceSimple on MemberCreditBalance {
  id
  balance
  creditTypeId
  creditType {
    ...creditTypeSimple
  }
}
    ${CreditTypeSimpleFragmentDoc}`;
export const FullMemberSimpleFragmentDoc = gql`
    fragment fullMemberSimple on FullMember {
  id
  surname
  givenName
  chineseName
  membershipNo
  membershipTypeId
  address1
  address2
  address3
  districtId
  subDistrictId
  memberLocationId
  birthDate
  hkid
  passport
  passportExpiryDate
  email
  nationalityId
  title
  gender
  mobileTel
  memberCreditBalanceList {
    ...memberCreditBalanceSimple
  }
}
    ${MemberCreditBalanceSimpleFragmentDoc}`;
export const MyorderItemLessonEnrolmentFragmentDoc = gql`
    fragment myorderItemLessonEnrolment on LessonEnrolment {
  uniformOption
  course {
    code
    nameEn
    nameTc
    nameSc
    overrideTimeDescEn
    overrideTimeDescTc
    overrideTimeDescSc
  }
  lesson {
    startDateTime
    endDateTime
  }
}
    `;
export const CreditPackageSimpleFragmentDoc = gql`
    fragment creditPackageSimple on CreditPackage {
  id
  creditTypeId
  sku
  nameTc
  nameSc
  nameEn
  creditAmount
  price
  creditType {
    ...creditTypeSimple
  }
}
    ${CreditTypeSimpleFragmentDoc}`;
export const MyorderItemDetailsFragmentDoc = gql`
    fragment myorderItemDetails on MyorderItem {
  id
  itemType
  bonusPointRedeemPromotionGroupId
  listPrice
  subtotalPrice
  posDiscount
  unshippedQty
  descEn
  frontendRemovable
  productQty
  unitPrice
  refStartDate
  refEndDate
  redeemEndDate
  offlineProductRedeemStatus
  lostCardNo
  bonusPointEarned
  bonusPointSpent
  refBonusPointDiscount
  membershipTypeId
  membership {
    nameEn
    nameTc
    nameSc
  }
  driveTeam {
    code
    name
  }
  driveMember {
    ...fullMemberSimple
  }
  referOrg {
    code
    nameEn
    nameTc
    nameSc
  }
  courseEnrolment {
    uniformOption
    course {
      code
      nameEn
      nameTc
      nameSc
      remarkTc
      remarkSc
      remarkEn
      overrideTimeDescEn
      overrideTimeDescTc
      overrideTimeDescSc
      isTrial
    }
  }
  lessonEnrolmentList {
    ...myorderItemLessonEnrolment
  }
  member {
    ...fullMemberSimple
  }
  coachService {
    nameEn
    nameTc
    nameSc
  }
  coach {
    displayName
  }
  facilityBooking {
    id
    startDateTime
    endDateTime
    facility {
      id
      nameEn
      nameTc
      nameSc
      requiredNoOfMembers
      locationArea {
        nameEn
        nameTc
        nameSc
        location {
          nameEn
          nameTc
          nameSc
        }
      }
    }
    otherMemberList {
      id
      membershipNo
    }
  }
  myEventEnrolmentList {
    teamName
    teamMemberList {
      isCaptain
      member {
        ...fullMemberSimple
      }
    }
    seat {
      seatNo
      ticketType {
        prefix
        nameEn
        nameTc
        nameSc
        isFreeSeating
        myEvent {
          code
          nameEn
          nameTc
          nameSc
          isTeamMode
        }
      }
    }
  }
  locker {
    label
    lockerGroup {
      shortCode
      nameEn
      nameTc
      nameSc
    }
  }
  lockerGroupFee {
    nameEn
    nameTc
    nameSc
  }
  product {
    id
    sku
    nameEn
    nameTc
    nameSc
    isVirtual
    allowWebOversell
    webStockLevel
    requireOfflineRedemption
  }
  accessPass {
    nameEn
    nameTc
    nameSc
  }
  accessPassOption {
    nameEn
    nameTc
    nameSc
  }
  couponPackage {
    id
    couponType
    sku
    nameEn
    nameTc
    nameSc
    noOfCoupons
    validNoOfDays
  }
  referOrg {
    code
    nameEn
    nameTc
    nameSc
  }
  creditPackage {
    ...creditPackageSimple
  }
}
    ${FullMemberSimpleFragmentDoc}
${MyorderItemLessonEnrolmentFragmentDoc}
${CreditPackageSimpleFragmentDoc}`;
export const MyorderDetailsFragmentDoc = gql`
    fragment myorderDetails on Myorder {
  id
  status
  cartType
  isAllVirtual
  isSelfPickup
  address1
  address2
  address3
  memberLocationId
  districtId
  subDistrictId
  totalPrice
  freightCost
  payAmount
  deptTransferDeptId
  updatedDate
  paymentMethod
  memberRemarks
  paymentStatus
  myorderDate
  paymentConfirmDate
  shipmentDate
  totalDiscount
  totalBonusPointEarned
  totalBonusPointSpent
  bonusPointBefore
  bonusPointAfter
  totalCreditSpent
  totalCreditRefunded
  creditBefore
  creditAfter
  couponCode
  isCouponCodeValid
  creditTypeId
  itemList {
    ...myorderItemDetails
  }
  creditType {
    ...creditTypeSimple
  }
}
    ${MyorderItemDetailsFragmentDoc}
${CreditTypeSimpleFragmentDoc}`;
export const FreightCostSettingFragmentDoc = gql`
    fragment freightCostSetting on FreightCostSettingResGql {
  allowShipping
  allowSelfPickup
}
    `;
export const TncSettingFragmentDoc = gql`
    fragment tncSetting on TncSettingResGql {
  globalTncEn
  globalTncTc
  globalTncSc
  redeemPromotionTncEn
  redeemPromotionTncTc
  redeemPromotionTncSc
}
    `;
export const KpayNotifyLogFragmentDoc = gql`
    fragment kpayNotifyLog on GetKpayNotifyLogResGql {
  transactionState
  transactionStateDesc
}
    `;
export const NewsSimpleFragmentDoc = gql`
    fragment newsSimple on News {
  id
  titleEn
  titleTc
  titleSc
  publishDateTime
}
    `;
export const MyfileSimpleFragmentDoc = gql`
    fragment myfileSimple on Myfile {
  id
  fileIdPath
  sysFilename
  myfileList {
    viewport
    fileIdPath
    sysFilename
  }
}
    `;
export const NewsDetailsFragmentDoc = gql`
    fragment newsDetails on News {
  titleEn
  titleTc
  titleSc
  contentEn
  contentTc
  contentSc
  publishDateTime
  photoList {
    ...myfileSimple
  }
}
    ${MyfileSimpleFragmentDoc}`;
export const SearchAccessPassDocument = gql`
    query searchAccessPass($input: SearchAccessPassInput!) {
  searchAccessPass(input: $input) {
    itemList {
      ...accessPassSimple
    }
  }
}
    ${AccessPassSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAccessPassGQL extends Apollo.Query<SearchAccessPassQuery, SearchAccessPassQueryVariables> {
    override document = SearchAccessPassDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetAccessPassPurchaseListDocument = gql`
    query meGetAccessPassPurchaseList($input: MeGetAccessPassPurchaseListInput!) {
  meGetAccessPassPurchaseList(input: $input) {
    ...accessPassPurchaseList
  }
}
    ${AccessPassPurchaseListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetAccessPassPurchaseListGQL extends Apollo.Query<MeGetAccessPassPurchaseListQuery, MeGetAccessPassPurchaseListQueryVariables> {
    override document = MeGetAccessPassPurchaseListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeSearchCreditPackageDocument = gql`
    query meSearchCreditPackage($input: SearchCreditPackageInput!) {
  meSearchCreditPackage(input: $input) {
    itemList {
      ...creditPackageSimple
    }
  }
}
    ${CreditPackageSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeSearchCreditPackageGQL extends Apollo.Query<MeSearchCreditPackageQuery, MeSearchCreditPackageQueryVariables> {
    override document = MeSearchCreditPackageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientGetFacilityBookingSummaryDocument = gql`
    query clientGetFacilityBookingSummary($input: GetFacilityBookingSummaryInput!) {
  clientGetFacilityBookingSummary(input: $input) {
    ...facilityBookingSummary
  }
}
    ${FacilityBookingSummaryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientGetFacilityBookingSummaryGQL extends Apollo.Query<ClientGetFacilityBookingSummaryQuery, ClientGetFacilityBookingSummaryQueryVariables> {
    override document = ClientGetFacilityBookingSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetEffectiveFacilityLeadTimeForMemberDocument = gql`
    query meGetEffectiveFacilityLeadTimeForMember($input: MeGetFacilityEffectiveLeadTimeForMemberInput!) {
  meGetEffectiveFacilityLeadTimeForMember(input: $input) {
    minLeadTimeInDays
    maxLeadTimeInDays
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetEffectiveFacilityLeadTimeForMemberGQL extends Apollo.Query<MeGetEffectiveFacilityLeadTimeForMemberQuery, MeGetEffectiveFacilityLeadTimeForMemberQueryVariables> {
    override document = MeGetEffectiveFacilityLeadTimeForMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchLocationDocument = gql`
    query searchLocation($input: SearchLocationInput!) {
  searchLocation(input: $input) {
    totalNum
    itemList {
      ...locationDetails
    }
  }
}
    ${LocationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchLocationGQL extends Apollo.Query<SearchLocationQuery, SearchLocationQueryVariables> {
    override document = SearchLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchLocationAreaDocument = gql`
    query searchLocationArea($input: SearchLocationAreaInput!) {
  searchLocationArea(input: $input) {
    totalNum
    itemList {
      ...locationAreaDetails
    }
  }
}
    ${LocationAreaDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchLocationAreaGQL extends Apollo.Query<SearchLocationAreaQuery, SearchLocationAreaQueryVariables> {
    override document = SearchLocationAreaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSelectionJsonDocument = gql`
    query getSelectionJson {
  getSelectionJson {
    ...selectionJson
  }
}
    ${SelectionJsonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSelectionJsonGQL extends Apollo.Query<GetSelectionJsonQuery, GetSelectionJsonQueryVariables> {
    override document = GetSelectionJsonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetMemberSimpleDocument = gql`
    query meGetMemberSimple {
  meGetMember {
    ...fullMemberSimple
  }
}
    ${FullMemberSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetMemberSimpleGQL extends Apollo.Query<MeGetMemberSimpleQuery, MeGetMemberSimpleQueryVariables> {
    override document = MeGetMemberSimpleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetOwnSessionListDocument = gql`
    query meGetOwnSessionList {
  meGetOwnSessionList {
    ...mySessionSimple
  }
}
    ${MySessionSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetOwnSessionListGQL extends Apollo.Query<MeGetOwnSessionListQuery, MeGetOwnSessionListQueryVariables> {
    override document = MeGetOwnSessionListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetLatestMemberAccessPassHistoryListDocument = gql`
    query meGetLatestMemberAccessPassHistoryList($input: MeGetLatestMemberAccessPassHistoryListInput!) {
  meGetLatestMemberAccessPassHistoryList(input: $input) {
    ...accessPassHistorySimple
  }
}
    ${AccessPassHistorySimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetLatestMemberAccessPassHistoryListGQL extends Apollo.Query<MeGetLatestMemberAccessPassHistoryListQuery, MeGetLatestMemberAccessPassHistoryListQueryVariables> {
    override document = MeGetLatestMemberAccessPassHistoryListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetMemberFacilityBookingHistoryDocument = gql`
    query meGetMemberFacilityBookingHistory($input: MeGetMemberFacilityBookingHistoryInput!) {
  meGetMemberFacilityBookingHistory(input: $input) {
    itemList {
      ...facilityBookingSimple
    }
  }
}
    ${FacilityBookingSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetMemberFacilityBookingHistoryGQL extends Apollo.Query<MeGetMemberFacilityBookingHistoryQuery, MeGetMemberFacilityBookingHistoryQueryVariables> {
    override document = MeGetMemberFacilityBookingHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateGuestDocument = gql`
    mutation createGuest {
  createGuest {
    member {
      ...fullMemberSimple
    }
    accessToken
    requireTotp
  }
}
    ${FullMemberSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateGuestGQL extends Apollo.Mutation<CreateGuestMutation, CreateGuestMutationVariables> {
    override document = CreateGuestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeInitEshopMemberDocument = gql`
    mutation meInitEshopMember($input: MeUpdateEshopMemberInput!) {
  meInitEshopMember(input: $input) {
    ...fullMemberSimple
  }
}
    ${FullMemberSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeInitEshopMemberGQL extends Apollo.Mutation<MeInitEshopMemberMutation, MeInitEshopMemberMutationVariables> {
    override document = MeInitEshopMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MemberLoginDocument = gql`
    mutation memberLogin($input: LoginMemberInput!) {
  memberLogin(input: $input) {
    accessToken
    requireTotp
    member {
      ...fullMemberSimple
    }
  }
}
    ${FullMemberSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MemberLoginGQL extends Apollo.Mutation<MemberLoginMutation, MemberLoginMutationVariables> {
    override document = MemberLoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuthSessionWithTotpDocument = gql`
    mutation authSessionWithTotp($input: AuthSessionWithTotpInput!) {
  authSessionWithTotp(input: $input) {
    accessToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AuthSessionWithTotpGQL extends Apollo.Mutation<AuthSessionWithTotpMutation, AuthSessionWithTotpMutationVariables> {
    override document = AuthSessionWithTotpDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterMemberLoginKeyDocument = gql`
    mutation registerMemberLoginKey($input: RegisterMemberLoginKeyInput!) {
  registerMemberLoginKey(input: $input) {
    id
    membershipNo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterMemberLoginKeyGQL extends Apollo.Mutation<RegisterMemberLoginKeyMutation, RegisterMemberLoginKeyMutationVariables> {
    override document = RegisterMemberLoginKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogoutGQL extends Apollo.Mutation<LogoutMutation, LogoutMutationVariables> {
    override document = LogoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeUpdateMemberDocument = gql`
    mutation meUpdateMember($input: MeUpdateMemberInput!) {
  meUpdateMember(input: $input) {
    ...fullMemberSimple
  }
}
    ${FullMemberSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeUpdateMemberGQL extends Apollo.Mutation<MeUpdateMemberMutation, MeUpdateMemberMutationVariables> {
    override document = MeUpdateMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeCleanMemberSessionDocument = gql`
    mutation meCleanMemberSession($input: MeCleanMemberSessionInput!) {
  meCleanMemberSession(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeCleanMemberSessionGQL extends Apollo.Mutation<MeCleanMemberSessionMutation, MeCleanMemberSessionMutationVariables> {
    override document = MeCleanMemberSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetOtpDocument = gql`
    mutation meGetOtp($input: MeGetOtpInput!) {
  meGetOtp(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetOtpGQL extends Apollo.Mutation<MeGetOtpMutation, MeGetOtpMutationVariables> {
    override document = MeGetOtpDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeVerifyOtpDocument = gql`
    mutation meVerifyOtp($input: MeVerifyOtpInput!) {
  meVerifyOtp(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeVerifyOtpGQL extends Apollo.Mutation<MeVerifyOtpMutation, MeVerifyOtpMutationVariables> {
    override document = MeVerifyOtpDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBannerListDocument = gql`
    query getBannerList($input: GetBannerListInput!) {
  getBannerList(input: $input) {
    ...myfileSimple
  }
}
    ${MyfileSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBannerListGQL extends Apollo.Query<GetBannerListQuery, GetBannerListQueryVariables> {
    override document = GetBannerListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MemberGetMyfileInfoDocument = gql`
    query memberGetMyfileInfo($input: MeGetMyfileInput!) {
  memberGetMyfileInfo(input: $input) {
    ...myfileRes
  }
}
    ${MyfileResFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MemberGetMyfileInfoGQL extends Apollo.Query<MemberGetMyfileInfoQuery, MemberGetMyfileInfoQueryVariables> {
    override document = MemberGetMyfileInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MePurgeMyfileFromMemberDocument = gql`
    mutation mePurgeMyfileFromMember($input: MePurgeMyfileFromMemberInput!) {
  mePurgeMyfileFromMember(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MePurgeMyfileFromMemberGQL extends Apollo.Mutation<MePurgeMyfileFromMemberMutation, MePurgeMyfileFromMemberMutationVariables> {
    override document = MePurgeMyfileFromMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetCartDocument = gql`
    query meGetCart($input: MeGetCartInput!) {
  meGetCart(input: $input) {
    ...myorderDetails
  }
}
    ${MyorderDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetCartGQL extends Apollo.Query<MeGetCartQuery, MeGetCartQueryVariables> {
    override document = MeGetCartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetMyorderDocument = gql`
    query meGetMyorder($input: GetMyorderInput!) {
  meGetMyorder(input: $input) {
    ...myorderDetails
  }
}
    ${MyorderDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetMyorderGQL extends Apollo.Query<MeGetMyorderQuery, MeGetMyorderQueryVariables> {
    override document = MeGetMyorderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeGetMemberMyorderHistoryDocument = gql`
    query meGetMemberMyorderHistory($input: MeGetMemberMyorderHistoryInput!) {
  meGetMemberMyorderHistory(input: $input) {
    totalNum
    itemList {
      ...myorderList
    }
  }
}
    ${MyorderListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGetMemberMyorderHistoryGQL extends Apollo.Query<MeGetMemberMyorderHistoryQuery, MeGetMemberMyorderHistoryQueryVariables> {
    override document = MeGetMemberMyorderHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFreightCostSettingDocument = gql`
    query getFreightCostSetting {
  getFreightCostSetting {
    ...freightCostSetting
  }
}
    ${FreightCostSettingFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFreightCostSettingGQL extends Apollo.Query<GetFreightCostSettingQuery, GetFreightCostSettingQueryVariables> {
    override document = GetFreightCostSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTncSettingDocument = gql`
    query getTncSetting {
  getTncSetting {
    ...tncSetting
  }
}
    ${TncSettingFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTncSettingGQL extends Apollo.Query<GetTncSettingQuery, GetTncSettingQueryVariables> {
    override document = GetTncSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpayNotifyLogDocument = gql`
    query getKpayNotifyLog($input: GetKpayNotifyLogInput!) {
  getKpayNotifyLog(input: $input) {
    ...kpayNotifyLog
  }
}
    ${KpayNotifyLogFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpayNotifyLogGQL extends Apollo.Query<GetKpayNotifyLogQuery, GetKpayNotifyLogQueryVariables> {
    override document = GetKpayNotifyLogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeAddAccessPassToCartDocument = gql`
    mutation meAddAccessPassToCart($input: MeAddAccessPassToCartInput!) {
  meAddAccessPassToCart(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeAddAccessPassToCartGQL extends Apollo.Mutation<MeAddAccessPassToCartMutation, MeAddAccessPassToCartMutationVariables> {
    override document = MeAddAccessPassToCartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeAddFacilityBookingToCartDocument = gql`
    mutation meAddFacilityBookingToCart($input: MeAddBookingToCartInput!) {
  meAddFacilityBookingToCart(input: $input) {
    ...myorderDetails
  }
}
    ${MyorderDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeAddFacilityBookingToCartGQL extends Apollo.Mutation<MeAddFacilityBookingToCartMutation, MeAddFacilityBookingToCartMutationVariables> {
    override document = MeAddFacilityBookingToCartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeAddCreditPackageToCartDocument = gql`
    mutation meAddCreditPackageToCart($input: MeAddCreditPackageToCartInput!) {
  meAddCreditPackageToCart(input: $input) {
    ...myorderDetails
  }
}
    ${MyorderDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeAddCreditPackageToCartGQL extends Apollo.Mutation<MeAddCreditPackageToCartMutation, MeAddCreditPackageToCartMutationVariables> {
    override document = MeAddCreditPackageToCartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeRemoveItemFromCartDocument = gql`
    mutation meRemoveItemFromCart($input: MeRemoveItemFromCartInput!) {
  meRemoveItemFromCart(input: $input) {
    ...myorderDetails
  }
}
    ${MyorderDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeRemoveItemFromCartGQL extends Apollo.Mutation<MeRemoveItemFromCartMutation, MeRemoveItemFromCartMutationVariables> {
    override document = MeRemoveItemFromCartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeUpdateMyorderDocument = gql`
    mutation meUpdateMyorder($input: UpdateMyorderInput!) {
  meUpdateMyorder(input: $input) {
    ...myorderDetails
  }
}
    ${MyorderDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeUpdateMyorderGQL extends Apollo.Mutation<MeUpdateMyorderMutation, MeUpdateMyorderMutationVariables> {
    override document = MeUpdateMyorderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeClearCartDocument = gql`
    mutation meClearCart($input: MeGetCartInput!) {
  meClearCart(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeClearCartGQL extends Apollo.Mutation<MeClearCartMutation, MeClearCartMutationVariables> {
    override document = MeClearCartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeConvertToOrderDocument = gql`
    mutation meConvertToOrder($input: MeConvertToOrderInput!) {
  meConvertToOrder(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeConvertToOrderGQL extends Apollo.Mutation<MeConvertToOrderMutation, MeConvertToOrderMutationVariables> {
    override document = MeConvertToOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeApplyCouponToFacilityBookingDocument = gql`
    mutation meApplyCouponToFacilityBooking($input: MeApplyCouponToFacilityBookingInput!) {
  meApplyCouponToFacilityBooking(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeApplyCouponToFacilityBookingGQL extends Apollo.Mutation<MeApplyCouponToFacilityBookingMutation, MeApplyCouponToFacilityBookingMutationVariables> {
    override document = MeApplyCouponToFacilityBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeCancelMyorderDocument = gql`
    mutation meCancelMyorder($input: MeCancelMyorderInput!) {
  meCancelMyorder(input: $input) {
    ...myorderDetails
  }
}
    ${MyorderDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeCancelMyorderGQL extends Apollo.Mutation<MeCancelMyorderMutation, MeCancelMyorderMutationVariables> {
    override document = MeCancelMyorderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchNewsDocument = gql`
    query searchNews($input: SearchNewsInput!) {
  searchNews(input: $input) {
    itemList {
      ...newsSimple
    }
  }
}
    ${NewsSimpleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchNewsGQL extends Apollo.Query<SearchNewsQuery, SearchNewsQueryVariables> {
    override document = SearchNewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNewsDocument = gql`
    query getNews($input: GetNewsInput!) {
  getNews(input: $input) {
    ...newsDetails
  }
}
    ${NewsDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNewsGQL extends Apollo.Query<GetNewsQuery, GetNewsQueryVariables> {
    override document = GetNewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }